//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.3.0.0 (NJsonSchema v11.2.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import * as http from "@angular/common/http";
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, from as _observableFrom, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import { DateTime, Duration } from "luxon";

export const P2_API_BASE_URL = new InjectionToken<string>('P2_API_BASE_URL');

export class ServiceProxyBase {
    async transformOptions(options: RequestOptions): Promise<RequestOptions> {
        const self = this as any;

        if (!self.jsonParseReviver) {
            self.jsonParseReviver = createPillar2CalendarDateReviver();
        }

        if (typeof options.body === 'string') {
            options.body = JSON.stringify(JSON.parse(options.body, createPillar2CalendarDateReviver()));
        }

        return options;
    }
}

@Injectable()
export class AccessManagementServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param projectId (optional) 
     * @param filter (optional) 
     * @return OK
     */
    requestOverview(projectId: number | undefined, filter: string | null | undefined): Observable<AccessManagementOverviewDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/AccessManagement/RequestOverview?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRequestOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccessManagementOverviewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccessManagementOverviewDto[]>;
        }));
    }

    protected processRequestOverview(response: HttpResponseBase): Observable<AccessManagementOverviewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccessManagementOverviewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    getAllAvailableCountries(projectId: number | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/AccessManagement/GetAllAvailableCountries?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllAvailableCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAvailableCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllAvailableCountries(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    requestUserOrOrganizatioUnitPermissions(body: GetUserOrOrganizationalUnitPermissionsInput | undefined): Observable<GetUserOrOrganizationalUnitPermissionsDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/AccessManagement/RequestUserOrOrganizatioUnitPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRequestUserOrOrganizatioUnitPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestUserOrOrganizatioUnitPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserOrOrganizationalUnitPermissionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserOrOrganizationalUnitPermissionsDto>;
        }));
    }

    protected processRequestUserOrOrganizatioUnitPermissions(response: HttpResponseBase): Observable<GetUserOrOrganizationalUnitPermissionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserOrOrganizationalUnitPermissionsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    requestUserOrOrganizatioUnitBulkPermissions(body: GetUserOrOrganizationalUnitBulkPermissionsInput | undefined): Observable<GetUserOrOrganizationalUnitPermissionsDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/AccessManagement/RequestUserOrOrganizatioUnitBulkPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRequestUserOrOrganizatioUnitBulkPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestUserOrOrganizatioUnitBulkPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserOrOrganizationalUnitPermissionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserOrOrganizationalUnitPermissionsDto>;
        }));
    }

    protected processRequestUserOrOrganizatioUnitBulkPermissions(response: HttpResponseBase): Observable<GetUserOrOrganizationalUnitPermissionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserOrOrganizationalUnitPermissionsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body: UpdateAccessManagementInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/AccessManagement/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    bulkUpdate(body: BulkUpdateAccessManagementInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/AccessManagement/BulkUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBulkUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BlendingCirclesServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    bulkSetSuggestedBlendingCircleSubgroups(body: BulkSetSuggestedBlendingCircleSubgroupsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/BlendingCircles/BulkSetSuggestedBlendingCircleSubgroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBulkSetSuggestedBlendingCircleSubgroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkSetSuggestedBlendingCircleSubgroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkSetSuggestedBlendingCircleSubgroups(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    bulkSetEntityControllingInterests(body: BulkSetEntityControllingInterestsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/BlendingCircles/BulkSetEntityControllingInterests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBulkSetEntityControllingInterests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkSetEntityControllingInterests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkSetEntityControllingInterests(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CombinedDataPointsServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    recalculateCombinedNode(body: RequestRecalculateCombinedNodeInput | undefined): Observable<FinancialNodeDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/CombinedDataPoints/RecalculateCombinedNode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRecalculateCombinedNode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecalculateCombinedNode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinancialNodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinancialNodeDto>;
        }));
    }

    protected processRecalculateCombinedNode(response: HttpResponseBase): Observable<FinancialNodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinancialNodeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createMultipleNodeGroupData(body: CreateMultipleNodeGroupInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/CombinedDataPoints/CreateMultipleNodeGroupData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateMultipleNodeGroupData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMultipleNodeGroupData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateMultipleNodeGroupData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createCombinedDataPoint(body: CombinedDataPointInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/CombinedDataPoints/CreateCombinedDataPoint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateCombinedDataPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCombinedDataPoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateCombinedDataPoint(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param organizationalEntityId (optional) 
     * @param nodeGroupType (optional) 
     * @param nodeGroupId (optional) 
     * @param financialTreeType (optional) 
     * @return OK
     */
    deleteMultipleNodeGroupData(projectId: number | undefined, organizationalEntityId: number | undefined, nodeGroupType: FinancialNodeGroupType | null | undefined, nodeGroupId: number | undefined, financialTreeType: FinancialTreeType | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/CombinedDataPoints/DeleteMultipleNodeGroupData?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (organizationalEntityId === null)
            throw new Error("The parameter 'organizationalEntityId' cannot be null.");
        else if (organizationalEntityId !== undefined)
            url_ += "OrganizationalEntityId=" + encodeURIComponent("" + organizationalEntityId) + "&";
        if (nodeGroupType !== undefined && nodeGroupType !== null)
            url_ += "NodeGroupType=" + encodeURIComponent("" + nodeGroupType) + "&";
        if (nodeGroupId === null)
            throw new Error("The parameter 'nodeGroupId' cannot be null.");
        else if (nodeGroupId !== undefined)
            url_ += "NodeGroupId=" + encodeURIComponent("" + nodeGroupId) + "&";
        if (financialTreeType !== undefined && financialTreeType !== null)
            url_ += "FinancialTreeType=" + encodeURIComponent("" + financialTreeType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteMultipleNodeGroupData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMultipleNodeGroupData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteMultipleNodeGroupData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateCombinedDataPoint(body: UpdateCombinedDataPointInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/CombinedDataPoints/UpdateCombinedDataPoint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateCombinedDataPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCombinedDataPoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCombinedDataPoint(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateCombinedDataPointStatus(body: UpdateDataPointStatusInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/CombinedDataPoints/UpdateCombinedDataPointStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateCombinedDataPointStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCombinedDataPointStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCombinedDataPointStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DataPointChangesServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param projectId (optional) 
     * @param dataPointId (optional) 
     * @param financialTreeType (optional) 
     * @return OK
     */
    getValueDataPointChanges(projectId: number | undefined, dataPointId: number | undefined, financialTreeType: FinancialTreeType | null | undefined): Observable<EntityChangesDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/DataPointChanges/GetValueDataPointChanges?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (dataPointId === null)
            throw new Error("The parameter 'dataPointId' cannot be null.");
        else if (dataPointId !== undefined)
            url_ += "DataPointId=" + encodeURIComponent("" + dataPointId) + "&";
        if (financialTreeType !== undefined && financialTreeType !== null)
            url_ += "FinancialTreeType=" + encodeURIComponent("" + financialTreeType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetValueDataPointChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValueDataPointChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityChangesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityChangesDto>;
        }));
    }

    protected processGetValueDataPointChanges(response: HttpResponseBase): Observable<EntityChangesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EntityChangesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param dataPointId (optional) 
     * @param financialTreeType (optional) 
     * @return OK
     */
    getShiftDataPointChanges(projectId: number | undefined, dataPointId: number | undefined, financialTreeType: FinancialTreeType | null | undefined): Observable<EntityChangesDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/DataPointChanges/GetShiftDataPointChanges?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (dataPointId === null)
            throw new Error("The parameter 'dataPointId' cannot be null.");
        else if (dataPointId !== undefined)
            url_ += "DataPointId=" + encodeURIComponent("" + dataPointId) + "&";
        if (financialTreeType !== undefined && financialTreeType !== null)
            url_ += "FinancialTreeType=" + encodeURIComponent("" + financialTreeType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetShiftDataPointChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShiftDataPointChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityChangesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityChangesDto>;
        }));
    }

    protected processGetShiftDataPointChanges(response: HttpResponseBase): Observable<EntityChangesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EntityChangesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param dataPointId (optional) 
     * @param financialTreeType (optional) 
     * @return OK
     */
    getCombinedDataPointChanges(projectId: number | undefined, dataPointId: number | undefined, financialTreeType: FinancialTreeType | null | undefined): Observable<EntityChangesDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/DataPointChanges/GetCombinedDataPointChanges?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (dataPointId === null)
            throw new Error("The parameter 'dataPointId' cannot be null.");
        else if (dataPointId !== undefined)
            url_ += "DataPointId=" + encodeURIComponent("" + dataPointId) + "&";
        if (financialTreeType !== undefined && financialTreeType !== null)
            url_ += "FinancialTreeType=" + encodeURIComponent("" + financialTreeType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCombinedDataPointChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCombinedDataPointChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityChangesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityChangesDto>;
        }));
    }

    protected processGetCombinedDataPointChanges(response: HttpResponseBase): Observable<EntityChangesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EntityChangesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectCurrencyRateId (optional) 
     * @return OK
     */
    getProjectCurrencyRateChanges(projectCurrencyRateId: number | undefined): Observable<EntityChangeDataDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/DataPointChanges/GetProjectCurrencyRateChanges?";
        if (projectCurrencyRateId === null)
            throw new Error("The parameter 'projectCurrencyRateId' cannot be null.");
        else if (projectCurrencyRateId !== undefined)
            url_ += "projectCurrencyRateId=" + encodeURIComponent("" + projectCurrencyRateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProjectCurrencyRateChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectCurrencyRateChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityChangeDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityChangeDataDto[]>;
        }));
    }

    protected processGetProjectCurrencyRateChanges(response: HttpResponseBase): Observable<EntityChangeDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityChangeDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationalEntityId (optional) 
     * @param financialGroupType (optional) 
     * @param financialTreeType (optional) 
     * @return OK
     */
    getOrganizationalEntityFullScopeConfirmationChanges(organizationalEntityId: number | undefined, financialGroupType: FinancialGroupType | null | undefined, financialTreeType: FinancialTreeType | null | undefined): Observable<EntityChangeDataDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/DataPointChanges/GetOrganizationalEntityFullScopeConfirmationChanges?";
        if (organizationalEntityId === null)
            throw new Error("The parameter 'organizationalEntityId' cannot be null.");
        else if (organizationalEntityId !== undefined)
            url_ += "OrganizationalEntityId=" + encodeURIComponent("" + organizationalEntityId) + "&";
        if (financialGroupType !== undefined && financialGroupType !== null)
            url_ += "FinancialGroupType=" + encodeURIComponent("" + financialGroupType) + "&";
        if (financialTreeType !== undefined && financialTreeType !== null)
            url_ += "FinancialTreeType=" + encodeURIComponent("" + financialTreeType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOrganizationalEntityFullScopeConfirmationChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationalEntityFullScopeConfirmationChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityChangeDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityChangeDataDto[]>;
        }));
    }

    protected processGetOrganizationalEntityFullScopeConfirmationChanges(response: HttpResponseBase): Observable<EntityChangeDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityChangeDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DeferredTaxesServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param projectId (optional) 
     * @param blendingCircleSubgroupId (optional) 
     * @return OK
     */
    getTransitionData(projectId: number | undefined, blendingCircleSubgroupId: number | undefined): Observable<TransitionDataDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/DeferredTaxes/GetTransitionData?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (blendingCircleSubgroupId === null)
            throw new Error("The parameter 'blendingCircleSubgroupId' cannot be null.");
        else if (blendingCircleSubgroupId !== undefined)
            url_ += "blendingCircleSubgroupId=" + encodeURIComponent("" + blendingCircleSubgroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTransitionData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransitionData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransitionDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransitionDataDto>;
        }));
    }

    protected processGetTransitionData(response: HttpResponseBase): Observable<TransitionDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransitionDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveTransitionData(body: SaveTransitionDataInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/DeferredTaxes/SaveTransitionData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSaveTransitionData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveTransitionData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveTransitionData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param blendingCircleSubgroupId (optional) 
     * @return OK
     */
    getRecaptureDeferredData(projectId: number | undefined, blendingCircleSubgroupId: number | undefined): Observable<RecaptureDeferredDataDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/DeferredTaxes/GetRecaptureDeferredData?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (blendingCircleSubgroupId === null)
            throw new Error("The parameter 'blendingCircleSubgroupId' cannot be null.");
        else if (blendingCircleSubgroupId !== undefined)
            url_ += "blendingCircleSubgroupId=" + encodeURIComponent("" + blendingCircleSubgroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRecaptureDeferredData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecaptureDeferredData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecaptureDeferredDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecaptureDeferredDataDto>;
        }));
    }

    protected processGetRecaptureDeferredData(response: HttpResponseBase): Observable<RecaptureDeferredDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecaptureDeferredDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveRecaptureDeferredData(body: SaveRecaptureDeferredDataInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/DeferredTaxes/SaveRecaptureDeferredData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSaveRecaptureDeferredData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveRecaptureDeferredData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveRecaptureDeferredData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ExportServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    exportReportData(body: ProjectDataExcelExportInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Export/ExportReportData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processExportReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportReportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExportReportData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    compareProjects(body: CompareProjectsToExcelInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Export/CompareProjects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCompareProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompareProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCompareProjects(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FileUploadServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param file (optional) 
     * @return OK
     */
    uploadFile(file: FileParameter | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/pillar2/FileUpload/UploadFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FinancialDataServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param projectId (optional) 
     * @param safeHarbourGroupId (optional) 
     * @param organizationalEntityId (optional) 
     * @param traceId (optional) 
     * @return OK
     */
    getFinancialValuePoint(projectId: number | undefined, safeHarbourGroupId: number | null | undefined, organizationalEntityId: number | null | undefined, traceId: number | undefined): Observable<FinancialValuePointDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/FinancialData/GetFinancialValuePoint?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (safeHarbourGroupId !== undefined && safeHarbourGroupId !== null)
            url_ += "SafeHarbourGroupId=" + encodeURIComponent("" + safeHarbourGroupId) + "&";
        if (organizationalEntityId !== undefined && organizationalEntityId !== null)
            url_ += "OrganizationalEntityId=" + encodeURIComponent("" + organizationalEntityId) + "&";
        if (traceId === null)
            throw new Error("The parameter 'traceId' cannot be null.");
        else if (traceId !== undefined)
            url_ += "TraceId=" + encodeURIComponent("" + traceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFinancialValuePoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinancialValuePoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinancialValuePointDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinancialValuePointDto>;
        }));
    }

    protected processGetFinancialValuePoint(response: HttpResponseBase): Observable<FinancialValuePointDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinancialValuePointDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getFinancialDataCurrencyConvertedFinal(body: GetFinancialDataCurrencyConvertedFinalInput | undefined): Observable<FinancialDataCurrencyConvertedFinalDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/FinancialData/GetFinancialDataCurrencyConvertedFinal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFinancialDataCurrencyConvertedFinal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinancialDataCurrencyConvertedFinal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinancialDataCurrencyConvertedFinalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinancialDataCurrencyConvertedFinalDto>;
        }));
    }

    protected processGetFinancialDataCurrencyConvertedFinal(response: HttpResponseBase): Observable<FinancialDataCurrencyConvertedFinalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinancialDataCurrencyConvertedFinalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    getProjectUserConfiguration(projectId: number | undefined): Observable<ProjectUserSettingsDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/FinancialData/GetProjectUserConfiguration?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProjectUserConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectUserConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectUserSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectUserSettingsDto>;
        }));
    }

    protected processGetProjectUserConfiguration(response: HttpResponseBase): Observable<ProjectUserSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectUserSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveProjectUserConfiguration(body: UpdateProjectUserConfigurationInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/FinancialData/SaveProjectUserConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSaveProjectUserConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveProjectUserConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveProjectUserConfiguration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param pointId (optional) 
     * @return OK
     */
    getFinancialPointChanges(pointId: number | undefined): Observable<GetFinancialValuePointChangeDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/FinancialData/GetFinancialPointChanges?";
        if (pointId === null)
            throw new Error("The parameter 'pointId' cannot be null.");
        else if (pointId !== undefined)
            url_ += "pointId=" + encodeURIComponent("" + pointId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFinancialPointChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinancialPointChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFinancialValuePointChangeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFinancialValuePointChangeDto[]>;
        }));
    }

    protected processGetFinancialPointChanges(response: HttpResponseBase): Observable<GetFinancialValuePointChangeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetFinancialValuePointChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createFinancialValuePointOrganizationalEntity(body: CreateFinancialValuePointOrganizationalEntityInput | undefined): Observable<FinancialValuePointDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/FinancialData/CreateFinancialValuePointOrganizationalEntity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateFinancialValuePointOrganizationalEntity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFinancialValuePointOrganizationalEntity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinancialValuePointDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinancialValuePointDto>;
        }));
    }

    protected processCreateFinancialValuePointOrganizationalEntity(response: HttpResponseBase): Observable<FinancialValuePointDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinancialValuePointDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createFinancialValuePointSafeHarbourGroup(body: CreateFinancialValuePointSafeHarbourGroupInput | undefined): Observable<FinancialValuePointDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/FinancialData/CreateFinancialValuePointSafeHarbourGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateFinancialValuePointSafeHarbourGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFinancialValuePointSafeHarbourGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinancialValuePointDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinancialValuePointDto>;
        }));
    }

    protected processCreateFinancialValuePointSafeHarbourGroup(response: HttpResponseBase): Observable<FinancialValuePointDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinancialValuePointDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateFinancialValuePoint(body: UpdateFinancialValuePointInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/FinancialData/UpdateFinancialValuePoint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateFinancialValuePoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFinancialValuePoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateFinancialValuePoint(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateFinancialValuePointStatus(body: UpdateFinancialValuePointStatusInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/FinancialData/UpdateFinancialValuePointStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateFinancialValuePointStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFinancialValuePointStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateFinancialValuePointStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    bulkUpdateFinancialValuePoint(body: BulkUpdateFinancialValuePointInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/FinancialData/BulkUpdateFinancialValuePoint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBulkUpdateFinancialValuePoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkUpdateFinancialValuePoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkUpdateFinancialValuePoint(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FinancialDataExportHistoryServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    generatePdf(projectId: number | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/FinancialDataExportHistory/GeneratePdf?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGeneratePdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneratePdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processGeneratePdf(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FullScopeCalculationsServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    requestOverview(body: FinancialGroupDataOverviewInput | undefined): Observable<PagedResultDtoOfFullScopeCalculationsOverviewDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeCalculations/RequestOverview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRequestOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfFullScopeCalculationsOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfFullScopeCalculationsOverviewDto>;
        }));
    }

    protected processRequestOverview(response: HttpResponseBase): Observable<PagedResultDtoOfFullScopeCalculationsOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfFullScopeCalculationsOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getFullScopeCalculationsBlendingCircleSubgroupDetails(body: FinancialGroupDataOverviewByBlendingCircleSubgroupInput | undefined): Observable<FinancialGroupDataJurisdictionsOverviewDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeCalculations/GetFullScopeCalculationsBlendingCircleSubgroupDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFullScopeCalculationsBlendingCircleSubgroupDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFullScopeCalculationsBlendingCircleSubgroupDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinancialGroupDataJurisdictionsOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinancialGroupDataJurisdictionsOverviewDto>;
        }));
    }

    protected processGetFullScopeCalculationsBlendingCircleSubgroupDetails(response: HttpResponseBase): Observable<FinancialGroupDataJurisdictionsOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinancialGroupDataJurisdictionsOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getFullScopeCalculationsOrganizationalEntities(body: FinancialGroupDataOverviewByBlendingCircleSubgroupInput | undefined): Observable<ListResultDtoOfFinancialGroupDataOrganizationalEntityOverviewDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeCalculations/GetFullScopeCalculationsOrganizationalEntities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFullScopeCalculationsOrganizationalEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFullScopeCalculationsOrganizationalEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfFinancialGroupDataOrganizationalEntityOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfFinancialGroupDataOrganizationalEntityOverviewDto>;
        }));
    }

    protected processGetFullScopeCalculationsOrganizationalEntities(response: HttpResponseBase): Observable<ListResultDtoOfFinancialGroupDataOrganizationalEntityOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfFinancialGroupDataOrganizationalEntityOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param blendingCircleCountry (optional) 
     * @param blendingCircleSubgroupId (optional) 
     * @param organizationalEntityId (optional) 
     * @param financialGroupType (optional) 
     * @param financialTreeType (optional) 
     * @return OK
     */
    getFinancialGroupData(projectId: number | undefined, blendingCircleCountry: string | null | undefined, blendingCircleSubgroupId: number | undefined, organizationalEntityId: number | null | undefined, financialGroupType: FinancialGroupType | null | undefined, financialTreeType: FinancialTreeType | null | undefined): Observable<FinancialGroupDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeCalculations/GetFinancialGroupData?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (blendingCircleCountry !== undefined && blendingCircleCountry !== null)
            url_ += "BlendingCircleCountry=" + encodeURIComponent("" + blendingCircleCountry) + "&";
        if (blendingCircleSubgroupId === null)
            throw new Error("The parameter 'blendingCircleSubgroupId' cannot be null.");
        else if (blendingCircleSubgroupId !== undefined)
            url_ += "BlendingCircleSubgroupId=" + encodeURIComponent("" + blendingCircleSubgroupId) + "&";
        if (organizationalEntityId !== undefined && organizationalEntityId !== null)
            url_ += "OrganizationalEntityId=" + encodeURIComponent("" + organizationalEntityId) + "&";
        if (financialGroupType !== undefined && financialGroupType !== null)
            url_ += "FinancialGroupType=" + encodeURIComponent("" + financialGroupType) + "&";
        if (financialTreeType !== undefined && financialTreeType !== null)
            url_ += "FinancialTreeType=" + encodeURIComponent("" + financialTreeType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFinancialGroupData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinancialGroupData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinancialGroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinancialGroupDto>;
        }));
    }

    protected processGetFinancialGroupData(response: HttpResponseBase): Observable<FinancialGroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinancialGroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param organizationalEntityId (optional) 
     * @param blendingCircleCountry (optional) 
     * @param blendingCircleSubgroupId (optional) 
     * @param financialTreeType (optional) 
     * @return OK
     */
    getTutForOrganizationalEntity(projectId: number | undefined, organizationalEntityId: number | undefined, blendingCircleCountry: string | null | undefined, blendingCircleSubgroupId: number | undefined, financialTreeType: FinancialTreeType | null | undefined): Observable<TutForOrganizationalEntityDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeCalculations/GetTutForOrganizationalEntity?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (organizationalEntityId === null)
            throw new Error("The parameter 'organizationalEntityId' cannot be null.");
        else if (organizationalEntityId !== undefined)
            url_ += "OrganizationalEntityId=" + encodeURIComponent("" + organizationalEntityId) + "&";
        if (blendingCircleCountry !== undefined && blendingCircleCountry !== null)
            url_ += "BlendingCircleCountry=" + encodeURIComponent("" + blendingCircleCountry) + "&";
        if (blendingCircleSubgroupId === null)
            throw new Error("The parameter 'blendingCircleSubgroupId' cannot be null.");
        else if (blendingCircleSubgroupId !== undefined)
            url_ += "BlendingCircleSubgroupId=" + encodeURIComponent("" + blendingCircleSubgroupId) + "&";
        if (financialTreeType !== undefined && financialTreeType !== null)
            url_ += "FinancialTreeType=" + encodeURIComponent("" + financialTreeType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTutForOrganizationalEntity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTutForOrganizationalEntity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TutForOrganizationalEntityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TutForOrganizationalEntityDto>;
        }));
    }

    protected processGetTutForOrganizationalEntity(response: HttpResponseBase): Observable<TutForOrganizationalEntityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TutForOrganizationalEntityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param blendingCircleCountry (optional) 
     * @param blendingCircleSubgroupId (optional) 
     * @param financialTreeType (optional) 
     * @return OK
     */
    getTutForBlendingCircleSubgroup(projectId: number | undefined, blendingCircleCountry: string | null | undefined, blendingCircleSubgroupId: number | undefined, financialTreeType: FinancialTreeType | null | undefined): Observable<TutForBlendingCircleSubgroupDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeCalculations/GetTutForBlendingCircleSubgroup?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (blendingCircleCountry !== undefined && blendingCircleCountry !== null)
            url_ += "BlendingCircleCountry=" + encodeURIComponent("" + blendingCircleCountry) + "&";
        if (blendingCircleSubgroupId === null)
            throw new Error("The parameter 'blendingCircleSubgroupId' cannot be null.");
        else if (blendingCircleSubgroupId !== undefined)
            url_ += "BlendingCircleSubgroupId=" + encodeURIComponent("" + blendingCircleSubgroupId) + "&";
        if (financialTreeType !== undefined && financialTreeType !== null)
            url_ += "FinancialTreeType=" + encodeURIComponent("" + financialTreeType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTutForBlendingCircleSubgroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTutForBlendingCircleSubgroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TutForBlendingCircleSubgroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TutForBlendingCircleSubgroupDto>;
        }));
    }

    protected processGetTutForBlendingCircleSubgroup(response: HttpResponseBase): Observable<TutForBlendingCircleSubgroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TutForBlendingCircleSubgroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    changeSwitchOffStatus(body: ChangeSwitchOffStatusInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeCalculations/ChangeSwitchOffStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processChangeSwitchOffStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeSwitchOffStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeSwitchOffStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateFinancialGroupConfirmation(body: UpdateFinancialGroupConfirmationInput | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeCalculations/UpdateFinancialGroupConfirmation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateFinancialGroupConfirmation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFinancialGroupConfirmation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processUpdateFinancialGroupConfirmation(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    getBlendingCircles(projectId: number | undefined): Observable<BlendingCircleReferenceDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeCalculations/GetBlendingCircles?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBlendingCircles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBlendingCircles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BlendingCircleReferenceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BlendingCircleReferenceDto[]>;
        }));
    }

    protected processGetBlendingCircles(response: HttpResponseBase): Observable<BlendingCircleReferenceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BlendingCircleReferenceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param taxJurisdictionCountry (optional) 
     * @return OK
     */
    getBlendingCircleSubgroups(projectId: number | undefined, taxJurisdictionCountry: string | null | undefined): Observable<BlendingCircleReferenceSubgroupDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeCalculations/GetBlendingCircleSubgroups?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (taxJurisdictionCountry !== undefined && taxJurisdictionCountry !== null)
            url_ += "taxJurisdictionCountry=" + encodeURIComponent("" + taxJurisdictionCountry) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBlendingCircleSubgroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBlendingCircleSubgroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BlendingCircleReferenceSubgroupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BlendingCircleReferenceSubgroupDto[]>;
        }));
    }

    protected processGetBlendingCircleSubgroups(response: HttpResponseBase): Observable<BlendingCircleReferenceSubgroupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BlendingCircleReferenceSubgroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param country (optional) 
     * @param blendingCircleSubgroupId (optional) 
     * @param organizationalEntityId (optional) 
     * @return OK
     */
    isQdmttActive(projectId: number | undefined, country: string | null | undefined, blendingCircleSubgroupId: number | null | undefined, organizationalEntityId: number | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeCalculations/IsQdmttActive?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (country !== undefined && country !== null)
            url_ += "Country=" + encodeURIComponent("" + country) + "&";
        if (blendingCircleSubgroupId !== undefined && blendingCircleSubgroupId !== null)
            url_ += "BlendingCircleSubgroupId=" + encodeURIComponent("" + blendingCircleSubgroupId) + "&";
        if (organizationalEntityId !== undefined && organizationalEntityId !== null)
            url_ += "OrganizationalEntityId=" + encodeURIComponent("" + organizationalEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processIsQdmttActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsQdmttActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsQdmttActive(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param country (optional) 
     * @param blendingCircleSubgroupId (optional) 
     * @param organizationalEntityId (optional) 
     * @return OK
     */
    isEtrAndTutSwitchOffEnabled(projectId: number | undefined, country: string | null | undefined, blendingCircleSubgroupId: number | null | undefined, organizationalEntityId: number | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeCalculations/IsEtrAndTutSwitchOffEnabled?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (country !== undefined && country !== null)
            url_ += "Country=" + encodeURIComponent("" + country) + "&";
        if (blendingCircleSubgroupId !== undefined && blendingCircleSubgroupId !== null)
            url_ += "BlendingCircleSubgroupId=" + encodeURIComponent("" + blendingCircleSubgroupId) + "&";
        if (organizationalEntityId !== undefined && organizationalEntityId !== null)
            url_ += "OrganizationalEntityId=" + encodeURIComponent("" + organizationalEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processIsEtrAndTutSwitchOffEnabled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsEtrAndTutSwitchOffEnabled(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsEtrAndTutSwitchOffEnabled(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FullScopeCalculationsReferenceDataServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param projectId (optional) 
     * @param blendingCircleSubgroupId (optional) 
     * @param blendingCircleCountry (optional) 
     * @param entityId (optional) 
     * @param entityLegalName (optional) 
     * @return OK
     */
    getEntitiesByBlendingCircleSubgroupId(projectId: number | undefined, blendingCircleSubgroupId: number | null | undefined, blendingCircleCountry: string | null | undefined, entityId: number | null | undefined, entityLegalName: string | null | undefined): Observable<OrganizationalEntityReferenceDataDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeCalculationsReferenceData/GetEntitiesByBlendingCircleSubgroupId?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (blendingCircleSubgroupId !== undefined && blendingCircleSubgroupId !== null)
            url_ += "blendingCircleSubgroupId=" + encodeURIComponent("" + blendingCircleSubgroupId) + "&";
        if (blendingCircleCountry !== undefined && blendingCircleCountry !== null)
            url_ += "blendingCircleCountry=" + encodeURIComponent("" + blendingCircleCountry) + "&";
        if (entityId !== undefined && entityId !== null)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        if (entityLegalName !== undefined && entityLegalName !== null)
            url_ += "entityLegalName=" + encodeURIComponent("" + entityLegalName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEntitiesByBlendingCircleSubgroupId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntitiesByBlendingCircleSubgroupId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationalEntityReferenceDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationalEntityReferenceDataDto[]>;
        }));
    }

    protected processGetEntitiesByBlendingCircleSubgroupId(response: HttpResponseBase): Observable<OrganizationalEntityReferenceDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationalEntityReferenceDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getBlendingCircleSubgroups(body: RequestBlendingCircleSubgroups | undefined): Observable<BlendingCircleSubgroupDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeCalculationsReferenceData/GetBlendingCircleSubgroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBlendingCircleSubgroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBlendingCircleSubgroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BlendingCircleSubgroupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BlendingCircleSubgroupDto[]>;
        }));
    }

    protected processGetBlendingCircleSubgroups(response: HttpResponseBase): Observable<BlendingCircleSubgroupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BlendingCircleSubgroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    getEntitiesByProjectId(projectId: number | undefined): Observable<OrganizationalEntityReferenceDataDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeCalculationsReferenceData/GetEntitiesByProjectId?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEntitiesByProjectId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntitiesByProjectId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationalEntityReferenceDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationalEntityReferenceDataDto[]>;
        }));
    }

    protected processGetEntitiesByProjectId(response: HttpResponseBase): Observable<OrganizationalEntityReferenceDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationalEntityReferenceDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getFinancialGroups(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeCalculationsReferenceData/GetFinancialGroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFinancialGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinancialGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetFinancialGroups(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setAssignedUser(body: SetAssignedUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeCalculationsReferenceData/SetAssignedUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSetAssignedUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAssignedUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetAssignedUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setDueDate(body: SetDueDateInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeCalculationsReferenceData/SetDueDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSetDueDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDueDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetDueDate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param organizationalEntityId (optional) 
     * @return OK
     */
    getEntityManagement(projectId: number | undefined, organizationalEntityId: number | undefined): Observable<EntityManagementDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeCalculationsReferenceData/GetEntityManagement?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (organizationalEntityId === null)
            throw new Error("The parameter 'organizationalEntityId' cannot be null.");
        else if (organizationalEntityId !== undefined)
            url_ += "organizationalEntityId=" + encodeURIComponent("" + organizationalEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEntityManagement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityManagement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityManagementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityManagementDto>;
        }));
    }

    protected processGetEntityManagement(response: HttpResponseBase): Observable<EntityManagementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EntityManagementDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getProjectDueDateStatuses(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeCalculationsReferenceData/GetProjectDueDateStatuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProjectDueDateStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectDueDateStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetProjectDueDateStatuses(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isQualified (optional) 
     * @return OK
     */
    getInternationalShippingIncomeCategories(isQualified: boolean | undefined): Observable<InternationalShippingIncomeCategory[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeCalculationsReferenceData/GetInternationalShippingIncomeCategories?";
        if (isQualified === null)
            throw new Error("The parameter 'isQualified' cannot be null.");
        else if (isQualified !== undefined)
            url_ += "isQualified=" + encodeURIComponent("" + isQualified) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetInternationalShippingIncomeCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInternationalShippingIncomeCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InternationalShippingIncomeCategory[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InternationalShippingIncomeCategory[]>;
        }));
    }

    protected processGetInternationalShippingIncomeCategories(response: HttpResponseBase): Observable<InternationalShippingIncomeCategory[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FullScopeElectionsServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param projectId (optional) 
     * @param blendingCircleCountry (optional) 
     * @param blendingCircleSubgroupId (optional) 
     * @param organizationalEntityId (optional) 
     * @return OK
     */
    getAll(projectId: number | undefined, blendingCircleCountry: string | null | undefined, blendingCircleSubgroupId: number | null | undefined, organizationalEntityId: number | null | undefined): Observable<ElectionNodeDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeElections/GetAll?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (blendingCircleCountry !== undefined && blendingCircleCountry !== null)
            url_ += "BlendingCircleCountry=" + encodeURIComponent("" + blendingCircleCountry) + "&";
        if (blendingCircleSubgroupId !== undefined && blendingCircleSubgroupId !== null)
            url_ += "BlendingCircleSubgroupId=" + encodeURIComponent("" + blendingCircleSubgroupId) + "&";
        if (organizationalEntityId !== undefined && organizationalEntityId !== null)
            url_ += "OrganizationalEntityId=" + encodeURIComponent("" + organizationalEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElectionNodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElectionNodeDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ElectionNodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ElectionNodeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addOrUpdateBlendingCircleElection(body: BlendingCircleElectionInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeElections/AddOrUpdateBlendingCircleElection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAddOrUpdateBlendingCircleElection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateBlendingCircleElection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddOrUpdateBlendingCircleElection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addOrUpdateOrganizationalEntityElection(body: OrganizationalEntityElectionInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeElections/AddOrUpdateOrganizationalEntityElection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAddOrUpdateOrganizationalEntityElection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateOrganizationalEntityElection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddOrUpdateOrganizationalEntityElection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class GirCountrySpecificsServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param countryCode (optional) 
     * @return OK
     */
    getCountrySpecificParams(countryCode: string | null | undefined): Observable<CountrySpecificParamDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/GirCountrySpecifics/GetCountrySpecificParams?";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCountrySpecificParams(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountrySpecificParams(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountrySpecificParamDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountrySpecificParamDto[]>;
        }));
    }

    protected processGetCountrySpecificParams(response: HttpResponseBase): Observable<CountrySpecificParamDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountrySpecificParamDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class IirTaxPayerServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param projectId (optional) 
     * @param organizationalEntityId (optional) 
     * @return OK
     */
    getTaxPayerType(projectId: number | undefined, organizationalEntityId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/pillar2/IirTaxPayer/GetTaxPayerType?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (organizationalEntityId === null)
            throw new Error("The parameter 'organizationalEntityId' cannot be null.");
        else if (organizationalEntityId !== undefined)
            url_ += "organizationalEntityId=" + encodeURIComponent("" + organizationalEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTaxPayerType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaxPayerType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetTaxPayerType(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ImportServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param templateType (optional) 
     * @param scopingType (optional) 
     * @return OK
     */
    downloadExcelTemplate(templateType: ProjectTemplateType | null | undefined, scopingType: ProjectScopingDataType | null | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Import/DownloadExcelTemplate?";
        if (templateType !== undefined && templateType !== null)
            url_ += "TemplateType=" + encodeURIComponent("" + templateType) + "&";
        if (scopingType !== undefined && scopingType !== null)
            url_ += "ScopingType=" + encodeURIComponent("" + scopingType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDownloadExcelTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadExcelTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processDownloadExcelTemplate(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    importReport(body: ImportReportInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Import/ImportReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processImportReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fileToken (optional) 
     * @return OK
     */
    getImportFileInfo(fileToken: string | null | undefined): Observable<ImportFileInfoDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Import/GetImportFileInfo?";
        if (fileToken !== undefined && fileToken !== null)
            url_ += "FileToken=" + encodeURIComponent("" + fileToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetImportFileInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImportFileInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportFileInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportFileInfoDto>;
        }));
    }

    protected processGetImportFileInfo(response: HttpResponseBase): Observable<ImportFileInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportFileInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param projectId (optional) 
     * @return OK
     */
    downloadImport(id: number | undefined, projectId: number | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Import/DownloadImport?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDownloadImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processDownloadImport(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getImportsOverview(projectId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfImportOverviewDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Import/GetImportsOverview?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetImportsOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImportsOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfImportOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfImportOverviewDto>;
        }));
    }

    protected processGetImportsOverview(response: HttpResponseBase): Observable<PagedResultDtoOfImportOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfImportOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    generateGirReport(projectId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Import/GenerateGirReport?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGenerateGirReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateGirReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGenerateGirReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param projectId (optional) 
     * @return OK
     */
    delete(id: number | undefined, projectId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Import/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InsightsServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    getRiskIndicationData(projectId: number | undefined): Observable<RiskIndicationDataDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/Insights/GetRiskIndicationData?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRiskIndicationData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRiskIndicationData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RiskIndicationDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RiskIndicationDataDto[]>;
        }));
    }

    protected processGetRiskIndicationData(response: HttpResponseBase): Observable<RiskIndicationDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RiskIndicationDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param safeHarbourGroupsFilter (optional) 
     * @param sorting (optional) 
     * @return OK
     */
    getDeMinimisCheckData(projectId: number | undefined, safeHarbourGroupsFilter: string[] | null | undefined, sorting: string | null | undefined): Observable<RevenueToProfitLossCoparisonDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/Insights/GetDeMinimisCheckData?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (safeHarbourGroupsFilter !== undefined && safeHarbourGroupsFilter !== null)
            safeHarbourGroupsFilter && safeHarbourGroupsFilter.forEach(item => { url_ += "SafeHarbourGroupsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDeMinimisCheckData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeMinimisCheckData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RevenueToProfitLossCoparisonDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RevenueToProfitLossCoparisonDto[]>;
        }));
    }

    protected processGetDeMinimisCheckData(response: HttpResponseBase): Observable<RevenueToProfitLossCoparisonDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RevenueToProfitLossCoparisonDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param safeHarbourGroupsFilter (optional) 
     * @param sorting (optional) 
     * @return OK
     */
    getRptCheckData(projectId: number | undefined, safeHarbourGroupsFilter: string[] | null | undefined, sorting: string | null | undefined): Observable<FreeAllowanceToProfitDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/Insights/GetRptCheckData?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (safeHarbourGroupsFilter !== undefined && safeHarbourGroupsFilter !== null)
            safeHarbourGroupsFilter && safeHarbourGroupsFilter.forEach(item => { url_ += "SafeHarbourGroupsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRptCheckData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRptCheckData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FreeAllowanceToProfitDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FreeAllowanceToProfitDto[]>;
        }));
    }

    protected processGetRptCheckData(response: HttpResponseBase): Observable<FreeAllowanceToProfitDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FreeAllowanceToProfitDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param safeHarbourGroupsFilter (optional) 
     * @param sorting (optional) 
     * @return OK
     */
    getSetrCheckData(projectId: number | undefined, safeHarbourGroupsFilter: string[] | null | undefined, sorting: string | null | undefined): Observable<SetrCheckDataDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/Insights/GetSetrCheckData?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (safeHarbourGroupsFilter !== undefined && safeHarbourGroupsFilter !== null)
            safeHarbourGroupsFilter && safeHarbourGroupsFilter.forEach(item => { url_ += "SafeHarbourGroupsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSetrCheckData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSetrCheckData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetrCheckDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetrCheckDataDto[]>;
        }));
    }

    protected processGetSetrCheckData(response: HttpResponseBase): Observable<SetrCheckDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SetrCheckDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class JurisdictionsServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    requestOverview(body: GetJurisdictionsOverviewInput | undefined): Observable<PagedResultDtoOfJurisdictionOverviewDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Jurisdictions/RequestOverview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRequestOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfJurisdictionOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfJurisdictionOverviewDto>;
        }));
    }

    protected processRequestOverview(response: HttpResponseBase): Observable<PagedResultDtoOfJurisdictionOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfJurisdictionOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addOrUpdateJurisdiction(body: UpdateJurisdictionInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/pillar2/Jurisdictions/AddOrUpdateJurisdiction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAddOrUpdateJurisdiction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateJurisdiction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddOrUpdateJurisdiction(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param jurisdictionId (optional) 
     * @return OK
     */
    deleteJurisdiction(projectId: number | undefined, jurisdictionId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Jurisdictions/DeleteJurisdiction?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (jurisdictionId === null)
            throw new Error("The parameter 'jurisdictionId' cannot be null.");
        else if (jurisdictionId !== undefined)
            url_ += "JurisdictionId=" + encodeURIComponent("" + jurisdictionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteJurisdiction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteJurisdiction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteJurisdiction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    validateUpdateJurisdictionInput(body: UpdateJurisdictionInput | undefined): Observable<JurisdictionWarningsResult> {
        let url_ = this.baseUrl + "/api/services/pillar2/Jurisdictions/ValidateUpdateJurisdictionInput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processValidateUpdateJurisdictionInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateUpdateJurisdictionInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JurisdictionWarningsResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JurisdictionWarningsResult>;
        }));
    }

    protected processValidateUpdateJurisdictionInput(response: HttpResponseBase): Observable<JurisdictionWarningsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JurisdictionWarningsResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param newValue (optional) 
     * @param projectId (optional) 
     * @param jurisdictionCountryCode (optional) 
     * @return OK
     */
    validateUtprSafeHarbourValueTreshhold(newValue: number | undefined, projectId: number | undefined, jurisdictionCountryCode: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/pillar2/Jurisdictions/ValidateUtprSafeHarbourValueTreshhold?";
        if (newValue === null)
            throw new Error("The parameter 'newValue' cannot be null.");
        else if (newValue !== undefined)
            url_ += "NewValue=" + encodeURIComponent("" + newValue) + "&";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (jurisdictionCountryCode !== undefined && jurisdictionCountryCode !== null)
            url_ += "JurisdictionCountryCode=" + encodeURIComponent("" + jurisdictionCountryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processValidateUtprSafeHarbourValueTreshhold(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateUtprSafeHarbourValueTreshhold(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processValidateUtprSafeHarbourValueTreshhold(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ObligationAttachmentLinksServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param projectId (optional) 
     * @param obligationId (optional) 
     * @return OK
     */
    getObligationAttachmentLinks(projectId: number | undefined, obligationId: number | undefined): Observable<ObligationAttachmentLinkDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ObligationAttachmentLinks/GetObligationAttachmentLinks?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (obligationId === null)
            throw new Error("The parameter 'obligationId' cannot be null.");
        else if (obligationId !== undefined)
            url_ += "ObligationId=" + encodeURIComponent("" + obligationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetObligationAttachmentLinks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObligationAttachmentLinks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObligationAttachmentLinkDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObligationAttachmentLinkDto[]>;
        }));
    }

    protected processGetObligationAttachmentLinks(response: HttpResponseBase): Observable<ObligationAttachmentLinkDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObligationAttachmentLinkDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createAttachmentLink(body: CreateAttachmentLinkInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/pillar2/ObligationAttachmentLinks/CreateAttachmentLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateAttachmentLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAttachmentLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateAttachmentLink(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    bulkCreateAttachmentLink(body: CreateAttachmentLinkInput[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ObligationAttachmentLinks/BulkCreateAttachmentLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBulkCreateAttachmentLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkCreateAttachmentLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkCreateAttachmentLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param obligationId (optional) 
     * @param attachmentLinkId (optional) 
     * @param id (optional) 
     * @return OK
     */
    deleteAttachmentLink(projectId: number | undefined, obligationId: number | undefined, attachmentLinkId: number | undefined, id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ObligationAttachmentLinks/DeleteAttachmentLink?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (obligationId === null)
            throw new Error("The parameter 'obligationId' cannot be null.");
        else if (obligationId !== undefined)
            url_ += "ObligationId=" + encodeURIComponent("" + obligationId) + "&";
        if (attachmentLinkId === null)
            throw new Error("The parameter 'attachmentLinkId' cannot be null.");
        else if (attachmentLinkId !== undefined)
            url_ += "AttachmentLinkId=" + encodeURIComponent("" + attachmentLinkId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteAttachmentLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAttachmentLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAttachmentLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param obligationId (optional) 
     * @param attachmentLinkId (optional) 
     * @param id (optional) 
     * @return OK
     */
    checkIfAttachmentLinkIsLast(projectId: number | undefined, obligationId: number | undefined, attachmentLinkId: number | undefined, id: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/pillar2/ObligationAttachmentLinks/CheckIfAttachmentLinkIsLast?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (obligationId === null)
            throw new Error("The parameter 'obligationId' cannot be null.");
        else if (obligationId !== undefined)
            url_ += "ObligationId=" + encodeURIComponent("" + obligationId) + "&";
        if (attachmentLinkId === null)
            throw new Error("The parameter 'attachmentLinkId' cannot be null.");
        else if (attachmentLinkId !== undefined)
            url_ += "AttachmentLinkId=" + encodeURIComponent("" + attachmentLinkId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckIfAttachmentLinkIsLast(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfAttachmentLinkIsLast(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckIfAttachmentLinkIsLast(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ObligationAttachmentsServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param file (optional) 
     * @return OK
     */
    uploadFile(file: FileParameter | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/pillar2/ObligationAttachments/UploadFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateAttachmentInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/pillar2/ObligationAttachments/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body: UpdateAttachmentInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ObligationAttachments/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param referenceId (optional) 
     * @param id (optional) 
     * @return OK
     */
    delete(referenceId: number | undefined, id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ObligationAttachments/Delete?";
        if (referenceId === null)
            throw new Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "ReferenceId=" + encodeURIComponent("" + referenceId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAll(body: AttachmentsFilterRequest | undefined): Observable<PagedResultDtoOfAttachmentOverviewDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/ObligationAttachments/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAttachmentOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAttachmentOverviewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfAttachmentOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAttachmentOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getTags(filter: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ObligationAttachments/GetTags?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetTags(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllowedFileTypes(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ObligationAttachments/GetAllowedFileTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllowedFileTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllowedFileTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllowedFileTypes(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllowedMaxFileLength(): Observable<FileMaxLengthSettings> {
        let url_ = this.baseUrl + "/api/services/pillar2/ObligationAttachments/GetAllowedMaxFileLength";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllowedMaxFileLength(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllowedMaxFileLength(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileMaxLengthSettings>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileMaxLengthSettings>;
        }));
    }

    protected processGetAllowedMaxFileLength(response: HttpResponseBase): Observable<FileMaxLengthSettings> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileMaxLengthSettings.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param referenceId (optional) 
     * @param id (optional) 
     * @return OK
     */
    downloadFile(referenceId: number | undefined, id: number | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/ObligationAttachments/DownloadFile?";
        if (referenceId === null)
            throw new Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "ReferenceId=" + encodeURIComponent("" + referenceId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDownloadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processDownloadFile(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param referenceId (optional) 
     * @param id (optional) 
     * @return OK
     */
    getById(referenceId: number | undefined, id: number | undefined): Observable<AttachmentDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/ObligationAttachments/GetById?";
        if (referenceId === null)
            throw new Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "ReferenceId=" + encodeURIComponent("" + referenceId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttachmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttachmentDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<AttachmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttachmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    downloadGirJson(projectId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/pillar2/ObligationAttachments/DownloadGirJson?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDownloadGirJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadGirJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDownloadGirJson(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param referenceId (optional) 
     * @return OK
     */
    getCreatedByUsers(referenceId: number | undefined): Observable<UserReferenceDataDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ObligationAttachments/GetCreatedByUsers?";
        if (referenceId === null)
            throw new Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "referenceId=" + encodeURIComponent("" + referenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCreatedByUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCreatedByUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserReferenceDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserReferenceDataDto[]>;
        }));
    }

    protected processGetCreatedByUsers(response: HttpResponseBase): Observable<UserReferenceDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserReferenceDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ObligationChangesServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param projectObligationId (optional) 
     * @return OK
     */
    getObligationChanges(projectObligationId: number | undefined): Observable<EntityChangeDataDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ObligationChanges/GetObligationChanges?";
        if (projectObligationId === null)
            throw new Error("The parameter 'projectObligationId' cannot be null.");
        else if (projectObligationId !== undefined)
            url_ += "projectObligationId=" + encodeURIComponent("" + projectObligationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetObligationChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObligationChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityChangeDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityChangeDataDto[]>;
        }));
    }

    protected processGetObligationChanges(response: HttpResponseBase): Observable<EntityChangeDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityChangeDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ObligationsServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    requestOverview(body: GetObligationsOverviewInput | undefined): Observable<PagedResultDtoOfObligationOverviewDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Obligations/RequestOverview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRequestOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfObligationOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfObligationOverviewDto>;
        }));
    }

    protected processRequestOverview(response: HttpResponseBase): Observable<PagedResultDtoOfObligationOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfObligationOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addOrUpdateObligation(body: UpdateObligationInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Obligations/AddOrUpdateObligation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAddOrUpdateObligation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateObligation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddOrUpdateObligation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createObligation(body: CreateObligationInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Obligations/CreateObligation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateObligation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateObligation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateObligation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addOrUpdateDueDate(body: ObligationSetDueDateInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Obligations/AddOrUpdateDueDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAddOrUpdateDueDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateDueDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddOrUpdateDueDate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addOrUpdateAssigned(body: ObligationAssignedUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Obligations/AddOrUpdateAssigned";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAddOrUpdateAssigned(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateAssigned(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddOrUpdateAssigned(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addOrUpdateStatus(body: UpdateObligationStatusInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Obligations/AddOrUpdateStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAddOrUpdateStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddOrUpdateStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param obligationId (optional) 
     * @return OK
     */
    deleteObligation(projectId: number | undefined, obligationId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Obligations/DeleteObligation?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (obligationId === null)
            throw new Error("The parameter 'obligationId' cannot be null.");
        else if (obligationId !== undefined)
            url_ += "ObligationId=" + encodeURIComponent("" + obligationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteObligation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteObligation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteObligation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setSubmissionAsLinkedToObligation(body: UpdateLinkedSubmissionInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Obligations/SetSubmissionAsLinkedToObligation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSetSubmissionAsLinkedToObligation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetSubmissionAsLinkedToObligation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetSubmissionAsLinkedToObligation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ObligationsExcelExportableServiceServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    exportOverviewToExcel(body: ExportOverviewToExcelInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ObligationsExcelExportableService/ExportOverviewToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processExportOverviewToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportOverviewToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExportOverviewToExcel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ObligationsReferenceDataServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    getJurisdictionsByProjectId(projectId: number | undefined): Observable<TaxJurisdictionCountryReferenceDataDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ObligationsReferenceData/GetJurisdictionsByProjectId?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetJurisdictionsByProjectId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJurisdictionsByProjectId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxJurisdictionCountryReferenceDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxJurisdictionCountryReferenceDataDto[]>;
        }));
    }

    protected processGetJurisdictionsByProjectId(response: HttpResponseBase): Observable<TaxJurisdictionCountryReferenceDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaxJurisdictionCountryReferenceDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param referenceId (optional) 
     * @param filter (optional) 
     * @return OK
     */
    getAssignableUsers(referenceId: number | undefined, filter: string | null | undefined): Observable<AssignableUserDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ObligationsReferenceData/GetAssignableUsers?";
        if (referenceId === null)
            throw new Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "ReferenceId=" + encodeURIComponent("" + referenceId) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAssignableUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignableUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignableUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignableUserDto[]>;
        }));
    }

    protected processGetAssignableUsers(response: HttpResponseBase): Observable<AssignableUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssignableUserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getObligationDueDateStatuses(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ObligationsReferenceData/GetObligationDueDateStatuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetObligationDueDateStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObligationDueDateStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetObligationDueDateStatuses(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class Pillar2AdminSettingsServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getAll(): Observable<Pillar2AdminSettingsDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Pillar2AdminSettings/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Pillar2AdminSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Pillar2AdminSettingsDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<Pillar2AdminSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Pillar2AdminSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveAll(body: Pillar2AdminSettingsInput | undefined): Observable<Pillar2AdminSettingsDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Pillar2AdminSettings/SaveAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSaveAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Pillar2AdminSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Pillar2AdminSettingsDto>;
        }));
    }

    protected processSaveAll(response: HttpResponseBase): Observable<Pillar2AdminSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Pillar2AdminSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class Pillar2ChancelleryServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getClients(): Observable<ChancelleryClientDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/Pillar2Chancellery/GetClients";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetClients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChancelleryClientDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChancelleryClientDto[]>;
        }));
    }

    protected processGetClients(response: HttpResponseBase): Observable<ChancelleryClientDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChancelleryClientDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param clientNumber (optional) 
     * @return OK
     */
    getProjects(clientNumber: string | null | undefined): Observable<ChancelleryProjectDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/Pillar2Chancellery/GetProjects?";
        if (clientNumber !== undefined && clientNumber !== null)
            url_ += "ClientNumber=" + encodeURIComponent("" + clientNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChancelleryProjectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChancelleryProjectDto[]>;
        }));
    }

    protected processGetProjects(response: HttpResponseBase): Observable<ChancelleryProjectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChancelleryProjectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class Pillar2UserGridConfigurationServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setColumnVisibilitySettings(body: MazarsGridDefinitionInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Pillar2UserGridConfiguration/SetColumnVisibilitySettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSetColumnVisibilitySettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetColumnVisibilitySettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetColumnVisibilitySettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param key (optional) 
     * @return OK
     */
    getGridColumnSettings(key: string | null | undefined): Observable<MazarsGridDefinitionDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Pillar2UserGridConfiguration/GetGridColumnSettings?";
        if (key !== undefined && key !== null)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGridColumnSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGridColumnSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MazarsGridDefinitionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MazarsGridDefinitionDto>;
        }));
    }

    protected processGetGridColumnSettings(response: HttpResponseBase): Observable<MazarsGridDefinitionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MazarsGridDefinitionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param key (optional) 
     * @return OK
     */
    resetGridColumnSettings(key: string | null | undefined): Observable<MazarsGridDefinitionDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Pillar2UserGridConfiguration/ResetGridColumnSettings?";
        if (key !== undefined && key !== null)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processResetGridColumnSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetGridColumnSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MazarsGridDefinitionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MazarsGridDefinitionDto>;
        }));
    }

    protected processResetGridColumnSettings(response: HttpResponseBase): Observable<MazarsGridDefinitionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MazarsGridDefinitionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class Pillar2UserManualsServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param languageCode (optional) 
     * @return OK
     */
    getUserManual(languageCode: string | null | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Pillar2UserManuals/GetUserManual?";
        if (languageCode !== undefined && languageCode !== null)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserManual(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserManual(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processGetUserManual(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class Pillar2WidgetServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getProjects(): Observable<ProjectDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/Pillar2Widget/GetProjects";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDto[]>;
        }));
    }

    protected processGetProjects(response: HttpResponseBase): Observable<ProjectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getDataByProjectId(id: number | undefined): Observable<ProjectWidgetDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Pillar2Widget/GetDataByProjectId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDataByProjectId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDataByProjectId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectWidgetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectWidgetDto>;
        }));
    }

    protected processGetDataByProjectId(response: HttpResponseBase): Observable<ProjectWidgetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectWidgetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getMyProjectTasks(): Observable<TaskDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/Pillar2Widget/GetMyProjectTasks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMyProjectTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyProjectTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskDto[]>;
        }));
    }

    protected processGetMyProjectTasks(response: HttpResponseBase): Observable<TaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getMyObligationTasks(): Observable<TaskDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/Pillar2Widget/GetMyObligationTasks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMyObligationTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyObligationTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskDto[]>;
        }));
    }

    protected processGetMyObligationTasks(response: HttpResponseBase): Observable<TaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getMyOrganizationalEntityTasks(): Observable<TaskDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/Pillar2Widget/GetMyOrganizationalEntityTasks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMyOrganizationalEntityTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyOrganizationalEntityTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskDto[]>;
        }));
    }

    protected processGetMyOrganizationalEntityTasks(response: HttpResponseBase): Observable<TaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectAttachmentsServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAll(body: AttachmentsFilterRequest | undefined): Observable<PagedResultDtoOfAttachmentOverviewDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectAttachments/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAttachmentOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAttachmentOverviewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfAttachmentOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAttachmentOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getTags(filter: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectAttachments/GetTags?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetTags(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllowedFileTypes(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectAttachments/GetAllowedFileTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllowedFileTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllowedFileTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllowedFileTypes(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllowedMaxFileLength(): Observable<FileMaxLengthSettings> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectAttachments/GetAllowedMaxFileLength";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllowedMaxFileLength(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllowedMaxFileLength(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileMaxLengthSettings>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileMaxLengthSettings>;
        }));
    }

    protected processGetAllowedMaxFileLength(response: HttpResponseBase): Observable<FileMaxLengthSettings> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileMaxLengthSettings.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param file (optional) 
     * @return OK
     */
    uploadFile(file: FileParameter | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectAttachments/UploadFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param referenceId (optional) 
     * @param id (optional) 
     * @return OK
     */
    downloadFile(referenceId: number | undefined, id: number | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectAttachments/DownloadFile?";
        if (referenceId === null)
            throw new Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "ReferenceId=" + encodeURIComponent("" + referenceId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDownloadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processDownloadFile(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param referenceId (optional) 
     * @param id (optional) 
     * @return OK
     */
    getById(referenceId: number | undefined, id: number | undefined): Observable<AttachmentDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectAttachments/GetById?";
        if (referenceId === null)
            throw new Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "ReferenceId=" + encodeURIComponent("" + referenceId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttachmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttachmentDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<AttachmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttachmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateAttachmentInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectAttachments/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body: UpdateAttachmentInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectAttachments/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param referenceId (optional) 
     * @param id (optional) 
     * @return OK
     */
    delete(referenceId: number | undefined, id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectAttachments/Delete?";
        if (referenceId === null)
            throw new Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "ReferenceId=" + encodeURIComponent("" + referenceId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    downloadGirJson(projectId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectAttachments/DownloadGirJson?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDownloadGirJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadGirJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDownloadGirJson(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param referenceId (optional) 
     * @return OK
     */
    getCreatedByUsers(referenceId: number | undefined): Observable<UserReferenceDataDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectAttachments/GetCreatedByUsers?";
        if (referenceId === null)
            throw new Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "referenceId=" + encodeURIComponent("" + referenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCreatedByUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCreatedByUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserReferenceDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserReferenceDataDto[]>;
        }));
    }

    protected processGetCreatedByUsers(response: HttpResponseBase): Observable<UserReferenceDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserReferenceDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectChannelServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateChannelInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectChannel/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param referenceId (optional) 
     * @return OK
     */
    delete(id: number | undefined, referenceId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectChannel/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (referenceId === null)
            throw new Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "ReferenceId=" + encodeURIComponent("" + referenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param rootId (optional) 
     * @return OK
     */
    getAll(rootId: number | undefined): Observable<ChannelOverviewDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectChannel/GetAll?";
        if (rootId === null)
            throw new Error("The parameter 'rootId' cannot be null.");
        else if (rootId !== undefined)
            url_ += "rootId=" + encodeURIComponent("" + rootId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChannelOverviewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChannelOverviewDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ChannelOverviewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChannelOverviewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param rootId (optional) 
     * @return OK
     */
    getNumberOfUnreadChannels(rootId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectChannel/GetNumberOfUnreadChannels?";
        if (rootId === null)
            throw new Error("The parameter 'rootId' cannot be null.");
        else if (rootId !== undefined)
            url_ += "rootId=" + encodeURIComponent("" + rootId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetNumberOfUnreadChannels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumberOfUnreadChannels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetNumberOfUnreadChannels(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    initiateEmailConversation(body: InitiateEmailConversationInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectChannel/InitiateEmailConversation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processInitiateEmailConversation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInitiateEmailConversation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInitiateEmailConversation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body: EditChannelInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectChannel/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectChannelWhiteListServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param channelId (optional) 
     * @return OK
     */
    getAll(channelId: number | undefined): Observable<WhiteListOverviewDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectChannelWhiteList/GetAll?";
        if (channelId === null)
            throw new Error("The parameter 'channelId' cannot be null.");
        else if (channelId !== undefined)
            url_ += "channelId=" + encodeURIComponent("" + channelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WhiteListOverviewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WhiteListOverviewDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<WhiteListOverviewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WhiteListOverviewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveAll(body: SaveAllWhiteListInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectChannelWhiteList/SaveAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSaveAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveAll(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectCommunicationReferencesServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getAuthors(): Observable<AuthorDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectCommunicationReferences/GetAuthors";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAuthors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthorDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthorDto[]>;
        }));
    }

    protected processGetAuthors(response: HttpResponseBase): Observable<AuthorDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuthorDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectCommunicationsServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    search(body: CommunicationsFilterRequest | undefined): Observable<SearchCommunicationDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectCommunications/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchCommunicationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchCommunicationDto[]>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<SearchCommunicationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchCommunicationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param channelId (optional) 
     * @return OK
     */
    getAll(channelId: number | undefined): Observable<CommunicationDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectCommunications/GetAll?";
        if (channelId === null)
            throw new Error("The parameter 'channelId' cannot be null.");
        else if (channelId !== undefined)
            url_ += "channelId=" + encodeURIComponent("" + channelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommunicationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommunicationDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CommunicationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommunicationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param channelId (optional) 
     * @return OK
     */
    getAllChannelUserDetail(channelId: number | undefined): Observable<UserDetailsDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectCommunications/GetAllChannelUserDetail?";
        if (channelId === null)
            throw new Error("The parameter 'channelId' cannot be null.");
        else if (channelId !== undefined)
            url_ += "channelId=" + encodeURIComponent("" + channelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllChannelUserDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllChannelUserDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDetailsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDetailsDto[]>;
        }));
    }

    protected processGetAllChannelUserDetail(response: HttpResponseBase): Observable<UserDetailsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDetailsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getById(id: number | undefined): Observable<CommunicationDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectCommunications/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommunicationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommunicationDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<CommunicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommunicationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateCommunicationInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectCommunications/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body: EditCommunicationInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectCommunications/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectCommunications/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectCurrencyRatesServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param projectId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    requestOverview(projectId: number | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ProjectCurrencyRateOverviewDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectCurrencyRates/RequestOverview?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRequestOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectCurrencyRateOverviewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectCurrencyRateOverviewDto[]>;
        }));
    }

    protected processRequestOverview(response: HttpResponseBase): Observable<ProjectCurrencyRateOverviewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectCurrencyRateOverviewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body: UpdateProjectCurrencyRateInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectCurrencyRates/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectCustomGrantsServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    getAll(projectId: number | undefined): Observable<EntityPermissionDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectCustomGrants/GetAll?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityPermissionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityPermissionDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<EntityPermissionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityPermissionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    getAllCustomGrantsPermissions(projectId: number | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectCustomGrants/GetAllCustomGrantsPermissions?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllCustomGrantsPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCustomGrantsPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllCustomGrantsPermissions(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAllWithProvisionalData(body: CustomGrantsWithAccessRestrictionInput | undefined): Observable<EntityPermissionDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectCustomGrants/GetAllWithProvisionalData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllWithProvisionalData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWithProvisionalData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityPermissionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityPermissionDto[]>;
        }));
    }

    protected processGetAllWithProvisionalData(response: HttpResponseBase): Observable<EntityPermissionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityPermissionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param permissionName (optional) 
     * @param excludeUsers (optional) 
     * @param organizationalEntityId (optional) 
     * @param submissionId (optional) 
     * @return OK
     */
    getAllPossibleUsers(projectId: number | undefined, permissionName: string | null | undefined, excludeUsers: boolean | undefined, organizationalEntityId: number | null | undefined, submissionId: number | null | undefined): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectCustomGrants/GetAllPossibleUsers?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (permissionName !== undefined && permissionName !== null)
            url_ += "permissionName=" + encodeURIComponent("" + permissionName) + "&";
        if (excludeUsers === null)
            throw new Error("The parameter 'excludeUsers' cannot be null.");
        else if (excludeUsers !== undefined)
            url_ += "excludeUsers=" + encodeURIComponent("" + excludeUsers) + "&";
        if (organizationalEntityId !== undefined && organizationalEntityId !== null)
            url_ += "organizationalEntityId=" + encodeURIComponent("" + organizationalEntityId) + "&";
        if (submissionId !== undefined && submissionId !== null)
            url_ += "submissionId=" + encodeURIComponent("" + submissionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllPossibleUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPossibleUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
        }));
    }

    protected processGetAllPossibleUsers(response: HttpResponseBase): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfUserOrOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAccessRestrictedUsers(): Observable<ProjectAccessRestrictedUsersDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectCustomGrants/GetAccessRestrictedUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAccessRestrictedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccessRestrictedUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectAccessRestrictedUsersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectAccessRestrictedUsersDto>;
        }));
    }

    protected processGetAccessRestrictedUsers(response: HttpResponseBase): Observable<ProjectAccessRestrictedUsersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectAccessRestrictedUsersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAllPossibleUsersWithProvisionalData(body: CustomGrantsForPermissionWithAccessRestrictionDataInput | undefined): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectCustomGrants/GetAllPossibleUsersWithProvisionalData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllPossibleUsersWithProvisionalData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPossibleUsersWithProvisionalData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
        }));
    }

    protected processGetAllPossibleUsersWithProvisionalData(response: HttpResponseBase): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfUserOrOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param usersAndOrganizationUnits (optional) 
     * @return OK
     */
    checkCurrentUserIsInList(usersAndOrganizationUnits: UserOrOrganizationUnitInput[] | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectCustomGrants/CheckCurrentUserIsInList?";
        if (usersAndOrganizationUnits !== undefined && usersAndOrganizationUnits !== null)
            usersAndOrganizationUnits && usersAndOrganizationUnits.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "usersAndOrganizationUnits[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckCurrentUserIsInList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckCurrentUserIsInList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckCurrentUserIsInList(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectExcelExportableServiceServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    exportOverviewToExcel(body: ExportOverviewToExcelInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectExcelExportableService/ExportOverviewToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processExportOverviewToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportOverviewToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExportOverviewToExcel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectLookupServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param referenceId (optional) 
     * @return OK
     */
    getSurveys(referenceId: number | undefined): Observable<SurveyLookupDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectLookup/GetSurveys?";
        if (referenceId === null)
            throw new Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "referenceId=" + encodeURIComponent("" + referenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveys(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveys(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyLookupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyLookupDto[]>;
        }));
    }

    protected processGetSurveys(response: HttpResponseBase): Observable<SurveyLookupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SurveyLookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param referenceId (optional) 
     * @return OK
     */
    getAttachments(referenceId: number | undefined): Observable<AttachmentLookupDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectLookup/GetAttachments?";
        if (referenceId === null)
            throw new Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "referenceId=" + encodeURIComponent("" + referenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAttachments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttachmentLookupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttachmentLookupDto[]>;
        }));
    }

    protected processGetAttachments(response: HttpResponseBase): Observable<AttachmentLookupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttachmentLookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param referenceId (optional) 
     * @param entityId (optional) 
     * @param countryCode (optional) 
     * @param userPermissions (optional) 
     * @param adminPermissions (optional) 
     * @return OK
     */
    getTenantUsers(referenceId: number | undefined, entityId: number | null | undefined, countryCode: string | null | undefined, userPermissions: string | null | undefined, adminPermissions: string | null | undefined): Observable<UserLookupDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectLookup/GetTenantUsers?";
        if (referenceId === null)
            throw new Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "ReferenceId=" + encodeURIComponent("" + referenceId) + "&";
        if (entityId !== undefined && entityId !== null)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (userPermissions !== undefined && userPermissions !== null)
            url_ += "UserPermissions=" + encodeURIComponent("" + userPermissions) + "&";
        if (adminPermissions !== undefined && adminPermissions !== null)
            url_ += "AdminPermissions=" + encodeURIComponent("" + adminPermissions) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTenantUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserLookupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserLookupDto[]>;
        }));
    }

    protected processGetTenantUsers(response: HttpResponseBase): Observable<UserLookupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserLookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectNotificationReportServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param projectId (optional) 
     * @param typesFiler (optional) 
     * @param dataPointsFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    requestOverview(filter: string | null | undefined, projectId: number | undefined, typesFiler: string[] | null | undefined, dataPointsFilter: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfProjectNotificationOverviewDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectNotificationReport/RequestOverview?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (typesFiler !== undefined && typesFiler !== null)
            typesFiler && typesFiler.forEach(item => { url_ += "TypesFiler=" + encodeURIComponent("" + item) + "&"; });
        if (dataPointsFilter !== undefined && dataPointsFilter !== null)
            dataPointsFilter && dataPointsFilter.forEach(item => { url_ += "DataPointsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRequestOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfProjectNotificationOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfProjectNotificationOverviewDto>;
        }));
    }

    protected processRequestOverview(response: HttpResponseBase): Observable<PagedResultDtoOfProjectNotificationOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfProjectNotificationOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    getLastProjectNotificationReport(projectId: number | undefined): Observable<LastProjectNotificationReport> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectNotificationReport/GetLastProjectNotificationReport?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLastProjectNotificationReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastProjectNotificationReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LastProjectNotificationReport>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LastProjectNotificationReport>;
        }));
    }

    protected processGetLastProjectNotificationReport(response: HttpResponseBase): Observable<LastProjectNotificationReport> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LastProjectNotificationReport.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    refresh(body: RefreshProjectNotificationReportInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectNotificationReport/Refresh";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRefresh(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefresh(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRefresh(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectNotificationReportReferenceDataServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getNotificationTypes(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectNotificationReportReferenceData/GetNotificationTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetNotificationTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetNotificationTypes(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getNotificationDataPointTypes(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectNotificationReportReferenceData/GetNotificationDataPointTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetNotificationDataPointTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationDataPointTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetNotificationDataPointTypes(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectsServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param tagsFilter (optional) 
     * @param assignedUsersFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getOverview(filter: string | null | undefined, tagsFilter: string[] | null | undefined, assignedUsersFilter: number[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfProjectOverviewDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Projects/GetOverview?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (tagsFilter !== undefined && tagsFilter !== null)
            tagsFilter && tagsFilter.forEach(item => { url_ += "TagsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (assignedUsersFilter !== undefined && assignedUsersFilter !== null)
            assignedUsersFilter && assignedUsersFilter.forEach(item => { url_ += "AssignedUsersFilter=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfProjectOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfProjectOverviewDto>;
        }));
    }

    protected processGetOverview(response: HttpResponseBase): Observable<PagedResultDtoOfProjectOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfProjectOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateProjectInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/pillar2/Projects/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOutOfTemplate(body: CreateOutOfTemplateProjectInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/pillar2/Projects/CreateOutOfTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOutOfTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOutOfTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOutOfTemplate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body: UpdateProjectInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Projects/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getById(id: number | undefined): Observable<ProjectDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Projects/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ProjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getTags(filter: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/Projects/GetTags?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetTags(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Projects/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    changeAccessRestriction(body: CustomGrantsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Projects/ChangeAccessRestriction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processChangeAccessRestriction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeAccessRestriction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeAccessRestriction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param referenceId (optional) 
     * @return OK
     */
    getAssignedUser(referenceId: number | undefined): Observable<AssignableUserDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Projects/GetAssignedUser?";
        if (referenceId === null)
            throw new Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "referenceId=" + encodeURIComponent("" + referenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAssignedUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignedUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignableUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignableUserDto>;
        }));
    }

    protected processGetAssignedUser(response: HttpResponseBase): Observable<AssignableUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignableUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setAssignedUser(body: SetAssignedUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Projects/SetAssignedUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSetAssignedUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAssignedUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetAssignedUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param referenceId (optional) 
     * @param filter (optional) 
     * @return OK
     */
    getAssignableUsers(referenceId: number | undefined, filter: string | null | undefined): Observable<AssignableUserDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/Projects/GetAssignableUsers?";
        if (referenceId === null)
            throw new Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "ReferenceId=" + encodeURIComponent("" + referenceId) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAssignableUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignableUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignableUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignableUserDto[]>;
        }));
    }

    protected processGetAssignableUsers(response: HttpResponseBase): Observable<AssignableUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssignableUserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectsBulkServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param ids (optional) 
     * @return OK
     */
    getManageTagsDetails(ids: number[] | null | undefined): Observable<ManageTagsDetailsDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectsBulk/GetManageTagsDetails?";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetManageTagsDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetManageTagsDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ManageTagsDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ManageTagsDetailsDto>;
        }));
    }

    protected processGetManageTagsDetails(response: HttpResponseBase): Observable<ManageTagsDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ManageTagsDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    bulkUpdateTags(body: ManageTagsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectsBulk/BulkUpdateTags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBulkUpdateTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkUpdateTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkUpdateTags(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    checkBulkOperationsDetails(body: BulkInput | undefined): Observable<BulkProjectOperationDetailsDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectsBulk/CheckBulkOperationsDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckBulkOperationsDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckBulkOperationsDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BulkProjectOperationDetailsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BulkProjectOperationDetailsDto[]>;
        }));
    }

    protected processCheckBulkOperationsDetails(response: HttpResponseBase): Observable<BulkProjectOperationDetailsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BulkProjectOperationDetailsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    bulkDelete(body: BulkInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectsBulk/BulkDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBulkDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    bulkCheckAccessRestriction(body: BulkChangeAccessRestrictionInput | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectsBulk/BulkCheckAccessRestriction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBulkCheckAccessRestriction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkCheckAccessRestriction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processBulkCheckAccessRestriction(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    bulkChangeAccessRestriction(body: BulkChangeAccessRestrictionInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectsBulk/BulkChangeAccessRestriction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBulkChangeAccessRestriction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkChangeAccessRestriction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkChangeAccessRestriction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectsReferenceDataServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    getJurisdictionsByProjectId(projectId: number | undefined): Observable<TaxJurisdictionCountryReferenceDataDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectsReferenceData/GetJurisdictionsByProjectId?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetJurisdictionsByProjectId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJurisdictionsByProjectId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxJurisdictionCountryReferenceDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxJurisdictionCountryReferenceDataDto[]>;
        }));
    }

    protected processGetJurisdictionsByProjectId(response: HttpResponseBase): Observable<TaxJurisdictionCountryReferenceDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaxJurisdictionCountryReferenceDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    getAllTaxJurisdictionCountriesByProjectId(projectId: number | undefined): Observable<TaxJurisdictionCountryReferenceDataDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectsReferenceData/GetAllTaxJurisdictionCountriesByProjectId?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllTaxJurisdictionCountriesByProjectId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTaxJurisdictionCountriesByProjectId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxJurisdictionCountryReferenceDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxJurisdictionCountryReferenceDataDto[]>;
        }));
    }

    protected processGetAllTaxJurisdictionCountriesByProjectId(response: HttpResponseBase): Observable<TaxJurisdictionCountryReferenceDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaxJurisdictionCountryReferenceDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    getOrganizationalEntitiesByProjectId(projectId: number | undefined): Observable<OrganizationalEntityReferenceDataDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectsReferenceData/GetOrganizationalEntitiesByProjectId?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOrganizationalEntitiesByProjectId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationalEntitiesByProjectId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationalEntityReferenceDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationalEntityReferenceDataDto[]>;
        }));
    }

    protected processGetOrganizationalEntitiesByProjectId(response: HttpResponseBase): Observable<OrganizationalEntityReferenceDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationalEntityReferenceDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    getOrganizationalEntitiesWithNameAndNumber(projectId: number | undefined): Observable<ListResultDtoOfOrganizationalEntityReferenceDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectsReferenceData/GetOrganizationalEntitiesWithNameAndNumber?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOrganizationalEntitiesWithNameAndNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationalEntitiesWithNameAndNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfOrganizationalEntityReferenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfOrganizationalEntityReferenceDto>;
        }));
    }

    protected processGetOrganizationalEntitiesWithNameAndNumber(response: HttpResponseBase): Observable<ListResultDtoOfOrganizationalEntityReferenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfOrganizationalEntityReferenceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationalEntityId (optional) 
     * @param projectId (optional) 
     * @return OK
     */
    getOrganizationalEntitiesForControllingInterest(organizationalEntityId: number | undefined, projectId: number | undefined): Observable<OrganizationalEntityReferenceDataDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectsReferenceData/GetOrganizationalEntitiesForControllingInterest?";
        if (organizationalEntityId === null)
            throw new Error("The parameter 'organizationalEntityId' cannot be null.");
        else if (organizationalEntityId !== undefined)
            url_ += "OrganizationalEntityId=" + encodeURIComponent("" + organizationalEntityId) + "&";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOrganizationalEntitiesForControllingInterest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationalEntitiesForControllingInterest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationalEntityReferenceDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationalEntityReferenceDataDto[]>;
        }));
    }

    protected processGetOrganizationalEntitiesForControllingInterest(response: HttpResponseBase): Observable<OrganizationalEntityReferenceDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationalEntityReferenceDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param organizationalEntityId (optional) 
     * @return OK
     */
    getOrganizationalEntityDetailsById(projectId: number | undefined, organizationalEntityId: number | undefined): Observable<OrganizationalEntityReferenceDataDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectsReferenceData/GetOrganizationalEntityDetailsById?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (organizationalEntityId === null)
            throw new Error("The parameter 'organizationalEntityId' cannot be null.");
        else if (organizationalEntityId !== undefined)
            url_ += "organizationalEntityId=" + encodeURIComponent("" + organizationalEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOrganizationalEntityDetailsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationalEntityDetailsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationalEntityReferenceDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationalEntityReferenceDataDto>;
        }));
    }

    protected processGetOrganizationalEntityDetailsById(response: HttpResponseBase): Observable<OrganizationalEntityReferenceDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationalEntityReferenceDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getConsolidationMethods(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectsReferenceData/GetConsolidationMethods";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetConsolidationMethods(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsolidationMethods(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetConsolidationMethods(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param gloBEParentType (optional) 
     * @return OK
     */
    getGloBEStatuses(gloBEParentType: GloBEParentType2 | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectsReferenceData/GetGloBEStatuses?";
        if (gloBEParentType === null)
            throw new Error("The parameter 'gloBEParentType' cannot be null.");
        else if (gloBEParentType !== undefined)
            url_ += "gloBEParentType=" + encodeURIComponent("" + gloBEParentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGloBEStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGloBEStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetGloBEStatuses(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getEligibilityReductionTypes(): Observable<EligibilityReductionReferenceDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectsReferenceData/GetEligibilityReductionTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEligibilityReductionTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEligibilityReductionTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EligibilityReductionReferenceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EligibilityReductionReferenceDto[]>;
        }));
    }

    protected processGetEligibilityReductionTypes(response: HttpResponseBase): Observable<EligibilityReductionReferenceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EligibilityReductionReferenceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    getBlendingCircleSubgroups(projectId: number | undefined): Observable<ListResultDtoOfBlendingCirlceSubroupReferenceDataDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectsReferenceData/GetBlendingCircleSubgroups?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBlendingCircleSubgroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBlendingCircleSubgroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfBlendingCirlceSubroupReferenceDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfBlendingCirlceSubroupReferenceDataDto>;
        }));
    }

    protected processGetBlendingCircleSubgroups(response: HttpResponseBase): Observable<ListResultDtoOfBlendingCirlceSubroupReferenceDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfBlendingCirlceSubroupReferenceDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    getSafeHarbourGroups(projectId: number | undefined): Observable<ListResultDtoOfSafeHarbourGroupReferenceDataDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectsReferenceData/GetSafeHarbourGroups?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSafeHarbourGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSafeHarbourGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfSafeHarbourGroupReferenceDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfSafeHarbourGroupReferenceDataDto>;
        }));
    }

    protected processGetSafeHarbourGroups(response: HttpResponseBase): Observable<ListResultDtoOfSafeHarbourGroupReferenceDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfSafeHarbourGroupReferenceDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ReportServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createReport(body: GenerateProjectReportInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Report/CreateReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getReportsOverview(projectId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfReportOverviewDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Report/GetReportsOverview?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetReportsOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportsOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfReportOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfReportOverviewDto>;
        }));
    }

    protected processGetReportsOverview(response: HttpResponseBase): Observable<PagedResultDtoOfReportOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfReportOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param projectId (optional) 
     * @return OK
     */
    downloadReport(id: number | undefined, projectId: number | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Report/DownloadReport?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDownloadReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processDownloadReport(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param projectId (optional) 
     * @return OK
     */
    delete(id: number | undefined, projectId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Report/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SafeHarbourTestsServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    requestOverview(body: GetSafeHarbourGroupOverviewInput | undefined): Observable<PagedResultDtoOfSafeHarbourGroupOverviewDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/SafeHarbourTests/RequestOverview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRequestOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSafeHarbourGroupOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSafeHarbourGroupOverviewDto>;
        }));
    }

    protected processRequestOverview(response: HttpResponseBase): Observable<PagedResultDtoOfSafeHarbourGroupOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSafeHarbourGroupOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getFinancialDataBySafeHarbourGroup(body: GetFinancialDataSafeHarbourGroupOverviewInput | undefined): Observable<FinancialDataSafeHarbourGroupOverviewDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/SafeHarbourTests/GetFinancialDataBySafeHarbourGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFinancialDataBySafeHarbourGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinancialDataBySafeHarbourGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinancialDataSafeHarbourGroupOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinancialDataSafeHarbourGroupOverviewDto>;
        }));
    }

    protected processGetFinancialDataBySafeHarbourGroup(response: HttpResponseBase): Observable<FinancialDataSafeHarbourGroupOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinancialDataSafeHarbourGroupOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getFinancialDataOrganizationalEntityOverviewByIds(body: GetFinancialDataOrganizationalEntityByIdsOverviewInput | undefined): Observable<ListResultDtoOfFinancialDataOrganizationalEntityOverviewDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/SafeHarbourTests/GetFinancialDataOrganizationalEntityOverviewByIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFinancialDataOrganizationalEntityOverviewByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinancialDataOrganizationalEntityOverviewByIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfFinancialDataOrganizationalEntityOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfFinancialDataOrganizationalEntityOverviewDto>;
        }));
    }

    protected processGetFinancialDataOrganizationalEntityOverviewByIds(response: HttpResponseBase): Observable<ListResultDtoOfFinancialDataOrganizationalEntityOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfFinancialDataOrganizationalEntityOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    getSafeHarbourGroupCountries(projectId: number | undefined): Observable<TaxJurisdictionCountryReferenceDataDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/SafeHarbourTests/GetSafeHarbourGroupCountries?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSafeHarbourGroupCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSafeHarbourGroupCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxJurisdictionCountryReferenceDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxJurisdictionCountryReferenceDataDto[]>;
        }));
    }

    protected processGetSafeHarbourGroupCountries(response: HttpResponseBase): Observable<TaxJurisdictionCountryReferenceDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaxJurisdictionCountryReferenceDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param countryCode (optional) 
     * @return OK
     */
    getSafeHarbourGroupTests(projectId: number | undefined, countryCode: string | null | undefined): Observable<SafeHarbourGroupWorldMapDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/SafeHarbourTests/GetSafeHarbourGroupTests?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSafeHarbourGroupTests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSafeHarbourGroupTests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SafeHarbourGroupWorldMapDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SafeHarbourGroupWorldMapDto>;
        }));
    }

    protected processGetSafeHarbourGroupTests(response: HttpResponseBase): Observable<SafeHarbourGroupWorldMapDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SafeHarbourGroupWorldMapDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateGirReportingSelections(body: UpdateSafeHarbourGroupGirReportingSelectionsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/SafeHarbourTests/UpdateGirReportingSelections";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateGirReportingSelections(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGirReportingSelections(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateGirReportingSelections(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getSbieSafeHaroubourInconsitencies(body: SbieSafeHarbourVerificationInput | undefined): Observable<SbieConsistencyResultDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/SafeHarbourTests/GetSbieSafeHaroubourInconsitencies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSbieSafeHaroubourInconsitencies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSbieSafeHaroubourInconsitencies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SbieConsistencyResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SbieConsistencyResultDto>;
        }));
    }

    protected processGetSbieSafeHaroubourInconsitencies(response: HttpResponseBase): Observable<SbieConsistencyResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SbieConsistencyResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ScopingsServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    requestOverview(body: OrganizationalEntityOverviewInput | undefined): Observable<PagedResultDtoOfOrganizationalEntityOverviewDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Scopings/RequestOverview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRequestOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfOrganizationalEntityOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfOrganizationalEntityOverviewDto>;
        }));
    }

    protected processRequestOverview(response: HttpResponseBase): Observable<PagedResultDtoOfOrganizationalEntityOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrganizationalEntityOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getOrganizationalChart(body: GetOrganizationalChartInput | undefined): Observable<OrganizationalChartDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Scopings/GetOrganizationalChart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOrganizationalChart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationalChart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationalChartDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationalChartDto>;
        }));
    }

    protected processGetOrganizationalChart(response: HttpResponseBase): Observable<OrganizationalChartDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationalChartDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationalEntityId (optional) 
     * @param projectId (optional) 
     * @return OK
     */
    getById(organizationalEntityId: number | undefined, projectId: number | undefined): Observable<OrganizationalEntityDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Scopings/GetById?";
        if (organizationalEntityId === null)
            throw new Error("The parameter 'organizationalEntityId' cannot be null.");
        else if (organizationalEntityId !== undefined)
            url_ += "OrganizationalEntityId=" + encodeURIComponent("" + organizationalEntityId) + "&";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationalEntityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationalEntityDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<OrganizationalEntityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationalEntityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationalEntityId (optional) 
     * @param projectId (optional) 
     * @return OK
     */
    getGroupShare(organizationalEntityId: number | undefined, projectId: number | undefined): Observable<OrganizationalEntityGroupShareDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Scopings/GetGroupShare?";
        if (organizationalEntityId === null)
            throw new Error("The parameter 'organizationalEntityId' cannot be null.");
        else if (organizationalEntityId !== undefined)
            url_ += "OrganizationalEntityId=" + encodeURIComponent("" + organizationalEntityId) + "&";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGroupShare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroupShare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationalEntityGroupShareDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationalEntityGroupShareDto>;
        }));
    }

    protected processGetGroupShare(response: HttpResponseBase): Observable<OrganizationalEntityGroupShareDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationalEntityGroupShareDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    isEntityWithTheOwnersJurisdiction(body: CheckEntityWithTheOwnersJurisdictionInput | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/pillar2/Scopings/IsEntityWithTheOwnersJurisdiction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processIsEntityWithTheOwnersJurisdiction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsEntityWithTheOwnersJurisdiction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsEntityWithTheOwnersJurisdiction(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateOrganizationalEntityInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/pillar2/Scopings/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body: UpdateOrganizationalEntityInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Scopings/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateFieldStatus(body: UpdateOrganizationalEntityFieldStatusInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Scopings/UpdateFieldStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateFieldStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFieldStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateFieldStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationalEntityId (optional) 
     * @param projectId (optional) 
     * @return OK
     */
    delete(organizationalEntityId: number | undefined, projectId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Scopings/Delete?";
        if (organizationalEntityId === null)
            throw new Error("The parameter 'organizationalEntityId' cannot be null.");
        else if (organizationalEntityId !== undefined)
            url_ += "OrganizationalEntityId=" + encodeURIComponent("" + organizationalEntityId) + "&";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param ids (optional) 
     * @return OK
     */
    deleteAll(projectId: number | undefined, ids: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Scopings/DeleteAll?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAll(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    validateUpdateOrganizationalEntityInput(body: UpdateOrganizationalEntityInput | undefined): Observable<OrganizationalEntityWarningsAndErrorsResult> {
        let url_ = this.baseUrl + "/api/services/pillar2/Scopings/ValidateUpdateOrganizationalEntityInput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processValidateUpdateOrganizationalEntityInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateUpdateOrganizationalEntityInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationalEntityWarningsAndErrorsResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationalEntityWarningsAndErrorsResult>;
        }));
    }

    protected processValidateUpdateOrganizationalEntityInput(response: HttpResponseBase): Observable<OrganizationalEntityWarningsAndErrorsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationalEntityWarningsAndErrorsResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getSuggestedBlendingCircle(body: UpdateOrganizationalEntityInput | undefined): Observable<BlendingCircleDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Scopings/GetSuggestedBlendingCircle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSuggestedBlendingCircle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSuggestedBlendingCircle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BlendingCircleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BlendingCircleDto>;
        }));
    }

    protected processGetSuggestedBlendingCircle(response: HttpResponseBase): Observable<BlendingCircleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BlendingCircleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createEntityComment(body: CreateJurisdictionCommentInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Scopings/CreateEntityComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateEntityComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEntityComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateEntityComment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param id (optional) 
     * @return OK
     */
    getEntityComments(projectId: number | undefined, id: number | undefined): Observable<ProjectReferenceChannelDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Scopings/GetEntityComments?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEntityComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectReferenceChannelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectReferenceChannelDto>;
        }));
    }

    protected processGetEntityComments(response: HttpResponseBase): Observable<ProjectReferenceChannelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectReferenceChannelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param excludedEntityId (optional) 
     * @return OK
     */
    checkEntitiesForUpe(projectId: number | undefined, excludedEntityId: number | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/pillar2/Scopings/CheckEntitiesForUpe?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (excludedEntityId !== undefined && excludedEntityId !== null)
            url_ += "excludedEntityId=" + encodeURIComponent("" + excludedEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckEntitiesForUpe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckEntitiesForUpe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckEntitiesForUpe(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    toggleConfirmation(body: ToggleConfirmationInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Scopings/ToggleConfirmation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processToggleConfirmation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleConfirmation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processToggleConfirmation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    bulkToggleConfirmation(body: BulkToggleConfirmationInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Scopings/BulkToggleConfirmation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBulkToggleConfirmation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkToggleConfirmation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkToggleConfirmation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ShiftDataPointsServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    recalculateShiftNode(body: RequestRecalculateShiftNodeInput | undefined): Observable<FinancialNodeDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/ShiftDataPoints/RecalculateShiftNode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRecalculateShiftNode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecalculateShiftNode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinancialNodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinancialNodeDto>;
        }));
    }

    protected processRecalculateShiftNode(response: HttpResponseBase): Observable<FinancialNodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinancialNodeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    calculateFinalArticle432cOrArticle432d(body: RequestCalculateFinalArticle432Input | undefined): Observable<FinancialNodeDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/ShiftDataPoints/CalculateFinalArticle432cOrArticle432d";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCalculateFinalArticle432cOrArticle432d(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateFinalArticle432cOrArticle432d(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinancialNodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinancialNodeDto>;
        }));
    }

    protected processCalculateFinalArticle432cOrArticle432d(response: HttpResponseBase): Observable<FinancialNodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinancialNodeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    calculateFinalFiscalYearAverage(body: CalculateFinalFiscalYearAverageShiftDataInput | undefined): Observable<FinancialNodeDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/ShiftDataPoints/CalculateFinalFiscalYearAverage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCalculateFinalFiscalYearAverage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateFinalFiscalYearAverage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinancialNodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinancialNodeDto>;
        }));
    }

    protected processCalculateFinalFiscalYearAverage(response: HttpResponseBase): Observable<FinancialNodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinancialNodeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param organizationalEntityId (optional) 
     * @param value (optional) 
     * @param initialValue (optional) 
     * @param financialTreeType (optional) 
     * @return OK
     */
    checkIfArticle345Exists(projectId: number | undefined, organizationalEntityId: number | undefined, value: string | null | undefined, initialValue: string | null | undefined, financialTreeType: FinancialTreeType | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/pillar2/ShiftDataPoints/CheckIfArticle345Exists?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (organizationalEntityId === null)
            throw new Error("The parameter 'organizationalEntityId' cannot be null.");
        else if (organizationalEntityId !== undefined)
            url_ += "OrganizationalEntityId=" + encodeURIComponent("" + organizationalEntityId) + "&";
        if (value !== undefined && value !== null)
            url_ += "Value=" + encodeURIComponent("" + value) + "&";
        if (initialValue !== undefined && initialValue !== null)
            url_ += "InitialValue=" + encodeURIComponent("" + initialValue) + "&";
        if (financialTreeType !== undefined && financialTreeType !== null)
            url_ += "FinancialTreeType=" + encodeURIComponent("" + financialTreeType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckIfArticle345Exists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfArticle345Exists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckIfArticle345Exists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param organizationalEntityId (optional) 
     * @param otherEntityId (optional) 
     * @param financialShiftType (optional) 
     * @param basisForAdjustments (optional) 
     * @return OK
     */
    checkIfQdmttApplicable(projectId: number | undefined, organizationalEntityId: number | undefined, otherEntityId: number | null | undefined, financialShiftType: FinancialShiftType | null | undefined, basisForAdjustments: BasisForAdjustmentsType | null | undefined): Observable<CheckIfQdmttApplicableDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/ShiftDataPoints/CheckIfQdmttApplicable?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (organizationalEntityId === null)
            throw new Error("The parameter 'organizationalEntityId' cannot be null.");
        else if (organizationalEntityId !== undefined)
            url_ += "OrganizationalEntityId=" + encodeURIComponent("" + organizationalEntityId) + "&";
        if (otherEntityId !== undefined && otherEntityId !== null)
            url_ += "OtherEntityId=" + encodeURIComponent("" + otherEntityId) + "&";
        if (financialShiftType !== undefined && financialShiftType !== null)
            url_ += "FinancialShiftType=" + encodeURIComponent("" + financialShiftType) + "&";
        if (basisForAdjustments !== undefined && basisForAdjustments !== null)
            url_ += "BasisForAdjustments=" + encodeURIComponent("" + basisForAdjustments) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckIfQdmttApplicable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfQdmttApplicable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckIfQdmttApplicableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckIfQdmttApplicableDto>;
        }));
    }

    protected processCheckIfQdmttApplicable(response: HttpResponseBase): Observable<CheckIfQdmttApplicableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckIfQdmttApplicableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param organizationalEntityId (optional) 
     * @param value (optional) 
     * @param initialValue (optional) 
     * @param financialTreeType (optional) 
     * @return OK
     */
    getArticle345TraceName(projectId: number | undefined, organizationalEntityId: number | undefined, value: string | null | undefined, initialValue: string | null | undefined, financialTreeType: FinancialTreeType | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/pillar2/ShiftDataPoints/GetArticle345TraceName?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (organizationalEntityId === null)
            throw new Error("The parameter 'organizationalEntityId' cannot be null.");
        else if (organizationalEntityId !== undefined)
            url_ += "OrganizationalEntityId=" + encodeURIComponent("" + organizationalEntityId) + "&";
        if (value !== undefined && value !== null)
            url_ += "Value=" + encodeURIComponent("" + value) + "&";
        if (initialValue !== undefined && initialValue !== null)
            url_ += "InitialValue=" + encodeURIComponent("" + initialValue) + "&";
        if (financialTreeType !== undefined && financialTreeType !== null)
            url_ += "FinancialTreeType=" + encodeURIComponent("" + financialTreeType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetArticle345TraceName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArticle345TraceName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetArticle345TraceName(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createShiftDataPoint(body: CreateFinancialShiftInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/pillar2/ShiftDataPoints/CreateShiftDataPoint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateShiftDataPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateShiftDataPoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateShiftDataPoint(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createMultipleShiftNodeGroupData(body: CreateMultipleShiftNodeGroupInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ShiftDataPoints/CreateMultipleShiftNodeGroupData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateMultipleShiftNodeGroupData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMultipleShiftNodeGroupData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateMultipleShiftNodeGroupData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deleteMultipleShiftNodeGroupData(body: DeleteMultipleShiftNodeGroupInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ShiftDataPoints/DeleteMultipleShiftNodeGroupData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteMultipleShiftNodeGroupData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMultipleShiftNodeGroupData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteMultipleShiftNodeGroupData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateShiftDataPoint(body: UpdateFinancialShiftInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ShiftDataPoints/UpdateShiftDataPoint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateShiftDataPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateShiftDataPoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateShiftDataPoint(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addOrUpdateShiftDataPoint(body: AddOrUpdateFinancialShiftInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/pillar2/ShiftDataPoints/AddOrUpdateShiftDataPoint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAddOrUpdateShiftDataPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateShiftDataPoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddOrUpdateShiftDataPoint(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateShiftDataPointStatus(body: UpdateDataPointStatusInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ShiftDataPoints/UpdateShiftDataPointStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateShiftDataPointStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateShiftDataPointStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateShiftDataPointStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param targetOrganizationalEntityId (optional) 
     * @param financialTreeType (optional) 
     * @param id (optional) 
     * @return OK
     */
    deleteShiftDataPoint(projectId: number | undefined, targetOrganizationalEntityId: number | null | undefined, financialTreeType: FinancialTreeType | null | undefined, id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ShiftDataPoints/DeleteShiftDataPoint?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (targetOrganizationalEntityId !== undefined && targetOrganizationalEntityId !== null)
            url_ += "TargetOrganizationalEntityId=" + encodeURIComponent("" + targetOrganizationalEntityId) + "&";
        if (financialTreeType !== undefined && financialTreeType !== null)
            url_ += "FinancialTreeType=" + encodeURIComponent("" + financialTreeType) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteShiftDataPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteShiftDataPoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteShiftDataPoint(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SubmissionExcelExportableServiceServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    exportOverviewToExcel(body: ExportOverviewToExcelInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/SubmissionExcelExportableService/ExportOverviewToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processExportOverviewToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportOverviewToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExportOverviewToExcel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SubmissionFileManagmentServiceServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param projectId (optional) 
     * @param id (optional) 
     * @return OK
     */
    downloadSubmissionXml(projectId: number | null | undefined, id: number | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/SubmissionFileManagmentService/DownloadSubmissionXml?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDownloadSubmissionXml(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadSubmissionXml(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processDownloadSubmissionXml(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param id (optional) 
     * @return OK
     */
    downloadSubmissionPdf(projectId: number | null | undefined, id: number | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/SubmissionFileManagmentService/DownloadSubmissionPdf?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDownloadSubmissionPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadSubmissionPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processDownloadSubmissionPdf(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    uploadSubmissionUserUploadFile(body: UploadSubmissionFeedbackFileInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/SubmissionFileManagmentService/UploadSubmissionUserUploadFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUploadSubmissionUserUploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadSubmissionUserUploadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadSubmissionUserUploadFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param submissionId (optional) 
     * @param id (optional) 
     * @return OK
     */
    downloadSubmissionFeedbackFile(submissionId: number | undefined, id: number | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/SubmissionFileManagmentService/DownloadSubmissionFeedbackFile?";
        if (submissionId === null)
            throw new Error("The parameter 'submissionId' cannot be null.");
        else if (submissionId !== undefined)
            url_ += "SubmissionId=" + encodeURIComponent("" + submissionId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDownloadSubmissionFeedbackFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadSubmissionFeedbackFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processDownloadSubmissionFeedbackFile(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param submissionId (optional) 
     * @param id (optional) 
     * @return OK
     */
    downloadUserUploadFile(submissionId: number | undefined, id: number | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/SubmissionFileManagmentService/DownloadUserUploadFile?";
        if (submissionId === null)
            throw new Error("The parameter 'submissionId' cannot be null.");
        else if (submissionId !== undefined)
            url_ += "SubmissionId=" + encodeURIComponent("" + submissionId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDownloadUserUploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadUserUploadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processDownloadUserUploadFile(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param id (optional) 
     * @return OK
     */
    getSubmissionFiles(projectId: number | null | undefined, id: number | undefined): Observable<SubmissionFilesDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/SubmissionFileManagmentService/GetSubmissionFiles?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSubmissionFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubmissionFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubmissionFilesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubmissionFilesDto>;
        }));
    }

    protected processGetSubmissionFiles(response: HttpResponseBase): Observable<SubmissionFilesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubmissionFilesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param submissionId (optional) 
     * @param id (optional) 
     * @return OK
     */
    deleteSubmissionUserUploadFile(submissionId: number | undefined, id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/SubmissionFileManagmentService/DeleteSubmissionUserUploadFile?";
        if (submissionId === null)
            throw new Error("The parameter 'submissionId' cannot be null.");
        else if (submissionId !== undefined)
            url_ += "SubmissionId=" + encodeURIComponent("" + submissionId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteSubmissionUserUploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSubmissionUserUploadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSubmissionUserUploadFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SubmissionsServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    requestOverview(body: SubmissionsRequestOverviewInput | undefined): Observable<MazarsPagedResultDtoOfSubmissionOverviewDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Submissions/RequestOverview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRequestOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MazarsPagedResultDtoOfSubmissionOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MazarsPagedResultDtoOfSubmissionOverviewDto>;
        }));
    }

    protected processRequestOverview(response: HttpResponseBase): Observable<MazarsPagedResultDtoOfSubmissionOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MazarsPagedResultDtoOfSubmissionOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param id (optional) 
     * @return OK
     */
    getById(projectId: number | null | undefined, id: number | undefined): Observable<SubmissionDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Submissions/GetById?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubmissionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubmissionDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<SubmissionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubmissionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param submissionId (optional) 
     * @return OK
     */
    getSubmissionCorrectionAvailableCountries(submissionId: number | undefined): Observable<SubmissionCorrectionAvaliableCountriesDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Submissions/GetSubmissionCorrectionAvailableCountries?";
        if (submissionId === null)
            throw new Error("The parameter 'submissionId' cannot be null.");
        else if (submissionId !== undefined)
            url_ += "submissionId=" + encodeURIComponent("" + submissionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSubmissionCorrectionAvailableCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubmissionCorrectionAvailableCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubmissionCorrectionAvaliableCountriesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubmissionCorrectionAvaliableCountriesDto>;
        }));
    }

    protected processGetSubmissionCorrectionAvailableCountries(response: HttpResponseBase): Observable<SubmissionCorrectionAvaliableCountriesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubmissionCorrectionAvaliableCountriesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateSubmissionInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/pillar2/Submissions/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOutOfTemplate(body: CreateSubmissionOutOfTeplateInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/pillar2/Submissions/CreateOutOfTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOutOfTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOutOfTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOutOfTemplate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body: UpdateSubmissionInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Submissions/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param obligationId (optional) 
     * @param id (optional) 
     * @return OK
     */
    delete(projectId: number | undefined, obligationId: number | undefined, id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Submissions/Delete?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (obligationId === null)
            throw new Error("The parameter 'obligationId' cannot be null.");
        else if (obligationId !== undefined)
            url_ += "ObligationId=" + encodeURIComponent("" + obligationId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    hasSubmissionCreationInProgress(projectId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/pillar2/Submissions/HasSubmissionCreationInProgress?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processHasSubmissionCreationInProgress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasSubmissionCreationInProgress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processHasSubmissionCreationInProgress(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param obligationCountry (optional) 
     * @param id (optional) 
     * @return OK
     */
    hasSubmissions(projectId: number | undefined, obligationCountry: string | null | undefined, id: number | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/pillar2/Submissions/HasSubmissions?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (obligationCountry !== undefined && obligationCountry !== null)
            url_ += "ObligationCountry=" + encodeURIComponent("" + obligationCountry) + "&";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processHasSubmissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasSubmissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processHasSubmissions(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getTags(filter: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/Submissions/GetTags?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetTags(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setAssignedUser(body: SetAssignedUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Submissions/SetAssignedUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSetAssignedUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAssignedUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetAssignedUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getSubmissionFormData(id: number | undefined): Observable<SubmissionFormDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Submissions/GetSubmissionFormData?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSubmissionFormData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubmissionFormData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubmissionFormDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubmissionFormDto>;
        }));
    }

    protected processGetSubmissionFormData(response: HttpResponseBase): Observable<SubmissionFormDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubmissionFormDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateSubmissionFormData(body: UpdateSubmissionFormDataInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Submissions/UpdateSubmissionFormData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateSubmissionFormData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSubmissionFormData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSubmissionFormData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    validateSubmissionFormData(body: ValidateSubmissionFormDataInput | undefined): Observable<ValidateResultDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Submissions/ValidateSubmissionFormData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processValidateSubmissionFormData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateSubmissionFormData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValidateResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValidateResultDto>;
        }));
    }

    protected processValidateSubmissionFormData(response: HttpResponseBase): Observable<ValidateResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidateResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getSubmissionProcessStates(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/Submissions/GetSubmissionProcessStates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSubmissionProcessStates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubmissionProcessStates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetSubmissionProcessStates(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param referenceId (optional) 
     * @param filter (optional) 
     * @return OK
     */
    getAssignableUsers(referenceId: number | undefined, filter: string | null | undefined): Observable<AssignableUserDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/Submissions/GetAssignableUsers?";
        if (referenceId === null)
            throw new Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "ReferenceId=" + encodeURIComponent("" + referenceId) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAssignableUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignableUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignableUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignableUserDto[]>;
        }));
    }

    protected processGetAssignableUsers(response: HttpResponseBase): Observable<AssignableUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssignableUserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    exportPdf(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Submissions/ExportPdf?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processExportPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExportPdf(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SubmissionsProcessStatesServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getGroupedSubmissionProcessStates(): Observable<ProcessStateGroupedDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/SubmissionsProcessStates/GetGroupedSubmissionProcessStates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGroupedSubmissionProcessStates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroupedSubmissionProcessStates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessStateGroupedDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessStateGroupedDto[]>;
        }));
    }

    protected processGetGroupedSubmissionProcessStates(response: HttpResponseBase): Observable<ProcessStateGroupedDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProcessStateGroupedDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param submissionId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getProcessStateHistory(projectId: number | undefined, submissionId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSubmissionProcessStateHistoryOverviewDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/SubmissionsProcessStates/GetProcessStateHistory?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (submissionId === null)
            throw new Error("The parameter 'submissionId' cannot be null.");
        else if (submissionId !== undefined)
            url_ += "SubmissionId=" + encodeURIComponent("" + submissionId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProcessStateHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProcessStateHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSubmissionProcessStateHistoryOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSubmissionProcessStateHistoryOverviewDto>;
        }));
    }

    protected processGetProcessStateHistory(response: HttpResponseBase): Observable<PagedResultDtoOfSubmissionProcessStateHistoryOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSubmissionProcessStateHistoryOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param submissionId (optional) 
     * @return OK
     */
    exportProcessStateHistory(projectId: number | undefined, submissionId: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/SubmissionsProcessStates/ExportProcessStateHistory?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (submissionId === null)
            throw new Error("The parameter 'submissionId' cannot be null.");
        else if (submissionId !== undefined)
            url_ += "submissionId=" + encodeURIComponent("" + submissionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processExportProcessStateHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportProcessStateHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processExportProcessStateHistory(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    finishEditingPhase(body: SubmissionFinishEditingInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/SubmissionsProcessStates/FinishEditingPhase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFinishEditingPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishEditingPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFinishEditingPhase(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    finishReviewPhase(body: SubmissionFinishReviewInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/SubmissionsProcessStates/FinishReviewPhase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFinishReviewPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishReviewPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFinishReviewPhase(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    submitPhase(body: SubmissionSubmitInput | undefined): Observable<ValidateResultDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/SubmissionsProcessStates/SubmitPhase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSubmitPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValidateResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValidateResultDto>;
        }));
    }

    protected processSubmitPhase(response: HttpResponseBase): Observable<ValidateResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidateResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    revokePhase(body: SubmissionRevokeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/SubmissionsProcessStates/RevokePhase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRevokePhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRevokePhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRevokePhase(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    finishPhase(body: SubmissionFinishInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/SubmissionsProcessStates/FinishPhase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFinishPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFinishPhase(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TaxJurisdictionCountriesServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createJurisdictionComment(body: CreateJurisdictionCommentInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/TaxJurisdictionCountries/CreateJurisdictionComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateJurisdictionComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateJurisdictionComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateJurisdictionComment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param taxJurisdictionCountry (optional) 
     * @param jurisdictionType (optional) 
     * @param id (optional) 
     * @return OK
     */
    getJurisdictionComments(projectId: number | undefined, taxJurisdictionCountry: string | null | undefined, jurisdictionType: JurisdictionType | null | undefined, id: number | undefined): Observable<ProjectReferenceChannelDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/TaxJurisdictionCountries/GetJurisdictionComments?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (taxJurisdictionCountry !== undefined && taxJurisdictionCountry !== null)
            url_ += "TaxJurisdictionCountry=" + encodeURIComponent("" + taxJurisdictionCountry) + "&";
        if (jurisdictionType !== undefined && jurisdictionType !== null)
            url_ += "JurisdictionType=" + encodeURIComponent("" + jurisdictionType) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetJurisdictionComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJurisdictionComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectReferenceChannelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectReferenceChannelDto>;
        }));
    }

    protected processGetJurisdictionComments(response: HttpResponseBase): Observable<ProjectReferenceChannelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectReferenceChannelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TopupTaxServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param projectId (optional) 
     * @param financialTreeType (optional) 
     * @return OK
     */
    requestTutOverview(projectId: number | undefined, financialTreeType: FinancialTreeType | null | undefined): Observable<TutBlendingCirclesOverviewDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/TopupTax/RequestTutOverview?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (financialTreeType !== undefined && financialTreeType !== null)
            url_ += "FinancialTreeType=" + encodeURIComponent("" + financialTreeType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRequestTutOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestTutOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TutBlendingCirclesOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TutBlendingCirclesOverviewDto>;
        }));
    }

    protected processRequestTutOverview(response: HttpResponseBase): Observable<TutBlendingCirclesOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TutBlendingCirclesOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getTutBlendingCircleOverview(body: FinancialGroupInput | undefined): Observable<TutOverviewDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/TopupTax/GetTutBlendingCircleOverview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTutBlendingCircleOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTutBlendingCircleOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TutOverviewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TutOverviewDto[]>;
        }));
    }

    protected processGetTutBlendingCircleOverview(response: HttpResponseBase): Observable<TutOverviewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TutOverviewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TopUpTaxDistributionServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param projectId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    calculateTopUpTaxDistribution(projectId: number | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfTopUpTaxAssignmentDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/TopUpTaxDistribution/CalculateTopUpTaxDistribution?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCalculateTopUpTaxDistribution(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateTopUpTaxDistribution(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTopUpTaxAssignmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTopUpTaxAssignmentDto>;
        }));
    }

    protected processCalculateTopUpTaxDistribution(response: HttpResponseBase): Observable<PagedResultDtoOfTopUpTaxAssignmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTopUpTaxAssignmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserNotificationServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    notifyAssignedUserAboutSubmissionStatusUpdate(body: SubmissionStatusUpdateInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/UserNotification/NotifyAssignedUserAboutSubmissionStatusUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processNotifyAssignedUserAboutSubmissionStatusUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotifyAssignedUserAboutSubmissionStatusUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNotifyAssignedUserAboutSubmissionStatusUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UtprJurisdictionsServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param projectId (optional) 
     * @return OK
     */
    isUtprActive(projectId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/pillar2/UtprJurisdictions/IsUtprActive?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processIsUtprActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsUtprActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsUtprActive(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    requestOverview(body: GetUtprJurisdictionsOverviewInput | undefined): Observable<PagedResultDtoOfUtprJurisdictionOverviewDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/UtprJurisdictions/RequestOverview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRequestOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUtprJurisdictionOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUtprJurisdictionOverviewDto>;
        }));
    }

    protected processRequestOverview(response: HttpResponseBase): Observable<PagedResultDtoOfUtprJurisdictionOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUtprJurisdictionOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param jurisdictionId (optional) 
     * @return OK
     */
    getUtprDataPointsForJurisdiction(projectId: number | undefined, jurisdictionId: number | undefined): Observable<UtprDataPointDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/UtprJurisdictions/GetUtprDataPointsForJurisdiction?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (jurisdictionId === null)
            throw new Error("The parameter 'jurisdictionId' cannot be null.");
        else if (jurisdictionId !== undefined)
            url_ += "JurisdictionId=" + encodeURIComponent("" + jurisdictionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUtprDataPointsForJurisdiction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUtprDataPointsForJurisdiction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UtprDataPointDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UtprDataPointDto[]>;
        }));
    }

    protected processGetUtprDataPointsForJurisdiction(response: HttpResponseBase): Observable<UtprDataPointDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UtprDataPointDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param pointId (optional) 
     * @return OK
     */
    getUtprDataPointChanges(pointId: number | undefined): Observable<GetUtprDataPointChangeDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/UtprJurisdictions/GetUtprDataPointChanges?";
        if (pointId === null)
            throw new Error("The parameter 'pointId' cannot be null.");
        else if (pointId !== undefined)
            url_ += "pointId=" + encodeURIComponent("" + pointId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUtprDataPointChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUtprDataPointChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUtprDataPointChangeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUtprDataPointChangeDto[]>;
        }));
    }

    protected processGetUtprDataPointChanges(response: HttpResponseBase): Observable<GetUtprDataPointChangeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetUtprDataPointChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addOrUpdateUtprDataPoint(body: AddOrUpdateUtprDataPointInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/UtprJurisdictions/AddOrUpdateUtprDataPoint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAddOrUpdateUtprDataPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateUtprDataPoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddOrUpdateUtprDataPoint(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateUtprDataPointsConfirmation(body: UpdateUtprDataPointsConfirmationInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/UtprJurisdictions/UpdateUtprDataPointsConfirmation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateUtprDataPointsConfirmation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUtprDataPointsConfirmation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUtprDataPointsConfirmation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    bulkUpdateUtprDataPointsConfirmation(body: BulkUpdateUtprDataPointsConfirmationInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/UtprJurisdictions/BulkUpdateUtprDataPointsConfirmation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBulkUpdateUtprDataPointsConfirmation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkUpdateUtprDataPointsConfirmation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkUpdateUtprDataPointsConfirmation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ValueDataPointsServiceProxy extends ServiceProxyBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    recalculateValueNode(body: RequestRecalculateValueNodeInput | undefined): Observable<FinancialNodeDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/ValueDataPoints/RecalculateValueNode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRecalculateValueNode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecalculateValueNode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinancialNodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinancialNodeDto>;
        }));
    }

    protected processRecalculateValueNode(response: HttpResponseBase): Observable<FinancialNodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinancialNodeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    calculateNonEligibleEmployeeCosts(body: CalculateNonEligibleEmployeeCostsValueDataInput | undefined): Observable<FinancialNodeDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/ValueDataPoints/CalculateNonEligibleEmployeeCosts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCalculateNonEligibleEmployeeCosts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateNonEligibleEmployeeCosts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinancialNodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinancialNodeDto>;
        }));
    }

    protected processCalculateNonEligibleEmployeeCosts(response: HttpResponseBase): Observable<FinancialNodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinancialNodeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    calculateFinalFiscalYearAverage(body: CalculateFinalFiscalYearAverageValueDataInput | undefined): Observable<FinancialNodeDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/ValueDataPoints/CalculateFinalFiscalYearAverage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCalculateFinalFiscalYearAverage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateFinalFiscalYearAverage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinancialNodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinancialNodeDto>;
        }));
    }

    protected processCalculateFinalFiscalYearAverage(response: HttpResponseBase): Observable<FinancialNodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinancialNodeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addOrUpdateValueDataPoint(body: UpdateFinancialValueInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/pillar2/ValueDataPoints/AddOrUpdateValueDataPoint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAddOrUpdateValueDataPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateValueDataPoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddOrUpdateValueDataPoint(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createMultipleNodeGroupData(body: CreateMultipleNodeGroupInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ValueDataPoints/CreateMultipleNodeGroupData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateMultipleNodeGroupData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMultipleNodeGroupData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateMultipleNodeGroupData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deleteMultipleNodeGroupData(body: DeleteMultipleNodeGroupInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ValueDataPoints/DeleteMultipleNodeGroupData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteMultipleNodeGroupData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMultipleNodeGroupData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteMultipleNodeGroupData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createValueDataPoint(body: CreateFinancialValueInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/pillar2/ValueDataPoints/CreateValueDataPoint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateValueDataPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateValueDataPoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateValueDataPoint(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateValueDataPoint(body: UpdateFinancialValueInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ValueDataPoints/UpdateValueDataPoint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateValueDataPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateValueDataPoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateValueDataPoint(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateValueDataPointStatus(body: UpdateDataPointStatusInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ValueDataPoints/UpdateValueDataPointStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateValueDataPointStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateValueDataPointStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateValueDataPointStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param financialTreeType (optional) 
     * @param id (optional) 
     * @return OK
     */
    deleteValueDataPoint(projectId: number | undefined, financialTreeType: FinancialTreeType | null | undefined, id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ValueDataPoints/DeleteValueDataPoint?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (financialTreeType !== undefined && financialTreeType !== null)
            url_ += "FinancialTreeType=" + encodeURIComponent("" + financialTreeType) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteValueDataPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteValueDataPoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteValueDataPoint(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AccessManagementOverviewDto implements IAccessManagementOverviewDto {
    taxJurisdictionName!: string | undefined;
    countryCode!: string | undefined;
    organizationalEntityId!: number | undefined;
    entityName!: string | undefined;
    entityNumber!: string | undefined;
    hasSpecialPermission!: boolean;

    constructor(data?: IAccessManagementOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxJurisdictionName = _data["taxJurisdictionName"];
            this.countryCode = _data["countryCode"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.entityName = _data["entityName"];
            this.entityNumber = _data["entityNumber"];
            this.hasSpecialPermission = _data["hasSpecialPermission"];
        }
    }

    static fromJS(data: any): AccessManagementOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccessManagementOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxJurisdictionName"] = this.taxJurisdictionName;
        data["countryCode"] = this.countryCode;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["entityName"] = this.entityName;
        data["entityNumber"] = this.entityNumber;
        data["hasSpecialPermission"] = this.hasSpecialPermission;
        return data;
    }
}

export interface IAccessManagementOverviewDto {
    taxJurisdictionName: string | undefined;
    countryCode: string | undefined;
    organizationalEntityId: number | undefined;
    entityName: string | undefined;
    entityNumber: string | undefined;
    hasSpecialPermission: boolean;
}

export class ActArticle72DeferredTaxesAfterRecastAdjustmentsDto implements IActArticle72DeferredTaxesAfterRecastAdjustmentsDto {
    amountOfCoveredTaxes!: FinancialValueDto | undefined;
    thereofTaxesNotToBeCorrectedSinceDividendDeductionWasAllowed!: FinancialValueDto | undefined;
    amountToBeCorrected!: FinancialValueDto | undefined;
    reductionOfCoveredTaxesAccordingToArticle722!: FinancialValueDto | undefined;

    constructor(data?: IActArticle72DeferredTaxesAfterRecastAdjustmentsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amountOfCoveredTaxes = _data["amountOfCoveredTaxes"] ? FinancialValueDto.fromJS(_data["amountOfCoveredTaxes"]) : <any>undefined;
            this.thereofTaxesNotToBeCorrectedSinceDividendDeductionWasAllowed = _data["thereofTaxesNotToBeCorrectedSinceDividendDeductionWasAllowed"] ? FinancialValueDto.fromJS(_data["thereofTaxesNotToBeCorrectedSinceDividendDeductionWasAllowed"]) : <any>undefined;
            this.amountToBeCorrected = _data["amountToBeCorrected"] ? FinancialValueDto.fromJS(_data["amountToBeCorrected"]) : <any>undefined;
            this.reductionOfCoveredTaxesAccordingToArticle722 = _data["reductionOfCoveredTaxesAccordingToArticle722"] ? FinancialValueDto.fromJS(_data["reductionOfCoveredTaxesAccordingToArticle722"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ActArticle72DeferredTaxesAfterRecastAdjustmentsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActArticle72DeferredTaxesAfterRecastAdjustmentsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amountOfCoveredTaxes"] = this.amountOfCoveredTaxes ? this.amountOfCoveredTaxes.toJSON() : <any>undefined;
        data["thereofTaxesNotToBeCorrectedSinceDividendDeductionWasAllowed"] = this.thereofTaxesNotToBeCorrectedSinceDividendDeductionWasAllowed ? this.thereofTaxesNotToBeCorrectedSinceDividendDeductionWasAllowed.toJSON() : <any>undefined;
        data["amountToBeCorrected"] = this.amountToBeCorrected ? this.amountToBeCorrected.toJSON() : <any>undefined;
        data["reductionOfCoveredTaxesAccordingToArticle722"] = this.reductionOfCoveredTaxesAccordingToArticle722 ? this.reductionOfCoveredTaxesAccordingToArticle722.toJSON() : <any>undefined;
        return data;
    }
}

export interface IActArticle72DeferredTaxesAfterRecastAdjustmentsDto {
    amountOfCoveredTaxes: FinancialValueDto | undefined;
    thereofTaxesNotToBeCorrectedSinceDividendDeductionWasAllowed: FinancialValueDto | undefined;
    amountToBeCorrected: FinancialValueDto | undefined;
    reductionOfCoveredTaxesAccordingToArticle722: FinancialValueDto | undefined;
}

export class AddOrUpdateFinancialShiftInput implements IAddOrUpdateFinancialShiftInput {
    projectId!: number;
    value!: string | undefined;
    comment!: string | undefined;
    notes!: string | undefined;
    isConfirmed!: boolean;
    financialShiftType!: FinancialShiftType;
    targetOrganizationalEntityId!: number | undefined;
    basisForAdjustments!: BasisForAdjustmentsType | undefined;
    maxTaxRateOfMainEntityJurisdiction!: string | undefined;
    passiveIncomeOfCEOrHybridEntity!: string | undefined;
    thereofOnActiveIncome!: string | undefined;
    fiscalYearBeginning!: string | undefined;
    fiscalYearEnd!: string | undefined;
    financialTreeType!: FinancialTreeType;
    directionType!: DirectionType | undefined;
    finalValue!: string | undefined;
    sourceOrganizationalEntityId!: number;
    id!: number;
    isManualCorrectionIncoming!: boolean;

    constructor(data?: IAddOrUpdateFinancialShiftInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.value = _data["value"];
            this.comment = _data["comment"];
            this.notes = _data["notes"];
            this.isConfirmed = _data["isConfirmed"];
            this.financialShiftType = _data["financialShiftType"];
            this.targetOrganizationalEntityId = _data["targetOrganizationalEntityId"];
            this.basisForAdjustments = _data["basisForAdjustments"];
            this.maxTaxRateOfMainEntityJurisdiction = _data["maxTaxRateOfMainEntityJurisdiction"];
            this.passiveIncomeOfCEOrHybridEntity = _data["passiveIncomeOfCEOrHybridEntity"];
            this.thereofOnActiveIncome = _data["thereofOnActiveIncome"];
            this.fiscalYearBeginning = _data["fiscalYearBeginning"];
            this.fiscalYearEnd = _data["fiscalYearEnd"];
            this.financialTreeType = _data["financialTreeType"];
            this.directionType = _data["directionType"];
            this.finalValue = _data["finalValue"];
            this.sourceOrganizationalEntityId = _data["sourceOrganizationalEntityId"];
            this.id = _data["id"];
            this.isManualCorrectionIncoming = _data["isManualCorrectionIncoming"];
        }
    }

    static fromJS(data: any): AddOrUpdateFinancialShiftInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddOrUpdateFinancialShiftInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["value"] = this.value;
        data["comment"] = this.comment;
        data["notes"] = this.notes;
        data["isConfirmed"] = this.isConfirmed;
        data["financialShiftType"] = this.financialShiftType;
        data["targetOrganizationalEntityId"] = this.targetOrganizationalEntityId;
        data["basisForAdjustments"] = this.basisForAdjustments;
        data["maxTaxRateOfMainEntityJurisdiction"] = this.maxTaxRateOfMainEntityJurisdiction;
        data["passiveIncomeOfCEOrHybridEntity"] = this.passiveIncomeOfCEOrHybridEntity;
        data["thereofOnActiveIncome"] = this.thereofOnActiveIncome;
        data["fiscalYearBeginning"] = this.fiscalYearBeginning;
        data["fiscalYearEnd"] = this.fiscalYearEnd;
        data["financialTreeType"] = this.financialTreeType;
        data["directionType"] = this.directionType;
        data["finalValue"] = this.finalValue;
        data["sourceOrganizationalEntityId"] = this.sourceOrganizationalEntityId;
        data["id"] = this.id;
        data["isManualCorrectionIncoming"] = this.isManualCorrectionIncoming;
        return data;
    }
}

export interface IAddOrUpdateFinancialShiftInput {
    projectId: number;
    value: string | undefined;
    comment: string | undefined;
    notes: string | undefined;
    isConfirmed: boolean;
    financialShiftType: FinancialShiftType;
    targetOrganizationalEntityId: number | undefined;
    basisForAdjustments: BasisForAdjustmentsType | undefined;
    maxTaxRateOfMainEntityJurisdiction: string | undefined;
    passiveIncomeOfCEOrHybridEntity: string | undefined;
    thereofOnActiveIncome: string | undefined;
    fiscalYearBeginning: string | undefined;
    fiscalYearEnd: string | undefined;
    financialTreeType: FinancialTreeType;
    directionType: DirectionType | undefined;
    finalValue: string | undefined;
    sourceOrganizationalEntityId: number;
    id: number;
    isManualCorrectionIncoming: boolean;
}

export class AddOrUpdateUtprDataPointInput implements IAddOrUpdateUtprDataPointInput {
    id!: number;
    projectId!: number;
    jurisdictionId!: number;
    utprDataType!: UtprDataType;
    value!: string | undefined;
    isConfirmed!: boolean;
    notes!: string | undefined;
    comment!: string | undefined;

    constructor(data?: IAddOrUpdateUtprDataPointInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.jurisdictionId = _data["jurisdictionId"];
            this.utprDataType = _data["utprDataType"];
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
            this.notes = _data["notes"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): AddOrUpdateUtprDataPointInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddOrUpdateUtprDataPointInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["jurisdictionId"] = this.jurisdictionId;
        data["utprDataType"] = this.utprDataType;
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        data["notes"] = this.notes;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IAddOrUpdateUtprDataPointInput {
    id: number;
    projectId: number;
    jurisdictionId: number;
    utprDataType: UtprDataType;
    value: string | undefined;
    isConfirmed: boolean;
    notes: string | undefined;
    comment: string | undefined;
}

export class AdditionalPropertyInfoDto implements IAdditionalPropertyInfoDto {
    propertyName!: string | undefined;
    isPercentage!: boolean;
    localizationKey!: string | undefined;

    constructor(data?: IAdditionalPropertyInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyName = _data["propertyName"];
            this.isPercentage = _data["isPercentage"];
            this.localizationKey = _data["localizationKey"];
        }
    }

    static fromJS(data: any): AdditionalPropertyInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalPropertyInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName;
        data["isPercentage"] = this.isPercentage;
        data["localizationKey"] = this.localizationKey;
        return data;
    }
}

export interface IAdditionalPropertyInfoDto {
    propertyName: string | undefined;
    isPercentage: boolean;
    localizationKey: string | undefined;
}

export class AssignableUserDto implements IAssignableUserDto {
    id!: number;
    fullName!: string | undefined;
    userName!: string | undefined;

    constructor(data?: IAssignableUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): AssignableUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignableUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["userName"] = this.userName;
        return data;
    }
}

export interface IAssignableUserDto {
    id: number;
    fullName: string | undefined;
    userName: string | undefined;
}

export class AssignableUserInput implements IAssignableUserInput {
    id!: number | undefined;

    constructor(data?: IAssignableUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AssignableUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new AssignableUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IAssignableUserInput {
    id: number | undefined;
}

export class AttachmentDto implements IAttachmentDto {
    id!: number;
    name!: string | undefined;
    note!: string | undefined;
    type!: string | undefined;
    fileName!: string | undefined;
    fileUrl!: string | undefined;
    url!: string | undefined;
    dateOfAttachment!: DateTime | undefined;
    tags!: TagDto[] | undefined;

    constructor(data?: IAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.note = _data["note"];
            this.type = _data["type"];
            this.fileName = _data["fileName"];
            this.fileUrl = _data["fileUrl"];
            this.url = _data["url"];
            this.dateOfAttachment = _data["dateOfAttachment"] ? DateTime.fromISO(_data["dateOfAttachment"].toString()) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["note"] = this.note;
        data["type"] = this.type;
        data["fileName"] = this.fileName;
        data["fileUrl"] = this.fileUrl;
        data["url"] = this.url;
        data["dateOfAttachment"] = this.dateOfAttachment ? this.dateOfAttachment.toString() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAttachmentDto {
    id: number;
    name: string | undefined;
    note: string | undefined;
    type: string | undefined;
    fileName: string | undefined;
    fileUrl: string | undefined;
    url: string | undefined;
    dateOfAttachment: DateTime | undefined;
    tags: TagDto[] | undefined;
}

export class AttachmentLookupDto implements IAttachmentLookupDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: IAttachmentLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AttachmentLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IAttachmentLookupDto {
    id: number;
    name: string | undefined;
}

export class AttachmentOverviewDto implements IAttachmentOverviewDto {
    id!: number;
    name!: string | undefined;
    note!: string | undefined;
    type!: string | undefined;
    fileName!: string | undefined;
    fileUrl!: string | undefined;
    url!: string | undefined;
    hasPreview!: boolean;
    creationDate!: DateTime;
    dateOfAttachment!: DateTime | undefined;
    tags!: TagDto[] | undefined;
    fileContributionInfos!: FileContributionInfoDto[] | undefined;
    lastModifier!: string | undefined;
    lastModifierUserId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    creatorUserId!: number;
    createdByModifier!: string | undefined;
    specialPermissionDto!: AttachmentSpecialPermissionDto | undefined;

    constructor(data?: IAttachmentOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.note = _data["note"];
            this.type = _data["type"];
            this.fileName = _data["fileName"];
            this.fileUrl = _data["fileUrl"];
            this.url = _data["url"];
            this.hasPreview = _data["hasPreview"];
            this.creationDate = _data["creationDate"] ? DateTime.fromISO(_data["creationDate"].toString()) : <any>undefined;
            this.dateOfAttachment = _data["dateOfAttachment"] ? DateTime.fromISO(_data["dateOfAttachment"].toString()) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
            if (Array.isArray(_data["fileContributionInfos"])) {
                this.fileContributionInfos = [] as any;
                for (let item of _data["fileContributionInfos"])
                    this.fileContributionInfos!.push(FileContributionInfoDto.fromJS(item));
            }
            this.lastModifier = _data["lastModifier"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.createdByModifier = _data["createdByModifier"];
            this.specialPermissionDto = _data["specialPermissionDto"] ? AttachmentSpecialPermissionDto.fromJS(_data["specialPermissionDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AttachmentOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["note"] = this.note;
        data["type"] = this.type;
        data["fileName"] = this.fileName;
        data["fileUrl"] = this.fileUrl;
        data["url"] = this.url;
        data["hasPreview"] = this.hasPreview;
        data["creationDate"] = this.creationDate ? this.creationDate.toString() : <any>undefined;
        data["dateOfAttachment"] = this.dateOfAttachment ? this.dateOfAttachment.toString() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        if (Array.isArray(this.fileContributionInfos)) {
            data["fileContributionInfos"] = [];
            for (let item of this.fileContributionInfos)
                data["fileContributionInfos"].push(item.toJSON());
        }
        data["lastModifier"] = this.lastModifier;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["createdByModifier"] = this.createdByModifier;
        data["specialPermissionDto"] = this.specialPermissionDto ? this.specialPermissionDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAttachmentOverviewDto {
    id: number;
    name: string | undefined;
    note: string | undefined;
    type: string | undefined;
    fileName: string | undefined;
    fileUrl: string | undefined;
    url: string | undefined;
    hasPreview: boolean;
    creationDate: DateTime;
    dateOfAttachment: DateTime | undefined;
    tags: TagDto[] | undefined;
    fileContributionInfos: FileContributionInfoDto[] | undefined;
    lastModifier: string | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: DateTime | undefined;
    creatorUserId: number;
    createdByModifier: string | undefined;
    specialPermissionDto: AttachmentSpecialPermissionDto | undefined;
}

export class AttachmentSpecialPermissionDto implements IAttachmentSpecialPermissionDto {
    isActive!: boolean;
    message!: string | undefined;

    constructor(data?: IAttachmentSpecialPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActive = _data["isActive"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): AttachmentSpecialPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentSpecialPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["message"] = this.message;
        return data;
    }
}

export interface IAttachmentSpecialPermissionDto {
    isActive: boolean;
    message: string | undefined;
}

export class AttachmentsFilterRequest implements IAttachmentsFilterRequest {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    referenceId!: number;
    filter!: string | undefined;
    typeFilter!: string[] | undefined;
    tagsFilter!: string[] | undefined;
    createdByFilter!: number[] | undefined;

    constructor(data?: IAttachmentsFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.referenceId = _data["referenceId"];
            this.filter = _data["filter"];
            if (Array.isArray(_data["typeFilter"])) {
                this.typeFilter = [] as any;
                for (let item of _data["typeFilter"])
                    this.typeFilter!.push(item);
            }
            if (Array.isArray(_data["tagsFilter"])) {
                this.tagsFilter = [] as any;
                for (let item of _data["tagsFilter"])
                    this.tagsFilter!.push(item);
            }
            if (Array.isArray(_data["createdByFilter"])) {
                this.createdByFilter = [] as any;
                for (let item of _data["createdByFilter"])
                    this.createdByFilter!.push(item);
            }
        }
    }

    static fromJS(data: any): AttachmentsFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentsFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["referenceId"] = this.referenceId;
        data["filter"] = this.filter;
        if (Array.isArray(this.typeFilter)) {
            data["typeFilter"] = [];
            for (let item of this.typeFilter)
                data["typeFilter"].push(item);
        }
        if (Array.isArray(this.tagsFilter)) {
            data["tagsFilter"] = [];
            for (let item of this.tagsFilter)
                data["tagsFilter"].push(item);
        }
        if (Array.isArray(this.createdByFilter)) {
            data["createdByFilter"] = [];
            for (let item of this.createdByFilter)
                data["createdByFilter"].push(item);
        }
        return data;
    }
}

export interface IAttachmentsFilterRequest {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    referenceId: number;
    filter: string | undefined;
    typeFilter: string[] | undefined;
    tagsFilter: string[] | undefined;
    createdByFilter: number[] | undefined;
}

export class AuthorDto implements IAuthorDto {
    id!: number;
    text!: string | undefined;

    constructor(data?: IAuthorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): AuthorDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        return data;
    }
}

export interface IAuthorDto {
    id: number;
    text: string | undefined;
}

export enum BasisForAdjustmentsType {
    Article34 = 1,
    Article353 = 2,
    Article351a = 3,
    Article351b = 4,
    Article345 = 5,
    Article432a = 11,
    Article432b = 12,
    Article432cBlendedCfcRegime = 13,
    Article432c = 14,
    Article432d = 15,
    Article432e = 16,
    Article434 = 17,
    Article326 = 100,
    Article444 = 101,
    Article461 = 102,
    Article464 = 103,
    Article735 = 104,
    Article737 = 105,
}

export enum BasisOfReductionOfGloBEIncome {
    Article71 = 1,
    Article72 = 2,
    All = 3,
}

export class BlendingCircleDto implements IBlendingCircleDto {
    id!: number | undefined;
    taxJurisdictionCountry!: string | undefined;
    subgroupType!: BlendingCircleSubgroupType | undefined;
    number!: number | undefined;
    isConfirmed!: boolean;

    constructor(data?: IBlendingCircleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taxJurisdictionCountry = _data["taxJurisdictionCountry"];
            this.subgroupType = _data["subgroupType"];
            this.number = _data["number"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): BlendingCircleDto {
        data = typeof data === 'object' ? data : {};
        let result = new BlendingCircleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taxJurisdictionCountry"] = this.taxJurisdictionCountry;
        data["subgroupType"] = this.subgroupType;
        data["number"] = this.number;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IBlendingCircleDto {
    id: number | undefined;
    taxJurisdictionCountry: string | undefined;
    subgroupType: BlendingCircleSubgroupType | undefined;
    number: number | undefined;
    isConfirmed: boolean;
}

export class BlendingCircleElectionInput implements IBlendingCircleElectionInput {
    id!: number;
    projectId!: number;
    electionType!: ElectionType | undefined;
    value!: boolean | undefined;
    electionYear!: DateTime | undefined;
    revocationYear!: DateTime | undefined;
    inclusionType!: ElectionInclusionType | undefined;
    equityInvestmentDetails!: EquityInvestmentInclusionElectionDetailsDto | undefined;
    permanentSafeHarbourTypes!: PermanentSafeHarbourType[] | undefined;
    blendingCircleCountry!: string | undefined;
    blendingCircleSubgroupId!: number | undefined;

    constructor(data?: IBlendingCircleElectionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.electionType = _data["electionType"];
            this.value = _data["value"];
            this.electionYear = _data["electionYear"] ? DateTime.fromISO(_data["electionYear"].toString()) : <any>undefined;
            this.revocationYear = _data["revocationYear"] ? DateTime.fromISO(_data["revocationYear"].toString()) : <any>undefined;
            this.inclusionType = _data["inclusionType"];
            this.equityInvestmentDetails = _data["equityInvestmentDetails"] ? EquityInvestmentInclusionElectionDetailsDto.fromJS(_data["equityInvestmentDetails"]) : <any>undefined;
            if (Array.isArray(_data["permanentSafeHarbourTypes"])) {
                this.permanentSafeHarbourTypes = [] as any;
                for (let item of _data["permanentSafeHarbourTypes"])
                    this.permanentSafeHarbourTypes!.push(item);
            }
            this.blendingCircleCountry = _data["blendingCircleCountry"];
            this.blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
        }
    }

    static fromJS(data: any): BlendingCircleElectionInput {
        data = typeof data === 'object' ? data : {};
        let result = new BlendingCircleElectionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["electionType"] = this.electionType;
        data["value"] = this.value;
        data["electionYear"] = this.electionYear ? this.electionYear.toString() : <any>undefined;
        data["revocationYear"] = this.revocationYear ? this.revocationYear.toString() : <any>undefined;
        data["inclusionType"] = this.inclusionType;
        data["equityInvestmentDetails"] = this.equityInvestmentDetails ? this.equityInvestmentDetails.toJSON() : <any>undefined;
        if (Array.isArray(this.permanentSafeHarbourTypes)) {
            data["permanentSafeHarbourTypes"] = [];
            for (let item of this.permanentSafeHarbourTypes)
                data["permanentSafeHarbourTypes"].push(item);
        }
        data["blendingCircleCountry"] = this.blendingCircleCountry;
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        return data;
    }
}

export interface IBlendingCircleElectionInput {
    id: number;
    projectId: number;
    electionType: ElectionType | undefined;
    value: boolean | undefined;
    electionYear: DateTime | undefined;
    revocationYear: DateTime | undefined;
    inclusionType: ElectionInclusionType | undefined;
    equityInvestmentDetails: EquityInvestmentInclusionElectionDetailsDto | undefined;
    permanentSafeHarbourTypes: PermanentSafeHarbourType[] | undefined;
    blendingCircleCountry: string | undefined;
    blendingCircleSubgroupId: number | undefined;
}

export class BlendingCircleInput implements IBlendingCircleInput {
    id!: number | undefined;
    projectId!: number;
    taxJurisdictionCountry!: string | undefined;
    organizationalEntityId!: number;
    isConfirmed!: boolean;
    subgroupType!: BlendingCircleSubgroupType | undefined;
    number!: number | undefined;

    constructor(data?: IBlendingCircleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.taxJurisdictionCountry = _data["taxJurisdictionCountry"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.isConfirmed = _data["isConfirmed"];
            this.subgroupType = _data["subgroupType"];
            this.number = _data["number"];
        }
    }

    static fromJS(data: any): BlendingCircleInput {
        data = typeof data === 'object' ? data : {};
        let result = new BlendingCircleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["taxJurisdictionCountry"] = this.taxJurisdictionCountry;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["isConfirmed"] = this.isConfirmed;
        data["subgroupType"] = this.subgroupType;
        data["number"] = this.number;
        return data;
    }
}

export interface IBlendingCircleInput {
    id: number | undefined;
    projectId: number;
    taxJurisdictionCountry: string | undefined;
    organizationalEntityId: number;
    isConfirmed: boolean;
    subgroupType: BlendingCircleSubgroupType | undefined;
    number: number | undefined;
}

export class BlendingCircleReferenceDto implements IBlendingCircleReferenceDto {
    id!: string | undefined;
    text!: string | undefined;

    constructor(data?: IBlendingCircleReferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): BlendingCircleReferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new BlendingCircleReferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        return data;
    }
}

export interface IBlendingCircleReferenceDto {
    id: string | undefined;
    text: string | undefined;
}

export class BlendingCircleReferenceSubgroupDto implements IBlendingCircleReferenceSubgroupDto {
    id!: number;
    text!: string | undefined;

    constructor(data?: IBlendingCircleReferenceSubgroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): BlendingCircleReferenceSubgroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new BlendingCircleReferenceSubgroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        return data;
    }
}

export interface IBlendingCircleReferenceSubgroupDto {
    id: number;
    text: string | undefined;
}

export class BlendingCircleSubgroupDto implements IBlendingCircleSubgroupDto {
    id!: BlendingCircleSubgroupType;
    text!: string | undefined;
    number!: number | undefined;
    isDisabled!: boolean;

    constructor(data?: IBlendingCircleSubgroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            this.number = _data["number"];
            this.isDisabled = _data["isDisabled"];
        }
    }

    static fromJS(data: any): BlendingCircleSubgroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new BlendingCircleSubgroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["number"] = this.number;
        data["isDisabled"] = this.isDisabled;
        return data;
    }
}

export interface IBlendingCircleSubgroupDto {
    id: BlendingCircleSubgroupType;
    text: string | undefined;
    number: number | undefined;
    isDisabled: boolean;
}

export enum BlendingCircleSubgroupType {
    Standard = 1,
    InsuranceInvestment = 2,
    MinorityOwnedSubgroup = 3,
    MinorityOwnedConstituentEntity = 4,
    JointVenture = 5,
    Stateless = 6,
}

export class BlendingCirlceSubroupReferenceDataDto implements IBlendingCirlceSubroupReferenceDataDto {
    id!: number;
    text!: string | undefined;
    subgroupType!: BlendingCircleSubgroupType | undefined;
    number!: number | undefined;

    constructor(data?: IBlendingCirlceSubroupReferenceDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            this.subgroupType = _data["subgroupType"];
            this.number = _data["number"];
        }
    }

    static fromJS(data: any): BlendingCirlceSubroupReferenceDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new BlendingCirlceSubroupReferenceDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["subgroupType"] = this.subgroupType;
        data["number"] = this.number;
        return data;
    }
}

export interface IBlendingCirlceSubroupReferenceDataDto {
    id: number;
    text: string | undefined;
    subgroupType: BlendingCircleSubgroupType | undefined;
    number: number | undefined;
}

export class BulkChangeAccessRestrictionInput implements IBulkChangeAccessRestrictionInput {
    ids!: number[] | undefined;
    usersAndOrganizationUnits!: UserOrOrganizationUnitInput[] | undefined;

    constructor(data?: IBulkChangeAccessRestrictionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            if (Array.isArray(_data["usersAndOrganizationUnits"])) {
                this.usersAndOrganizationUnits = [] as any;
                for (let item of _data["usersAndOrganizationUnits"])
                    this.usersAndOrganizationUnits!.push(UserOrOrganizationUnitInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BulkChangeAccessRestrictionInput {
        data = typeof data === 'object' ? data : {};
        let result = new BulkChangeAccessRestrictionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        if (Array.isArray(this.usersAndOrganizationUnits)) {
            data["usersAndOrganizationUnits"] = [];
            for (let item of this.usersAndOrganizationUnits)
                data["usersAndOrganizationUnits"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBulkChangeAccessRestrictionInput {
    ids: number[] | undefined;
    usersAndOrganizationUnits: UserOrOrganizationUnitInput[] | undefined;
}

export class BulkDetailsDto implements IBulkDetailsDto {
    possible!: number;
    total!: number;

    constructor(data?: IBulkDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.possible = _data["possible"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): BulkDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new BulkDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["possible"] = this.possible;
        data["total"] = this.total;
        return data;
    }
}

export interface IBulkDetailsDto {
    possible: number;
    total: number;
}

export class BulkInput implements IBulkInput {
    ids!: number[] | undefined;

    constructor(data?: IBulkInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): BulkInput {
        data = typeof data === 'object' ? data : {};
        let result = new BulkInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IBulkInput {
    ids: number[] | undefined;
}

export enum BulkProjectOperation {
    ChangeAccessRestriction = 4,
    Delete = 5,
}

export class BulkProjectOperationDetailsDto implements IBulkProjectOperationDetailsDto {
    bulkOperation!: BulkProjectOperation;
    bulkDetails!: BulkDetailsDto | undefined;

    constructor(data?: IBulkProjectOperationDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bulkOperation = _data["bulkOperation"];
            this.bulkDetails = _data["bulkDetails"] ? BulkDetailsDto.fromJS(_data["bulkDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BulkProjectOperationDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new BulkProjectOperationDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bulkOperation"] = this.bulkOperation;
        data["bulkDetails"] = this.bulkDetails ? this.bulkDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBulkProjectOperationDetailsDto {
    bulkOperation: BulkProjectOperation;
    bulkDetails: BulkDetailsDto | undefined;
}

export class BulkSetEntityControllingInterestsInput implements IBulkSetEntityControllingInterestsInput {
    ids!: number[] | undefined;
    projectId!: number;
    overwriteAll!: boolean;

    constructor(data?: IBulkSetEntityControllingInterestsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.projectId = _data["projectId"];
            this.overwriteAll = _data["overwriteAll"];
        }
    }

    static fromJS(data: any): BulkSetEntityControllingInterestsInput {
        data = typeof data === 'object' ? data : {};
        let result = new BulkSetEntityControllingInterestsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["projectId"] = this.projectId;
        data["overwriteAll"] = this.overwriteAll;
        return data;
    }
}

export interface IBulkSetEntityControllingInterestsInput {
    ids: number[] | undefined;
    projectId: number;
    overwriteAll: boolean;
}

export class BulkSetSuggestedBlendingCircleSubgroupsInput implements IBulkSetSuggestedBlendingCircleSubgroupsInput {
    ids!: number[] | undefined;
    projectId!: number;
    overwriteExisting!: boolean;
    confirmSuggested!: boolean;
    alignWithJurisdiction!: boolean;

    constructor(data?: IBulkSetSuggestedBlendingCircleSubgroupsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.projectId = _data["projectId"];
            this.overwriteExisting = _data["overwriteExisting"];
            this.confirmSuggested = _data["confirmSuggested"];
            this.alignWithJurisdiction = _data["alignWithJurisdiction"];
        }
    }

    static fromJS(data: any): BulkSetSuggestedBlendingCircleSubgroupsInput {
        data = typeof data === 'object' ? data : {};
        let result = new BulkSetSuggestedBlendingCircleSubgroupsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["projectId"] = this.projectId;
        data["overwriteExisting"] = this.overwriteExisting;
        data["confirmSuggested"] = this.confirmSuggested;
        data["alignWithJurisdiction"] = this.alignWithJurisdiction;
        return data;
    }
}

export interface IBulkSetSuggestedBlendingCircleSubgroupsInput {
    ids: number[] | undefined;
    projectId: number;
    overwriteExisting: boolean;
    confirmSuggested: boolean;
    alignWithJurisdiction: boolean;
}

export class BulkToggleConfirmationInput implements IBulkToggleConfirmationInput {
    ids!: number[] | undefined;
    projectId!: number;
    isConfirmed!: boolean;

    constructor(data?: IBulkToggleConfirmationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.projectId = _data["projectId"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): BulkToggleConfirmationInput {
        data = typeof data === 'object' ? data : {};
        let result = new BulkToggleConfirmationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["projectId"] = this.projectId;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IBulkToggleConfirmationInput {
    ids: number[] | undefined;
    projectId: number;
    isConfirmed: boolean;
}

export class BulkUpdateAccessManagementInput implements IBulkUpdateAccessManagementInput {
    projectId!: number;
    isReadingActivated!: boolean;
    readingCountryCodeInherited!: string | undefined;
    readingUsersAndOrganizationUnits!: UserOrOrganizationUnitInput[] | undefined;
    isWritingActivated!: boolean;
    writingCountryCodeInherited!: string | undefined;
    writingUsersAndOrganizationUnits!: UserOrOrganizationUnitInput[] | undefined;
    organizationalEntityIds!: number[] | undefined;
    countryCodes!: string[] | undefined;

    constructor(data?: IBulkUpdateAccessManagementInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.isReadingActivated = _data["isReadingActivated"];
            this.readingCountryCodeInherited = _data["readingCountryCodeInherited"];
            if (Array.isArray(_data["readingUsersAndOrganizationUnits"])) {
                this.readingUsersAndOrganizationUnits = [] as any;
                for (let item of _data["readingUsersAndOrganizationUnits"])
                    this.readingUsersAndOrganizationUnits!.push(UserOrOrganizationUnitInput.fromJS(item));
            }
            this.isWritingActivated = _data["isWritingActivated"];
            this.writingCountryCodeInherited = _data["writingCountryCodeInherited"];
            if (Array.isArray(_data["writingUsersAndOrganizationUnits"])) {
                this.writingUsersAndOrganizationUnits = [] as any;
                for (let item of _data["writingUsersAndOrganizationUnits"])
                    this.writingUsersAndOrganizationUnits!.push(UserOrOrganizationUnitInput.fromJS(item));
            }
            if (Array.isArray(_data["organizationalEntityIds"])) {
                this.organizationalEntityIds = [] as any;
                for (let item of _data["organizationalEntityIds"])
                    this.organizationalEntityIds!.push(item);
            }
            if (Array.isArray(_data["countryCodes"])) {
                this.countryCodes = [] as any;
                for (let item of _data["countryCodes"])
                    this.countryCodes!.push(item);
            }
        }
    }

    static fromJS(data: any): BulkUpdateAccessManagementInput {
        data = typeof data === 'object' ? data : {};
        let result = new BulkUpdateAccessManagementInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["isReadingActivated"] = this.isReadingActivated;
        data["readingCountryCodeInherited"] = this.readingCountryCodeInherited;
        if (Array.isArray(this.readingUsersAndOrganizationUnits)) {
            data["readingUsersAndOrganizationUnits"] = [];
            for (let item of this.readingUsersAndOrganizationUnits)
                data["readingUsersAndOrganizationUnits"].push(item.toJSON());
        }
        data["isWritingActivated"] = this.isWritingActivated;
        data["writingCountryCodeInherited"] = this.writingCountryCodeInherited;
        if (Array.isArray(this.writingUsersAndOrganizationUnits)) {
            data["writingUsersAndOrganizationUnits"] = [];
            for (let item of this.writingUsersAndOrganizationUnits)
                data["writingUsersAndOrganizationUnits"].push(item.toJSON());
        }
        if (Array.isArray(this.organizationalEntityIds)) {
            data["organizationalEntityIds"] = [];
            for (let item of this.organizationalEntityIds)
                data["organizationalEntityIds"].push(item);
        }
        if (Array.isArray(this.countryCodes)) {
            data["countryCodes"] = [];
            for (let item of this.countryCodes)
                data["countryCodes"].push(item);
        }
        return data;
    }
}

export interface IBulkUpdateAccessManagementInput {
    projectId: number;
    isReadingActivated: boolean;
    readingCountryCodeInherited: string | undefined;
    readingUsersAndOrganizationUnits: UserOrOrganizationUnitInput[] | undefined;
    isWritingActivated: boolean;
    writingCountryCodeInherited: string | undefined;
    writingUsersAndOrganizationUnits: UserOrOrganizationUnitInput[] | undefined;
    organizationalEntityIds: number[] | undefined;
    countryCodes: string[] | undefined;
}

export class BulkUpdateFinancialValuePointInput implements IBulkUpdateFinancialValuePointInput {
    projectId!: number;
    safeHarbourGroupId!: number | undefined;
    safeHarbourGroupType!: SafeHarbourGroupType | undefined;
    blendingCircleSubgroupCountryName!: string | undefined;
    blendingCircleSubgroupId!: number | undefined;
    organizationalEntityId!: number | undefined;
    comment!: string | undefined;
    isConfirmed!: boolean;
    traces!: FinancialValuePointWithFlatValueInput[] | undefined;

    constructor(data?: IBulkUpdateFinancialValuePointInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.safeHarbourGroupId = _data["safeHarbourGroupId"];
            this.safeHarbourGroupType = _data["safeHarbourGroupType"];
            this.blendingCircleSubgroupCountryName = _data["blendingCircleSubgroupCountryName"];
            this.blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.comment = _data["comment"];
            this.isConfirmed = _data["isConfirmed"];
            if (Array.isArray(_data["traces"])) {
                this.traces = [] as any;
                for (let item of _data["traces"])
                    this.traces!.push(FinancialValuePointWithFlatValueInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BulkUpdateFinancialValuePointInput {
        data = typeof data === 'object' ? data : {};
        let result = new BulkUpdateFinancialValuePointInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["safeHarbourGroupId"] = this.safeHarbourGroupId;
        data["safeHarbourGroupType"] = this.safeHarbourGroupType;
        data["blendingCircleSubgroupCountryName"] = this.blendingCircleSubgroupCountryName;
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["comment"] = this.comment;
        data["isConfirmed"] = this.isConfirmed;
        if (Array.isArray(this.traces)) {
            data["traces"] = [];
            for (let item of this.traces)
                data["traces"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBulkUpdateFinancialValuePointInput {
    projectId: number;
    safeHarbourGroupId: number | undefined;
    safeHarbourGroupType: SafeHarbourGroupType | undefined;
    blendingCircleSubgroupCountryName: string | undefined;
    blendingCircleSubgroupId: number | undefined;
    organizationalEntityId: number | undefined;
    comment: string | undefined;
    isConfirmed: boolean;
    traces: FinancialValuePointWithFlatValueInput[] | undefined;
}

export class BulkUpdateUtprDataPointsConfirmationInput implements IBulkUpdateUtprDataPointsConfirmationInput {
    projectId!: number;
    jurisdictionId!: number;
    comment!: string | undefined;
    isConfirmed!: boolean;

    constructor(data?: IBulkUpdateUtprDataPointsConfirmationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.jurisdictionId = _data["jurisdictionId"];
            this.comment = _data["comment"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): BulkUpdateUtprDataPointsConfirmationInput {
        data = typeof data === 'object' ? data : {};
        let result = new BulkUpdateUtprDataPointsConfirmationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["jurisdictionId"] = this.jurisdictionId;
        data["comment"] = this.comment;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IBulkUpdateUtprDataPointsConfirmationInput {
    projectId: number;
    jurisdictionId: number;
    comment: string | undefined;
    isConfirmed: boolean;
}

export class CalculateFinalFiscalYearAverageShiftDataInput implements ICalculateFinalFiscalYearAverageShiftDataInput {
    projectId!: number;
    organizationalEntityId!: number;
    targetOrganizationalEntityId!: number | undefined;
    pointId!: number | undefined;
    financialType!: FinancialShiftType;
    fiscalYearBeginning!: string | undefined;
    fiscalYearEnd!: string | undefined;
    financialTreeType!: FinancialTreeType;

    constructor(data?: ICalculateFinalFiscalYearAverageShiftDataInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.targetOrganizationalEntityId = _data["targetOrganizationalEntityId"];
            this.pointId = _data["pointId"];
            this.financialType = _data["financialType"];
            this.fiscalYearBeginning = _data["fiscalYearBeginning"];
            this.fiscalYearEnd = _data["fiscalYearEnd"];
            this.financialTreeType = _data["financialTreeType"];
        }
    }

    static fromJS(data: any): CalculateFinalFiscalYearAverageShiftDataInput {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateFinalFiscalYearAverageShiftDataInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["targetOrganizationalEntityId"] = this.targetOrganizationalEntityId;
        data["pointId"] = this.pointId;
        data["financialType"] = this.financialType;
        data["fiscalYearBeginning"] = this.fiscalYearBeginning;
        data["fiscalYearEnd"] = this.fiscalYearEnd;
        data["financialTreeType"] = this.financialTreeType;
        return data;
    }
}

export interface ICalculateFinalFiscalYearAverageShiftDataInput {
    projectId: number;
    organizationalEntityId: number;
    targetOrganizationalEntityId: number | undefined;
    pointId: number | undefined;
    financialType: FinancialShiftType;
    fiscalYearBeginning: string | undefined;
    fiscalYearEnd: string | undefined;
    financialTreeType: FinancialTreeType;
}

export class CalculateFinalFiscalYearAverageValueDataInput implements ICalculateFinalFiscalYearAverageValueDataInput {
    projectId!: number;
    organizationalEntityId!: number;
    pointId!: number | undefined;
    financialTreeType!: FinancialTreeType;
    financialType!: FinancialValueType;
    fiscalYearBeginning!: string | undefined;
    fiscalYearEnd!: string | undefined;
    percentageRateOfLocationTimeInJurisdiction!: string | undefined;
    proRataTemporis!: string | undefined;

    constructor(data?: ICalculateFinalFiscalYearAverageValueDataInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.pointId = _data["pointId"];
            this.financialTreeType = _data["financialTreeType"];
            this.financialType = _data["financialType"];
            this.fiscalYearBeginning = _data["fiscalYearBeginning"];
            this.fiscalYearEnd = _data["fiscalYearEnd"];
            this.percentageRateOfLocationTimeInJurisdiction = _data["percentageRateOfLocationTimeInJurisdiction"];
            this.proRataTemporis = _data["proRataTemporis"];
        }
    }

    static fromJS(data: any): CalculateFinalFiscalYearAverageValueDataInput {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateFinalFiscalYearAverageValueDataInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["pointId"] = this.pointId;
        data["financialTreeType"] = this.financialTreeType;
        data["financialType"] = this.financialType;
        data["fiscalYearBeginning"] = this.fiscalYearBeginning;
        data["fiscalYearEnd"] = this.fiscalYearEnd;
        data["percentageRateOfLocationTimeInJurisdiction"] = this.percentageRateOfLocationTimeInJurisdiction;
        data["proRataTemporis"] = this.proRataTemporis;
        return data;
    }
}

export interface ICalculateFinalFiscalYearAverageValueDataInput {
    projectId: number;
    organizationalEntityId: number;
    pointId: number | undefined;
    financialTreeType: FinancialTreeType;
    financialType: FinancialValueType;
    fiscalYearBeginning: string | undefined;
    fiscalYearEnd: string | undefined;
    percentageRateOfLocationTimeInJurisdiction: string | undefined;
    proRataTemporis: string | undefined;
}

export class CalculateNonEligibleEmployeeCostsValueDataInput implements ICalculateNonEligibleEmployeeCostsValueDataInput {
    projectId!: number;
    organizationalEntityId!: number;
    pointId!: number | undefined;
    financialTreeType!: FinancialTreeType;
    financialType!: FinancialValueType;
    nonEligibleEmployeeCostsPreliminary!: string | undefined;
    percentageRateWorkingTimeInJurisdiction!: string | undefined;

    constructor(data?: ICalculateNonEligibleEmployeeCostsValueDataInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.pointId = _data["pointId"];
            this.financialTreeType = _data["financialTreeType"];
            this.financialType = _data["financialType"];
            this.nonEligibleEmployeeCostsPreliminary = _data["nonEligibleEmployeeCostsPreliminary"];
            this.percentageRateWorkingTimeInJurisdiction = _data["percentageRateWorkingTimeInJurisdiction"];
        }
    }

    static fromJS(data: any): CalculateNonEligibleEmployeeCostsValueDataInput {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateNonEligibleEmployeeCostsValueDataInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["pointId"] = this.pointId;
        data["financialTreeType"] = this.financialTreeType;
        data["financialType"] = this.financialType;
        data["nonEligibleEmployeeCostsPreliminary"] = this.nonEligibleEmployeeCostsPreliminary;
        data["percentageRateWorkingTimeInJurisdiction"] = this.percentageRateWorkingTimeInJurisdiction;
        return data;
    }
}

export interface ICalculateNonEligibleEmployeeCostsValueDataInput {
    projectId: number;
    organizationalEntityId: number;
    pointId: number | undefined;
    financialTreeType: FinancialTreeType;
    financialType: FinancialValueType;
    nonEligibleEmployeeCostsPreliminary: string | undefined;
    percentageRateWorkingTimeInJurisdiction: string | undefined;
}

export class ChancelleryClientDto implements IChancelleryClientDto {
    clientNumber!: string | undefined;
    clientName!: string | undefined;

    constructor(data?: IChancelleryClientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientNumber = _data["clientNumber"];
            this.clientName = _data["clientName"];
        }
    }

    static fromJS(data: any): ChancelleryClientDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChancelleryClientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientNumber"] = this.clientNumber;
        data["clientName"] = this.clientName;
        return data;
    }
}

export interface IChancelleryClientDto {
    clientNumber: string | undefined;
    clientName: string | undefined;
}

export class ChancelleryDetailsDto implements IChancelleryDetailsDto {
    clientNumber!: string | undefined;
    clientName!: string | undefined;
    projectNumber!: string | undefined;
    projectName!: string | undefined;

    constructor(data?: IChancelleryDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientNumber = _data["clientNumber"];
            this.clientName = _data["clientName"];
            this.projectNumber = _data["projectNumber"];
            this.projectName = _data["projectName"];
        }
    }

    static fromJS(data: any): ChancelleryDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChancelleryDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientNumber"] = this.clientNumber;
        data["clientName"] = this.clientName;
        data["projectNumber"] = this.projectNumber;
        data["projectName"] = this.projectName;
        return data;
    }
}

export interface IChancelleryDetailsDto {
    clientNumber: string | undefined;
    clientName: string | undefined;
    projectNumber: string | undefined;
    projectName: string | undefined;
}

export class ChancelleryDetailsInput implements IChancelleryDetailsInput {
    clientNumber!: string | undefined;
    clientName!: string | undefined;
    projectNumber!: string | undefined;
    projectName!: string | undefined;

    constructor(data?: IChancelleryDetailsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientNumber = _data["clientNumber"];
            this.clientName = _data["clientName"];
            this.projectNumber = _data["projectNumber"];
            this.projectName = _data["projectName"];
        }
    }

    static fromJS(data: any): ChancelleryDetailsInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChancelleryDetailsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientNumber"] = this.clientNumber;
        data["clientName"] = this.clientName;
        data["projectNumber"] = this.projectNumber;
        data["projectName"] = this.projectName;
        return data;
    }
}

export interface IChancelleryDetailsInput {
    clientNumber: string | undefined;
    clientName: string | undefined;
    projectNumber: string | undefined;
    projectName: string | undefined;
}

export class ChancelleryProjectDto implements IChancelleryProjectDto {
    projectNumber!: string | undefined;
    projectName!: string | undefined;

    constructor(data?: IChancelleryProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectNumber = _data["projectNumber"];
            this.projectName = _data["projectName"];
        }
    }

    static fromJS(data: any): ChancelleryProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChancelleryProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectNumber"] = this.projectNumber;
        data["projectName"] = this.projectName;
        return data;
    }
}

export interface IChancelleryProjectDto {
    projectNumber: string | undefined;
    projectName: string | undefined;
}

export class ChancelleryViewAdminSettings implements IChancelleryViewAdminSettings {
    isChancelleryViewActive!: boolean;
    chancelleryViewClientsEndpointUrl!: string | undefined;
    chancelleryViewProjectsEndpointUrl!: string | undefined;
    chancelleryViewUsername!: string | undefined;
    chancelleryViewPassword!: string | undefined;
    chancelleryViewIsClientRequired!: boolean;
    chancelleryViewIsProjectRequired!: boolean;

    constructor(data?: IChancelleryViewAdminSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isChancelleryViewActive = _data["isChancelleryViewActive"];
            this.chancelleryViewClientsEndpointUrl = _data["chancelleryViewClientsEndpointUrl"];
            this.chancelleryViewProjectsEndpointUrl = _data["chancelleryViewProjectsEndpointUrl"];
            this.chancelleryViewUsername = _data["chancelleryViewUsername"];
            this.chancelleryViewPassword = _data["chancelleryViewPassword"];
            this.chancelleryViewIsClientRequired = _data["chancelleryViewIsClientRequired"];
            this.chancelleryViewIsProjectRequired = _data["chancelleryViewIsProjectRequired"];
        }
    }

    static fromJS(data: any): ChancelleryViewAdminSettings {
        data = typeof data === 'object' ? data : {};
        let result = new ChancelleryViewAdminSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isChancelleryViewActive"] = this.isChancelleryViewActive;
        data["chancelleryViewClientsEndpointUrl"] = this.chancelleryViewClientsEndpointUrl;
        data["chancelleryViewProjectsEndpointUrl"] = this.chancelleryViewProjectsEndpointUrl;
        data["chancelleryViewUsername"] = this.chancelleryViewUsername;
        data["chancelleryViewPassword"] = this.chancelleryViewPassword;
        data["chancelleryViewIsClientRequired"] = this.chancelleryViewIsClientRequired;
        data["chancelleryViewIsProjectRequired"] = this.chancelleryViewIsProjectRequired;
        return data;
    }
}

export interface IChancelleryViewAdminSettings {
    isChancelleryViewActive: boolean;
    chancelleryViewClientsEndpointUrl: string | undefined;
    chancelleryViewProjectsEndpointUrl: string | undefined;
    chancelleryViewUsername: string | undefined;
    chancelleryViewPassword: string | undefined;
    chancelleryViewIsClientRequired: boolean;
    chancelleryViewIsProjectRequired: boolean;
}

export class ChangeSwitchOffStatusInput implements IChangeSwitchOffStatusInput {
    projectId!: number;
    blendingCircleSubgroupId!: number;
    isEnabled!: boolean;

    constructor(data?: IChangeSwitchOffStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): ChangeSwitchOffStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeSwitchOffStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IChangeSwitchOffStatusInput {
    projectId: number;
    blendingCircleSubgroupId: number;
    isEnabled: boolean;
}

export class ChannelOverviewDto implements IChannelOverviewDto {
    id!: number;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    title!: string | undefined;
    isRead!: boolean;
    countryCode!: string | undefined;
    entityId!: number;

    constructor(data?: IChannelOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.isRead = _data["isRead"];
            this.countryCode = _data["countryCode"];
            this.entityId = _data["entityId"];
        }
    }

    static fromJS(data: any): ChannelOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["title"] = this.title;
        data["isRead"] = this.isRead;
        data["countryCode"] = this.countryCode;
        data["entityId"] = this.entityId;
        return data;
    }
}

export interface IChannelOverviewDto {
    id: number;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    title: string | undefined;
    isRead: boolean;
    countryCode: string | undefined;
    entityId: number;
}

export class CheckEntityWithTheOwnersJurisdictionInput implements ICheckEntityWithTheOwnersJurisdictionInput {
    projectId!: number;
    organizationalEntityId!: number;
    gloBEStatus!: ConfirmableInputOfListOfGloBEStatus | undefined;
    organizationalEntityShareholders!: OrganizationalEntityShareholderInput[] | undefined;
    taxJurisdictionCountry!: ConfirmableInputOfString | undefined;

    constructor(data?: ICheckEntityWithTheOwnersJurisdictionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.gloBEStatus = _data["gloBEStatus"] ? ConfirmableInputOfListOfGloBEStatus.fromJS(_data["gloBEStatus"]) : <any>undefined;
            if (Array.isArray(_data["organizationalEntityShareholders"])) {
                this.organizationalEntityShareholders = [] as any;
                for (let item of _data["organizationalEntityShareholders"])
                    this.organizationalEntityShareholders!.push(OrganizationalEntityShareholderInput.fromJS(item));
            }
            this.taxJurisdictionCountry = _data["taxJurisdictionCountry"] ? ConfirmableInputOfString.fromJS(_data["taxJurisdictionCountry"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CheckEntityWithTheOwnersJurisdictionInput {
        data = typeof data === 'object' ? data : {};
        let result = new CheckEntityWithTheOwnersJurisdictionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["gloBEStatus"] = this.gloBEStatus ? this.gloBEStatus.toJSON() : <any>undefined;
        if (Array.isArray(this.organizationalEntityShareholders)) {
            data["organizationalEntityShareholders"] = [];
            for (let item of this.organizationalEntityShareholders)
                data["organizationalEntityShareholders"].push(item.toJSON());
        }
        data["taxJurisdictionCountry"] = this.taxJurisdictionCountry ? this.taxJurisdictionCountry.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICheckEntityWithTheOwnersJurisdictionInput {
    projectId: number;
    organizationalEntityId: number;
    gloBEStatus: ConfirmableInputOfListOfGloBEStatus | undefined;
    organizationalEntityShareholders: OrganizationalEntityShareholderInput[] | undefined;
    taxJurisdictionCountry: ConfirmableInputOfString | undefined;
}

export class CheckIfQdmttApplicableDto implements ICheckIfQdmttApplicableDto {
    canChangeDirectionType!: boolean;
    qdmttNotApplicableForPair!: boolean;

    constructor(data?: ICheckIfQdmttApplicableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canChangeDirectionType = _data["canChangeDirectionType"];
            this.qdmttNotApplicableForPair = _data["qdmttNotApplicableForPair"];
        }
    }

    static fromJS(data: any): CheckIfQdmttApplicableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckIfQdmttApplicableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canChangeDirectionType"] = this.canChangeDirectionType;
        data["qdmttNotApplicableForPair"] = this.qdmttNotApplicableForPair;
        return data;
    }
}

export interface ICheckIfQdmttApplicableDto {
    canChangeDirectionType: boolean;
    qdmttNotApplicableForPair: boolean;
}

export enum CheckResultStatus {
    Passed = 0,
    Failed = 1,
    NotComputable = 2,
    NotRequired = 3,
}

export class CombinedDataPointInput implements ICombinedDataPointInput {
    projectId!: number;
    organizationalEntityId!: number;
    financialNodeGroupType!: FinancialNodeGroupType | undefined;
    multipleNodeGroupId!: number | undefined;
    childInvestmentEntityId!: number | undefined;
    value!: string | undefined;
    valueAccordingToFinancialStatements!: string | undefined;
    disposingJurisdiction!: string | undefined;
    taxPaidInRespectOfTheTransaction!: string | undefined;
    netDeferredTaxAsset!: string | undefined;
    globeCarryingValue!: string | undefined;
    netDeferredTaxAssetYearBeginning!: string | undefined;
    deemedDistribution!: string | undefined;
    thereofAlreadyIncludedInGlobeIncomeComputation!: string | undefined;
    localCreditableTaxGrossup!: string | undefined;
    isConfirmed!: boolean;
    comment!: string | undefined;
    notes!: string | undefined;
    financialTreeType!: FinancialTreeType;
    financialCombinedType!: FinancialCombinedType;

    constructor(data?: ICombinedDataPointInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.financialNodeGroupType = _data["financialNodeGroupType"];
            this.multipleNodeGroupId = _data["multipleNodeGroupId"];
            this.childInvestmentEntityId = _data["childInvestmentEntityId"];
            this.value = _data["value"];
            this.valueAccordingToFinancialStatements = _data["valueAccordingToFinancialStatements"];
            this.disposingJurisdiction = _data["disposingJurisdiction"];
            this.taxPaidInRespectOfTheTransaction = _data["taxPaidInRespectOfTheTransaction"];
            this.netDeferredTaxAsset = _data["netDeferredTaxAsset"];
            this.globeCarryingValue = _data["globeCarryingValue"];
            this.netDeferredTaxAssetYearBeginning = _data["netDeferredTaxAssetYearBeginning"];
            this.deemedDistribution = _data["deemedDistribution"];
            this.thereofAlreadyIncludedInGlobeIncomeComputation = _data["thereofAlreadyIncludedInGlobeIncomeComputation"];
            this.localCreditableTaxGrossup = _data["localCreditableTaxGrossup"];
            this.isConfirmed = _data["isConfirmed"];
            this.comment = _data["comment"];
            this.notes = _data["notes"];
            this.financialTreeType = _data["financialTreeType"];
            this.financialCombinedType = _data["financialCombinedType"];
        }
    }

    static fromJS(data: any): CombinedDataPointInput {
        data = typeof data === 'object' ? data : {};
        let result = new CombinedDataPointInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["financialNodeGroupType"] = this.financialNodeGroupType;
        data["multipleNodeGroupId"] = this.multipleNodeGroupId;
        data["childInvestmentEntityId"] = this.childInvestmentEntityId;
        data["value"] = this.value;
        data["valueAccordingToFinancialStatements"] = this.valueAccordingToFinancialStatements;
        data["disposingJurisdiction"] = this.disposingJurisdiction;
        data["taxPaidInRespectOfTheTransaction"] = this.taxPaidInRespectOfTheTransaction;
        data["netDeferredTaxAsset"] = this.netDeferredTaxAsset;
        data["globeCarryingValue"] = this.globeCarryingValue;
        data["netDeferredTaxAssetYearBeginning"] = this.netDeferredTaxAssetYearBeginning;
        data["deemedDistribution"] = this.deemedDistribution;
        data["thereofAlreadyIncludedInGlobeIncomeComputation"] = this.thereofAlreadyIncludedInGlobeIncomeComputation;
        data["localCreditableTaxGrossup"] = this.localCreditableTaxGrossup;
        data["isConfirmed"] = this.isConfirmed;
        data["comment"] = this.comment;
        data["notes"] = this.notes;
        data["financialTreeType"] = this.financialTreeType;
        data["financialCombinedType"] = this.financialCombinedType;
        return data;
    }
}

export interface ICombinedDataPointInput {
    projectId: number;
    organizationalEntityId: number;
    financialNodeGroupType: FinancialNodeGroupType | undefined;
    multipleNodeGroupId: number | undefined;
    childInvestmentEntityId: number | undefined;
    value: string | undefined;
    valueAccordingToFinancialStatements: string | undefined;
    disposingJurisdiction: string | undefined;
    taxPaidInRespectOfTheTransaction: string | undefined;
    netDeferredTaxAsset: string | undefined;
    globeCarryingValue: string | undefined;
    netDeferredTaxAssetYearBeginning: string | undefined;
    deemedDistribution: string | undefined;
    thereofAlreadyIncludedInGlobeIncomeComputation: string | undefined;
    localCreditableTaxGrossup: string | undefined;
    isConfirmed: boolean;
    comment: string | undefined;
    notes: string | undefined;
    financialTreeType: FinancialTreeType;
    financialCombinedType: FinancialCombinedType;
}

export class CommunicationDto implements ICommunicationDto {
    id!: number;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    referenceId!: number;
    content!: string | undefined;
    hasOriginalMailSourceCode!: boolean;
    userDetails!: UserDetailsDto[] | undefined;

    constructor(data?: ICommunicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.referenceId = _data["referenceId"];
            this.content = _data["content"];
            this.hasOriginalMailSourceCode = _data["hasOriginalMailSourceCode"];
            if (Array.isArray(_data["userDetails"])) {
                this.userDetails = [] as any;
                for (let item of _data["userDetails"])
                    this.userDetails!.push(UserDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CommunicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["referenceId"] = this.referenceId;
        data["content"] = this.content;
        data["hasOriginalMailSourceCode"] = this.hasOriginalMailSourceCode;
        if (Array.isArray(this.userDetails)) {
            data["userDetails"] = [];
            for (let item of this.userDetails)
                data["userDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICommunicationDto {
    id: number;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    referenceId: number;
    content: string | undefined;
    hasOriginalMailSourceCode: boolean;
    userDetails: UserDetailsDto[] | undefined;
}

export class CommunicationsFilterRequest implements ICommunicationsFilterRequest {
    referenceId!: number;
    filter!: string | undefined;

    constructor(data?: ICommunicationsFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referenceId = _data["referenceId"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): CommunicationsFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationsFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceId"] = this.referenceId;
        data["filter"] = this.filter;
        return data;
    }
}

export interface ICommunicationsFilterRequest {
    referenceId: number;
    filter: string | undefined;
}

export class CompareProjectsToExcelInput implements ICompareProjectsToExcelInput {
    projectIds!: number[] | undefined;

    constructor(data?: ICompareProjectsToExcelInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projectIds"])) {
                this.projectIds = [] as any;
                for (let item of _data["projectIds"])
                    this.projectIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CompareProjectsToExcelInput {
        data = typeof data === 'object' ? data : {};
        let result = new CompareProjectsToExcelInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projectIds)) {
            data["projectIds"] = [];
            for (let item of this.projectIds)
                data["projectIds"].push(item);
        }
        return data;
    }
}

export interface ICompareProjectsToExcelInput {
    projectIds: number[] | undefined;
}

export class ConfirmableDtoOfFinancialValueDto implements IConfirmableDtoOfFinancialValueDto {
    value!: FinancialValueDto | undefined;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableDtoOfFinancialValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? FinancialValueDto.fromJS(_data["value"]) : <any>undefined;
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableDtoOfFinancialValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableDtoOfFinancialValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableDtoOfFinancialValueDto {
    value: FinancialValueDto | undefined;
    isConfirmed: boolean;
}

export class ConfirmableDtoOfIListOfGloBEStatus implements IConfirmableDtoOfIListOfGloBEStatus {
    value!: GloBEStatus[] | undefined;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableDtoOfIListOfGloBEStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(item);
            }
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableDtoOfIListOfGloBEStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableDtoOfIListOfGloBEStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableDtoOfIListOfGloBEStatus {
    value: GloBEStatus[] | undefined;
    isConfirmed: boolean;
}

export class ConfirmableDtoOfInt64 implements IConfirmableDtoOfInt64 {
    value!: number;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableDtoOfInt64) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableDtoOfInt64 {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableDtoOfInt64();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableDtoOfInt64 {
    value: number;
    isConfirmed: boolean;
}

export class ConfirmableDtoOfNullableOfBoolean implements IConfirmableDtoOfNullableOfBoolean {
    value!: boolean | undefined;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableDtoOfNullableOfBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableDtoOfNullableOfBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableDtoOfNullableOfBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableDtoOfNullableOfBoolean {
    value: boolean | undefined;
    isConfirmed: boolean;
}

export class ConfirmableDtoOfNullableOfConsolidationMethod implements IConfirmableDtoOfNullableOfConsolidationMethod {
    value!: ConsolidationMethod | undefined;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableDtoOfNullableOfConsolidationMethod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableDtoOfNullableOfConsolidationMethod {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableDtoOfNullableOfConsolidationMethod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableDtoOfNullableOfConsolidationMethod {
    value: ConsolidationMethod | undefined;
    isConfirmed: boolean;
}

export class ConfirmableDtoOfNullableOfCorporateShareholderExcludedType implements IConfirmableDtoOfNullableOfCorporateShareholderExcludedType {
    value!: CorporateShareholderExcludedType | undefined;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableDtoOfNullableOfCorporateShareholderExcludedType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableDtoOfNullableOfCorporateShareholderExcludedType {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableDtoOfNullableOfCorporateShareholderExcludedType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableDtoOfNullableOfCorporateShareholderExcludedType {
    value: CorporateShareholderExcludedType | undefined;
    isConfirmed: boolean;
}

export class ConfirmableDtoOfNullableOfDecimal implements IConfirmableDtoOfNullableOfDecimal {
    value!: number | undefined;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableDtoOfNullableOfDecimal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableDtoOfNullableOfDecimal {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableDtoOfNullableOfDecimal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableDtoOfNullableOfDecimal {
    value: number | undefined;
    isConfirmed: boolean;
}

export class ConfirmableDtoOfNullableOfEligibilityReductionType implements IConfirmableDtoOfNullableOfEligibilityReductionType {
    value!: EligibilityReductionType | undefined;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableDtoOfNullableOfEligibilityReductionType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableDtoOfNullableOfEligibilityReductionType {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableDtoOfNullableOfEligibilityReductionType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableDtoOfNullableOfEligibilityReductionType {
    value: EligibilityReductionType | undefined;
    isConfirmed: boolean;
}

export class ConfirmableDtoOfNullableOfInt32 implements IConfirmableDtoOfNullableOfInt32 {
    value!: number | undefined;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableDtoOfNullableOfInt32) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableDtoOfNullableOfInt32 {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableDtoOfNullableOfInt32();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableDtoOfNullableOfInt32 {
    value: number | undefined;
    isConfirmed: boolean;
}

export class ConfirmableDtoOfNullableOfInt64 implements IConfirmableDtoOfNullableOfInt64 {
    value!: number | undefined;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableDtoOfNullableOfInt64) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableDtoOfNullableOfInt64 {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableDtoOfNullableOfInt64();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableDtoOfNullableOfInt64 {
    value: number | undefined;
    isConfirmed: boolean;
}

export class ConfirmableDtoOfNullableOfInvestmentElectionType implements IConfirmableDtoOfNullableOfInvestmentElectionType {
    value!: InvestmentElectionType | undefined;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableDtoOfNullableOfInvestmentElectionType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableDtoOfNullableOfInvestmentElectionType {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableDtoOfNullableOfInvestmentElectionType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableDtoOfNullableOfInvestmentElectionType {
    value: InvestmentElectionType | undefined;
    isConfirmed: boolean;
}

export class ConfirmableDtoOfNullableOfOrganizationalEntityExcludedType implements IConfirmableDtoOfNullableOfOrganizationalEntityExcludedType {
    value!: OrganizationalEntityExcludedType | undefined;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableDtoOfNullableOfOrganizationalEntityExcludedType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableDtoOfNullableOfOrganizationalEntityExcludedType {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableDtoOfNullableOfOrganizationalEntityExcludedType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableDtoOfNullableOfOrganizationalEntityExcludedType {
    value: OrganizationalEntityExcludedType | undefined;
    isConfirmed: boolean;
}

export class ConfirmableDtoOfNullableOfTaxTreatment implements IConfirmableDtoOfNullableOfTaxTreatment {
    value!: TaxTreatment | undefined;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableDtoOfNullableOfTaxTreatment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableDtoOfNullableOfTaxTreatment {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableDtoOfNullableOfTaxTreatment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableDtoOfNullableOfTaxTreatment {
    value: TaxTreatment | undefined;
    isConfirmed: boolean;
}

export class ConfirmableDtoOfNullableOfTinType implements IConfirmableDtoOfNullableOfTinType {
    value!: TinType | undefined;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableDtoOfNullableOfTinType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableDtoOfNullableOfTinType {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableDtoOfNullableOfTinType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableDtoOfNullableOfTinType {
    value: TinType | undefined;
    isConfirmed: boolean;
}

export class ConfirmableDtoOfString implements IConfirmableDtoOfString {
    value!: string | undefined;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableDtoOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableDtoOfString {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableDtoOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableDtoOfString {
    value: string | undefined;
    isConfirmed: boolean;
}

export class ConfirmableInputOfIListOfGloBEStatus implements IConfirmableInputOfIListOfGloBEStatus {
    value!: GloBEStatus[] | undefined;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableInputOfIListOfGloBEStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(item);
            }
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableInputOfIListOfGloBEStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableInputOfIListOfGloBEStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableInputOfIListOfGloBEStatus {
    value: GloBEStatus[] | undefined;
    isConfirmed: boolean;
}

export class ConfirmableInputOfListOfGloBEStatus implements IConfirmableInputOfListOfGloBEStatus {
    value!: GloBEStatus[] | undefined;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableInputOfListOfGloBEStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(item);
            }
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableInputOfListOfGloBEStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableInputOfListOfGloBEStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableInputOfListOfGloBEStatus {
    value: GloBEStatus[] | undefined;
    isConfirmed: boolean;
}

export class ConfirmableInputOfNullableOfBoolean implements IConfirmableInputOfNullableOfBoolean {
    value!: boolean | undefined;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableInputOfNullableOfBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableInputOfNullableOfBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableInputOfNullableOfBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableInputOfNullableOfBoolean {
    value: boolean | undefined;
    isConfirmed: boolean;
}

export class ConfirmableInputOfNullableOfConsolidationMethod implements IConfirmableInputOfNullableOfConsolidationMethod {
    value!: ConsolidationMethod | undefined;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableInputOfNullableOfConsolidationMethod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableInputOfNullableOfConsolidationMethod {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableInputOfNullableOfConsolidationMethod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableInputOfNullableOfConsolidationMethod {
    value: ConsolidationMethod | undefined;
    isConfirmed: boolean;
}

export class ConfirmableInputOfNullableOfCorporateShareholderExcludedType implements IConfirmableInputOfNullableOfCorporateShareholderExcludedType {
    value!: CorporateShareholderExcludedType | undefined;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableInputOfNullableOfCorporateShareholderExcludedType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableInputOfNullableOfCorporateShareholderExcludedType {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableInputOfNullableOfCorporateShareholderExcludedType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableInputOfNullableOfCorporateShareholderExcludedType {
    value: CorporateShareholderExcludedType | undefined;
    isConfirmed: boolean;
}

export class ConfirmableInputOfNullableOfDecimal implements IConfirmableInputOfNullableOfDecimal {
    value!: number | undefined;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableInputOfNullableOfDecimal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableInputOfNullableOfDecimal {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableInputOfNullableOfDecimal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableInputOfNullableOfDecimal {
    value: number | undefined;
    isConfirmed: boolean;
}

export class ConfirmableInputOfNullableOfEligibilityReductionType implements IConfirmableInputOfNullableOfEligibilityReductionType {
    value!: EligibilityReductionType | undefined;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableInputOfNullableOfEligibilityReductionType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableInputOfNullableOfEligibilityReductionType {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableInputOfNullableOfEligibilityReductionType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableInputOfNullableOfEligibilityReductionType {
    value: EligibilityReductionType | undefined;
    isConfirmed: boolean;
}

export class ConfirmableInputOfNullableOfInt32 implements IConfirmableInputOfNullableOfInt32 {
    value!: number | undefined;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableInputOfNullableOfInt32) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableInputOfNullableOfInt32 {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableInputOfNullableOfInt32();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableInputOfNullableOfInt32 {
    value: number | undefined;
    isConfirmed: boolean;
}

export class ConfirmableInputOfNullableOfInt64 implements IConfirmableInputOfNullableOfInt64 {
    value!: number | undefined;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableInputOfNullableOfInt64) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableInputOfNullableOfInt64 {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableInputOfNullableOfInt64();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableInputOfNullableOfInt64 {
    value: number | undefined;
    isConfirmed: boolean;
}

export class ConfirmableInputOfNullableOfInvestmentElectionType implements IConfirmableInputOfNullableOfInvestmentElectionType {
    value!: InvestmentElectionType | undefined;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableInputOfNullableOfInvestmentElectionType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableInputOfNullableOfInvestmentElectionType {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableInputOfNullableOfInvestmentElectionType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableInputOfNullableOfInvestmentElectionType {
    value: InvestmentElectionType | undefined;
    isConfirmed: boolean;
}

export class ConfirmableInputOfNullableOfOrganizationalEntityExcludedType implements IConfirmableInputOfNullableOfOrganizationalEntityExcludedType {
    value!: OrganizationalEntityExcludedType | undefined;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableInputOfNullableOfOrganizationalEntityExcludedType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableInputOfNullableOfOrganizationalEntityExcludedType {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableInputOfNullableOfOrganizationalEntityExcludedType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableInputOfNullableOfOrganizationalEntityExcludedType {
    value: OrganizationalEntityExcludedType | undefined;
    isConfirmed: boolean;
}

export class ConfirmableInputOfNullableOfTaxTreatment implements IConfirmableInputOfNullableOfTaxTreatment {
    value!: TaxTreatment | undefined;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableInputOfNullableOfTaxTreatment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableInputOfNullableOfTaxTreatment {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableInputOfNullableOfTaxTreatment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableInputOfNullableOfTaxTreatment {
    value: TaxTreatment | undefined;
    isConfirmed: boolean;
}

export class ConfirmableInputOfNullableOfTinType implements IConfirmableInputOfNullableOfTinType {
    value!: TinType | undefined;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableInputOfNullableOfTinType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableInputOfNullableOfTinType {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableInputOfNullableOfTinType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableInputOfNullableOfTinType {
    value: TinType | undefined;
    isConfirmed: boolean;
}

export class ConfirmableInputOfString implements IConfirmableInputOfString {
    value!: string | undefined;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableInputOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableInputOfString {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableInputOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableInputOfString {
    value: string | undefined;
    isConfirmed: boolean;
}

export enum ConsolidatedFinancialStatementsDto {
    SubparagraphA = 0,
    SubparagraphB = 1,
    SubparagraphC = 2,
    SubparagraphD = 3,
}

export enum ConsolidationMethod {
    ConsolidatingEntity = 1,
    FullConsolidation = 2,
    Proportionate = 3,
    AtEquity = 4,
    NotConsolidatedDueToMateriality = 5,
    NotConsolidatedGeneral = 6,
    NotConsolidatedHeldForSale = 7,
}

export class CorporateShareholderDto implements ICorporateShareholderDto {
    id!: number;
    organizationalEntityId!: number;
    jurisdiction!: ConfirmableDtoOfString | undefined;
    taxRate!: ConfirmableDtoOfNullableOfDecimal | undefined;
    eligibilityReductionType!: ConfirmableDtoOfNullableOfEligibilityReductionType | undefined;
    legalName!: ConfirmableDtoOfString | undefined;
    tin!: ConfirmableDtoOfString | undefined;
    tinIssuedBy!: ConfirmableDtoOfString | undefined;
    typeOfTIN!: ConfirmableDtoOfNullableOfTinType | undefined;
    ownershipPercentage!: ConfirmableDtoOfString | undefined;
    typeOfExcluded!: ConfirmableDtoOfNullableOfCorporateShareholderExcludedType | undefined;

    constructor(data?: ICorporateShareholderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.jurisdiction = _data["jurisdiction"] ? ConfirmableDtoOfString.fromJS(_data["jurisdiction"]) : <any>undefined;
            this.taxRate = _data["taxRate"] ? ConfirmableDtoOfNullableOfDecimal.fromJS(_data["taxRate"]) : <any>undefined;
            this.eligibilityReductionType = _data["eligibilityReductionType"] ? ConfirmableDtoOfNullableOfEligibilityReductionType.fromJS(_data["eligibilityReductionType"]) : <any>undefined;
            this.legalName = _data["legalName"] ? ConfirmableDtoOfString.fromJS(_data["legalName"]) : <any>undefined;
            this.tin = _data["tin"] ? ConfirmableDtoOfString.fromJS(_data["tin"]) : <any>undefined;
            this.tinIssuedBy = _data["tinIssuedBy"] ? ConfirmableDtoOfString.fromJS(_data["tinIssuedBy"]) : <any>undefined;
            this.typeOfTIN = _data["typeOfTIN"] ? ConfirmableDtoOfNullableOfTinType.fromJS(_data["typeOfTIN"]) : <any>undefined;
            this.ownershipPercentage = _data["ownershipPercentage"] ? ConfirmableDtoOfString.fromJS(_data["ownershipPercentage"]) : <any>undefined;
            this.typeOfExcluded = _data["typeOfExcluded"] ? ConfirmableDtoOfNullableOfCorporateShareholderExcludedType.fromJS(_data["typeOfExcluded"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CorporateShareholderDto {
        data = typeof data === 'object' ? data : {};
        let result = new CorporateShareholderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["jurisdiction"] = this.jurisdiction ? this.jurisdiction.toJSON() : <any>undefined;
        data["taxRate"] = this.taxRate ? this.taxRate.toJSON() : <any>undefined;
        data["eligibilityReductionType"] = this.eligibilityReductionType ? this.eligibilityReductionType.toJSON() : <any>undefined;
        data["legalName"] = this.legalName ? this.legalName.toJSON() : <any>undefined;
        data["tin"] = this.tin ? this.tin.toJSON() : <any>undefined;
        data["tinIssuedBy"] = this.tinIssuedBy ? this.tinIssuedBy.toJSON() : <any>undefined;
        data["typeOfTIN"] = this.typeOfTIN ? this.typeOfTIN.toJSON() : <any>undefined;
        data["ownershipPercentage"] = this.ownershipPercentage ? this.ownershipPercentage.toJSON() : <any>undefined;
        data["typeOfExcluded"] = this.typeOfExcluded ? this.typeOfExcluded.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICorporateShareholderDto {
    id: number;
    organizationalEntityId: number;
    jurisdiction: ConfirmableDtoOfString | undefined;
    taxRate: ConfirmableDtoOfNullableOfDecimal | undefined;
    eligibilityReductionType: ConfirmableDtoOfNullableOfEligibilityReductionType | undefined;
    legalName: ConfirmableDtoOfString | undefined;
    tin: ConfirmableDtoOfString | undefined;
    tinIssuedBy: ConfirmableDtoOfString | undefined;
    typeOfTIN: ConfirmableDtoOfNullableOfTinType | undefined;
    ownershipPercentage: ConfirmableDtoOfString | undefined;
    typeOfExcluded: ConfirmableDtoOfNullableOfCorporateShareholderExcludedType | undefined;
}

export enum CorporateShareholderExcludedType {
    No = 1,
    GovernmentalEntity = 2,
    InternationalOrganisation = 3,
    NonProfitOrganization = 4,
    PensionFund = 5,
    PensionFundThatIsNotPensionServicesEntity = 6,
}

export class CountrySpecificParamDto implements ICountrySpecificParamDto {
    name!: string | undefined;
    description!: string | undefined;

    constructor(data?: ICountrySpecificParamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CountrySpecificParamDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountrySpecificParamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface ICountrySpecificParamDto {
    name: string | undefined;
    description: string | undefined;
}

export class CreateAttachmentInput implements ICreateAttachmentInput {
    note!: string | undefined;
    dateOfAttachment!: DateTime | undefined;
    tags!: TagDto[] | undefined;
    referenceId!: number;
    type!: string;
    fileToken!: string | undefined;
    url!: string | undefined;

    constructor(data?: ICreateAttachmentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.note = _data["note"];
            this.dateOfAttachment = _data["dateOfAttachment"] ? DateTime.fromISO(_data["dateOfAttachment"].toString()) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
            this.referenceId = _data["referenceId"];
            this.type = _data["type"];
            this.fileToken = _data["fileToken"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): CreateAttachmentInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAttachmentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["note"] = this.note;
        data["dateOfAttachment"] = this.dateOfAttachment ? this.dateOfAttachment.toString() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["referenceId"] = this.referenceId;
        data["type"] = this.type;
        data["fileToken"] = this.fileToken;
        data["url"] = this.url;
        return data;
    }
}

export interface ICreateAttachmentInput {
    note: string | undefined;
    dateOfAttachment: DateTime | undefined;
    tags: TagDto[] | undefined;
    referenceId: number;
    type: string;
    fileToken: string | undefined;
    url: string | undefined;
}

export class CreateAttachmentLinkInput implements ICreateAttachmentLinkInput {
    projectId!: number;
    obligationId!: number;
    organizationalEntityId!: number | undefined;
    obligationCountry!: string | undefined;
    obligationReturnType!: ObligationReturnType;
    attachmentId!: number;
    obligationReference!: string | undefined;

    constructor(data?: ICreateAttachmentLinkInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.obligationId = _data["obligationId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.obligationCountry = _data["obligationCountry"];
            this.obligationReturnType = _data["obligationReturnType"];
            this.attachmentId = _data["attachmentId"];
            this.obligationReference = _data["obligationReference"];
        }
    }

    static fromJS(data: any): CreateAttachmentLinkInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAttachmentLinkInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["obligationId"] = this.obligationId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["obligationCountry"] = this.obligationCountry;
        data["obligationReturnType"] = this.obligationReturnType;
        data["attachmentId"] = this.attachmentId;
        data["obligationReference"] = this.obligationReference;
        return data;
    }
}

export interface ICreateAttachmentLinkInput {
    projectId: number;
    obligationId: number;
    organizationalEntityId: number | undefined;
    obligationCountry: string | undefined;
    obligationReturnType: ObligationReturnType;
    attachmentId: number;
    obligationReference: string | undefined;
}

export class CreateChannelInput implements ICreateChannelInput {
    referenceId!: number;
    title!: string | undefined;

    constructor(data?: ICreateChannelInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referenceId = _data["referenceId"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): CreateChannelInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateChannelInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceId"] = this.referenceId;
        data["title"] = this.title;
        return data;
    }
}

export interface ICreateChannelInput {
    referenceId: number;
    title: string | undefined;
}

export class CreateCommunicationInput implements ICreateCommunicationInput {
    content!: string | undefined;
    referenceId!: number;

    constructor(data?: ICreateCommunicationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"];
            this.referenceId = _data["referenceId"];
        }
    }

    static fromJS(data: any): CreateCommunicationInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCommunicationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        data["referenceId"] = this.referenceId;
        return data;
    }
}

export interface ICreateCommunicationInput {
    content: string | undefined;
    referenceId: number;
}

export class CreateCorporateShareholderInput implements ICreateCorporateShareholderInput {
    id!: number;
    organizationalEntityId!: number;
    jurisdiction!: ConfirmableInputOfString | undefined;
    taxRate!: ConfirmableInputOfNullableOfDecimal | undefined;
    eligibilityReductionType!: ConfirmableInputOfNullableOfEligibilityReductionType | undefined;
    legalName!: ConfirmableInputOfString | undefined;
    tin!: ConfirmableInputOfString | undefined;
    tinIssuedBy!: ConfirmableInputOfString | undefined;
    typeOfTIN!: ConfirmableInputOfNullableOfTinType | undefined;
    ownershipPercentage!: ConfirmableInputOfString | undefined;
    typeOfExcluded!: ConfirmableInputOfNullableOfCorporateShareholderExcludedType | undefined;

    constructor(data?: ICreateCorporateShareholderInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.jurisdiction = _data["jurisdiction"] ? ConfirmableInputOfString.fromJS(_data["jurisdiction"]) : <any>undefined;
            this.taxRate = _data["taxRate"] ? ConfirmableInputOfNullableOfDecimal.fromJS(_data["taxRate"]) : <any>undefined;
            this.eligibilityReductionType = _data["eligibilityReductionType"] ? ConfirmableInputOfNullableOfEligibilityReductionType.fromJS(_data["eligibilityReductionType"]) : <any>undefined;
            this.legalName = _data["legalName"] ? ConfirmableInputOfString.fromJS(_data["legalName"]) : <any>undefined;
            this.tin = _data["tin"] ? ConfirmableInputOfString.fromJS(_data["tin"]) : <any>undefined;
            this.tinIssuedBy = _data["tinIssuedBy"] ? ConfirmableInputOfString.fromJS(_data["tinIssuedBy"]) : <any>undefined;
            this.typeOfTIN = _data["typeOfTIN"] ? ConfirmableInputOfNullableOfTinType.fromJS(_data["typeOfTIN"]) : <any>undefined;
            this.ownershipPercentage = _data["ownershipPercentage"] ? ConfirmableInputOfString.fromJS(_data["ownershipPercentage"]) : <any>undefined;
            this.typeOfExcluded = _data["typeOfExcluded"] ? ConfirmableInputOfNullableOfCorporateShareholderExcludedType.fromJS(_data["typeOfExcluded"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateCorporateShareholderInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCorporateShareholderInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["jurisdiction"] = this.jurisdiction ? this.jurisdiction.toJSON() : <any>undefined;
        data["taxRate"] = this.taxRate ? this.taxRate.toJSON() : <any>undefined;
        data["eligibilityReductionType"] = this.eligibilityReductionType ? this.eligibilityReductionType.toJSON() : <any>undefined;
        data["legalName"] = this.legalName ? this.legalName.toJSON() : <any>undefined;
        data["tin"] = this.tin ? this.tin.toJSON() : <any>undefined;
        data["tinIssuedBy"] = this.tinIssuedBy ? this.tinIssuedBy.toJSON() : <any>undefined;
        data["typeOfTIN"] = this.typeOfTIN ? this.typeOfTIN.toJSON() : <any>undefined;
        data["ownershipPercentage"] = this.ownershipPercentage ? this.ownershipPercentage.toJSON() : <any>undefined;
        data["typeOfExcluded"] = this.typeOfExcluded ? this.typeOfExcluded.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateCorporateShareholderInput {
    id: number;
    organizationalEntityId: number;
    jurisdiction: ConfirmableInputOfString | undefined;
    taxRate: ConfirmableInputOfNullableOfDecimal | undefined;
    eligibilityReductionType: ConfirmableInputOfNullableOfEligibilityReductionType | undefined;
    legalName: ConfirmableInputOfString | undefined;
    tin: ConfirmableInputOfString | undefined;
    tinIssuedBy: ConfirmableInputOfString | undefined;
    typeOfTIN: ConfirmableInputOfNullableOfTinType | undefined;
    ownershipPercentage: ConfirmableInputOfString | undefined;
    typeOfExcluded: ConfirmableInputOfNullableOfCorporateShareholderExcludedType | undefined;
}

export class CreateFinancialShiftInput implements ICreateFinancialShiftInput {
    projectId!: number;
    value!: string | undefined;
    comment!: string | undefined;
    notes!: string | undefined;
    isConfirmed!: boolean;
    financialShiftType!: FinancialShiftType;
    targetOrganizationalEntityId!: number | undefined;
    basisForAdjustments!: BasisForAdjustmentsType | undefined;
    maxTaxRateOfMainEntityJurisdiction!: string | undefined;
    passiveIncomeOfCEOrHybridEntity!: string | undefined;
    thereofOnActiveIncome!: string | undefined;
    fiscalYearBeginning!: string | undefined;
    fiscalYearEnd!: string | undefined;
    financialTreeType!: FinancialTreeType;
    directionType!: DirectionType | undefined;
    finalValue!: string | undefined;
    sourceOrganizationalEntityId!: number;

    constructor(data?: ICreateFinancialShiftInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.value = _data["value"];
            this.comment = _data["comment"];
            this.notes = _data["notes"];
            this.isConfirmed = _data["isConfirmed"];
            this.financialShiftType = _data["financialShiftType"];
            this.targetOrganizationalEntityId = _data["targetOrganizationalEntityId"];
            this.basisForAdjustments = _data["basisForAdjustments"];
            this.maxTaxRateOfMainEntityJurisdiction = _data["maxTaxRateOfMainEntityJurisdiction"];
            this.passiveIncomeOfCEOrHybridEntity = _data["passiveIncomeOfCEOrHybridEntity"];
            this.thereofOnActiveIncome = _data["thereofOnActiveIncome"];
            this.fiscalYearBeginning = _data["fiscalYearBeginning"];
            this.fiscalYearEnd = _data["fiscalYearEnd"];
            this.financialTreeType = _data["financialTreeType"];
            this.directionType = _data["directionType"];
            this.finalValue = _data["finalValue"];
            this.sourceOrganizationalEntityId = _data["sourceOrganizationalEntityId"];
        }
    }

    static fromJS(data: any): CreateFinancialShiftInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFinancialShiftInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["value"] = this.value;
        data["comment"] = this.comment;
        data["notes"] = this.notes;
        data["isConfirmed"] = this.isConfirmed;
        data["financialShiftType"] = this.financialShiftType;
        data["targetOrganizationalEntityId"] = this.targetOrganizationalEntityId;
        data["basisForAdjustments"] = this.basisForAdjustments;
        data["maxTaxRateOfMainEntityJurisdiction"] = this.maxTaxRateOfMainEntityJurisdiction;
        data["passiveIncomeOfCEOrHybridEntity"] = this.passiveIncomeOfCEOrHybridEntity;
        data["thereofOnActiveIncome"] = this.thereofOnActiveIncome;
        data["fiscalYearBeginning"] = this.fiscalYearBeginning;
        data["fiscalYearEnd"] = this.fiscalYearEnd;
        data["financialTreeType"] = this.financialTreeType;
        data["directionType"] = this.directionType;
        data["finalValue"] = this.finalValue;
        data["sourceOrganizationalEntityId"] = this.sourceOrganizationalEntityId;
        return data;
    }
}

export interface ICreateFinancialShiftInput {
    projectId: number;
    value: string | undefined;
    comment: string | undefined;
    notes: string | undefined;
    isConfirmed: boolean;
    financialShiftType: FinancialShiftType;
    targetOrganizationalEntityId: number | undefined;
    basisForAdjustments: BasisForAdjustmentsType | undefined;
    maxTaxRateOfMainEntityJurisdiction: string | undefined;
    passiveIncomeOfCEOrHybridEntity: string | undefined;
    thereofOnActiveIncome: string | undefined;
    fiscalYearBeginning: string | undefined;
    fiscalYearEnd: string | undefined;
    financialTreeType: FinancialTreeType;
    directionType: DirectionType | undefined;
    finalValue: string | undefined;
    sourceOrganizationalEntityId: number;
}

export class CreateFinancialValueInput implements ICreateFinancialValueInput {
    projectId!: number;
    organizationalEntityId!: number | undefined;
    blendingCircleSubgroupId!: number | undefined;
    organizationalEntityUpeShareholderId!: number | undefined;
    ownerId!: number | undefined;
    assignedEntityId!: number | undefined;
    financialTreeType!: FinancialTreeType;
    financialValueType!: FinancialValueType;
    value!: string | undefined;
    isConfirmed!: boolean;
    isValueInLocalCurrency!: boolean;
    comment!: string | undefined;
    notes!: string | undefined;
    financialYear!: FinancialYearType | undefined;
    lossCarryBack!: string | undefined;
    domesticTaxRate!: string | undefined;
    nonEligibleEmployeeCostsPreliminary!: string | undefined;
    percentageRateWorkingTimeInJurisdiction!: number | undefined;
    percentageRateOfLocationTimeInJurisdiction!: number | undefined;
    proRataTemporis!: number | undefined;
    fiscalYearBeginning!: string | undefined;
    fiscalYearEnd!: string | undefined;
    proportionalReductionOfAct!: string | undefined;
    financialNodeGroupType!: FinancialNodeGroupType | undefined;
    multipleNodeGroupId!: number | undefined;
    financialValueTracePointAdditionalInput!: UpdateFinancialValueTracePointAdditionalInput | undefined;
    internationalShippingIncome!: InternationalShippingIncomeDetailInput | undefined;
    qualifiedAncillaryInternationalShippingIncome!: InternationalShippingIncomeDetailInput | undefined;

    constructor(data?: ICreateFinancialValueInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
            this.organizationalEntityUpeShareholderId = _data["organizationalEntityUpeShareholderId"];
            this.ownerId = _data["ownerId"];
            this.assignedEntityId = _data["assignedEntityId"];
            this.financialTreeType = _data["financialTreeType"];
            this.financialValueType = _data["financialValueType"];
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
            this.isValueInLocalCurrency = _data["isValueInLocalCurrency"];
            this.comment = _data["comment"];
            this.notes = _data["notes"];
            this.financialYear = _data["financialYear"];
            this.lossCarryBack = _data["lossCarryBack"];
            this.domesticTaxRate = _data["domesticTaxRate"];
            this.nonEligibleEmployeeCostsPreliminary = _data["nonEligibleEmployeeCostsPreliminary"];
            this.percentageRateWorkingTimeInJurisdiction = _data["percentageRateWorkingTimeInJurisdiction"];
            this.percentageRateOfLocationTimeInJurisdiction = _data["percentageRateOfLocationTimeInJurisdiction"];
            this.proRataTemporis = _data["proRataTemporis"];
            this.fiscalYearBeginning = _data["fiscalYearBeginning"];
            this.fiscalYearEnd = _data["fiscalYearEnd"];
            this.proportionalReductionOfAct = _data["proportionalReductionOfAct"];
            this.financialNodeGroupType = _data["financialNodeGroupType"];
            this.multipleNodeGroupId = _data["multipleNodeGroupId"];
            this.financialValueTracePointAdditionalInput = _data["financialValueTracePointAdditionalInput"] ? UpdateFinancialValueTracePointAdditionalInput.fromJS(_data["financialValueTracePointAdditionalInput"]) : <any>undefined;
            this.internationalShippingIncome = _data["internationalShippingIncome"] ? InternationalShippingIncomeDetailInput.fromJS(_data["internationalShippingIncome"]) : <any>undefined;
            this.qualifiedAncillaryInternationalShippingIncome = _data["qualifiedAncillaryInternationalShippingIncome"] ? InternationalShippingIncomeDetailInput.fromJS(_data["qualifiedAncillaryInternationalShippingIncome"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateFinancialValueInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFinancialValueInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        data["organizationalEntityUpeShareholderId"] = this.organizationalEntityUpeShareholderId;
        data["ownerId"] = this.ownerId;
        data["assignedEntityId"] = this.assignedEntityId;
        data["financialTreeType"] = this.financialTreeType;
        data["financialValueType"] = this.financialValueType;
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        data["isValueInLocalCurrency"] = this.isValueInLocalCurrency;
        data["comment"] = this.comment;
        data["notes"] = this.notes;
        data["financialYear"] = this.financialYear;
        data["lossCarryBack"] = this.lossCarryBack;
        data["domesticTaxRate"] = this.domesticTaxRate;
        data["nonEligibleEmployeeCostsPreliminary"] = this.nonEligibleEmployeeCostsPreliminary;
        data["percentageRateWorkingTimeInJurisdiction"] = this.percentageRateWorkingTimeInJurisdiction;
        data["percentageRateOfLocationTimeInJurisdiction"] = this.percentageRateOfLocationTimeInJurisdiction;
        data["proRataTemporis"] = this.proRataTemporis;
        data["fiscalYearBeginning"] = this.fiscalYearBeginning;
        data["fiscalYearEnd"] = this.fiscalYearEnd;
        data["proportionalReductionOfAct"] = this.proportionalReductionOfAct;
        data["financialNodeGroupType"] = this.financialNodeGroupType;
        data["multipleNodeGroupId"] = this.multipleNodeGroupId;
        data["financialValueTracePointAdditionalInput"] = this.financialValueTracePointAdditionalInput ? this.financialValueTracePointAdditionalInput.toJSON() : <any>undefined;
        data["internationalShippingIncome"] = this.internationalShippingIncome ? this.internationalShippingIncome.toJSON() : <any>undefined;
        data["qualifiedAncillaryInternationalShippingIncome"] = this.qualifiedAncillaryInternationalShippingIncome ? this.qualifiedAncillaryInternationalShippingIncome.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateFinancialValueInput {
    projectId: number;
    organizationalEntityId: number | undefined;
    blendingCircleSubgroupId: number | undefined;
    organizationalEntityUpeShareholderId: number | undefined;
    ownerId: number | undefined;
    assignedEntityId: number | undefined;
    financialTreeType: FinancialTreeType;
    financialValueType: FinancialValueType;
    value: string | undefined;
    isConfirmed: boolean;
    isValueInLocalCurrency: boolean;
    comment: string | undefined;
    notes: string | undefined;
    financialYear: FinancialYearType | undefined;
    lossCarryBack: string | undefined;
    domesticTaxRate: string | undefined;
    nonEligibleEmployeeCostsPreliminary: string | undefined;
    percentageRateWorkingTimeInJurisdiction: number | undefined;
    percentageRateOfLocationTimeInJurisdiction: number | undefined;
    proRataTemporis: number | undefined;
    fiscalYearBeginning: string | undefined;
    fiscalYearEnd: string | undefined;
    proportionalReductionOfAct: string | undefined;
    financialNodeGroupType: FinancialNodeGroupType | undefined;
    multipleNodeGroupId: number | undefined;
    financialValueTracePointAdditionalInput: UpdateFinancialValueTracePointAdditionalInput | undefined;
    internationalShippingIncome: InternationalShippingIncomeDetailInput | undefined;
    qualifiedAncillaryInternationalShippingIncome: InternationalShippingIncomeDetailInput | undefined;
}

export class CreateFinancialValuePointOrganizationalEntityInput implements ICreateFinancialValuePointOrganizationalEntityInput {
    projectId!: number;
    financialType!: FinancialType;
    comment!: string | undefined;
    organizationalEntityId!: number;

    constructor(data?: ICreateFinancialValuePointOrganizationalEntityInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.financialType = _data["financialType"];
            this.comment = _data["comment"];
            this.organizationalEntityId = _data["organizationalEntityId"];
        }
    }

    static fromJS(data: any): CreateFinancialValuePointOrganizationalEntityInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFinancialValuePointOrganizationalEntityInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["financialType"] = this.financialType;
        data["comment"] = this.comment;
        data["organizationalEntityId"] = this.organizationalEntityId;
        return data;
    }
}

export interface ICreateFinancialValuePointOrganizationalEntityInput {
    projectId: number;
    financialType: FinancialType;
    comment: string | undefined;
    organizationalEntityId: number;
}

export class CreateFinancialValuePointSafeHarbourGroupInput implements ICreateFinancialValuePointSafeHarbourGroupInput {
    projectId!: number;
    financialType!: FinancialType;
    comment!: string | undefined;
    blendingCircleCountry!: string | undefined;
    blendingCircleSubgroupId!: number | undefined;
    safeHarbourGroupId!: number | undefined;
    safeHarbourGroupType!: SafeHarbourGroupType;

    constructor(data?: ICreateFinancialValuePointSafeHarbourGroupInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.financialType = _data["financialType"];
            this.comment = _data["comment"];
            this.blendingCircleCountry = _data["blendingCircleCountry"];
            this.blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
            this.safeHarbourGroupId = _data["safeHarbourGroupId"];
            this.safeHarbourGroupType = _data["safeHarbourGroupType"];
        }
    }

    static fromJS(data: any): CreateFinancialValuePointSafeHarbourGroupInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFinancialValuePointSafeHarbourGroupInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["financialType"] = this.financialType;
        data["comment"] = this.comment;
        data["blendingCircleCountry"] = this.blendingCircleCountry;
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        data["safeHarbourGroupId"] = this.safeHarbourGroupId;
        data["safeHarbourGroupType"] = this.safeHarbourGroupType;
        return data;
    }
}

export interface ICreateFinancialValuePointSafeHarbourGroupInput {
    projectId: number;
    financialType: FinancialType;
    comment: string | undefined;
    blendingCircleCountry: string | undefined;
    blendingCircleSubgroupId: number | undefined;
    safeHarbourGroupId: number | undefined;
    safeHarbourGroupType: SafeHarbourGroupType;
}

export class CreateJurisdictionCommentInput implements ICreateJurisdictionCommentInput {
    referenceId!: number;
    itemId!: number;
    taxJurisdictionCountry!: string | undefined;
    content!: string | undefined;
    jurisdictionType!: JurisdictionType;

    constructor(data?: ICreateJurisdictionCommentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referenceId = _data["referenceId"];
            this.itemId = _data["itemId"];
            this.taxJurisdictionCountry = _data["taxJurisdictionCountry"];
            this.content = _data["content"];
            this.jurisdictionType = _data["jurisdictionType"];
        }
    }

    static fromJS(data: any): CreateJurisdictionCommentInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateJurisdictionCommentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceId"] = this.referenceId;
        data["itemId"] = this.itemId;
        data["taxJurisdictionCountry"] = this.taxJurisdictionCountry;
        data["content"] = this.content;
        data["jurisdictionType"] = this.jurisdictionType;
        return data;
    }
}

export interface ICreateJurisdictionCommentInput {
    referenceId: number;
    itemId: number;
    taxJurisdictionCountry: string | undefined;
    content: string | undefined;
    jurisdictionType: JurisdictionType;
}

export class CreateMultipleNodeGroupInput implements ICreateMultipleNodeGroupInput {
    projectId!: number;
    organizationalEntityId!: number | undefined;
    blendingCircleSubgroupId!: number | undefined;
    organizationalEntityUpeShareholderId!: number | undefined;
    ownerId!: number | undefined;
    financialTreeType!: FinancialTreeType;
    multipleNodeGroupType!: FinancialNodeGroupType;

    constructor(data?: ICreateMultipleNodeGroupInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
            this.organizationalEntityUpeShareholderId = _data["organizationalEntityUpeShareholderId"];
            this.ownerId = _data["ownerId"];
            this.financialTreeType = _data["financialTreeType"];
            this.multipleNodeGroupType = _data["multipleNodeGroupType"];
        }
    }

    static fromJS(data: any): CreateMultipleNodeGroupInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMultipleNodeGroupInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        data["organizationalEntityUpeShareholderId"] = this.organizationalEntityUpeShareholderId;
        data["ownerId"] = this.ownerId;
        data["financialTreeType"] = this.financialTreeType;
        data["multipleNodeGroupType"] = this.multipleNodeGroupType;
        return data;
    }
}

export interface ICreateMultipleNodeGroupInput {
    projectId: number;
    organizationalEntityId: number | undefined;
    blendingCircleSubgroupId: number | undefined;
    organizationalEntityUpeShareholderId: number | undefined;
    ownerId: number | undefined;
    financialTreeType: FinancialTreeType;
    multipleNodeGroupType: FinancialNodeGroupType;
}

export class CreateMultipleShiftNodeGroupInput implements ICreateMultipleShiftNodeGroupInput {
    projectId!: number;
    value!: string | undefined;
    comment!: string | undefined;
    notes!: string | undefined;
    isConfirmed!: boolean;
    financialShiftType!: FinancialShiftType;
    targetOrganizationalEntityId!: number | undefined;
    basisForAdjustments!: BasisForAdjustmentsType | undefined;
    maxTaxRateOfMainEntityJurisdiction!: string | undefined;
    passiveIncomeOfCEOrHybridEntity!: string | undefined;
    thereofOnActiveIncome!: string | undefined;
    fiscalYearBeginning!: string | undefined;
    fiscalYearEnd!: string | undefined;
    financialTreeType!: FinancialTreeType;
    directionType!: DirectionType | undefined;
    finalValue!: string | undefined;
    sourceOrganizationalEntityId!: number;
    multipleNodeGroupType!: FinancialNodeGroupType;

    constructor(data?: ICreateMultipleShiftNodeGroupInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.value = _data["value"];
            this.comment = _data["comment"];
            this.notes = _data["notes"];
            this.isConfirmed = _data["isConfirmed"];
            this.financialShiftType = _data["financialShiftType"];
            this.targetOrganizationalEntityId = _data["targetOrganizationalEntityId"];
            this.basisForAdjustments = _data["basisForAdjustments"];
            this.maxTaxRateOfMainEntityJurisdiction = _data["maxTaxRateOfMainEntityJurisdiction"];
            this.passiveIncomeOfCEOrHybridEntity = _data["passiveIncomeOfCEOrHybridEntity"];
            this.thereofOnActiveIncome = _data["thereofOnActiveIncome"];
            this.fiscalYearBeginning = _data["fiscalYearBeginning"];
            this.fiscalYearEnd = _data["fiscalYearEnd"];
            this.financialTreeType = _data["financialTreeType"];
            this.directionType = _data["directionType"];
            this.finalValue = _data["finalValue"];
            this.sourceOrganizationalEntityId = _data["sourceOrganizationalEntityId"];
            this.multipleNodeGroupType = _data["multipleNodeGroupType"];
        }
    }

    static fromJS(data: any): CreateMultipleShiftNodeGroupInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMultipleShiftNodeGroupInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["value"] = this.value;
        data["comment"] = this.comment;
        data["notes"] = this.notes;
        data["isConfirmed"] = this.isConfirmed;
        data["financialShiftType"] = this.financialShiftType;
        data["targetOrganizationalEntityId"] = this.targetOrganizationalEntityId;
        data["basisForAdjustments"] = this.basisForAdjustments;
        data["maxTaxRateOfMainEntityJurisdiction"] = this.maxTaxRateOfMainEntityJurisdiction;
        data["passiveIncomeOfCEOrHybridEntity"] = this.passiveIncomeOfCEOrHybridEntity;
        data["thereofOnActiveIncome"] = this.thereofOnActiveIncome;
        data["fiscalYearBeginning"] = this.fiscalYearBeginning;
        data["fiscalYearEnd"] = this.fiscalYearEnd;
        data["financialTreeType"] = this.financialTreeType;
        data["directionType"] = this.directionType;
        data["finalValue"] = this.finalValue;
        data["sourceOrganizationalEntityId"] = this.sourceOrganizationalEntityId;
        data["multipleNodeGroupType"] = this.multipleNodeGroupType;
        return data;
    }
}

export interface ICreateMultipleShiftNodeGroupInput {
    projectId: number;
    value: string | undefined;
    comment: string | undefined;
    notes: string | undefined;
    isConfirmed: boolean;
    financialShiftType: FinancialShiftType;
    targetOrganizationalEntityId: number | undefined;
    basisForAdjustments: BasisForAdjustmentsType | undefined;
    maxTaxRateOfMainEntityJurisdiction: string | undefined;
    passiveIncomeOfCEOrHybridEntity: string | undefined;
    thereofOnActiveIncome: string | undefined;
    fiscalYearBeginning: string | undefined;
    fiscalYearEnd: string | undefined;
    financialTreeType: FinancialTreeType;
    directionType: DirectionType | undefined;
    finalValue: string | undefined;
    sourceOrganizationalEntityId: number;
    multipleNodeGroupType: FinancialNodeGroupType;
}

export class CreateNaturalPersonShareholderInput implements ICreateNaturalPersonShareholderInput {
    id!: number;
    organizationalEntityId!: number;
    jurisdiction!: ConfirmableInputOfString | undefined;
    taxRate!: ConfirmableInputOfNullableOfDecimal | undefined;
    eligibilityReductionType!: ConfirmableInputOfNullableOfEligibilityReductionType | undefined;
    numberOfShareholders!: ConfirmableInputOfNullableOfInt32 | undefined;
    totalOwnershipPercentage!: ConfirmableInputOfString | undefined;

    constructor(data?: ICreateNaturalPersonShareholderInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.jurisdiction = _data["jurisdiction"] ? ConfirmableInputOfString.fromJS(_data["jurisdiction"]) : <any>undefined;
            this.taxRate = _data["taxRate"] ? ConfirmableInputOfNullableOfDecimal.fromJS(_data["taxRate"]) : <any>undefined;
            this.eligibilityReductionType = _data["eligibilityReductionType"] ? ConfirmableInputOfNullableOfEligibilityReductionType.fromJS(_data["eligibilityReductionType"]) : <any>undefined;
            this.numberOfShareholders = _data["numberOfShareholders"] ? ConfirmableInputOfNullableOfInt32.fromJS(_data["numberOfShareholders"]) : <any>undefined;
            this.totalOwnershipPercentage = _data["totalOwnershipPercentage"] ? ConfirmableInputOfString.fromJS(_data["totalOwnershipPercentage"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateNaturalPersonShareholderInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNaturalPersonShareholderInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["jurisdiction"] = this.jurisdiction ? this.jurisdiction.toJSON() : <any>undefined;
        data["taxRate"] = this.taxRate ? this.taxRate.toJSON() : <any>undefined;
        data["eligibilityReductionType"] = this.eligibilityReductionType ? this.eligibilityReductionType.toJSON() : <any>undefined;
        data["numberOfShareholders"] = this.numberOfShareholders ? this.numberOfShareholders.toJSON() : <any>undefined;
        data["totalOwnershipPercentage"] = this.totalOwnershipPercentage ? this.totalOwnershipPercentage.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateNaturalPersonShareholderInput {
    id: number;
    organizationalEntityId: number;
    jurisdiction: ConfirmableInputOfString | undefined;
    taxRate: ConfirmableInputOfNullableOfDecimal | undefined;
    eligibilityReductionType: ConfirmableInputOfNullableOfEligibilityReductionType | undefined;
    numberOfShareholders: ConfirmableInputOfNullableOfInt32 | undefined;
    totalOwnershipPercentage: ConfirmableInputOfString | undefined;
}

export class CreateObligationInput implements ICreateObligationInput {
    projectId!: number;
    organizationalEntityId!: number | undefined;
    obligationCountry!: string | undefined;
    obligationReturnType!: ObligationReturnType;
    obligationStatus!: ObligationStatus;
    dueDate!: DateTime | undefined;
    assignedUserId!: number | undefined;
    note!: string | undefined;
    comment!: string | undefined;

    constructor(data?: ICreateObligationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.obligationCountry = _data["obligationCountry"];
            this.obligationReturnType = _data["obligationReturnType"];
            this.obligationStatus = _data["obligationStatus"];
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
            this.assignedUserId = _data["assignedUserId"];
            this.note = _data["note"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): CreateObligationInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateObligationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["obligationCountry"] = this.obligationCountry;
        data["obligationReturnType"] = this.obligationReturnType;
        data["obligationStatus"] = this.obligationStatus;
        data["dueDate"] = this.dueDate ? this.dueDate.toString() : <any>undefined;
        data["assignedUserId"] = this.assignedUserId;
        data["note"] = this.note;
        data["comment"] = this.comment;
        return data;
    }
}

export interface ICreateObligationInput {
    projectId: number;
    organizationalEntityId: number | undefined;
    obligationCountry: string | undefined;
    obligationReturnType: ObligationReturnType;
    obligationStatus: ObligationStatus;
    dueDate: DateTime | undefined;
    assignedUserId: number | undefined;
    note: string | undefined;
    comment: string | undefined;
}

export class CreateOrganizationalEntityInput implements ICreateOrganizationalEntityInput {
    projectId!: number;
    entityNumber!: ConfirmableInputOfString | undefined;
    legalName!: ConfirmableInputOfString | undefined;
    gloBEStatus!: ConfirmableInputOfIListOfGloBEStatus | undefined;
    tin!: ConfirmableInputOfString | undefined;
    tinIssuedBy!: ConfirmableInputOfString | undefined;
    typeOfTIN!: ConfirmableInputOfNullableOfTinType | undefined;
    taxJurisdictionCountry!: ConfirmableInputOfString | undefined;
    taxTreatment!: ConfirmableInputOfNullableOfTaxTreatment | undefined;
    isUpeAsFlowThrough!: ConfirmableInputOfNullableOfBoolean | undefined;
    isUpeSubjectToDeductiveDividendRegime!: ConfirmableInputOfNullableOfBoolean | undefined;
    typeOfExcluded!: ConfirmableInputOfNullableOfOrganizationalEntityExcludedType | undefined;
    notTreatingEntityAsExcludedEntity!: ConfirmableInputOfNullableOfBoolean | undefined;
    electionYear!: DateTime | undefined;
    revocationYear!: DateTime | undefined;
    isPermanentEstablishment!: ConfirmableInputOfNullableOfBoolean | undefined;
    mainEntityId!: ConfirmableInputOfNullableOfInt64 | undefined;
    taxFunctionalCurrency!: ConfirmableInputOfString | undefined;
    accountingFunctionalCurrency!: ConfirmableInputOfString | undefined;
    financialAccountingStandardOfCe!: ConfirmableInputOfString | undefined;
    consolidationMethod!: ConfirmableInputOfNullableOfConsolidationMethod | undefined;
    controllingInterestEntityId!: number | undefined;
    shareholders!: ShareholderInput | undefined;
    blendingCircleInput!: BlendingCircleInput | undefined;
    ownershipChanges!: CreateOwnershipChangeInput[] | undefined;
    corporateShareholders!: CreateCorporateShareholderInput[] | undefined;
    naturalPersonShareholders!: CreateNaturalPersonShareholderInput[] | undefined;

    constructor(data?: ICreateOrganizationalEntityInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.entityNumber = _data["entityNumber"] ? ConfirmableInputOfString.fromJS(_data["entityNumber"]) : <any>undefined;
            this.legalName = _data["legalName"] ? ConfirmableInputOfString.fromJS(_data["legalName"]) : <any>undefined;
            this.gloBEStatus = _data["gloBEStatus"] ? ConfirmableInputOfIListOfGloBEStatus.fromJS(_data["gloBEStatus"]) : <any>undefined;
            this.tin = _data["tin"] ? ConfirmableInputOfString.fromJS(_data["tin"]) : <any>undefined;
            this.tinIssuedBy = _data["tinIssuedBy"] ? ConfirmableInputOfString.fromJS(_data["tinIssuedBy"]) : <any>undefined;
            this.typeOfTIN = _data["typeOfTIN"] ? ConfirmableInputOfNullableOfTinType.fromJS(_data["typeOfTIN"]) : <any>undefined;
            this.taxJurisdictionCountry = _data["taxJurisdictionCountry"] ? ConfirmableInputOfString.fromJS(_data["taxJurisdictionCountry"]) : <any>undefined;
            this.taxTreatment = _data["taxTreatment"] ? ConfirmableInputOfNullableOfTaxTreatment.fromJS(_data["taxTreatment"]) : <any>undefined;
            this.isUpeAsFlowThrough = _data["isUpeAsFlowThrough"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isUpeAsFlowThrough"]) : <any>undefined;
            this.isUpeSubjectToDeductiveDividendRegime = _data["isUpeSubjectToDeductiveDividendRegime"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isUpeSubjectToDeductiveDividendRegime"]) : <any>undefined;
            this.typeOfExcluded = _data["typeOfExcluded"] ? ConfirmableInputOfNullableOfOrganizationalEntityExcludedType.fromJS(_data["typeOfExcluded"]) : <any>undefined;
            this.notTreatingEntityAsExcludedEntity = _data["notTreatingEntityAsExcludedEntity"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["notTreatingEntityAsExcludedEntity"]) : <any>undefined;
            this.electionYear = _data["electionYear"] ? DateTime.fromISO(_data["electionYear"].toString()) : <any>undefined;
            this.revocationYear = _data["revocationYear"] ? DateTime.fromISO(_data["revocationYear"].toString()) : <any>undefined;
            this.isPermanentEstablishment = _data["isPermanentEstablishment"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isPermanentEstablishment"]) : <any>undefined;
            this.mainEntityId = _data["mainEntityId"] ? ConfirmableInputOfNullableOfInt64.fromJS(_data["mainEntityId"]) : <any>undefined;
            this.taxFunctionalCurrency = _data["taxFunctionalCurrency"] ? ConfirmableInputOfString.fromJS(_data["taxFunctionalCurrency"]) : <any>undefined;
            this.accountingFunctionalCurrency = _data["accountingFunctionalCurrency"] ? ConfirmableInputOfString.fromJS(_data["accountingFunctionalCurrency"]) : <any>undefined;
            this.financialAccountingStandardOfCe = _data["financialAccountingStandardOfCe"] ? ConfirmableInputOfString.fromJS(_data["financialAccountingStandardOfCe"]) : <any>undefined;
            this.consolidationMethod = _data["consolidationMethod"] ? ConfirmableInputOfNullableOfConsolidationMethod.fromJS(_data["consolidationMethod"]) : <any>undefined;
            this.controllingInterestEntityId = _data["controllingInterestEntityId"];
            this.shareholders = _data["shareholders"] ? ShareholderInput.fromJS(_data["shareholders"]) : <any>undefined;
            this.blendingCircleInput = _data["blendingCircleInput"] ? BlendingCircleInput.fromJS(_data["blendingCircleInput"]) : <any>undefined;
            if (Array.isArray(_data["ownershipChanges"])) {
                this.ownershipChanges = [] as any;
                for (let item of _data["ownershipChanges"])
                    this.ownershipChanges!.push(CreateOwnershipChangeInput.fromJS(item));
            }
            if (Array.isArray(_data["corporateShareholders"])) {
                this.corporateShareholders = [] as any;
                for (let item of _data["corporateShareholders"])
                    this.corporateShareholders!.push(CreateCorporateShareholderInput.fromJS(item));
            }
            if (Array.isArray(_data["naturalPersonShareholders"])) {
                this.naturalPersonShareholders = [] as any;
                for (let item of _data["naturalPersonShareholders"])
                    this.naturalPersonShareholders!.push(CreateNaturalPersonShareholderInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrganizationalEntityInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrganizationalEntityInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["entityNumber"] = this.entityNumber ? this.entityNumber.toJSON() : <any>undefined;
        data["legalName"] = this.legalName ? this.legalName.toJSON() : <any>undefined;
        data["gloBEStatus"] = this.gloBEStatus ? this.gloBEStatus.toJSON() : <any>undefined;
        data["tin"] = this.tin ? this.tin.toJSON() : <any>undefined;
        data["tinIssuedBy"] = this.tinIssuedBy ? this.tinIssuedBy.toJSON() : <any>undefined;
        data["typeOfTIN"] = this.typeOfTIN ? this.typeOfTIN.toJSON() : <any>undefined;
        data["taxJurisdictionCountry"] = this.taxJurisdictionCountry ? this.taxJurisdictionCountry.toJSON() : <any>undefined;
        data["taxTreatment"] = this.taxTreatment ? this.taxTreatment.toJSON() : <any>undefined;
        data["isUpeAsFlowThrough"] = this.isUpeAsFlowThrough ? this.isUpeAsFlowThrough.toJSON() : <any>undefined;
        data["isUpeSubjectToDeductiveDividendRegime"] = this.isUpeSubjectToDeductiveDividendRegime ? this.isUpeSubjectToDeductiveDividendRegime.toJSON() : <any>undefined;
        data["typeOfExcluded"] = this.typeOfExcluded ? this.typeOfExcluded.toJSON() : <any>undefined;
        data["notTreatingEntityAsExcludedEntity"] = this.notTreatingEntityAsExcludedEntity ? this.notTreatingEntityAsExcludedEntity.toJSON() : <any>undefined;
        data["electionYear"] = this.electionYear ? this.electionYear.toString() : <any>undefined;
        data["revocationYear"] = this.revocationYear ? this.revocationYear.toString() : <any>undefined;
        data["isPermanentEstablishment"] = this.isPermanentEstablishment ? this.isPermanentEstablishment.toJSON() : <any>undefined;
        data["mainEntityId"] = this.mainEntityId ? this.mainEntityId.toJSON() : <any>undefined;
        data["taxFunctionalCurrency"] = this.taxFunctionalCurrency ? this.taxFunctionalCurrency.toJSON() : <any>undefined;
        data["accountingFunctionalCurrency"] = this.accountingFunctionalCurrency ? this.accountingFunctionalCurrency.toJSON() : <any>undefined;
        data["financialAccountingStandardOfCe"] = this.financialAccountingStandardOfCe ? this.financialAccountingStandardOfCe.toJSON() : <any>undefined;
        data["consolidationMethod"] = this.consolidationMethod ? this.consolidationMethod.toJSON() : <any>undefined;
        data["controllingInterestEntityId"] = this.controllingInterestEntityId;
        data["shareholders"] = this.shareholders ? this.shareholders.toJSON() : <any>undefined;
        data["blendingCircleInput"] = this.blendingCircleInput ? this.blendingCircleInput.toJSON() : <any>undefined;
        if (Array.isArray(this.ownershipChanges)) {
            data["ownershipChanges"] = [];
            for (let item of this.ownershipChanges)
                data["ownershipChanges"].push(item.toJSON());
        }
        if (Array.isArray(this.corporateShareholders)) {
            data["corporateShareholders"] = [];
            for (let item of this.corporateShareholders)
                data["corporateShareholders"].push(item.toJSON());
        }
        if (Array.isArray(this.naturalPersonShareholders)) {
            data["naturalPersonShareholders"] = [];
            for (let item of this.naturalPersonShareholders)
                data["naturalPersonShareholders"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrganizationalEntityInput {
    projectId: number;
    entityNumber: ConfirmableInputOfString | undefined;
    legalName: ConfirmableInputOfString | undefined;
    gloBEStatus: ConfirmableInputOfIListOfGloBEStatus | undefined;
    tin: ConfirmableInputOfString | undefined;
    tinIssuedBy: ConfirmableInputOfString | undefined;
    typeOfTIN: ConfirmableInputOfNullableOfTinType | undefined;
    taxJurisdictionCountry: ConfirmableInputOfString | undefined;
    taxTreatment: ConfirmableInputOfNullableOfTaxTreatment | undefined;
    isUpeAsFlowThrough: ConfirmableInputOfNullableOfBoolean | undefined;
    isUpeSubjectToDeductiveDividendRegime: ConfirmableInputOfNullableOfBoolean | undefined;
    typeOfExcluded: ConfirmableInputOfNullableOfOrganizationalEntityExcludedType | undefined;
    notTreatingEntityAsExcludedEntity: ConfirmableInputOfNullableOfBoolean | undefined;
    electionYear: DateTime | undefined;
    revocationYear: DateTime | undefined;
    isPermanentEstablishment: ConfirmableInputOfNullableOfBoolean | undefined;
    mainEntityId: ConfirmableInputOfNullableOfInt64 | undefined;
    taxFunctionalCurrency: ConfirmableInputOfString | undefined;
    accountingFunctionalCurrency: ConfirmableInputOfString | undefined;
    financialAccountingStandardOfCe: ConfirmableInputOfString | undefined;
    consolidationMethod: ConfirmableInputOfNullableOfConsolidationMethod | undefined;
    controllingInterestEntityId: number | undefined;
    shareholders: ShareholderInput | undefined;
    blendingCircleInput: BlendingCircleInput | undefined;
    ownershipChanges: CreateOwnershipChangeInput[] | undefined;
    corporateShareholders: CreateCorporateShareholderInput[] | undefined;
    naturalPersonShareholders: CreateNaturalPersonShareholderInput[] | undefined;
}

export enum CreateOutOfTemplateAction {
    Copy = 0,
    ReplaceDocRefIds = 1,
    Correction = 2,
}

export class CreateOutOfTemplateProjectInput implements ICreateOutOfTemplateProjectInput {
    general!: GeneraInput | undefined;
    accessAndPermission!: ProjectAccessAndPermissionInput | undefined;
    projectManagement!: FullProjectManagementInput | undefined;
    specifics!: ProjectSpecificInput | undefined;
    referenceId!: number;
    comment!: string | undefined;
    includeScoping!: boolean;
    includeJurisdictions!: boolean;
    includeCurrencies!: boolean;
    includeSafeHarbourFinancialDataOfEntities!: boolean;
    includeSafeHarbourFinancialDataOfSafeHarbourGroups!: boolean;
    includeFullScopeCalculation!: boolean;

    constructor(data?: ICreateOutOfTemplateProjectInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.general = _data["general"] ? GeneraInput.fromJS(_data["general"]) : <any>undefined;
            this.accessAndPermission = _data["accessAndPermission"] ? ProjectAccessAndPermissionInput.fromJS(_data["accessAndPermission"]) : <any>undefined;
            this.projectManagement = _data["projectManagement"] ? FullProjectManagementInput.fromJS(_data["projectManagement"]) : <any>undefined;
            this.specifics = _data["specifics"] ? ProjectSpecificInput.fromJS(_data["specifics"]) : <any>undefined;
            this.referenceId = _data["referenceId"];
            this.comment = _data["comment"];
            this.includeScoping = _data["includeScoping"];
            this.includeJurisdictions = _data["includeJurisdictions"];
            this.includeCurrencies = _data["includeCurrencies"];
            this.includeSafeHarbourFinancialDataOfEntities = _data["includeSafeHarbourFinancialDataOfEntities"];
            this.includeSafeHarbourFinancialDataOfSafeHarbourGroups = _data["includeSafeHarbourFinancialDataOfSafeHarbourGroups"];
            this.includeFullScopeCalculation = _data["includeFullScopeCalculation"];
        }
    }

    static fromJS(data: any): CreateOutOfTemplateProjectInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOutOfTemplateProjectInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["accessAndPermission"] = this.accessAndPermission ? this.accessAndPermission.toJSON() : <any>undefined;
        data["projectManagement"] = this.projectManagement ? this.projectManagement.toJSON() : <any>undefined;
        data["specifics"] = this.specifics ? this.specifics.toJSON() : <any>undefined;
        data["referenceId"] = this.referenceId;
        data["comment"] = this.comment;
        data["includeScoping"] = this.includeScoping;
        data["includeJurisdictions"] = this.includeJurisdictions;
        data["includeCurrencies"] = this.includeCurrencies;
        data["includeSafeHarbourFinancialDataOfEntities"] = this.includeSafeHarbourFinancialDataOfEntities;
        data["includeSafeHarbourFinancialDataOfSafeHarbourGroups"] = this.includeSafeHarbourFinancialDataOfSafeHarbourGroups;
        data["includeFullScopeCalculation"] = this.includeFullScopeCalculation;
        return data;
    }
}

export interface ICreateOutOfTemplateProjectInput {
    general: GeneraInput | undefined;
    accessAndPermission: ProjectAccessAndPermissionInput | undefined;
    projectManagement: FullProjectManagementInput | undefined;
    specifics: ProjectSpecificInput | undefined;
    referenceId: number;
    comment: string | undefined;
    includeScoping: boolean;
    includeJurisdictions: boolean;
    includeCurrencies: boolean;
    includeSafeHarbourFinancialDataOfEntities: boolean;
    includeSafeHarbourFinancialDataOfSafeHarbourGroups: boolean;
    includeFullScopeCalculation: boolean;
}

export class CreateOwnershipChangeInput implements ICreateOwnershipChangeInput {
    id!: number;
    name!: string | undefined;
    organizationalEntityId!: number;
    changeDate!: string | undefined;
    ownShares!: number | undefined;
    gloBEStatus!: OwnershipChangeGloBEStatus[] | undefined;
    interestParticipation!: number | undefined;
    ownershipChangeInternalOwners!: CreateOwnershipChangeInternalOwnerInput[] | undefined;
    ownershipChangeThirdPartyParticipations!: CreateOwnershipChangeThirdPartyParticipationInput[] | undefined;

    constructor(data?: ICreateOwnershipChangeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.changeDate = _data["changeDate"];
            this.ownShares = _data["ownShares"];
            if (Array.isArray(_data["gloBEStatus"])) {
                this.gloBEStatus = [] as any;
                for (let item of _data["gloBEStatus"])
                    this.gloBEStatus!.push(item);
            }
            this.interestParticipation = _data["interestParticipation"];
            if (Array.isArray(_data["ownershipChangeInternalOwners"])) {
                this.ownershipChangeInternalOwners = [] as any;
                for (let item of _data["ownershipChangeInternalOwners"])
                    this.ownershipChangeInternalOwners!.push(CreateOwnershipChangeInternalOwnerInput.fromJS(item));
            }
            if (Array.isArray(_data["ownershipChangeThirdPartyParticipations"])) {
                this.ownershipChangeThirdPartyParticipations = [] as any;
                for (let item of _data["ownershipChangeThirdPartyParticipations"])
                    this.ownershipChangeThirdPartyParticipations!.push(CreateOwnershipChangeThirdPartyParticipationInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOwnershipChangeInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOwnershipChangeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["changeDate"] = this.changeDate;
        data["ownShares"] = this.ownShares;
        if (Array.isArray(this.gloBEStatus)) {
            data["gloBEStatus"] = [];
            for (let item of this.gloBEStatus)
                data["gloBEStatus"].push(item);
        }
        data["interestParticipation"] = this.interestParticipation;
        if (Array.isArray(this.ownershipChangeInternalOwners)) {
            data["ownershipChangeInternalOwners"] = [];
            for (let item of this.ownershipChangeInternalOwners)
                data["ownershipChangeInternalOwners"].push(item.toJSON());
        }
        if (Array.isArray(this.ownershipChangeThirdPartyParticipations)) {
            data["ownershipChangeThirdPartyParticipations"] = [];
            for (let item of this.ownershipChangeThirdPartyParticipations)
                data["ownershipChangeThirdPartyParticipations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOwnershipChangeInput {
    id: number;
    name: string | undefined;
    organizationalEntityId: number;
    changeDate: string | undefined;
    ownShares: number | undefined;
    gloBEStatus: OwnershipChangeGloBEStatus[] | undefined;
    interestParticipation: number | undefined;
    ownershipChangeInternalOwners: CreateOwnershipChangeInternalOwnerInput[] | undefined;
    ownershipChangeThirdPartyParticipations: CreateOwnershipChangeThirdPartyParticipationInput[] | undefined;
}

export class CreateOwnershipChangeInternalOwnerInput implements ICreateOwnershipChangeInternalOwnerInput {
    id!: number | undefined;
    interestValue!: number | undefined;
    ownershipChangeId!: number;
    holdingOrganizationalEntityId!: number;
    taxTreatment!: TaxTreatment | undefined;

    constructor(data?: ICreateOwnershipChangeInternalOwnerInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.interestValue = _data["interestValue"];
            this.ownershipChangeId = _data["ownershipChangeId"];
            this.holdingOrganizationalEntityId = _data["holdingOrganizationalEntityId"];
            this.taxTreatment = _data["taxTreatment"];
        }
    }

    static fromJS(data: any): CreateOwnershipChangeInternalOwnerInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOwnershipChangeInternalOwnerInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["interestValue"] = this.interestValue;
        data["ownershipChangeId"] = this.ownershipChangeId;
        data["holdingOrganizationalEntityId"] = this.holdingOrganizationalEntityId;
        data["taxTreatment"] = this.taxTreatment;
        return data;
    }
}

export interface ICreateOwnershipChangeInternalOwnerInput {
    id: number | undefined;
    interestValue: number | undefined;
    ownershipChangeId: number;
    holdingOrganizationalEntityId: number;
    taxTreatment: TaxTreatment | undefined;
}

export class CreateOwnershipChangeThirdPartyParticipationInput implements ICreateOwnershipChangeThirdPartyParticipationInput {
    id!: number | undefined;
    ownershipChangeId!: number;
    interestValue!: number;
    heldOrganizationalEntityId!: number;

    constructor(data?: ICreateOwnershipChangeThirdPartyParticipationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ownershipChangeId = _data["ownershipChangeId"];
            this.interestValue = _data["interestValue"];
            this.heldOrganizationalEntityId = _data["heldOrganizationalEntityId"];
        }
    }

    static fromJS(data: any): CreateOwnershipChangeThirdPartyParticipationInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOwnershipChangeThirdPartyParticipationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ownershipChangeId"] = this.ownershipChangeId;
        data["interestValue"] = this.interestValue;
        data["heldOrganizationalEntityId"] = this.heldOrganizationalEntityId;
        return data;
    }
}

export interface ICreateOwnershipChangeThirdPartyParticipationInput {
    id: number | undefined;
    ownershipChangeId: number;
    interestValue: number;
    heldOrganizationalEntityId: number;
}

export class CreateProjectInput implements ICreateProjectInput {
    general!: GeneraInput | undefined;
    accessAndPermission!: ProjectAccessAndPermissionInput | undefined;
    projectManagement!: FullProjectManagementInput | undefined;
    specifics!: ProjectSpecificInput | undefined;

    constructor(data?: ICreateProjectInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.general = _data["general"] ? GeneraInput.fromJS(_data["general"]) : <any>undefined;
            this.accessAndPermission = _data["accessAndPermission"] ? ProjectAccessAndPermissionInput.fromJS(_data["accessAndPermission"]) : <any>undefined;
            this.projectManagement = _data["projectManagement"] ? FullProjectManagementInput.fromJS(_data["projectManagement"]) : <any>undefined;
            this.specifics = _data["specifics"] ? ProjectSpecificInput.fromJS(_data["specifics"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateProjectInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProjectInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["accessAndPermission"] = this.accessAndPermission ? this.accessAndPermission.toJSON() : <any>undefined;
        data["projectManagement"] = this.projectManagement ? this.projectManagement.toJSON() : <any>undefined;
        data["specifics"] = this.specifics ? this.specifics.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateProjectInput {
    general: GeneraInput | undefined;
    accessAndPermission: ProjectAccessAndPermissionInput | undefined;
    projectManagement: FullProjectManagementInput | undefined;
    specifics: ProjectSpecificInput | undefined;
}

export class CreateSubmissionInput implements ICreateSubmissionInput {
    general!: SubmissionGeneralInput | undefined;
    projectManagement!: FullProjectManagementInput | undefined;
    specifics!: SubmissionSpecificInput | undefined;
    details!: SubmissionDetailsInput | undefined;
    projectId!: number;
    setAsLinkedSubmission!: boolean;

    constructor(data?: ICreateSubmissionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.general = _data["general"] ? SubmissionGeneralInput.fromJS(_data["general"]) : <any>undefined;
            this.projectManagement = _data["projectManagement"] ? FullProjectManagementInput.fromJS(_data["projectManagement"]) : <any>undefined;
            this.specifics = _data["specifics"] ? SubmissionSpecificInput.fromJS(_data["specifics"]) : <any>undefined;
            this.details = _data["details"] ? SubmissionDetailsInput.fromJS(_data["details"]) : <any>undefined;
            this.projectId = _data["projectId"];
            this.setAsLinkedSubmission = _data["setAsLinkedSubmission"];
        }
    }

    static fromJS(data: any): CreateSubmissionInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSubmissionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["projectManagement"] = this.projectManagement ? this.projectManagement.toJSON() : <any>undefined;
        data["specifics"] = this.specifics ? this.specifics.toJSON() : <any>undefined;
        data["details"] = this.details ? this.details.toJSON() : <any>undefined;
        data["projectId"] = this.projectId;
        data["setAsLinkedSubmission"] = this.setAsLinkedSubmission;
        return data;
    }
}

export interface ICreateSubmissionInput {
    general: SubmissionGeneralInput | undefined;
    projectManagement: FullProjectManagementInput | undefined;
    specifics: SubmissionSpecificInput | undefined;
    details: SubmissionDetailsInput | undefined;
    projectId: number;
    setAsLinkedSubmission: boolean;
}

export class CreateSubmissionOutOfTeplateInput implements ICreateSubmissionOutOfTeplateInput {
    submissionId!: number;
    submissionGeneralInput!: SubmissionGeneralInput | undefined;
    projectManagement!: FullProjectManagementInput | undefined;
    submissionDeadline!: DateTime;
    action!: CreateOutOfTemplateAction;
    submissionCorrectionInput!: SubmissionCorrectionInput | undefined;
    setAsLinkedSubmission!: boolean;

    constructor(data?: ICreateSubmissionOutOfTeplateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submissionId = _data["submissionId"];
            this.submissionGeneralInput = _data["submissionGeneralInput"] ? SubmissionGeneralInput.fromJS(_data["submissionGeneralInput"]) : <any>undefined;
            this.projectManagement = _data["projectManagement"] ? FullProjectManagementInput.fromJS(_data["projectManagement"]) : <any>undefined;
            this.submissionDeadline = _data["submissionDeadline"] ? DateTime.fromISO(_data["submissionDeadline"].toString()) : <any>undefined;
            this.action = _data["action"];
            this.submissionCorrectionInput = _data["submissionCorrectionInput"] ? SubmissionCorrectionInput.fromJS(_data["submissionCorrectionInput"]) : <any>undefined;
            this.setAsLinkedSubmission = _data["setAsLinkedSubmission"];
        }
    }

    static fromJS(data: any): CreateSubmissionOutOfTeplateInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSubmissionOutOfTeplateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submissionId"] = this.submissionId;
        data["submissionGeneralInput"] = this.submissionGeneralInput ? this.submissionGeneralInput.toJSON() : <any>undefined;
        data["projectManagement"] = this.projectManagement ? this.projectManagement.toJSON() : <any>undefined;
        data["submissionDeadline"] = this.submissionDeadline ? this.submissionDeadline.toString() : <any>undefined;
        data["action"] = this.action;
        data["submissionCorrectionInput"] = this.submissionCorrectionInput ? this.submissionCorrectionInput.toJSON() : <any>undefined;
        data["setAsLinkedSubmission"] = this.setAsLinkedSubmission;
        return data;
    }
}

export interface ICreateSubmissionOutOfTeplateInput {
    submissionId: number;
    submissionGeneralInput: SubmissionGeneralInput | undefined;
    projectManagement: FullProjectManagementInput | undefined;
    submissionDeadline: DateTime;
    action: CreateOutOfTemplateAction;
    submissionCorrectionInput: SubmissionCorrectionInput | undefined;
    setAsLinkedSubmission: boolean;
}

export enum Criticality {
    VeryLow = 1,
    Low = 2,
    Medium = 3,
    High = 4,
}

export class CrossAllocationOfTaxes434RecalculationWarningDto implements ICrossAllocationOfTaxes434RecalculationWarningDto {
    relatedGloBEAllocation!: FinancialValueDto | undefined;
    maxTaxRatePercentage!: string | undefined;
    initialValue!: FinancialValueDto | undefined;
    calculatedFinal!: FinancialValueDto | undefined;
    allowedTaxAllocationValue!: FinancialValueDto | undefined;

    constructor(data?: ICrossAllocationOfTaxes434RecalculationWarningDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.relatedGloBEAllocation = _data["relatedGloBEAllocation"] ? FinancialValueDto.fromJS(_data["relatedGloBEAllocation"]) : <any>undefined;
            this.maxTaxRatePercentage = _data["maxTaxRatePercentage"];
            this.initialValue = _data["initialValue"] ? FinancialValueDto.fromJS(_data["initialValue"]) : <any>undefined;
            this.calculatedFinal = _data["calculatedFinal"] ? FinancialValueDto.fromJS(_data["calculatedFinal"]) : <any>undefined;
            this.allowedTaxAllocationValue = _data["allowedTaxAllocationValue"] ? FinancialValueDto.fromJS(_data["allowedTaxAllocationValue"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CrossAllocationOfTaxes434RecalculationWarningDto {
        data = typeof data === 'object' ? data : {};
        let result = new CrossAllocationOfTaxes434RecalculationWarningDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["relatedGloBEAllocation"] = this.relatedGloBEAllocation ? this.relatedGloBEAllocation.toJSON() : <any>undefined;
        data["maxTaxRatePercentage"] = this.maxTaxRatePercentage;
        data["initialValue"] = this.initialValue ? this.initialValue.toJSON() : <any>undefined;
        data["calculatedFinal"] = this.calculatedFinal ? this.calculatedFinal.toJSON() : <any>undefined;
        data["allowedTaxAllocationValue"] = this.allowedTaxAllocationValue ? this.allowedTaxAllocationValue.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICrossAllocationOfTaxes434RecalculationWarningDto {
    relatedGloBEAllocation: FinancialValueDto | undefined;
    maxTaxRatePercentage: string | undefined;
    initialValue: FinancialValueDto | undefined;
    calculatedFinal: FinancialValueDto | undefined;
    allowedTaxAllocationValue: FinancialValueDto | undefined;
}

export class CrossAllocationOfTaxesRecalculationWarningDto implements ICrossAllocationOfTaxesRecalculationWarningDto {
    legalName!: string | undefined;
    taxesSubjectToCap!: FinancialValueDto | undefined;
    thereofOnActiveIncome!: FinancialValueDto | undefined;
    tutPercentageRateBeforeAllocations!: string | undefined;
    passiveIncomeMaximalAmount!: FinancialValueDto | undefined;
    passiveIncome!: FinancialValueDto | undefined;
    allocationAmount!: FinancialValueDto | undefined;

    constructor(data?: ICrossAllocationOfTaxesRecalculationWarningDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.legalName = _data["legalName"];
            this.taxesSubjectToCap = _data["taxesSubjectToCap"] ? FinancialValueDto.fromJS(_data["taxesSubjectToCap"]) : <any>undefined;
            this.thereofOnActiveIncome = _data["thereofOnActiveIncome"] ? FinancialValueDto.fromJS(_data["thereofOnActiveIncome"]) : <any>undefined;
            this.tutPercentageRateBeforeAllocations = _data["tutPercentageRateBeforeAllocations"];
            this.passiveIncomeMaximalAmount = _data["passiveIncomeMaximalAmount"] ? FinancialValueDto.fromJS(_data["passiveIncomeMaximalAmount"]) : <any>undefined;
            this.passiveIncome = _data["passiveIncome"] ? FinancialValueDto.fromJS(_data["passiveIncome"]) : <any>undefined;
            this.allocationAmount = _data["allocationAmount"] ? FinancialValueDto.fromJS(_data["allocationAmount"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CrossAllocationOfTaxesRecalculationWarningDto {
        data = typeof data === 'object' ? data : {};
        let result = new CrossAllocationOfTaxesRecalculationWarningDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["taxesSubjectToCap"] = this.taxesSubjectToCap ? this.taxesSubjectToCap.toJSON() : <any>undefined;
        data["thereofOnActiveIncome"] = this.thereofOnActiveIncome ? this.thereofOnActiveIncome.toJSON() : <any>undefined;
        data["tutPercentageRateBeforeAllocations"] = this.tutPercentageRateBeforeAllocations;
        data["passiveIncomeMaximalAmount"] = this.passiveIncomeMaximalAmount ? this.passiveIncomeMaximalAmount.toJSON() : <any>undefined;
        data["passiveIncome"] = this.passiveIncome ? this.passiveIncome.toJSON() : <any>undefined;
        data["allocationAmount"] = this.allocationAmount ? this.allocationAmount.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICrossAllocationOfTaxesRecalculationWarningDto {
    legalName: string | undefined;
    taxesSubjectToCap: FinancialValueDto | undefined;
    thereofOnActiveIncome: FinancialValueDto | undefined;
    tutPercentageRateBeforeAllocations: string | undefined;
    passiveIncomeMaximalAmount: FinancialValueDto | undefined;
    passiveIncome: FinancialValueDto | undefined;
    allocationAmount: FinancialValueDto | undefined;
}

export class CustomGrantsForPermissionInput implements ICustomGrantsForPermissionInput {
    entityId!: number;
    usersAndOrganizationUnits!: UserOrOrganizationUnitInput[] | undefined;
    permissionName!: string | undefined;
    excludeUsers!: boolean;

    constructor(data?: ICustomGrantsForPermissionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            if (Array.isArray(_data["usersAndOrganizationUnits"])) {
                this.usersAndOrganizationUnits = [] as any;
                for (let item of _data["usersAndOrganizationUnits"])
                    this.usersAndOrganizationUnits!.push(UserOrOrganizationUnitInput.fromJS(item));
            }
            this.permissionName = _data["permissionName"];
            this.excludeUsers = _data["excludeUsers"];
        }
    }

    static fromJS(data: any): CustomGrantsForPermissionInput {
        data = typeof data === 'object' ? data : {};
        let result = new CustomGrantsForPermissionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        if (Array.isArray(this.usersAndOrganizationUnits)) {
            data["usersAndOrganizationUnits"] = [];
            for (let item of this.usersAndOrganizationUnits)
                data["usersAndOrganizationUnits"].push(item.toJSON());
        }
        data["permissionName"] = this.permissionName;
        data["excludeUsers"] = this.excludeUsers;
        return data;
    }
}

export interface ICustomGrantsForPermissionInput {
    entityId: number;
    usersAndOrganizationUnits: UserOrOrganizationUnitInput[] | undefined;
    permissionName: string | undefined;
    excludeUsers: boolean;
}

export class CustomGrantsForPermissionWithAccessRestrictionDataInput implements ICustomGrantsForPermissionWithAccessRestrictionDataInput {
    entityId!: number;
    usersAndOrganizationUnits!: UserOrOrganizationUnitInput[] | undefined;
    permissionName!: string | undefined;
    excludeUsers!: boolean;
    accessRestrictionProvisionalData!: UserOrOrganizationUnitInput[] | undefined;

    constructor(data?: ICustomGrantsForPermissionWithAccessRestrictionDataInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            if (Array.isArray(_data["usersAndOrganizationUnits"])) {
                this.usersAndOrganizationUnits = [] as any;
                for (let item of _data["usersAndOrganizationUnits"])
                    this.usersAndOrganizationUnits!.push(UserOrOrganizationUnitInput.fromJS(item));
            }
            this.permissionName = _data["permissionName"];
            this.excludeUsers = _data["excludeUsers"];
            if (Array.isArray(_data["accessRestrictionProvisionalData"])) {
                this.accessRestrictionProvisionalData = [] as any;
                for (let item of _data["accessRestrictionProvisionalData"])
                    this.accessRestrictionProvisionalData!.push(UserOrOrganizationUnitInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomGrantsForPermissionWithAccessRestrictionDataInput {
        data = typeof data === 'object' ? data : {};
        let result = new CustomGrantsForPermissionWithAccessRestrictionDataInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        if (Array.isArray(this.usersAndOrganizationUnits)) {
            data["usersAndOrganizationUnits"] = [];
            for (let item of this.usersAndOrganizationUnits)
                data["usersAndOrganizationUnits"].push(item.toJSON());
        }
        data["permissionName"] = this.permissionName;
        data["excludeUsers"] = this.excludeUsers;
        if (Array.isArray(this.accessRestrictionProvisionalData)) {
            data["accessRestrictionProvisionalData"] = [];
            for (let item of this.accessRestrictionProvisionalData)
                data["accessRestrictionProvisionalData"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomGrantsForPermissionWithAccessRestrictionDataInput {
    entityId: number;
    usersAndOrganizationUnits: UserOrOrganizationUnitInput[] | undefined;
    permissionName: string | undefined;
    excludeUsers: boolean;
    accessRestrictionProvisionalData: UserOrOrganizationUnitInput[] | undefined;
}

export class CustomGrantsInput implements ICustomGrantsInput {
    entityId!: number;
    usersAndOrganizationUnits!: UserOrOrganizationUnitInput[] | undefined;

    constructor(data?: ICustomGrantsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            if (Array.isArray(_data["usersAndOrganizationUnits"])) {
                this.usersAndOrganizationUnits = [] as any;
                for (let item of _data["usersAndOrganizationUnits"])
                    this.usersAndOrganizationUnits!.push(UserOrOrganizationUnitInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomGrantsInput {
        data = typeof data === 'object' ? data : {};
        let result = new CustomGrantsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        if (Array.isArray(this.usersAndOrganizationUnits)) {
            data["usersAndOrganizationUnits"] = [];
            for (let item of this.usersAndOrganizationUnits)
                data["usersAndOrganizationUnits"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomGrantsInput {
    entityId: number;
    usersAndOrganizationUnits: UserOrOrganizationUnitInput[] | undefined;
}

export class CustomGrantsWithAccessRestrictionInput implements ICustomGrantsWithAccessRestrictionInput {
    entityId!: number;
    accessRestrictionProvisionalData!: UserOrOrganizationUnitInput[] | undefined;
    customGrantsForPermissions!: CustomGrantsForPermissionInput[] | undefined;

    constructor(data?: ICustomGrantsWithAccessRestrictionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            if (Array.isArray(_data["accessRestrictionProvisionalData"])) {
                this.accessRestrictionProvisionalData = [] as any;
                for (let item of _data["accessRestrictionProvisionalData"])
                    this.accessRestrictionProvisionalData!.push(UserOrOrganizationUnitInput.fromJS(item));
            }
            if (Array.isArray(_data["customGrantsForPermissions"])) {
                this.customGrantsForPermissions = [] as any;
                for (let item of _data["customGrantsForPermissions"])
                    this.customGrantsForPermissions!.push(CustomGrantsForPermissionInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomGrantsWithAccessRestrictionInput {
        data = typeof data === 'object' ? data : {};
        let result = new CustomGrantsWithAccessRestrictionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        if (Array.isArray(this.accessRestrictionProvisionalData)) {
            data["accessRestrictionProvisionalData"] = [];
            for (let item of this.accessRestrictionProvisionalData)
                data["accessRestrictionProvisionalData"].push(item.toJSON());
        }
        if (Array.isArray(this.customGrantsForPermissions)) {
            data["customGrantsForPermissions"] = [];
            for (let item of this.customGrantsForPermissions)
                data["customGrantsForPermissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomGrantsWithAccessRestrictionInput {
    entityId: number;
    accessRestrictionProvisionalData: UserOrOrganizationUnitInput[] | undefined;
    customGrantsForPermissions: CustomGrantsForPermissionInput[] | undefined;
}

export class DateRange implements IDateRange {
    startDate!: DateTime | undefined;
    endDate!: DateTime | undefined;

    constructor(data?: IDateRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DateRange {
        data = typeof data === 'object' ? data : {};
        let result = new DateRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
        return data;
    }
}

export interface IDateRange {
    startDate: DateTime | undefined;
    endDate: DateTime | undefined;
}

export class DeleteMultipleNodeGroupInput implements IDeleteMultipleNodeGroupInput {
    projectId!: number;
    organizationalEntityId!: number | undefined;
    blendingCircleSubgroupId!: number | undefined;
    organizationalEntityUpeShareholderId!: number | undefined;
    ownerId!: number | undefined;
    financialTreeType!: FinancialTreeType;
    multipleNodeGroupType!: FinancialNodeGroupType;
    nodeGroupId!: number;

    constructor(data?: IDeleteMultipleNodeGroupInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
            this.organizationalEntityUpeShareholderId = _data["organizationalEntityUpeShareholderId"];
            this.ownerId = _data["ownerId"];
            this.financialTreeType = _data["financialTreeType"];
            this.multipleNodeGroupType = _data["multipleNodeGroupType"];
            this.nodeGroupId = _data["nodeGroupId"];
        }
    }

    static fromJS(data: any): DeleteMultipleNodeGroupInput {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMultipleNodeGroupInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        data["organizationalEntityUpeShareholderId"] = this.organizationalEntityUpeShareholderId;
        data["ownerId"] = this.ownerId;
        data["financialTreeType"] = this.financialTreeType;
        data["multipleNodeGroupType"] = this.multipleNodeGroupType;
        data["nodeGroupId"] = this.nodeGroupId;
        return data;
    }
}

export interface IDeleteMultipleNodeGroupInput {
    projectId: number;
    organizationalEntityId: number | undefined;
    blendingCircleSubgroupId: number | undefined;
    organizationalEntityUpeShareholderId: number | undefined;
    ownerId: number | undefined;
    financialTreeType: FinancialTreeType;
    multipleNodeGroupType: FinancialNodeGroupType;
    nodeGroupId: number;
}

export class DeleteMultipleShiftNodeGroupInput implements IDeleteMultipleShiftNodeGroupInput {
    projectId!: number;
    sourceOrganizationalEntityId!: number;
    targetOrganizationalEntityId!: number | undefined;
    multipleNodeGroupType!: FinancialNodeGroupType;
    nodeGroupId!: number;
    financialTreeType!: FinancialTreeType;
    directionType!: DirectionType | undefined;

    constructor(data?: IDeleteMultipleShiftNodeGroupInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.sourceOrganizationalEntityId = _data["sourceOrganizationalEntityId"];
            this.targetOrganizationalEntityId = _data["targetOrganizationalEntityId"];
            this.multipleNodeGroupType = _data["multipleNodeGroupType"];
            this.nodeGroupId = _data["nodeGroupId"];
            this.financialTreeType = _data["financialTreeType"];
            this.directionType = _data["directionType"];
        }
    }

    static fromJS(data: any): DeleteMultipleShiftNodeGroupInput {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMultipleShiftNodeGroupInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["sourceOrganizationalEntityId"] = this.sourceOrganizationalEntityId;
        data["targetOrganizationalEntityId"] = this.targetOrganizationalEntityId;
        data["multipleNodeGroupType"] = this.multipleNodeGroupType;
        data["nodeGroupId"] = this.nodeGroupId;
        data["financialTreeType"] = this.financialTreeType;
        data["directionType"] = this.directionType;
        return data;
    }
}

export interface IDeleteMultipleShiftNodeGroupInput {
    projectId: number;
    sourceOrganizationalEntityId: number;
    targetOrganizationalEntityId: number | undefined;
    multipleNodeGroupType: FinancialNodeGroupType;
    nodeGroupId: number;
    financialTreeType: FinancialTreeType;
    directionType: DirectionType | undefined;
}

export enum DirectionType {
    SendingOnly = 1,
    ReceivingOnly = 2,
    Bidirectional = 3,
}

export enum DueDateStatus {
    InPlan = 0,
    Urgent = 1,
    OverDue = 2,
}

export class EditChannelInput implements IEditChannelInput {
    referenceId!: number;
    title!: string | undefined;
    id!: number;

    constructor(data?: IEditChannelInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referenceId = _data["referenceId"];
            this.title = _data["title"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EditChannelInput {
        data = typeof data === 'object' ? data : {};
        let result = new EditChannelInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceId"] = this.referenceId;
        data["title"] = this.title;
        data["id"] = this.id;
        return data;
    }
}

export interface IEditChannelInput {
    referenceId: number;
    title: string | undefined;
    id: number;
}

export class EditCommunicationInput implements IEditCommunicationInput {
    content!: string | undefined;
    id!: number;

    constructor(data?: IEditCommunicationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EditCommunicationInput {
        data = typeof data === 'object' ? data : {};
        let result = new EditCommunicationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        data["id"] = this.id;
        return data;
    }
}

export interface IEditCommunicationInput {
    content: string | undefined;
    id: number;
}

export enum ElectionCurrency {
    Local = 1,
    Cfs = 2,
}

export enum ElectionInclusionType {
    TotalAmountInclusionInTheTriggeringEventFiscalYear = 1,
    FiveYearInclusion = 2,
}

export class ElectionNodeDto implements IElectionNodeDto {
    id!: number;
    blendingCircleSubgroupId!: number | undefined;
    organizationalEntityId!: number | undefined;
    electionType!: ElectionType | undefined;
    value!: boolean | undefined;
    hasYear!: boolean;
    electionYear!: DateTime | undefined;
    revocationYear!: DateTime | undefined;
    inclusionType!: ElectionInclusionType | undefined;
    hasReadPermission!: boolean;
    hasWritePermission!: boolean;
    validationLogic!: ElectionValidationLogic | undefined;
    equityInvestmentDetails!: EquityInvestmentInclusionElectionDetailsDto | undefined;
    permanentSafeHarbourTypes!: PermanentSafeHarbourType[] | undefined;

    constructor(data?: IElectionNodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.electionType = _data["electionType"];
            this.value = _data["value"];
            this.hasYear = _data["hasYear"];
            this.electionYear = _data["electionYear"] ? DateTime.fromISO(_data["electionYear"].toString()) : <any>undefined;
            this.revocationYear = _data["revocationYear"] ? DateTime.fromISO(_data["revocationYear"].toString()) : <any>undefined;
            this.inclusionType = _data["inclusionType"];
            this.hasReadPermission = _data["hasReadPermission"];
            this.hasWritePermission = _data["hasWritePermission"];
            this.validationLogic = _data["validationLogic"] ? ElectionValidationLogic.fromJS(_data["validationLogic"]) : <any>undefined;
            this.equityInvestmentDetails = _data["equityInvestmentDetails"] ? EquityInvestmentInclusionElectionDetailsDto.fromJS(_data["equityInvestmentDetails"]) : <any>undefined;
            if (Array.isArray(_data["permanentSafeHarbourTypes"])) {
                this.permanentSafeHarbourTypes = [] as any;
                for (let item of _data["permanentSafeHarbourTypes"])
                    this.permanentSafeHarbourTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): ElectionNodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElectionNodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["electionType"] = this.electionType;
        data["value"] = this.value;
        data["hasYear"] = this.hasYear;
        data["electionYear"] = this.electionYear ? this.electionYear.toString() : <any>undefined;
        data["revocationYear"] = this.revocationYear ? this.revocationYear.toString() : <any>undefined;
        data["inclusionType"] = this.inclusionType;
        data["hasReadPermission"] = this.hasReadPermission;
        data["hasWritePermission"] = this.hasWritePermission;
        data["validationLogic"] = this.validationLogic ? this.validationLogic.toJSON() : <any>undefined;
        data["equityInvestmentDetails"] = this.equityInvestmentDetails ? this.equityInvestmentDetails.toJSON() : <any>undefined;
        if (Array.isArray(this.permanentSafeHarbourTypes)) {
            data["permanentSafeHarbourTypes"] = [];
            for (let item of this.permanentSafeHarbourTypes)
                data["permanentSafeHarbourTypes"].push(item);
        }
        return data;
    }
}

export interface IElectionNodeDto {
    id: number;
    blendingCircleSubgroupId: number | undefined;
    organizationalEntityId: number | undefined;
    electionType: ElectionType | undefined;
    value: boolean | undefined;
    hasYear: boolean;
    electionYear: DateTime | undefined;
    revocationYear: DateTime | undefined;
    inclusionType: ElectionInclusionType | undefined;
    hasReadPermission: boolean;
    hasWritePermission: boolean;
    validationLogic: ElectionValidationLogic | undefined;
    equityInvestmentDetails: EquityInvestmentInclusionElectionDetailsDto | undefined;
    permanentSafeHarbourTypes: PermanentSafeHarbourType[] | undefined;
}

export enum ElectionRuleType {
    MinYear2024 = 1,
    NoRevocationYear = 2,
    PermanentSafeHarbourRequired = 3,
}

export enum ElectionType {
    AggregateAssetGainElection = 1,
    RealisationPrincipleElection = 2,
    EquityInvestmentInclusionElection = 3,
    StockBasedCompensationElection = 4,
    IntraGroupTransactionsElection = 5,
    ApplicationOfTheSubstanceBasedIncomeExclusionRuleForachJurisdiction = 6,
    AdditionalCurrentTutAccToMr415Election = 7,
    DeemedDistributionTaxElection = 8,
    ImmaterialDecreaseInCoveredTaxesElection = 9,
    NotAllocateCrossBorderDeferredTaxElection = 10,
    DeMinimisExclusionElection = 11,
    DeptReleaseElection = 51,
    InclusionOfAllDividendsWithRespectToPortfolioShareholdings = 52,
    ЕxpenseRelatedUnclaimedAccElection = 53,
    TreatingForeignExchangeGainLossHedgingExcludedEquityGainLossElection = 54,
    UnclaimedAcrrualFiveYearElection = 55,
    NmceSimplifiedCalculationElection = 56,
    GlobeLossElection = 101,
    FairValueElection = 102,
}

export class ElectionValidationLogic implements IElectionValidationLogic {
    electionRules!: ElectionRuleType[] | undefined;

    constructor(data?: IElectionValidationLogic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["electionRules"])) {
                this.electionRules = [] as any;
                for (let item of _data["electionRules"])
                    this.electionRules!.push(item);
            }
        }
    }

    static fromJS(data: any): ElectionValidationLogic {
        data = typeof data === 'object' ? data : {};
        let result = new ElectionValidationLogic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.electionRules)) {
            data["electionRules"] = [];
            for (let item of this.electionRules)
                data["electionRules"].push(item);
        }
        return data;
    }
}

export interface IElectionValidationLogic {
    electionRules: ElectionRuleType[] | undefined;
}

export class EligibilityReductionReferenceDto implements IEligibilityReductionReferenceDto {
    id!: number;
    text!: string | undefined;
    discriminator!: BasisOfReductionOfGloBEIncome;

    constructor(data?: IEligibilityReductionReferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            this.discriminator = _data["discriminator"];
        }
    }

    static fromJS(data: any): EligibilityReductionReferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new EligibilityReductionReferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["discriminator"] = this.discriminator;
        return data;
    }
}

export interface IEligibilityReductionReferenceDto {
    id: number;
    text: string | undefined;
    discriminator: BasisOfReductionOfGloBEIncome;
}

export enum EligibilityReductionType {
    No = 1,
    TaxedAtMinimumRate = 2,
    TaxesExceedMinimum = 3,
    HolderIsNaturalPerson = 4,
    HolderIsCorporate = 5,
    DividendTaxedAtMinimumRate = 6,
    DividendTaxesExceedMinimum = 7,
    PatronageDividendNaturalPerson = 8,
    DividendHolderIsNaturalPerson = 9,
    DividendHolderIsCorporate = 10,
}

export class EnititySbieInconsistencyResultDto implements IEnititySbieInconsistencyResultDto {
    organisationalEntityId!: number;
    hasPayrollInconsistency!: boolean;
    hasTangibleAssetInconsitency!: boolean;

    constructor(data?: IEnititySbieInconsistencyResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisationalEntityId = _data["organisationalEntityId"];
            this.hasPayrollInconsistency = _data["hasPayrollInconsistency"];
            this.hasTangibleAssetInconsitency = _data["hasTangibleAssetInconsitency"];
        }
    }

    static fromJS(data: any): EnititySbieInconsistencyResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnititySbieInconsistencyResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisationalEntityId"] = this.organisationalEntityId;
        data["hasPayrollInconsistency"] = this.hasPayrollInconsistency;
        data["hasTangibleAssetInconsitency"] = this.hasTangibleAssetInconsitency;
        return data;
    }
}

export interface IEnititySbieInconsistencyResultDto {
    organisationalEntityId: number;
    hasPayrollInconsistency: boolean;
    hasTangibleAssetInconsitency: boolean;
}

export class EntityChangeDataDto implements IEntityChangeDataDto {
    id!: number;
    userId!: number | undefined;
    userName!: string | undefined;
    changeTime!: DateTime;
    entityTypeFullName!: string | undefined;
    changeType!: EntityChangeType;
    readonly changeTypeName!: string | undefined;
    entityChangeSetId!: number;
    entityId!: number;
    impersonatorUserName!: string | undefined;
    propertyChanges!: EntityPropertyChangeDto[] | undefined;
    user!: UserDetailsDto | undefined;

    constructor(data?: IEntityChangeDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.changeTime = _data["changeTime"] ? DateTime.fromISO(_data["changeTime"].toString()) : <any>undefined;
            this.entityTypeFullName = _data["entityTypeFullName"];
            this.changeType = _data["changeType"];
            (<any>this).changeTypeName = _data["changeTypeName"];
            this.entityChangeSetId = _data["entityChangeSetId"];
            this.entityId = _data["entityId"];
            this.impersonatorUserName = _data["impersonatorUserName"];
            if (Array.isArray(_data["propertyChanges"])) {
                this.propertyChanges = [] as any;
                for (let item of _data["propertyChanges"])
                    this.propertyChanges!.push(EntityPropertyChangeDto.fromJS(item));
            }
            this.user = _data["user"] ? UserDetailsDto.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EntityChangeDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityChangeDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["changeTime"] = this.changeTime ? this.changeTime.toString() : <any>undefined;
        data["entityTypeFullName"] = this.entityTypeFullName;
        data["changeType"] = this.changeType;
        data["changeTypeName"] = this.changeTypeName;
        data["entityChangeSetId"] = this.entityChangeSetId;
        data["entityId"] = this.entityId;
        data["impersonatorUserName"] = this.impersonatorUserName;
        if (Array.isArray(this.propertyChanges)) {
            data["propertyChanges"] = [];
            for (let item of this.propertyChanges)
                data["propertyChanges"].push(item.toJSON());
        }
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEntityChangeDataDto {
    id: number;
    userId: number | undefined;
    userName: string | undefined;
    changeTime: DateTime;
    entityTypeFullName: string | undefined;
    changeType: EntityChangeType;
    changeTypeName: string | undefined;
    entityChangeSetId: number;
    entityId: number;
    impersonatorUserName: string | undefined;
    propertyChanges: EntityPropertyChangeDto[] | undefined;
    user: UserDetailsDto | undefined;
}

export class EntityChangeResolvedDto implements IEntityChangeResolvedDto {
    id!: number;
    entityChangeSetId!: number;
    changeTime!: DateTime;
    isConfirmed!: boolean;
    isValueInLocalCurrency!: boolean;
    initialValue!: string | undefined;
    comment!: string | undefined;
    notes!: string | undefined;
    etrDisplayValue!: string | undefined;
    additionalProperties!: EntityChangeResolvedPropertyDto[] | undefined;
    user!: UserDetailsDto | undefined;

    constructor(data?: IEntityChangeResolvedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entityChangeSetId = _data["entityChangeSetId"];
            this.changeTime = _data["changeTime"] ? DateTime.fromISO(_data["changeTime"].toString()) : <any>undefined;
            this.isConfirmed = _data["isConfirmed"];
            this.isValueInLocalCurrency = _data["isValueInLocalCurrency"];
            this.initialValue = _data["initialValue"];
            this.comment = _data["comment"];
            this.notes = _data["notes"];
            this.etrDisplayValue = _data["etrDisplayValue"];
            if (Array.isArray(_data["additionalProperties"])) {
                this.additionalProperties = [] as any;
                for (let item of _data["additionalProperties"])
                    this.additionalProperties!.push(EntityChangeResolvedPropertyDto.fromJS(item));
            }
            this.user = _data["user"] ? UserDetailsDto.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EntityChangeResolvedDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityChangeResolvedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityChangeSetId"] = this.entityChangeSetId;
        data["changeTime"] = this.changeTime ? this.changeTime.toString() : <any>undefined;
        data["isConfirmed"] = this.isConfirmed;
        data["isValueInLocalCurrency"] = this.isValueInLocalCurrency;
        data["initialValue"] = this.initialValue;
        data["comment"] = this.comment;
        data["notes"] = this.notes;
        data["etrDisplayValue"] = this.etrDisplayValue;
        if (Array.isArray(this.additionalProperties)) {
            data["additionalProperties"] = [];
            for (let item of this.additionalProperties)
                data["additionalProperties"].push(item.toJSON());
        }
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEntityChangeResolvedDto {
    id: number;
    entityChangeSetId: number;
    changeTime: DateTime;
    isConfirmed: boolean;
    isValueInLocalCurrency: boolean;
    initialValue: string | undefined;
    comment: string | undefined;
    notes: string | undefined;
    etrDisplayValue: string | undefined;
    additionalProperties: EntityChangeResolvedPropertyDto[] | undefined;
    user: UserDetailsDto | undefined;
}

export class EntityChangeResolvedPropertyDto implements IEntityChangeResolvedPropertyDto {
    propertyName!: string | undefined;
    value!: string | undefined;

    constructor(data?: IEntityChangeResolvedPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyName = _data["propertyName"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): EntityChangeResolvedPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityChangeResolvedPropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName;
        data["value"] = this.value;
        return data;
    }
}

export interface IEntityChangeResolvedPropertyDto {
    propertyName: string | undefined;
    value: string | undefined;
}

export enum EntityChangeType {
    Created = 0,
    Updated = 1,
    Deleted = 2,
}

export class EntityChangesDto implements IEntityChangesDto {
    entityChanges!: EntityChangeDataDto[] | undefined;
    additionalProperties!: AdditionalPropertyInfoDto[] | undefined;
    resolvedEntityChanges!: EntityChangeResolvedDto[] | undefined;
    inputValueIsExcluded!: boolean;
    inputValueIsPercent!: boolean;

    constructor(data?: IEntityChangesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["entityChanges"])) {
                this.entityChanges = [] as any;
                for (let item of _data["entityChanges"])
                    this.entityChanges!.push(EntityChangeDataDto.fromJS(item));
            }
            if (Array.isArray(_data["additionalProperties"])) {
                this.additionalProperties = [] as any;
                for (let item of _data["additionalProperties"])
                    this.additionalProperties!.push(AdditionalPropertyInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["resolvedEntityChanges"])) {
                this.resolvedEntityChanges = [] as any;
                for (let item of _data["resolvedEntityChanges"])
                    this.resolvedEntityChanges!.push(EntityChangeResolvedDto.fromJS(item));
            }
            this.inputValueIsExcluded = _data["inputValueIsExcluded"];
            this.inputValueIsPercent = _data["inputValueIsPercent"];
        }
    }

    static fromJS(data: any): EntityChangesDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityChangesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entityChanges)) {
            data["entityChanges"] = [];
            for (let item of this.entityChanges)
                data["entityChanges"].push(item.toJSON());
        }
        if (Array.isArray(this.additionalProperties)) {
            data["additionalProperties"] = [];
            for (let item of this.additionalProperties)
                data["additionalProperties"].push(item.toJSON());
        }
        if (Array.isArray(this.resolvedEntityChanges)) {
            data["resolvedEntityChanges"] = [];
            for (let item of this.resolvedEntityChanges)
                data["resolvedEntityChanges"].push(item.toJSON());
        }
        data["inputValueIsExcluded"] = this.inputValueIsExcluded;
        data["inputValueIsPercent"] = this.inputValueIsPercent;
        return data;
    }
}

export interface IEntityChangesDto {
    entityChanges: EntityChangeDataDto[] | undefined;
    additionalProperties: AdditionalPropertyInfoDto[] | undefined;
    resolvedEntityChanges: EntityChangeResolvedDto[] | undefined;
    inputValueIsExcluded: boolean;
    inputValueIsPercent: boolean;
}

export class EntityManagementDto implements IEntityManagementDto {
    dueDate!: DateTime | undefined;
    dueDateStatus!: DueDateStatus | undefined;
    assignedUser!: AssignableUserDto | undefined;
    hasWriteAccess!: boolean;

    constructor(data?: IEntityManagementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
            this.dueDateStatus = _data["dueDateStatus"];
            this.assignedUser = _data["assignedUser"] ? AssignableUserDto.fromJS(_data["assignedUser"]) : <any>undefined;
            this.hasWriteAccess = _data["hasWriteAccess"];
        }
    }

    static fromJS(data: any): EntityManagementDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityManagementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dueDate"] = this.dueDate ? this.dueDate.toString() : <any>undefined;
        data["dueDateStatus"] = this.dueDateStatus;
        data["assignedUser"] = this.assignedUser ? this.assignedUser.toJSON() : <any>undefined;
        data["hasWriteAccess"] = this.hasWriteAccess;
        return data;
    }
}

export interface IEntityManagementDto {
    dueDate: DateTime | undefined;
    dueDateStatus: DueDateStatus | undefined;
    assignedUser: AssignableUserDto | undefined;
    hasWriteAccess: boolean;
}

export class EntityPermissionDto implements IEntityPermissionDto {
    referenceId!: number;
    permissionName!: string | undefined;
    isActive!: boolean;
    possibleUsers!: ListResultDtoOfUserOrOrganizationUnitDto | undefined;
    usersOrOrganizationUnits!: ListResultDtoOfUserOrOrganizationUnitDto | undefined;
    availableUsersOrOrganizationUnits!: ListResultDtoOfUserOrOrganizationUnitDto | undefined;

    constructor(data?: IEntityPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referenceId = _data["referenceId"];
            this.permissionName = _data["permissionName"];
            this.isActive = _data["isActive"];
            this.possibleUsers = _data["possibleUsers"] ? ListResultDtoOfUserOrOrganizationUnitDto.fromJS(_data["possibleUsers"]) : <any>undefined;
            this.usersOrOrganizationUnits = _data["usersOrOrganizationUnits"] ? ListResultDtoOfUserOrOrganizationUnitDto.fromJS(_data["usersOrOrganizationUnits"]) : <any>undefined;
            this.availableUsersOrOrganizationUnits = _data["availableUsersOrOrganizationUnits"] ? ListResultDtoOfUserOrOrganizationUnitDto.fromJS(_data["availableUsersOrOrganizationUnits"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EntityPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceId"] = this.referenceId;
        data["permissionName"] = this.permissionName;
        data["isActive"] = this.isActive;
        data["possibleUsers"] = this.possibleUsers ? this.possibleUsers.toJSON() : <any>undefined;
        data["usersOrOrganizationUnits"] = this.usersOrOrganizationUnits ? this.usersOrOrganizationUnits.toJSON() : <any>undefined;
        data["availableUsersOrOrganizationUnits"] = this.availableUsersOrOrganizationUnits ? this.availableUsersOrOrganizationUnits.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEntityPermissionDto {
    referenceId: number;
    permissionName: string | undefined;
    isActive: boolean;
    possibleUsers: ListResultDtoOfUserOrOrganizationUnitDto | undefined;
    usersOrOrganizationUnits: ListResultDtoOfUserOrOrganizationUnitDto | undefined;
    availableUsersOrOrganizationUnits: ListResultDtoOfUserOrOrganizationUnitDto | undefined;
}

export class EntityPropertyChangeDto implements IEntityPropertyChangeDto {
    id!: number;
    entityChangeId!: number;
    newValue!: string | undefined;
    originalValue!: string | undefined;
    propertyName!: string | undefined;
    propertyTypeFullName!: string | undefined;
    tenantId!: number | undefined;

    constructor(data?: IEntityPropertyChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entityChangeId = _data["entityChangeId"];
            this.newValue = _data["newValue"];
            this.originalValue = _data["originalValue"];
            this.propertyName = _data["propertyName"];
            this.propertyTypeFullName = _data["propertyTypeFullName"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): EntityPropertyChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityPropertyChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityChangeId"] = this.entityChangeId;
        data["newValue"] = this.newValue;
        data["originalValue"] = this.originalValue;
        data["propertyName"] = this.propertyName;
        data["propertyTypeFullName"] = this.propertyTypeFullName;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IEntityPropertyChangeDto {
    id: number;
    entityChangeId: number;
    newValue: string | undefined;
    originalValue: string | undefined;
    propertyName: string | undefined;
    propertyTypeFullName: string | undefined;
    tenantId: number | undefined;
}

export class EquityInvestmentInclusionElectionDetailsDto implements IEquityInvestmentInclusionElectionDetailsDto {
    qualifiedOwnershipInterest!: number;
    additions!: number;
    reductions!: number;

    constructor(data?: IEquityInvestmentInclusionElectionDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualifiedOwnershipInterest = _data["qualifiedOwnershipInterest"];
            this.additions = _data["additions"];
            this.reductions = _data["reductions"];
        }
    }

    static fromJS(data: any): EquityInvestmentInclusionElectionDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new EquityInvestmentInclusionElectionDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualifiedOwnershipInterest"] = this.qualifiedOwnershipInterest;
        data["additions"] = this.additions;
        data["reductions"] = this.reductions;
        return data;
    }
}

export interface IEquityInvestmentInclusionElectionDetailsDto {
    qualifiedOwnershipInterest: number;
    additions: number;
    reductions: number;
}

export class ExportOverviewToExcelInput implements IExportOverviewToExcelInput {
    referenceId!: string | undefined;
    exportAllEntries!: boolean;
    columns!: string[] | undefined;
    type!: string | undefined;
    settings!: string | undefined;

    constructor(data?: IExportOverviewToExcelInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referenceId = _data["referenceId"];
            this.exportAllEntries = _data["exportAllEntries"];
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(item);
            }
            this.type = _data["type"];
            this.settings = _data["settings"];
        }
    }

    static fromJS(data: any): ExportOverviewToExcelInput {
        data = typeof data === 'object' ? data : {};
        let result = new ExportOverviewToExcelInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceId"] = this.referenceId;
        data["exportAllEntries"] = this.exportAllEntries;
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item);
        }
        data["type"] = this.type;
        data["settings"] = this.settings;
        return data;
    }
}

export interface IExportOverviewToExcelInput {
    referenceId: string | undefined;
    exportAllEntries: boolean;
    columns: string[] | undefined;
    type: string | undefined;
    settings: string | undefined;
}

export class FileContributionInfoDto implements IFileContributionInfoDto {
    fileId!: number;
    isModifiable!: boolean;
    isForbidden!: boolean;
    refType!: string | undefined;
    refId!: number;
    refName!: string | undefined;

    constructor(data?: IFileContributionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.isModifiable = _data["isModifiable"];
            this.isForbidden = _data["isForbidden"];
            this.refType = _data["refType"];
            this.refId = _data["refId"];
            this.refName = _data["refName"];
        }
    }

    static fromJS(data: any): FileContributionInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileContributionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["isModifiable"] = this.isModifiable;
        data["isForbidden"] = this.isForbidden;
        data["refType"] = this.refType;
        data["refId"] = this.refId;
        data["refName"] = this.refName;
        return data;
    }
}

export interface IFileContributionInfoDto {
    fileId: number;
    isModifiable: boolean;
    isForbidden: boolean;
    refType: string | undefined;
    refId: number;
    refName: string | undefined;
}

export class FileDownloadDto implements IFileDownloadDto {
    fileName!: string | undefined;
    readonly content!: string | undefined;
    readonly mimeType!: string | undefined;

    constructor(data?: IFileDownloadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            (<any>this).content = _data["content"];
            (<any>this).mimeType = _data["mimeType"];
        }
    }

    static fromJS(data: any): FileDownloadDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDownloadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["content"] = this.content;
        data["mimeType"] = this.mimeType;
        return data;
    }
}

export interface IFileDownloadDto {
    fileName: string | undefined;
    content: string | undefined;
    mimeType: string | undefined;
}

export class FileDto implements IFileDto {
    fileName!: string;
    readonly fileType!: string | undefined;
    fileToken!: string;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            (<any>this).fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface IFileDto {
    fileName: string;
    fileType: string | undefined;
    fileToken: string;
}

export class FileMaxLengthSettings implements IFileMaxLengthSettings {
    maxFileLength!: number;
    maxFileLengthUserFriendlyValue!: string | undefined;

    constructor(data?: IFileMaxLengthSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxFileLength = _data["maxFileLength"];
            this.maxFileLengthUserFriendlyValue = _data["maxFileLengthUserFriendlyValue"];
        }
    }

    static fromJS(data: any): FileMaxLengthSettings {
        data = typeof data === 'object' ? data : {};
        let result = new FileMaxLengthSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxFileLength"] = this.maxFileLength;
        data["maxFileLengthUserFriendlyValue"] = this.maxFileLengthUserFriendlyValue;
        return data;
    }
}

export interface IFileMaxLengthSettings {
    maxFileLength: number;
    maxFileLengthUserFriendlyValue: string | undefined;
}

export enum FinancialAccountingStandard {
    IRFS = 1,
    HGB = 2,
    GAAP = 3,
}

export enum FinancialCombinedType {
    GlobeActTransactionsBetweenCesValue = 1,
    GlobeActTaxableDistributionMethod = 2,
}

export class FinancialDataCurrencyConvertedFinalDto implements IFinancialDataCurrencyConvertedFinalDto {
    currencyConvertedValue!: string | undefined;
    presentationCurrency!: string | undefined;

    constructor(data?: IFinancialDataCurrencyConvertedFinalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currencyConvertedValue = _data["currencyConvertedValue"];
            this.presentationCurrency = _data["presentationCurrency"];
        }
    }

    static fromJS(data: any): FinancialDataCurrencyConvertedFinalDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialDataCurrencyConvertedFinalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyConvertedValue"] = this.currencyConvertedValue;
        data["presentationCurrency"] = this.presentationCurrency;
        return data;
    }
}

export interface IFinancialDataCurrencyConvertedFinalDto {
    currencyConvertedValue: string | undefined;
    presentationCurrency: string | undefined;
}

export class FinancialDataOrganizationalEntityOverviewDto implements IFinancialDataOrganizationalEntityOverviewDto {
    points!: FinancialValuePointOverviewDto[] | undefined;
    hasWritePermission!: boolean;
    rowExpandDisabled!: boolean;
    organizationalEntityId!: number;
    legalName!: string | undefined;
    entityNumber!: string | undefined;
    legalNameInfoLabel!: string | undefined;
    currency!: string | undefined;
    isNotConsidered!: boolean;
    canAddOrUpdateFinancialData!: boolean;

    constructor(data?: IFinancialDataOrganizationalEntityOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["points"])) {
                this.points = [] as any;
                for (let item of _data["points"])
                    this.points!.push(FinancialValuePointOverviewDto.fromJS(item));
            }
            this.hasWritePermission = _data["hasWritePermission"];
            this.rowExpandDisabled = _data["rowExpandDisabled"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.legalName = _data["legalName"];
            this.entityNumber = _data["entityNumber"];
            this.legalNameInfoLabel = _data["legalNameInfoLabel"];
            this.currency = _data["currency"];
            this.isNotConsidered = _data["isNotConsidered"];
            this.canAddOrUpdateFinancialData = _data["canAddOrUpdateFinancialData"];
        }
    }

    static fromJS(data: any): FinancialDataOrganizationalEntityOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialDataOrganizationalEntityOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.points)) {
            data["points"] = [];
            for (let item of this.points)
                data["points"].push(item.toJSON());
        }
        data["hasWritePermission"] = this.hasWritePermission;
        data["rowExpandDisabled"] = this.rowExpandDisabled;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["legalName"] = this.legalName;
        data["entityNumber"] = this.entityNumber;
        data["legalNameInfoLabel"] = this.legalNameInfoLabel;
        data["currency"] = this.currency;
        data["isNotConsidered"] = this.isNotConsidered;
        data["canAddOrUpdateFinancialData"] = this.canAddOrUpdateFinancialData;
        return data;
    }
}

export interface IFinancialDataOrganizationalEntityOverviewDto {
    points: FinancialValuePointOverviewDto[] | undefined;
    hasWritePermission: boolean;
    rowExpandDisabled: boolean;
    organizationalEntityId: number;
    legalName: string | undefined;
    entityNumber: string | undefined;
    legalNameInfoLabel: string | undefined;
    currency: string | undefined;
    isNotConsidered: boolean;
    canAddOrUpdateFinancialData: boolean;
}

export class FinancialDataSafeHarbourGroupOverviewDto implements IFinancialDataSafeHarbourGroupOverviewDto {
    points!: FinancialValuePointOverviewDto[] | undefined;
    hasWritePermission!: boolean;
    rowExpandDisabled!: boolean;
    safeHarbourGroupId!: number | undefined;
    deMinimisCheckResult!: SafeHarbourCheckResultDto | undefined;
    setrCheckResult!: SafeHarbourCheckResultDto | undefined;
    routineProfitsCheckResult!: SafeHarbourCheckResultDto | undefined;
    testsStatus!: TestsStatus;
    hasReadPermission!: boolean;
    countryCode!: string | undefined;
    currency!: string | undefined;

    constructor(data?: IFinancialDataSafeHarbourGroupOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["points"])) {
                this.points = [] as any;
                for (let item of _data["points"])
                    this.points!.push(FinancialValuePointOverviewDto.fromJS(item));
            }
            this.hasWritePermission = _data["hasWritePermission"];
            this.rowExpandDisabled = _data["rowExpandDisabled"];
            this.safeHarbourGroupId = _data["safeHarbourGroupId"];
            this.deMinimisCheckResult = _data["deMinimisCheckResult"] ? SafeHarbourCheckResultDto.fromJS(_data["deMinimisCheckResult"]) : <any>undefined;
            this.setrCheckResult = _data["setrCheckResult"] ? SafeHarbourCheckResultDto.fromJS(_data["setrCheckResult"]) : <any>undefined;
            this.routineProfitsCheckResult = _data["routineProfitsCheckResult"] ? SafeHarbourCheckResultDto.fromJS(_data["routineProfitsCheckResult"]) : <any>undefined;
            this.testsStatus = _data["testsStatus"];
            this.hasReadPermission = _data["hasReadPermission"];
            this.countryCode = _data["countryCode"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): FinancialDataSafeHarbourGroupOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialDataSafeHarbourGroupOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.points)) {
            data["points"] = [];
            for (let item of this.points)
                data["points"].push(item.toJSON());
        }
        data["hasWritePermission"] = this.hasWritePermission;
        data["rowExpandDisabled"] = this.rowExpandDisabled;
        data["safeHarbourGroupId"] = this.safeHarbourGroupId;
        data["deMinimisCheckResult"] = this.deMinimisCheckResult ? this.deMinimisCheckResult.toJSON() : <any>undefined;
        data["setrCheckResult"] = this.setrCheckResult ? this.setrCheckResult.toJSON() : <any>undefined;
        data["routineProfitsCheckResult"] = this.routineProfitsCheckResult ? this.routineProfitsCheckResult.toJSON() : <any>undefined;
        data["testsStatus"] = this.testsStatus;
        data["hasReadPermission"] = this.hasReadPermission;
        data["countryCode"] = this.countryCode;
        data["currency"] = this.currency;
        return data;
    }
}

export interface IFinancialDataSafeHarbourGroupOverviewDto {
    points: FinancialValuePointOverviewDto[] | undefined;
    hasWritePermission: boolean;
    rowExpandDisabled: boolean;
    safeHarbourGroupId: number | undefined;
    deMinimisCheckResult: SafeHarbourCheckResultDto | undefined;
    setrCheckResult: SafeHarbourCheckResultDto | undefined;
    routineProfitsCheckResult: SafeHarbourCheckResultDto | undefined;
    testsStatus: TestsStatus;
    hasReadPermission: boolean;
    countryCode: string | undefined;
    currency: string | undefined;
}

export class FinancialDataSafeHarbourGroupWorldMapDto implements IFinancialDataSafeHarbourGroupWorldMapDto {
    points!: FinancialValuePointOverviewDto[] | undefined;
    hasWritePermission!: boolean;
    rowExpandDisabled!: boolean;
    safeHarbourGroupId!: number | undefined;
    deMinimisCheckResult!: SafeHarbourCheckResultDto | undefined;
    setrCheckResult!: SafeHarbourCheckResultDto | undefined;
    routineProfitsCheckResult!: SafeHarbourCheckResultDto | undefined;
    testsStatus!: TestsStatus;
    hasReadPermission!: boolean;
    countryCode!: string | undefined;
    currency!: string | undefined;
    safeHarbourGroupType!: SafeHarbourGroupType | undefined;
    number!: number | undefined;

    constructor(data?: IFinancialDataSafeHarbourGroupWorldMapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["points"])) {
                this.points = [] as any;
                for (let item of _data["points"])
                    this.points!.push(FinancialValuePointOverviewDto.fromJS(item));
            }
            this.hasWritePermission = _data["hasWritePermission"];
            this.rowExpandDisabled = _data["rowExpandDisabled"];
            this.safeHarbourGroupId = _data["safeHarbourGroupId"];
            this.deMinimisCheckResult = _data["deMinimisCheckResult"] ? SafeHarbourCheckResultDto.fromJS(_data["deMinimisCheckResult"]) : <any>undefined;
            this.setrCheckResult = _data["setrCheckResult"] ? SafeHarbourCheckResultDto.fromJS(_data["setrCheckResult"]) : <any>undefined;
            this.routineProfitsCheckResult = _data["routineProfitsCheckResult"] ? SafeHarbourCheckResultDto.fromJS(_data["routineProfitsCheckResult"]) : <any>undefined;
            this.testsStatus = _data["testsStatus"];
            this.hasReadPermission = _data["hasReadPermission"];
            this.countryCode = _data["countryCode"];
            this.currency = _data["currency"];
            this.safeHarbourGroupType = _data["safeHarbourGroupType"];
            this.number = _data["number"];
        }
    }

    static fromJS(data: any): FinancialDataSafeHarbourGroupWorldMapDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialDataSafeHarbourGroupWorldMapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.points)) {
            data["points"] = [];
            for (let item of this.points)
                data["points"].push(item.toJSON());
        }
        data["hasWritePermission"] = this.hasWritePermission;
        data["rowExpandDisabled"] = this.rowExpandDisabled;
        data["safeHarbourGroupId"] = this.safeHarbourGroupId;
        data["deMinimisCheckResult"] = this.deMinimisCheckResult ? this.deMinimisCheckResult.toJSON() : <any>undefined;
        data["setrCheckResult"] = this.setrCheckResult ? this.setrCheckResult.toJSON() : <any>undefined;
        data["routineProfitsCheckResult"] = this.routineProfitsCheckResult ? this.routineProfitsCheckResult.toJSON() : <any>undefined;
        data["testsStatus"] = this.testsStatus;
        data["hasReadPermission"] = this.hasReadPermission;
        data["countryCode"] = this.countryCode;
        data["currency"] = this.currency;
        data["safeHarbourGroupType"] = this.safeHarbourGroupType;
        data["number"] = this.number;
        return data;
    }
}

export interface IFinancialDataSafeHarbourGroupWorldMapDto {
    points: FinancialValuePointOverviewDto[] | undefined;
    hasWritePermission: boolean;
    rowExpandDisabled: boolean;
    safeHarbourGroupId: number | undefined;
    deMinimisCheckResult: SafeHarbourCheckResultDto | undefined;
    setrCheckResult: SafeHarbourCheckResultDto | undefined;
    routineProfitsCheckResult: SafeHarbourCheckResultDto | undefined;
    testsStatus: TestsStatus;
    hasReadPermission: boolean;
    countryCode: string | undefined;
    currency: string | undefined;
    safeHarbourGroupType: SafeHarbourGroupType | undefined;
    number: number | undefined;
}

export class FinancialDeltaPointDto implements IFinancialDeltaPointDto {
    id!: number;
    financialValuePointId!: number;
    delta!: string | undefined;
    description!: string | undefined;

    constructor(data?: IFinancialDeltaPointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.financialValuePointId = _data["financialValuePointId"];
            this.delta = _data["delta"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FinancialDeltaPointDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialDeltaPointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["financialValuePointId"] = this.financialValuePointId;
        data["delta"] = this.delta;
        data["description"] = this.description;
        return data;
    }
}

export interface IFinancialDeltaPointDto {
    id: number;
    financialValuePointId: number;
    delta: string | undefined;
    description: string | undefined;
}

export class FinancialGroupDataJurisdictionsOverviewDto implements IFinancialGroupDataJurisdictionsOverviewDto {
    taxJurisdictionCountry!: string | undefined;
    isSafeHarboursExisting!: boolean;
    isSafeHarboursApplicable!: boolean;
    isSafeHarbourUTPRApplicable!: boolean;
    isFullScopeCalculationActivated!: boolean;
    deMinimisCheckResult!: SafeHarbourCheckResultDto | undefined;
    setrCheckResult!: SafeHarbourCheckResultDto | undefined;
    routineProfitsCheckResult!: SafeHarbourCheckResultDto | undefined;
    utprSafeHarbourCheckResult!: SafeHarbourCheckResultDto | undefined;
    globeIncomeLossPercentage!: number;
    adjustedCoveredTaxesPercentage!: number;
    substanceBasedIncomeExclusionPercentage!: number;
    effectiveTaxRateAndTopUpTaxPercentage!: number;
    hasReadPermission!: boolean;
    hasWritePermission!: boolean;
    rowExpandDisabled!: boolean;
    isSpecialPermissionsActivated!: boolean;
    isWritingActivated!: boolean;

    constructor(data?: IFinancialGroupDataJurisdictionsOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxJurisdictionCountry = _data["taxJurisdictionCountry"];
            this.isSafeHarboursExisting = _data["isSafeHarboursExisting"];
            this.isSafeHarboursApplicable = _data["isSafeHarboursApplicable"];
            this.isSafeHarbourUTPRApplicable = _data["isSafeHarbourUTPRApplicable"];
            this.isFullScopeCalculationActivated = _data["isFullScopeCalculationActivated"];
            this.deMinimisCheckResult = _data["deMinimisCheckResult"] ? SafeHarbourCheckResultDto.fromJS(_data["deMinimisCheckResult"]) : <any>undefined;
            this.setrCheckResult = _data["setrCheckResult"] ? SafeHarbourCheckResultDto.fromJS(_data["setrCheckResult"]) : <any>undefined;
            this.routineProfitsCheckResult = _data["routineProfitsCheckResult"] ? SafeHarbourCheckResultDto.fromJS(_data["routineProfitsCheckResult"]) : <any>undefined;
            this.utprSafeHarbourCheckResult = _data["utprSafeHarbourCheckResult"] ? SafeHarbourCheckResultDto.fromJS(_data["utprSafeHarbourCheckResult"]) : <any>undefined;
            this.globeIncomeLossPercentage = _data["globeIncomeLossPercentage"];
            this.adjustedCoveredTaxesPercentage = _data["adjustedCoveredTaxesPercentage"];
            this.substanceBasedIncomeExclusionPercentage = _data["substanceBasedIncomeExclusionPercentage"];
            this.effectiveTaxRateAndTopUpTaxPercentage = _data["effectiveTaxRateAndTopUpTaxPercentage"];
            this.hasReadPermission = _data["hasReadPermission"];
            this.hasWritePermission = _data["hasWritePermission"];
            this.rowExpandDisabled = _data["rowExpandDisabled"];
            this.isSpecialPermissionsActivated = _data["isSpecialPermissionsActivated"];
            this.isWritingActivated = _data["isWritingActivated"];
        }
    }

    static fromJS(data: any): FinancialGroupDataJurisdictionsOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialGroupDataJurisdictionsOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxJurisdictionCountry"] = this.taxJurisdictionCountry;
        data["isSafeHarboursExisting"] = this.isSafeHarboursExisting;
        data["isSafeHarboursApplicable"] = this.isSafeHarboursApplicable;
        data["isSafeHarbourUTPRApplicable"] = this.isSafeHarbourUTPRApplicable;
        data["isFullScopeCalculationActivated"] = this.isFullScopeCalculationActivated;
        data["deMinimisCheckResult"] = this.deMinimisCheckResult ? this.deMinimisCheckResult.toJSON() : <any>undefined;
        data["setrCheckResult"] = this.setrCheckResult ? this.setrCheckResult.toJSON() : <any>undefined;
        data["routineProfitsCheckResult"] = this.routineProfitsCheckResult ? this.routineProfitsCheckResult.toJSON() : <any>undefined;
        data["utprSafeHarbourCheckResult"] = this.utprSafeHarbourCheckResult ? this.utprSafeHarbourCheckResult.toJSON() : <any>undefined;
        data["globeIncomeLossPercentage"] = this.globeIncomeLossPercentage;
        data["adjustedCoveredTaxesPercentage"] = this.adjustedCoveredTaxesPercentage;
        data["substanceBasedIncomeExclusionPercentage"] = this.substanceBasedIncomeExclusionPercentage;
        data["effectiveTaxRateAndTopUpTaxPercentage"] = this.effectiveTaxRateAndTopUpTaxPercentage;
        data["hasReadPermission"] = this.hasReadPermission;
        data["hasWritePermission"] = this.hasWritePermission;
        data["rowExpandDisabled"] = this.rowExpandDisabled;
        data["isSpecialPermissionsActivated"] = this.isSpecialPermissionsActivated;
        data["isWritingActivated"] = this.isWritingActivated;
        return data;
    }
}

export interface IFinancialGroupDataJurisdictionsOverviewDto {
    taxJurisdictionCountry: string | undefined;
    isSafeHarboursExisting: boolean;
    isSafeHarboursApplicable: boolean;
    isSafeHarbourUTPRApplicable: boolean;
    isFullScopeCalculationActivated: boolean;
    deMinimisCheckResult: SafeHarbourCheckResultDto | undefined;
    setrCheckResult: SafeHarbourCheckResultDto | undefined;
    routineProfitsCheckResult: SafeHarbourCheckResultDto | undefined;
    utprSafeHarbourCheckResult: SafeHarbourCheckResultDto | undefined;
    globeIncomeLossPercentage: number;
    adjustedCoveredTaxesPercentage: number;
    substanceBasedIncomeExclusionPercentage: number;
    effectiveTaxRateAndTopUpTaxPercentage: number;
    hasReadPermission: boolean;
    hasWritePermission: boolean;
    rowExpandDisabled: boolean;
    isSpecialPermissionsActivated: boolean;
    isWritingActivated: boolean;
}

export class FinancialGroupDataOrganizationalEntityOverviewDto implements IFinancialGroupDataOrganizationalEntityOverviewDto {
    organizationalEntityId!: number;
    entityName!: string | undefined;
    entityNumber!: string | undefined;
    blendingCircleSubgroupId!: number | undefined;
    dueDate!: DateTime | undefined;
    assignedUser!: AssignableUserDto | undefined;
    process!: ProcessDto | undefined;
    dueDateStatus!: DueDateStatus | undefined;
    globeIncomeLossStatus!: FinancialGroupDataStatus;
    adjustedCoveredTaxesStatus!: FinancialGroupDataStatus;
    substanceBasedIncomeExclusionStatus!: FinancialGroupDataStatus;
    isWritingActivated!: boolean;
    hasWriteAccess!: boolean;

    constructor(data?: IFinancialGroupDataOrganizationalEntityOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.entityName = _data["entityName"];
            this.entityNumber = _data["entityNumber"];
            this.blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
            this.assignedUser = _data["assignedUser"] ? AssignableUserDto.fromJS(_data["assignedUser"]) : <any>undefined;
            this.process = _data["process"] ? ProcessDto.fromJS(_data["process"]) : <any>undefined;
            this.dueDateStatus = _data["dueDateStatus"];
            this.globeIncomeLossStatus = _data["globeIncomeLossStatus"];
            this.adjustedCoveredTaxesStatus = _data["adjustedCoveredTaxesStatus"];
            this.substanceBasedIncomeExclusionStatus = _data["substanceBasedIncomeExclusionStatus"];
            this.isWritingActivated = _data["isWritingActivated"];
            this.hasWriteAccess = _data["hasWriteAccess"];
        }
    }

    static fromJS(data: any): FinancialGroupDataOrganizationalEntityOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialGroupDataOrganizationalEntityOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["entityName"] = this.entityName;
        data["entityNumber"] = this.entityNumber;
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        data["dueDate"] = this.dueDate ? this.dueDate.toString() : <any>undefined;
        data["assignedUser"] = this.assignedUser ? this.assignedUser.toJSON() : <any>undefined;
        data["process"] = this.process ? this.process.toJSON() : <any>undefined;
        data["dueDateStatus"] = this.dueDateStatus;
        data["globeIncomeLossStatus"] = this.globeIncomeLossStatus;
        data["adjustedCoveredTaxesStatus"] = this.adjustedCoveredTaxesStatus;
        data["substanceBasedIncomeExclusionStatus"] = this.substanceBasedIncomeExclusionStatus;
        data["isWritingActivated"] = this.isWritingActivated;
        data["hasWriteAccess"] = this.hasWriteAccess;
        return data;
    }
}

export interface IFinancialGroupDataOrganizationalEntityOverviewDto {
    organizationalEntityId: number;
    entityName: string | undefined;
    entityNumber: string | undefined;
    blendingCircleSubgroupId: number | undefined;
    dueDate: DateTime | undefined;
    assignedUser: AssignableUserDto | undefined;
    process: ProcessDto | undefined;
    dueDateStatus: DueDateStatus | undefined;
    globeIncomeLossStatus: FinancialGroupDataStatus;
    adjustedCoveredTaxesStatus: FinancialGroupDataStatus;
    substanceBasedIncomeExclusionStatus: FinancialGroupDataStatus;
    isWritingActivated: boolean;
    hasWriteAccess: boolean;
}

export class FinancialGroupDataOverviewByBlendingCircleSubgroupInput implements IFinancialGroupDataOverviewByBlendingCircleSubgroupInput {
    projectId!: number;
    blendingCircleSubgroupId!: number;
    filter!: string | undefined;
    blendingCircleFilter!: string[] | undefined;
    assignedUsersFilter!: number[] | undefined;
    dueDateFilter!: string[] | undefined;

    constructor(data?: IFinancialGroupDataOverviewByBlendingCircleSubgroupInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
            this.filter = _data["filter"];
            if (Array.isArray(_data["blendingCircleFilter"])) {
                this.blendingCircleFilter = [] as any;
                for (let item of _data["blendingCircleFilter"])
                    this.blendingCircleFilter!.push(item);
            }
            if (Array.isArray(_data["assignedUsersFilter"])) {
                this.assignedUsersFilter = [] as any;
                for (let item of _data["assignedUsersFilter"])
                    this.assignedUsersFilter!.push(item);
            }
            if (Array.isArray(_data["dueDateFilter"])) {
                this.dueDateFilter = [] as any;
                for (let item of _data["dueDateFilter"])
                    this.dueDateFilter!.push(item);
            }
        }
    }

    static fromJS(data: any): FinancialGroupDataOverviewByBlendingCircleSubgroupInput {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialGroupDataOverviewByBlendingCircleSubgroupInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        data["filter"] = this.filter;
        if (Array.isArray(this.blendingCircleFilter)) {
            data["blendingCircleFilter"] = [];
            for (let item of this.blendingCircleFilter)
                data["blendingCircleFilter"].push(item);
        }
        if (Array.isArray(this.assignedUsersFilter)) {
            data["assignedUsersFilter"] = [];
            for (let item of this.assignedUsersFilter)
                data["assignedUsersFilter"].push(item);
        }
        if (Array.isArray(this.dueDateFilter)) {
            data["dueDateFilter"] = [];
            for (let item of this.dueDateFilter)
                data["dueDateFilter"].push(item);
        }
        return data;
    }
}

export interface IFinancialGroupDataOverviewByBlendingCircleSubgroupInput {
    projectId: number;
    blendingCircleSubgroupId: number;
    filter: string | undefined;
    blendingCircleFilter: string[] | undefined;
    assignedUsersFilter: number[] | undefined;
    dueDateFilter: string[] | undefined;
}

export class FinancialGroupDataOverviewInput implements IFinancialGroupDataOverviewInput {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    projectId!: number;
    filter!: string | undefined;
    hideCompleted!: boolean;
    blendingCircleFilter!: string[] | undefined;
    assignedUsersFilter!: number[] | undefined;
    dueDateFilter!: string[] | undefined;

    constructor(data?: IFinancialGroupDataOverviewInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.projectId = _data["projectId"];
            this.filter = _data["filter"];
            this.hideCompleted = _data["hideCompleted"];
            if (Array.isArray(_data["blendingCircleFilter"])) {
                this.blendingCircleFilter = [] as any;
                for (let item of _data["blendingCircleFilter"])
                    this.blendingCircleFilter!.push(item);
            }
            if (Array.isArray(_data["assignedUsersFilter"])) {
                this.assignedUsersFilter = [] as any;
                for (let item of _data["assignedUsersFilter"])
                    this.assignedUsersFilter!.push(item);
            }
            if (Array.isArray(_data["dueDateFilter"])) {
                this.dueDateFilter = [] as any;
                for (let item of _data["dueDateFilter"])
                    this.dueDateFilter!.push(item);
            }
        }
    }

    static fromJS(data: any): FinancialGroupDataOverviewInput {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialGroupDataOverviewInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["projectId"] = this.projectId;
        data["filter"] = this.filter;
        data["hideCompleted"] = this.hideCompleted;
        if (Array.isArray(this.blendingCircleFilter)) {
            data["blendingCircleFilter"] = [];
            for (let item of this.blendingCircleFilter)
                data["blendingCircleFilter"].push(item);
        }
        if (Array.isArray(this.assignedUsersFilter)) {
            data["assignedUsersFilter"] = [];
            for (let item of this.assignedUsersFilter)
                data["assignedUsersFilter"].push(item);
        }
        if (Array.isArray(this.dueDateFilter)) {
            data["dueDateFilter"] = [];
            for (let item of this.dueDateFilter)
                data["dueDateFilter"].push(item);
        }
        return data;
    }
}

export interface IFinancialGroupDataOverviewInput {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    projectId: number;
    filter: string | undefined;
    hideCompleted: boolean;
    blendingCircleFilter: string[] | undefined;
    assignedUsersFilter: number[] | undefined;
    dueDateFilter: string[] | undefined;
}

export enum FinancialGroupDataStatus {
    NoData = 1,
    SomeData = 2,
    AllData = 3,
    AllDataConfirmed = 4,
}

export class FinancialGroupDto implements IFinancialGroupDto {
    name!: string | undefined;
    isConfirmed!: boolean;
    isConfirmedNotes!: string | undefined;
    footerName!: string | undefined;
    currentValue!: FinancialValueDto | undefined;
    prevoiusValue!: string | undefined;
    isApplicationOfTheSubstanceBasedIncomeExclusionRuleForachJurisdictionApplicable!: boolean;
    financialNodes!: FinancialNodeDto[] | undefined;
    hasReadPermission!: boolean;
    hasWritePermission!: boolean;
    requiredGirDataMessage!: string | undefined;
    sumOfGlobeIncomeLoss!: FinancialValueDto | undefined;
    sumOfAdjustedCoveredTaxes!: FinancialValueDto | undefined;
    isSpecialPermissionsActivated!: boolean;
    isWritingActivated!: boolean;
    presentationCurrency!: string | undefined;
    entityCurrency!: string | undefined;
    hasAccountingCurrencyValue!: boolean;
    hasWarningNode!: boolean;
    warnings!: string[] | undefined;

    constructor(data?: IFinancialGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isConfirmed = _data["isConfirmed"];
            this.isConfirmedNotes = _data["isConfirmedNotes"];
            this.footerName = _data["footerName"];
            this.currentValue = _data["currentValue"] ? FinancialValueDto.fromJS(_data["currentValue"]) : <any>undefined;
            this.prevoiusValue = _data["prevoiusValue"];
            this.isApplicationOfTheSubstanceBasedIncomeExclusionRuleForachJurisdictionApplicable = _data["isApplicationOfTheSubstanceBasedIncomeExclusionRuleForachJurisdictionApplicable"];
            if (Array.isArray(_data["financialNodes"])) {
                this.financialNodes = [] as any;
                for (let item of _data["financialNodes"])
                    this.financialNodes!.push(FinancialNodeDto.fromJS(item));
            }
            this.hasReadPermission = _data["hasReadPermission"];
            this.hasWritePermission = _data["hasWritePermission"];
            this.requiredGirDataMessage = _data["requiredGirDataMessage"];
            this.sumOfGlobeIncomeLoss = _data["sumOfGlobeIncomeLoss"] ? FinancialValueDto.fromJS(_data["sumOfGlobeIncomeLoss"]) : <any>undefined;
            this.sumOfAdjustedCoveredTaxes = _data["sumOfAdjustedCoveredTaxes"] ? FinancialValueDto.fromJS(_data["sumOfAdjustedCoveredTaxes"]) : <any>undefined;
            this.isSpecialPermissionsActivated = _data["isSpecialPermissionsActivated"];
            this.isWritingActivated = _data["isWritingActivated"];
            this.presentationCurrency = _data["presentationCurrency"];
            this.entityCurrency = _data["entityCurrency"];
            this.hasAccountingCurrencyValue = _data["hasAccountingCurrencyValue"];
            this.hasWarningNode = _data["hasWarningNode"];
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(item);
            }
        }
    }

    static fromJS(data: any): FinancialGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isConfirmed"] = this.isConfirmed;
        data["isConfirmedNotes"] = this.isConfirmedNotes;
        data["footerName"] = this.footerName;
        data["currentValue"] = this.currentValue ? this.currentValue.toJSON() : <any>undefined;
        data["prevoiusValue"] = this.prevoiusValue;
        data["isApplicationOfTheSubstanceBasedIncomeExclusionRuleForachJurisdictionApplicable"] = this.isApplicationOfTheSubstanceBasedIncomeExclusionRuleForachJurisdictionApplicable;
        if (Array.isArray(this.financialNodes)) {
            data["financialNodes"] = [];
            for (let item of this.financialNodes)
                data["financialNodes"].push(item.toJSON());
        }
        data["hasReadPermission"] = this.hasReadPermission;
        data["hasWritePermission"] = this.hasWritePermission;
        data["requiredGirDataMessage"] = this.requiredGirDataMessage;
        data["sumOfGlobeIncomeLoss"] = this.sumOfGlobeIncomeLoss ? this.sumOfGlobeIncomeLoss.toJSON() : <any>undefined;
        data["sumOfAdjustedCoveredTaxes"] = this.sumOfAdjustedCoveredTaxes ? this.sumOfAdjustedCoveredTaxes.toJSON() : <any>undefined;
        data["isSpecialPermissionsActivated"] = this.isSpecialPermissionsActivated;
        data["isWritingActivated"] = this.isWritingActivated;
        data["presentationCurrency"] = this.presentationCurrency;
        data["entityCurrency"] = this.entityCurrency;
        data["hasAccountingCurrencyValue"] = this.hasAccountingCurrencyValue;
        data["hasWarningNode"] = this.hasWarningNode;
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item);
        }
        return data;
    }
}

export interface IFinancialGroupDto {
    name: string | undefined;
    isConfirmed: boolean;
    isConfirmedNotes: string | undefined;
    footerName: string | undefined;
    currentValue: FinancialValueDto | undefined;
    prevoiusValue: string | undefined;
    isApplicationOfTheSubstanceBasedIncomeExclusionRuleForachJurisdictionApplicable: boolean;
    financialNodes: FinancialNodeDto[] | undefined;
    hasReadPermission: boolean;
    hasWritePermission: boolean;
    requiredGirDataMessage: string | undefined;
    sumOfGlobeIncomeLoss: FinancialValueDto | undefined;
    sumOfAdjustedCoveredTaxes: FinancialValueDto | undefined;
    isSpecialPermissionsActivated: boolean;
    isWritingActivated: boolean;
    presentationCurrency: string | undefined;
    entityCurrency: string | undefined;
    hasAccountingCurrencyValue: boolean;
    hasWarningNode: boolean;
    warnings: string[] | undefined;
}

export class FinancialGroupInput implements IFinancialGroupInput {
    projectId!: number;
    blendingCircleCountry!: string | undefined;
    blendingCircleSubgroupId!: number;
    organizationalEntityId!: number | undefined;
    financialGroupType!: FinancialGroupType;
    financialTreeType!: FinancialTreeType;

    constructor(data?: IFinancialGroupInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.blendingCircleCountry = _data["blendingCircleCountry"];
            this.blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.financialGroupType = _data["financialGroupType"];
            this.financialTreeType = _data["financialTreeType"];
        }
    }

    static fromJS(data: any): FinancialGroupInput {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialGroupInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["blendingCircleCountry"] = this.blendingCircleCountry;
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["financialGroupType"] = this.financialGroupType;
        data["financialTreeType"] = this.financialTreeType;
        return data;
    }
}

export interface IFinancialGroupInput {
    projectId: number;
    blendingCircleCountry: string | undefined;
    blendingCircleSubgroupId: number;
    organizationalEntityId: number | undefined;
    financialGroupType: FinancialGroupType;
    financialTreeType: FinancialTreeType;
}

export enum FinancialGroupType {
    Overview = 1,
    GlobeIncomeLoss = 2,
    SubstanceBasedIncomeExlusion = 3,
    AdjustedCoveredTaxes = 4,
    EtrAndTut = 5,
}

export class FinancialNodeDetailsDto implements IFinancialNodeDetailsDto {
    isInvestmentEntityShiftType!: boolean;
    isDeemedDeferredTaxAsset!: boolean;
    isNonEligibleEmployeeCosts!: boolean;
    isCarryingValueOfEligibleTangibleAssetsBeforeAllocationChildItem!: boolean;
    isNonEligibleTangibleAssetsValue!: boolean;
    isRelevantMarkupPercentage!: boolean;
    isRelevantMarkUpEligiblePayrollCostsPercentage!: boolean;
    isCrossAllocationEligibleTangibleAssetsPeAverage!: boolean;
    isCrossAllocationEligibleTangibleAssetsFlowThroughNonUpeAverage!: boolean;
    isEtrAndTutEtrAdjustmentArt!: boolean;
    isEtrAndTutYear!: boolean;
    isEtrAndTutFinancialAccountingStandard!: boolean;
    isProRataTemporis!: boolean;

    constructor(data?: IFinancialNodeDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isInvestmentEntityShiftType = _data["isInvestmentEntityShiftType"];
            this.isDeemedDeferredTaxAsset = _data["isDeemedDeferredTaxAsset"];
            this.isNonEligibleEmployeeCosts = _data["isNonEligibleEmployeeCosts"];
            this.isCarryingValueOfEligibleTangibleAssetsBeforeAllocationChildItem = _data["isCarryingValueOfEligibleTangibleAssetsBeforeAllocationChildItem"];
            this.isNonEligibleTangibleAssetsValue = _data["isNonEligibleTangibleAssetsValue"];
            this.isRelevantMarkupPercentage = _data["isRelevantMarkupPercentage"];
            this.isRelevantMarkUpEligiblePayrollCostsPercentage = _data["isRelevantMarkUpEligiblePayrollCostsPercentage"];
            this.isCrossAllocationEligibleTangibleAssetsPeAverage = _data["isCrossAllocationEligibleTangibleAssetsPeAverage"];
            this.isCrossAllocationEligibleTangibleAssetsFlowThroughNonUpeAverage = _data["isCrossAllocationEligibleTangibleAssetsFlowThroughNonUpeAverage"];
            this.isEtrAndTutEtrAdjustmentArt = _data["isEtrAndTutEtrAdjustmentArt"];
            this.isEtrAndTutYear = _data["isEtrAndTutYear"];
            this.isEtrAndTutFinancialAccountingStandard = _data["isEtrAndTutFinancialAccountingStandard"];
            this.isProRataTemporis = _data["isProRataTemporis"];
        }
    }

    static fromJS(data: any): FinancialNodeDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialNodeDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isInvestmentEntityShiftType"] = this.isInvestmentEntityShiftType;
        data["isDeemedDeferredTaxAsset"] = this.isDeemedDeferredTaxAsset;
        data["isNonEligibleEmployeeCosts"] = this.isNonEligibleEmployeeCosts;
        data["isCarryingValueOfEligibleTangibleAssetsBeforeAllocationChildItem"] = this.isCarryingValueOfEligibleTangibleAssetsBeforeAllocationChildItem;
        data["isNonEligibleTangibleAssetsValue"] = this.isNonEligibleTangibleAssetsValue;
        data["isRelevantMarkupPercentage"] = this.isRelevantMarkupPercentage;
        data["isRelevantMarkUpEligiblePayrollCostsPercentage"] = this.isRelevantMarkUpEligiblePayrollCostsPercentage;
        data["isCrossAllocationEligibleTangibleAssetsPeAverage"] = this.isCrossAllocationEligibleTangibleAssetsPeAverage;
        data["isCrossAllocationEligibleTangibleAssetsFlowThroughNonUpeAverage"] = this.isCrossAllocationEligibleTangibleAssetsFlowThroughNonUpeAverage;
        data["isEtrAndTutEtrAdjustmentArt"] = this.isEtrAndTutEtrAdjustmentArt;
        data["isEtrAndTutYear"] = this.isEtrAndTutYear;
        data["isEtrAndTutFinancialAccountingStandard"] = this.isEtrAndTutFinancialAccountingStandard;
        data["isProRataTemporis"] = this.isProRataTemporis;
        return data;
    }
}

export interface IFinancialNodeDetailsDto {
    isInvestmentEntityShiftType: boolean;
    isDeemedDeferredTaxAsset: boolean;
    isNonEligibleEmployeeCosts: boolean;
    isCarryingValueOfEligibleTangibleAssetsBeforeAllocationChildItem: boolean;
    isNonEligibleTangibleAssetsValue: boolean;
    isRelevantMarkupPercentage: boolean;
    isRelevantMarkUpEligiblePayrollCostsPercentage: boolean;
    isCrossAllocationEligibleTangibleAssetsPeAverage: boolean;
    isCrossAllocationEligibleTangibleAssetsFlowThroughNonUpeAverage: boolean;
    isEtrAndTutEtrAdjustmentArt: boolean;
    isEtrAndTutYear: boolean;
    isEtrAndTutFinancialAccountingStandard: boolean;
    isProRataTemporis: boolean;
}

export class FinancialNodeDto implements IFinancialNodeDto {
    id!: string | undefined;
    referenceId!: number;
    notes!: string | undefined;
    isSendingEntity!: boolean | undefined;
    anotherEntityId!: number | undefined;
    childInvestmentEntityId!: number | undefined;
    isAnotherEntityAccessible!: boolean;
    path!: string[] | undefined;
    financialNodeType!: FinancialNodeType;
    name!: string | undefined;
    financialType!: string | undefined;
    financialNodeGroupType!: string | undefined;
    localizationKey!: string | undefined;
    localizationParameters!: string[] | undefined;
    readonly footerName!: string | undefined;
    basisForAdjustments!: BasisForAdjustmentsType;
    lossCarryBack!: FinancialValueDto | undefined;
    maxTaxRateOfMainEntityJurisdiction!: string | undefined;
    actArticle72AmountOfTaxes!: FinancialValueDto | undefined;
    actArticle72AmountToBeCorrected!: FinancialValueDto | undefined;
    actArticle72ReductionOfCoveredTaxesAccordingToArticle722!: FinancialValueDto | undefined;
    proportionalReductionOfAct!: string | undefined;
    preCalculatedProportionalReductionOfAct!: string | undefined;
    actArticle72DeferredTaxesAfterRecastAdjustments!: ActArticle72DeferredTaxesAfterRecastAdjustmentsDto | undefined;
    passiveIncomeOfCEOrHybridEntity!: FinancialValueDto | undefined;
    thereofOnActiveIncome!: FinancialValueDto | undefined;
    domesticTaxRate!: FinancialValueDto | undefined;
    nonEligibleEmployeeCostsPreliminary!: FinancialValueDto | undefined;
    nonEligibleTangibleAssetsAveragePreliminary!: FinancialValueDto | undefined;
    percentageRateWorkingTimeInJurisdiction!: string | undefined;
    percentageRateOfLocationTimeInJurisdiction!: string | undefined;
    proRataTemporis!: string | undefined;
    fiscalYearBeginning!: FinancialValueDto | undefined;
    fiscalYearEnd!: FinancialValueDto | undefined;
    warnings!: string[] | undefined;
    hideWarningWhenExpanded!: boolean;
    initialValueWarning!: string | undefined;
    currentValueLabel!: string | undefined;
    currentValueDescription!: string | undefined;
    otherEntityLabel!: string | undefined;
    fiscalYearBeginningLabel!: string | undefined;
    fiscalYearEndLabel!: string | undefined;
    fiscalYearAverageLabel!: string | undefined;
    calculatedCurrent!: FinancialValueDto | undefined;
    calculatedFinal!: FinancialValueDto | undefined;
    financialYear!: FinancialYearType | undefined;
    currentValue!: ConfirmableDtoOfFinancialValueDto | undefined;
    previousValue!: ConfirmableDtoOfFinancialValueDto | undefined;
    globeCombinedValue!: FinancialValueDto | undefined;
    actCombinedValue!: FinancialValueDto | undefined;
    isDisabled!: boolean;
    isReadonly!: boolean;
    isActivated!: boolean;
    validationLogic!: FinancialTraceValidationLogic | undefined;
    multipleNodeGroupId!: number | undefined;
    financialValueTracePointAdditionalInfo!: FinancialValueTracePointAdditionalDto | undefined;
    isManualCorrectionIncoming!: boolean;
    hasDeletePermission!: boolean;
    crossAllocationOfTaxesRecalculationWarningDto!: CrossAllocationOfTaxesRecalculationWarningDto | undefined;
    crossAllocationOfTaxes434RecalculationWarningDto!: CrossAllocationOfTaxes434RecalculationWarningDto | undefined;
    country!: string | undefined;
    blendingCircleSubgroupId!: number | undefined;
    organizationalEntityUpeShareholderId!: number | undefined;
    ownerId!: number | undefined;
    assignedEntityId!: number | undefined;
    blendingCircleSubgroupType!: string | undefined;
    blendingCircleSubgroupNumber!: number | undefined;
    readonlyRules!: ReadonlyRulesDto | undefined;
    isCombinedNode!: boolean;
    financialGroupType!: FinancialGroupType | undefined;
    valueAccordingToFinancialStatements!: string | undefined;
    disposingJurisdiction!: string | undefined;
    taxPaidInRespectOfTheTransaction!: string | undefined;
    netDeferredTaxAsset!: string | undefined;
    globeCarryingValue!: string | undefined;
    netDeferredTaxAssetYearBeginning!: string | undefined;
    deemedDistribution!: string | undefined;
    thereofAlreadyIncludedInGlobeIncomeComputation!: string | undefined;
    localCreditableTaxGrossup!: string | undefined;
    comment!: string | undefined;
    directionType!: DirectionType | undefined;
    internationalShippingIncomeDetails!: InternationalShippingIncomeDetailsDto | undefined;
    isValueInLocalCurrency!: boolean;
    isInputCurrencyLocalCurrency!: boolean;
    hasAssignedEntity!: boolean;
    nameDetails!: FinancialNodeNameDetailsDto | undefined;
    nodeDetails!: FinancialNodeDetailsDto | undefined;

    constructor(data?: IFinancialNodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.referenceId = _data["referenceId"];
            this.notes = _data["notes"];
            this.isSendingEntity = _data["isSendingEntity"];
            this.anotherEntityId = _data["anotherEntityId"];
            this.childInvestmentEntityId = _data["childInvestmentEntityId"];
            this.isAnotherEntityAccessible = _data["isAnotherEntityAccessible"];
            if (Array.isArray(_data["path"])) {
                this.path = [] as any;
                for (let item of _data["path"])
                    this.path!.push(item);
            }
            this.financialNodeType = _data["financialNodeType"];
            this.name = _data["name"];
            this.financialType = _data["financialType"];
            this.financialNodeGroupType = _data["financialNodeGroupType"];
            this.localizationKey = _data["localizationKey"];
            if (Array.isArray(_data["localizationParameters"])) {
                this.localizationParameters = [] as any;
                for (let item of _data["localizationParameters"])
                    this.localizationParameters!.push(item);
            }
            (<any>this).footerName = _data["footerName"];
            this.basisForAdjustments = _data["basisForAdjustments"];
            this.lossCarryBack = _data["lossCarryBack"] ? FinancialValueDto.fromJS(_data["lossCarryBack"]) : <any>undefined;
            this.maxTaxRateOfMainEntityJurisdiction = _data["maxTaxRateOfMainEntityJurisdiction"];
            this.actArticle72AmountOfTaxes = _data["actArticle72AmountOfTaxes"] ? FinancialValueDto.fromJS(_data["actArticle72AmountOfTaxes"]) : <any>undefined;
            this.actArticle72AmountToBeCorrected = _data["actArticle72AmountToBeCorrected"] ? FinancialValueDto.fromJS(_data["actArticle72AmountToBeCorrected"]) : <any>undefined;
            this.actArticle72ReductionOfCoveredTaxesAccordingToArticle722 = _data["actArticle72ReductionOfCoveredTaxesAccordingToArticle722"] ? FinancialValueDto.fromJS(_data["actArticle72ReductionOfCoveredTaxesAccordingToArticle722"]) : <any>undefined;
            this.proportionalReductionOfAct = _data["proportionalReductionOfAct"];
            this.preCalculatedProportionalReductionOfAct = _data["preCalculatedProportionalReductionOfAct"];
            this.actArticle72DeferredTaxesAfterRecastAdjustments = _data["actArticle72DeferredTaxesAfterRecastAdjustments"] ? ActArticle72DeferredTaxesAfterRecastAdjustmentsDto.fromJS(_data["actArticle72DeferredTaxesAfterRecastAdjustments"]) : <any>undefined;
            this.passiveIncomeOfCEOrHybridEntity = _data["passiveIncomeOfCEOrHybridEntity"] ? FinancialValueDto.fromJS(_data["passiveIncomeOfCEOrHybridEntity"]) : <any>undefined;
            this.thereofOnActiveIncome = _data["thereofOnActiveIncome"] ? FinancialValueDto.fromJS(_data["thereofOnActiveIncome"]) : <any>undefined;
            this.domesticTaxRate = _data["domesticTaxRate"] ? FinancialValueDto.fromJS(_data["domesticTaxRate"]) : <any>undefined;
            this.nonEligibleEmployeeCostsPreliminary = _data["nonEligibleEmployeeCostsPreliminary"] ? FinancialValueDto.fromJS(_data["nonEligibleEmployeeCostsPreliminary"]) : <any>undefined;
            this.nonEligibleTangibleAssetsAveragePreliminary = _data["nonEligibleTangibleAssetsAveragePreliminary"] ? FinancialValueDto.fromJS(_data["nonEligibleTangibleAssetsAveragePreliminary"]) : <any>undefined;
            this.percentageRateWorkingTimeInJurisdiction = _data["percentageRateWorkingTimeInJurisdiction"];
            this.percentageRateOfLocationTimeInJurisdiction = _data["percentageRateOfLocationTimeInJurisdiction"];
            this.proRataTemporis = _data["proRataTemporis"];
            this.fiscalYearBeginning = _data["fiscalYearBeginning"] ? FinancialValueDto.fromJS(_data["fiscalYearBeginning"]) : <any>undefined;
            this.fiscalYearEnd = _data["fiscalYearEnd"] ? FinancialValueDto.fromJS(_data["fiscalYearEnd"]) : <any>undefined;
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(item);
            }
            this.hideWarningWhenExpanded = _data["hideWarningWhenExpanded"];
            this.initialValueWarning = _data["initialValueWarning"];
            this.currentValueLabel = _data["currentValueLabel"];
            this.currentValueDescription = _data["currentValueDescription"];
            this.otherEntityLabel = _data["otherEntityLabel"];
            this.fiscalYearBeginningLabel = _data["fiscalYearBeginningLabel"];
            this.fiscalYearEndLabel = _data["fiscalYearEndLabel"];
            this.fiscalYearAverageLabel = _data["fiscalYearAverageLabel"];
            this.calculatedCurrent = _data["calculatedCurrent"] ? FinancialValueDto.fromJS(_data["calculatedCurrent"]) : <any>undefined;
            this.calculatedFinal = _data["calculatedFinal"] ? FinancialValueDto.fromJS(_data["calculatedFinal"]) : <any>undefined;
            this.financialYear = _data["financialYear"];
            this.currentValue = _data["currentValue"] ? ConfirmableDtoOfFinancialValueDto.fromJS(_data["currentValue"]) : <any>undefined;
            this.previousValue = _data["previousValue"] ? ConfirmableDtoOfFinancialValueDto.fromJS(_data["previousValue"]) : <any>undefined;
            this.globeCombinedValue = _data["globeCombinedValue"] ? FinancialValueDto.fromJS(_data["globeCombinedValue"]) : <any>undefined;
            this.actCombinedValue = _data["actCombinedValue"] ? FinancialValueDto.fromJS(_data["actCombinedValue"]) : <any>undefined;
            this.isDisabled = _data["isDisabled"];
            this.isReadonly = _data["isReadonly"];
            this.isActivated = _data["isActivated"];
            this.validationLogic = _data["validationLogic"] ? FinancialTraceValidationLogic.fromJS(_data["validationLogic"]) : <any>undefined;
            this.multipleNodeGroupId = _data["multipleNodeGroupId"];
            this.financialValueTracePointAdditionalInfo = _data["financialValueTracePointAdditionalInfo"] ? FinancialValueTracePointAdditionalDto.fromJS(_data["financialValueTracePointAdditionalInfo"]) : <any>undefined;
            this.isManualCorrectionIncoming = _data["isManualCorrectionIncoming"];
            this.hasDeletePermission = _data["hasDeletePermission"];
            this.crossAllocationOfTaxesRecalculationWarningDto = _data["crossAllocationOfTaxesRecalculationWarningDto"] ? CrossAllocationOfTaxesRecalculationWarningDto.fromJS(_data["crossAllocationOfTaxesRecalculationWarningDto"]) : <any>undefined;
            this.crossAllocationOfTaxes434RecalculationWarningDto = _data["crossAllocationOfTaxes434RecalculationWarningDto"] ? CrossAllocationOfTaxes434RecalculationWarningDto.fromJS(_data["crossAllocationOfTaxes434RecalculationWarningDto"]) : <any>undefined;
            this.country = _data["country"];
            this.blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
            this.organizationalEntityUpeShareholderId = _data["organizationalEntityUpeShareholderId"];
            this.ownerId = _data["ownerId"];
            this.assignedEntityId = _data["assignedEntityId"];
            this.blendingCircleSubgroupType = _data["blendingCircleSubgroupType"];
            this.blendingCircleSubgroupNumber = _data["blendingCircleSubgroupNumber"];
            this.readonlyRules = _data["readonlyRules"] ? ReadonlyRulesDto.fromJS(_data["readonlyRules"]) : <any>undefined;
            this.isCombinedNode = _data["isCombinedNode"];
            this.financialGroupType = _data["financialGroupType"];
            this.valueAccordingToFinancialStatements = _data["valueAccordingToFinancialStatements"];
            this.disposingJurisdiction = _data["disposingJurisdiction"];
            this.taxPaidInRespectOfTheTransaction = _data["taxPaidInRespectOfTheTransaction"];
            this.netDeferredTaxAsset = _data["netDeferredTaxAsset"];
            this.globeCarryingValue = _data["globeCarryingValue"];
            this.netDeferredTaxAssetYearBeginning = _data["netDeferredTaxAssetYearBeginning"];
            this.deemedDistribution = _data["deemedDistribution"];
            this.thereofAlreadyIncludedInGlobeIncomeComputation = _data["thereofAlreadyIncludedInGlobeIncomeComputation"];
            this.localCreditableTaxGrossup = _data["localCreditableTaxGrossup"];
            this.comment = _data["comment"];
            this.directionType = _data["directionType"];
            this.internationalShippingIncomeDetails = _data["internationalShippingIncomeDetails"] ? InternationalShippingIncomeDetailsDto.fromJS(_data["internationalShippingIncomeDetails"]) : <any>undefined;
            this.isValueInLocalCurrency = _data["isValueInLocalCurrency"];
            this.isInputCurrencyLocalCurrency = _data["isInputCurrencyLocalCurrency"];
            this.hasAssignedEntity = _data["hasAssignedEntity"];
            this.nameDetails = _data["nameDetails"] ? FinancialNodeNameDetailsDto.fromJS(_data["nameDetails"]) : <any>undefined;
            this.nodeDetails = _data["nodeDetails"] ? FinancialNodeDetailsDto.fromJS(_data["nodeDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FinancialNodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialNodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["referenceId"] = this.referenceId;
        data["notes"] = this.notes;
        data["isSendingEntity"] = this.isSendingEntity;
        data["anotherEntityId"] = this.anotherEntityId;
        data["childInvestmentEntityId"] = this.childInvestmentEntityId;
        data["isAnotherEntityAccessible"] = this.isAnotherEntityAccessible;
        if (Array.isArray(this.path)) {
            data["path"] = [];
            for (let item of this.path)
                data["path"].push(item);
        }
        data["financialNodeType"] = this.financialNodeType;
        data["name"] = this.name;
        data["financialType"] = this.financialType;
        data["financialNodeGroupType"] = this.financialNodeGroupType;
        data["localizationKey"] = this.localizationKey;
        if (Array.isArray(this.localizationParameters)) {
            data["localizationParameters"] = [];
            for (let item of this.localizationParameters)
                data["localizationParameters"].push(item);
        }
        data["footerName"] = this.footerName;
        data["basisForAdjustments"] = this.basisForAdjustments;
        data["lossCarryBack"] = this.lossCarryBack ? this.lossCarryBack.toJSON() : <any>undefined;
        data["maxTaxRateOfMainEntityJurisdiction"] = this.maxTaxRateOfMainEntityJurisdiction;
        data["actArticle72AmountOfTaxes"] = this.actArticle72AmountOfTaxes ? this.actArticle72AmountOfTaxes.toJSON() : <any>undefined;
        data["actArticle72AmountToBeCorrected"] = this.actArticle72AmountToBeCorrected ? this.actArticle72AmountToBeCorrected.toJSON() : <any>undefined;
        data["actArticle72ReductionOfCoveredTaxesAccordingToArticle722"] = this.actArticle72ReductionOfCoveredTaxesAccordingToArticle722 ? this.actArticle72ReductionOfCoveredTaxesAccordingToArticle722.toJSON() : <any>undefined;
        data["proportionalReductionOfAct"] = this.proportionalReductionOfAct;
        data["preCalculatedProportionalReductionOfAct"] = this.preCalculatedProportionalReductionOfAct;
        data["actArticle72DeferredTaxesAfterRecastAdjustments"] = this.actArticle72DeferredTaxesAfterRecastAdjustments ? this.actArticle72DeferredTaxesAfterRecastAdjustments.toJSON() : <any>undefined;
        data["passiveIncomeOfCEOrHybridEntity"] = this.passiveIncomeOfCEOrHybridEntity ? this.passiveIncomeOfCEOrHybridEntity.toJSON() : <any>undefined;
        data["thereofOnActiveIncome"] = this.thereofOnActiveIncome ? this.thereofOnActiveIncome.toJSON() : <any>undefined;
        data["domesticTaxRate"] = this.domesticTaxRate ? this.domesticTaxRate.toJSON() : <any>undefined;
        data["nonEligibleEmployeeCostsPreliminary"] = this.nonEligibleEmployeeCostsPreliminary ? this.nonEligibleEmployeeCostsPreliminary.toJSON() : <any>undefined;
        data["nonEligibleTangibleAssetsAveragePreliminary"] = this.nonEligibleTangibleAssetsAveragePreliminary ? this.nonEligibleTangibleAssetsAveragePreliminary.toJSON() : <any>undefined;
        data["percentageRateWorkingTimeInJurisdiction"] = this.percentageRateWorkingTimeInJurisdiction;
        data["percentageRateOfLocationTimeInJurisdiction"] = this.percentageRateOfLocationTimeInJurisdiction;
        data["proRataTemporis"] = this.proRataTemporis;
        data["fiscalYearBeginning"] = this.fiscalYearBeginning ? this.fiscalYearBeginning.toJSON() : <any>undefined;
        data["fiscalYearEnd"] = this.fiscalYearEnd ? this.fiscalYearEnd.toJSON() : <any>undefined;
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item);
        }
        data["hideWarningWhenExpanded"] = this.hideWarningWhenExpanded;
        data["initialValueWarning"] = this.initialValueWarning;
        data["currentValueLabel"] = this.currentValueLabel;
        data["currentValueDescription"] = this.currentValueDescription;
        data["otherEntityLabel"] = this.otherEntityLabel;
        data["fiscalYearBeginningLabel"] = this.fiscalYearBeginningLabel;
        data["fiscalYearEndLabel"] = this.fiscalYearEndLabel;
        data["fiscalYearAverageLabel"] = this.fiscalYearAverageLabel;
        data["calculatedCurrent"] = this.calculatedCurrent ? this.calculatedCurrent.toJSON() : <any>undefined;
        data["calculatedFinal"] = this.calculatedFinal ? this.calculatedFinal.toJSON() : <any>undefined;
        data["financialYear"] = this.financialYear;
        data["currentValue"] = this.currentValue ? this.currentValue.toJSON() : <any>undefined;
        data["previousValue"] = this.previousValue ? this.previousValue.toJSON() : <any>undefined;
        data["globeCombinedValue"] = this.globeCombinedValue ? this.globeCombinedValue.toJSON() : <any>undefined;
        data["actCombinedValue"] = this.actCombinedValue ? this.actCombinedValue.toJSON() : <any>undefined;
        data["isDisabled"] = this.isDisabled;
        data["isReadonly"] = this.isReadonly;
        data["isActivated"] = this.isActivated;
        data["validationLogic"] = this.validationLogic ? this.validationLogic.toJSON() : <any>undefined;
        data["multipleNodeGroupId"] = this.multipleNodeGroupId;
        data["financialValueTracePointAdditionalInfo"] = this.financialValueTracePointAdditionalInfo ? this.financialValueTracePointAdditionalInfo.toJSON() : <any>undefined;
        data["isManualCorrectionIncoming"] = this.isManualCorrectionIncoming;
        data["hasDeletePermission"] = this.hasDeletePermission;
        data["crossAllocationOfTaxesRecalculationWarningDto"] = this.crossAllocationOfTaxesRecalculationWarningDto ? this.crossAllocationOfTaxesRecalculationWarningDto.toJSON() : <any>undefined;
        data["crossAllocationOfTaxes434RecalculationWarningDto"] = this.crossAllocationOfTaxes434RecalculationWarningDto ? this.crossAllocationOfTaxes434RecalculationWarningDto.toJSON() : <any>undefined;
        data["country"] = this.country;
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        data["organizationalEntityUpeShareholderId"] = this.organizationalEntityUpeShareholderId;
        data["ownerId"] = this.ownerId;
        data["assignedEntityId"] = this.assignedEntityId;
        data["blendingCircleSubgroupType"] = this.blendingCircleSubgroupType;
        data["blendingCircleSubgroupNumber"] = this.blendingCircleSubgroupNumber;
        data["readonlyRules"] = this.readonlyRules ? this.readonlyRules.toJSON() : <any>undefined;
        data["isCombinedNode"] = this.isCombinedNode;
        data["financialGroupType"] = this.financialGroupType;
        data["valueAccordingToFinancialStatements"] = this.valueAccordingToFinancialStatements;
        data["disposingJurisdiction"] = this.disposingJurisdiction;
        data["taxPaidInRespectOfTheTransaction"] = this.taxPaidInRespectOfTheTransaction;
        data["netDeferredTaxAsset"] = this.netDeferredTaxAsset;
        data["globeCarryingValue"] = this.globeCarryingValue;
        data["netDeferredTaxAssetYearBeginning"] = this.netDeferredTaxAssetYearBeginning;
        data["deemedDistribution"] = this.deemedDistribution;
        data["thereofAlreadyIncludedInGlobeIncomeComputation"] = this.thereofAlreadyIncludedInGlobeIncomeComputation;
        data["localCreditableTaxGrossup"] = this.localCreditableTaxGrossup;
        data["comment"] = this.comment;
        data["directionType"] = this.directionType;
        data["internationalShippingIncomeDetails"] = this.internationalShippingIncomeDetails ? this.internationalShippingIncomeDetails.toJSON() : <any>undefined;
        data["isValueInLocalCurrency"] = this.isValueInLocalCurrency;
        data["isInputCurrencyLocalCurrency"] = this.isInputCurrencyLocalCurrency;
        data["hasAssignedEntity"] = this.hasAssignedEntity;
        data["nameDetails"] = this.nameDetails ? this.nameDetails.toJSON() : <any>undefined;
        data["nodeDetails"] = this.nodeDetails ? this.nodeDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFinancialNodeDto {
    id: string | undefined;
    referenceId: number;
    notes: string | undefined;
    isSendingEntity: boolean | undefined;
    anotherEntityId: number | undefined;
    childInvestmentEntityId: number | undefined;
    isAnotherEntityAccessible: boolean;
    path: string[] | undefined;
    financialNodeType: FinancialNodeType;
    name: string | undefined;
    financialType: string | undefined;
    financialNodeGroupType: string | undefined;
    localizationKey: string | undefined;
    localizationParameters: string[] | undefined;
    footerName: string | undefined;
    basisForAdjustments: BasisForAdjustmentsType;
    lossCarryBack: FinancialValueDto | undefined;
    maxTaxRateOfMainEntityJurisdiction: string | undefined;
    actArticle72AmountOfTaxes: FinancialValueDto | undefined;
    actArticle72AmountToBeCorrected: FinancialValueDto | undefined;
    actArticle72ReductionOfCoveredTaxesAccordingToArticle722: FinancialValueDto | undefined;
    proportionalReductionOfAct: string | undefined;
    preCalculatedProportionalReductionOfAct: string | undefined;
    actArticle72DeferredTaxesAfterRecastAdjustments: ActArticle72DeferredTaxesAfterRecastAdjustmentsDto | undefined;
    passiveIncomeOfCEOrHybridEntity: FinancialValueDto | undefined;
    thereofOnActiveIncome: FinancialValueDto | undefined;
    domesticTaxRate: FinancialValueDto | undefined;
    nonEligibleEmployeeCostsPreliminary: FinancialValueDto | undefined;
    nonEligibleTangibleAssetsAveragePreliminary: FinancialValueDto | undefined;
    percentageRateWorkingTimeInJurisdiction: string | undefined;
    percentageRateOfLocationTimeInJurisdiction: string | undefined;
    proRataTemporis: string | undefined;
    fiscalYearBeginning: FinancialValueDto | undefined;
    fiscalYearEnd: FinancialValueDto | undefined;
    warnings: string[] | undefined;
    hideWarningWhenExpanded: boolean;
    initialValueWarning: string | undefined;
    currentValueLabel: string | undefined;
    currentValueDescription: string | undefined;
    otherEntityLabel: string | undefined;
    fiscalYearBeginningLabel: string | undefined;
    fiscalYearEndLabel: string | undefined;
    fiscalYearAverageLabel: string | undefined;
    calculatedCurrent: FinancialValueDto | undefined;
    calculatedFinal: FinancialValueDto | undefined;
    financialYear: FinancialYearType | undefined;
    currentValue: ConfirmableDtoOfFinancialValueDto | undefined;
    previousValue: ConfirmableDtoOfFinancialValueDto | undefined;
    globeCombinedValue: FinancialValueDto | undefined;
    actCombinedValue: FinancialValueDto | undefined;
    isDisabled: boolean;
    isReadonly: boolean;
    isActivated: boolean;
    validationLogic: FinancialTraceValidationLogic | undefined;
    multipleNodeGroupId: number | undefined;
    financialValueTracePointAdditionalInfo: FinancialValueTracePointAdditionalDto | undefined;
    isManualCorrectionIncoming: boolean;
    hasDeletePermission: boolean;
    crossAllocationOfTaxesRecalculationWarningDto: CrossAllocationOfTaxesRecalculationWarningDto | undefined;
    crossAllocationOfTaxes434RecalculationWarningDto: CrossAllocationOfTaxes434RecalculationWarningDto | undefined;
    country: string | undefined;
    blendingCircleSubgroupId: number | undefined;
    organizationalEntityUpeShareholderId: number | undefined;
    ownerId: number | undefined;
    assignedEntityId: number | undefined;
    blendingCircleSubgroupType: string | undefined;
    blendingCircleSubgroupNumber: number | undefined;
    readonlyRules: ReadonlyRulesDto | undefined;
    isCombinedNode: boolean;
    financialGroupType: FinancialGroupType | undefined;
    valueAccordingToFinancialStatements: string | undefined;
    disposingJurisdiction: string | undefined;
    taxPaidInRespectOfTheTransaction: string | undefined;
    netDeferredTaxAsset: string | undefined;
    globeCarryingValue: string | undefined;
    netDeferredTaxAssetYearBeginning: string | undefined;
    deemedDistribution: string | undefined;
    thereofAlreadyIncludedInGlobeIncomeComputation: string | undefined;
    localCreditableTaxGrossup: string | undefined;
    comment: string | undefined;
    directionType: DirectionType | undefined;
    internationalShippingIncomeDetails: InternationalShippingIncomeDetailsDto | undefined;
    isValueInLocalCurrency: boolean;
    isInputCurrencyLocalCurrency: boolean;
    hasAssignedEntity: boolean;
    nameDetails: FinancialNodeNameDetailsDto | undefined;
    nodeDetails: FinancialNodeDetailsDto | undefined;
}

export enum FinancialNodeGroupType {
    ACTDeferredTaxesRelatedToGloBEExclIncomeAndLosses = 1,
    ACTDeferredTaxExpenseRelatedToDisallowedAccruals = 2,
    ACTDeferredTaxExpenseRelatedToUnclaimedAccruals = 3,
    ACTDeferredTaxValuationAdjustment = 4,
    ACTRemeasurmentRelatedToChangesInTaxRate = 5,
    ACTGenerationAndUseOfTaxCredits = 6,
    ACTDeemedSubstituteLCF = 7,
    ACTDisallowedAccrualsOrUnclaimedAccrualsPaidDuringFY = 8,
    ACTRecaptureDTLiabilityPaidDuringFY = 9,
    ACTRecognitionOfDeemedDTA = 10,
    ACTDTEAdjustmentInCaseOfIncreaseOfTaxRate = 11,
    ACTDTEOnExcludedInternationalShippingIncome = 12,
    EtrAndTutAdditionalCurrentTutOther = 13,
    GloBEArmsLengthAdjustmentValue = 14,
    GloBEArmsLengthAdjustmentLoss = 15,
    ACTEntitiesJoiningLeavingMNEGroup = 16,
    GlobeActTransactionsBetweenCes = 17,
    GloBEAdjustmentsTo71CorporateShareholder = 18,
    GloBEAdjustmentsTo71NaturalPersonShareholder = 19,
    GloBEAdjustmentsTo72CorporateShareholder = 20,
    GloBEAdjustmentsTo72NaturalPersonShareholder = 21,
    ACTAdjustmentsTo71CorporateShareholder = 22,
    ACTAdjustmentsTo71NaturalPersonShareholder = 23,
    ACTAdjustmentsTo76Owner = 24,
    SBIEAdjustmentsTo71CorporateShareholder = 25,
    SBIEAdjustmentsTo71NaturalPersonShareholder = 26,
    ACTAdjustmentsWithDifferentGlobeValues = 27,
}

export class FinancialNodeNameDetailsDto implements IFinancialNodeNameDetailsDto {
    isDeleteVisible!: boolean;
    isCreateVisible!: boolean;
    isArmsLengthAdjustment!: boolean;
    showInfoIcon!: boolean;
    infoIconMessage!: string | undefined;
    showGroupInfoIcon!: boolean;
    groupInfoIconMessage!: string | undefined;
    isValueNode!: boolean;
    isHighlighted!: boolean;

    constructor(data?: IFinancialNodeNameDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDeleteVisible = _data["isDeleteVisible"];
            this.isCreateVisible = _data["isCreateVisible"];
            this.isArmsLengthAdjustment = _data["isArmsLengthAdjustment"];
            this.showInfoIcon = _data["showInfoIcon"];
            this.infoIconMessage = _data["infoIconMessage"];
            this.showGroupInfoIcon = _data["showGroupInfoIcon"];
            this.groupInfoIconMessage = _data["groupInfoIconMessage"];
            this.isValueNode = _data["isValueNode"];
            this.isHighlighted = _data["isHighlighted"];
        }
    }

    static fromJS(data: any): FinancialNodeNameDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialNodeNameDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDeleteVisible"] = this.isDeleteVisible;
        data["isCreateVisible"] = this.isCreateVisible;
        data["isArmsLengthAdjustment"] = this.isArmsLengthAdjustment;
        data["showInfoIcon"] = this.showInfoIcon;
        data["infoIconMessage"] = this.infoIconMessage;
        data["showGroupInfoIcon"] = this.showGroupInfoIcon;
        data["groupInfoIconMessage"] = this.groupInfoIconMessage;
        data["isValueNode"] = this.isValueNode;
        data["isHighlighted"] = this.isHighlighted;
        return data;
    }
}

export interface IFinancialNodeNameDetailsDto {
    isDeleteVisible: boolean;
    isCreateVisible: boolean;
    isArmsLengthAdjustment: boolean;
    showInfoIcon: boolean;
    infoIconMessage: string | undefined;
    showGroupInfoIcon: boolean;
    groupInfoIconMessage: string | undefined;
    isValueNode: boolean;
    isHighlighted: boolean;
}

export enum FinancialNodeType {
    GroupType = 1,
    SingleValueType = 2,
    GroupShiftType = 3,
    ShiftType = 4,
    MultipleNodeGroupType = 5,
    SingleNodeGroupType = 6,
    FinancialReadonlyType = 7,
    MultipleShiftNodeGroupType = 8,
    GroupValueType = 11,
    MultipleValueTypes = 22,
}

export enum FinancialShiftType {
    GloBEItemsBookedOtherLevel = 1,
    GloBEAllocationIncomeLossMainPeAndFte = 2,
    GloBEAllocationIncomeLoss = 3,
    GloBEValueArmsLengthAdjustmentValue = 4,
    GloBEValueArmsLengthAdjustmentLoss = 5,
    GloBEManualInvestmentOrInsuranceInvestmentAdjustment75 = 6,
    ACTCrossAllocationOfTaxes = 7,
    ACTManualInvestmentOrInsuranceInvestmentAdjustment75 = 8,
    SBIECrossAllocationOfPayrollCostsPe = 9,
    SBIECrossAllocationPayrollCostsForFlowThroughEntitiesThatAreNotTheUPE = 10,
    SBIECrossAllocationEligibleTangibleAssetsPeAverage = 11,
    SBIECrossAllocationEligibleTangibleAssetsFlowThroughNonUPE = 12,
}

export class FinancialTraceValidationLogic implements IFinancialTraceValidationLogic {
    currentValueRules!: ValidationRuleType[] | undefined;

    constructor(data?: IFinancialTraceValidationLogic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["currentValueRules"])) {
                this.currentValueRules = [] as any;
                for (let item of _data["currentValueRules"])
                    this.currentValueRules!.push(item);
            }
        }
    }

    static fromJS(data: any): FinancialTraceValidationLogic {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialTraceValidationLogic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.currentValueRules)) {
            data["currentValueRules"] = [];
            for (let item of this.currentValueRules)
                data["currentValueRules"].push(item);
        }
        return data;
    }
}

export interface IFinancialTraceValidationLogic {
    currentValueRules: ValidationRuleType[] | undefined;
}

export enum FinancialTreeType {
    IIR = 1,
    QDMTT = 2,
}

export enum FinancialType {
    Revenue = 1,
    ProfitLoss = 2,
    IncomeTax = 3,
    DeferredTax = 4,
    TangibleAssetsEnd = 5,
    TangibleAssetsBegin = 6,
    Payroll = 7,
}

export class FinancialValueDto implements IFinancialValueDto {
    readonly decimalValue!: number | undefined;
    readonly accountingFunctionalCurrency!: string | undefined;
    readonly displayValue!: string | undefined;
    readonly convertedDecimalValue!: number | undefined;
    readonly presentationCurrency!: string | undefined;
    readonly convertedDisplayValue!: string | undefined;
    decimals!: number;
    isCellValueConverted!: boolean;
    isCellValuePercent!: boolean;
    cellCurrency!: string | undefined;
    cellValue!: string | undefined;
    convertedCellValue!: string | undefined;
    readonly rate!: number | undefined;

    constructor(data?: IFinancialValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).decimalValue = _data["decimalValue"];
            (<any>this).accountingFunctionalCurrency = _data["accountingFunctionalCurrency"];
            (<any>this).displayValue = _data["displayValue"];
            (<any>this).convertedDecimalValue = _data["convertedDecimalValue"];
            (<any>this).presentationCurrency = _data["presentationCurrency"];
            (<any>this).convertedDisplayValue = _data["convertedDisplayValue"];
            this.decimals = _data["decimals"];
            this.isCellValueConverted = _data["isCellValueConverted"];
            this.isCellValuePercent = _data["isCellValuePercent"];
            this.cellCurrency = _data["cellCurrency"];
            this.cellValue = _data["cellValue"];
            this.convertedCellValue = _data["convertedCellValue"];
            (<any>this).rate = _data["rate"];
        }
    }

    static fromJS(data: any): FinancialValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["decimalValue"] = this.decimalValue;
        data["accountingFunctionalCurrency"] = this.accountingFunctionalCurrency;
        data["displayValue"] = this.displayValue;
        data["convertedDecimalValue"] = this.convertedDecimalValue;
        data["presentationCurrency"] = this.presentationCurrency;
        data["convertedDisplayValue"] = this.convertedDisplayValue;
        data["decimals"] = this.decimals;
        data["isCellValueConverted"] = this.isCellValueConverted;
        data["isCellValuePercent"] = this.isCellValuePercent;
        data["cellCurrency"] = this.cellCurrency;
        data["cellValue"] = this.cellValue;
        data["convertedCellValue"] = this.convertedCellValue;
        data["rate"] = this.rate;
        return data;
    }
}

export interface IFinancialValueDto {
    decimalValue: number | undefined;
    accountingFunctionalCurrency: string | undefined;
    displayValue: string | undefined;
    convertedDecimalValue: number | undefined;
    presentationCurrency: string | undefined;
    convertedDisplayValue: string | undefined;
    decimals: number;
    isCellValueConverted: boolean;
    isCellValuePercent: boolean;
    cellCurrency: string | undefined;
    cellValue: string | undefined;
    convertedCellValue: string | undefined;
    rate: number | undefined;
}

export class FinancialValuePointDto implements IFinancialValuePointDto {
    id!: number;
    safeHarbourGroupId!: number | undefined;
    organizationalEntityId!: number | undefined;
    financialType!: FinancialType;
    value!: string | undefined;
    isConfirmed!: boolean;
    currency!: string | undefined;
    hasWritePermission!: boolean;
    deltaPoints!: FinancialDeltaPointDto[] | undefined;
    notes!: string | undefined;

    constructor(data?: IFinancialValuePointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.safeHarbourGroupId = _data["safeHarbourGroupId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.financialType = _data["financialType"];
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
            this.currency = _data["currency"];
            this.hasWritePermission = _data["hasWritePermission"];
            if (Array.isArray(_data["deltaPoints"])) {
                this.deltaPoints = [] as any;
                for (let item of _data["deltaPoints"])
                    this.deltaPoints!.push(FinancialDeltaPointDto.fromJS(item));
            }
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): FinancialValuePointDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialValuePointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["safeHarbourGroupId"] = this.safeHarbourGroupId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["financialType"] = this.financialType;
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        data["currency"] = this.currency;
        data["hasWritePermission"] = this.hasWritePermission;
        if (Array.isArray(this.deltaPoints)) {
            data["deltaPoints"] = [];
            for (let item of this.deltaPoints)
                data["deltaPoints"].push(item.toJSON());
        }
        data["notes"] = this.notes;
        return data;
    }
}

export interface IFinancialValuePointDto {
    id: number;
    safeHarbourGroupId: number | undefined;
    organizationalEntityId: number | undefined;
    financialType: FinancialType;
    value: string | undefined;
    isConfirmed: boolean;
    currency: string | undefined;
    hasWritePermission: boolean;
    deltaPoints: FinancialDeltaPointDto[] | undefined;
    notes: string | undefined;
}

export class FinancialValuePointOverviewDto implements IFinancialValuePointOverviewDto {
    id!: number;
    value!: string | undefined;
    financialType!: FinancialType;
    isConfirmed!: boolean;
    isConsidered!: boolean;
    hasPlausibility!: boolean;
    hasAutomaticCalculatedValue!: boolean;
    warningMessage!: string | undefined;

    constructor(data?: IFinancialValuePointOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.financialType = _data["financialType"];
            this.isConfirmed = _data["isConfirmed"];
            this.isConsidered = _data["isConsidered"];
            this.hasPlausibility = _data["hasPlausibility"];
            this.hasAutomaticCalculatedValue = _data["hasAutomaticCalculatedValue"];
            this.warningMessage = _data["warningMessage"];
        }
    }

    static fromJS(data: any): FinancialValuePointOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialValuePointOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["financialType"] = this.financialType;
        data["isConfirmed"] = this.isConfirmed;
        data["isConsidered"] = this.isConsidered;
        data["hasPlausibility"] = this.hasPlausibility;
        data["hasAutomaticCalculatedValue"] = this.hasAutomaticCalculatedValue;
        data["warningMessage"] = this.warningMessage;
        return data;
    }
}

export interface IFinancialValuePointOverviewDto {
    id: number;
    value: string | undefined;
    financialType: FinancialType;
    isConfirmed: boolean;
    isConsidered: boolean;
    hasPlausibility: boolean;
    hasAutomaticCalculatedValue: boolean;
    warningMessage: string | undefined;
}

export class FinancialValuePointWithFlatValueInput implements IFinancialValuePointWithFlatValueInput {
    financialType!: FinancialType;
    value!: string | undefined;
    hasAutomaticCalculatedValue!: boolean;

    constructor(data?: IFinancialValuePointWithFlatValueInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.financialType = _data["financialType"];
            this.value = _data["value"];
            this.hasAutomaticCalculatedValue = _data["hasAutomaticCalculatedValue"];
        }
    }

    static fromJS(data: any): FinancialValuePointWithFlatValueInput {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialValuePointWithFlatValueInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financialType"] = this.financialType;
        data["value"] = this.value;
        data["hasAutomaticCalculatedValue"] = this.hasAutomaticCalculatedValue;
        return data;
    }
}

export interface IFinancialValuePointWithFlatValueInput {
    financialType: FinancialType;
    value: string | undefined;
    hasAutomaticCalculatedValue: boolean;
}

export class FinancialValueTracePointAdditionalDto implements IFinancialValueTracePointAdditionalDto {
    financialYear!: DateTime | undefined;
    basisForAdjustments!: BasisForAdjustmentsType | undefined;
    financialAccountingStandard!: FinancialAccountingStandard | undefined;

    constructor(data?: IFinancialValueTracePointAdditionalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.financialYear = _data["financialYear"] ? DateTime.fromISO(_data["financialYear"].toString()) : <any>undefined;
            this.basisForAdjustments = _data["basisForAdjustments"];
            this.financialAccountingStandard = _data["financialAccountingStandard"];
        }
    }

    static fromJS(data: any): FinancialValueTracePointAdditionalDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialValueTracePointAdditionalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financialYear"] = this.financialYear ? this.financialYear.toString() : <any>undefined;
        data["basisForAdjustments"] = this.basisForAdjustments;
        data["financialAccountingStandard"] = this.financialAccountingStandard;
        return data;
    }
}

export interface IFinancialValueTracePointAdditionalDto {
    financialYear: DateTime | undefined;
    basisForAdjustments: BasisForAdjustmentsType | undefined;
    financialAccountingStandard: FinancialAccountingStandard | undefined;
}

export enum FinancialValueType {
    GloBEFanilInit = 1,
    GloBEPurchasePriceAccounting = 2,
    GloBEArmsLengthAdjustmentAccounting = 3,
    GloBECorrectionArmsLengthAdjustmentValue = 4,
    GloBECorrectionArmsLengthAdjustmentLoss = 5,
    GloBEArmsLengthAdjustmentUnilateral = 6,
    GloBETaxCreditAccounting = 7,
    GloBENetTaxesExpense = 8,
    GloBENetTaxesExpenseCorrection = 9,
    GloBECoveredTaxesAboveTaxLine = 10,
    GloBEExcludedDividends = 11,
    GloBEExcludedEquityGainOrLoss = 12,
    GloBERevaluationMethod = 13,
    GloBEReorgEffects = 14,
    GloBEAsymmetricForeignCurrencyPL = 15,
    GloBEPolicyDisallowedExpenses = 16,
    GloBEPriorPeriodErrors = 17,
    GloBEChangesInAccountingPrinciples = 18,
    GloBEAccruedPensionExpense = 19,
    GloBEDebtRelease = 20,
    GloBEStockBasedCompensationTaxPurposes = 21,
    GloBEStockBasedCompensationFinancialStatements = 22,
    GloBEStockBasedCompensationExpiredWithoutExercise = 23,
    GloBEStockBasedCompensationOptInOutAdjustment = 24,
    GloBEQualifiedRefundableTaxCredits = 25,
    GloBENonQualifyingTaxCredit = 26,
    GloBEPLAttributableFairValueAccounting = 27,
    GloBEPLAttributableRealisationPrinciple = 28,
    GloBEAdjustedAmountRevocation = 29,
    GloBEAssetGainPL = 30,
    GloBEAmountActualYear = 31,
    GloBEIntragroupFinancingAgreementExpense = 32,
    GloBETaxGroupICTransactions = 33,
    GloBECorrectionRevocationYear = 34,
    GloBEInsuranceCompanyTaxesChargedToPolicyholders = 35,
    GloBEChangesInEquityForBanks = 36,
    GloBECeJoiningLeavingMNEGroup = 37,
    GloBEManualCorrectionAdjustment71 = 38,
    GloBEManualCorrectionAdjustment72 = 39,
    GloBEAddLossInReportingYearAdjustment71 = 40,
    GloBEDeductibleDividendDistributedAdjustment72 = 41,
    GlobeInternationalShippingIncome = 42,
    GloBEManualCorrectionAdjustments76 = 43,
    GloBEManualCorrectionAdjustments74 = 44,
    ACTInit = 45,
    ACTCurrentTaxExpenseWithRespectToCoveredTaxesAfterAllocations = 46,
    ACTAdditions = 47,
    ACTReductions = 48,
    ACTCoveredTaxBeforeAllocations = 49,
    ACTCoveredTaxesBookedAboveTheLine = 50,
    ACTUTPTaxesPaidForPriorYears = 51,
    ACTQualifiedRefundableTaxCredits = 52,
    ACTQualifiedFlowThroughTaxBenefits = 53,
    ACTAnyOtherTaxAmountInConnectionWithGloBEIncomeAdjustment = 54,
    ACTCurrentTaxExpenseOnExcludedInternationalShippingIncome = 55,
    ACTNonQualifiedTaxCredit = 56,
    ACTTaxRefundsNotTreatedAsAnAdjustementToCurrentTaxExpense = 57,
    ACTTaxCurrentTaxExpenseRelatedToUTP = 58,
    ACTCurrentTaxesNotExpectedToBePaidWithin3Years = 59,
    ACTCurrentTaxesNotPaidWithin3Years = 60,
    ACTCurrentTaxExpense = 61,
    ACTCurrentTaxCorrection = 62,
    ACTCurrentTaxesCorrection = 63,
    ACTGloBETaxes = 64,
    ACTDisqualifiedRefundableImputationTax = 65,
    ACTFurtherCorrections = 66,
    ACTDeferredTaxesAndOtherAdjustments = 67,
    ACTPostFilingAdjustmentsAndTaxLossCarryBacks = 68,
    ACTPostFilingAdjustment = 69,
    ACTTaxLossCarryBacksTLCB = 70,
    ACTCoveredTaxRefundForTLCBForEachCarryBackYears = 71,
    ACTDeemedDeferredTaxAssetForEachCarryBackYear = 72,
    ACTCoveredTaxesRelatingToNetAssetGainOrNetAssetLoss = 73,
    ACTDeferredTaxExpenseAmount = 74,
    ACTTaxRateDeferredTaxCalculationUsed = 75,
    ACTDTARecastForGloBELoss = 76,
    ACTDeferredTaxExpenseRecast = 77,
    ACTDeferredTaxExpenseBasedOnAccountingCarryingValues = 78,
    ACTAdaptedTaxRateAccountingCarryingValues = 79,
    ACTRecastCompensationAccountingCarryingValues = 80,
    ACTDeferredTaxExpenseBasedOnGlobeCarryingValues = 81,
    ACTAdaptedTaxRateGlobeCarryingValues = 82,
    ACTRecastCompensationGlobeCarryingValues = 83,
    ACTValueAccordingToFinancialStatements = 84,
    ACTAdaptedTaxRate = 85,
    ACTRecastCompensation = 86,
    ACTValueIncludedInComputation = 87,
    ACTDTEAdjustmentInCaseOfReductionOfTaxRate = 88,
    ACTIncreaseOrDecreaseInCoveredTaxesRecordedEquityOrOCI = 89,
    ACTReductionOfCoveredTaxesManualCorrectionAdjustment71 = 90,
    ACTDeferredTaxExpensesManualCorrectionAdjustment71 = 91,
    ACTArticle72CoveredTaxesForGlobeIncomeUpeReducedUnderDDD = 92,
    ACTArticle72DeferredTaxExpenseUPESubjectToDDD = 93,
    ACTDeemedDistributionTaxElection731 = 94,
    ACTManualCorrectionAdjustments76 = 95,
    ACTManualCorrectionAdjustments74 = 96,
    ACTDeferredTaxExpenseManualCorrectionAdjustments76 = 97,
    SBIESubstanceBasedIncomeExlusion = 98,
    SBIEPayrollCarveOut = 99,
    SBIEEligiblePayrollCosts = 100,
    SBIEEligiblePayrollCostsBeforeAllocation = 101,
    SBIEPayrollCosts = 102,
    SBIECorrectionIndependantContractors = 103,
    SBIEPayrolCarveOutEntitiesJoiningLeavingMNEGroup = 104,
    SBIENonEligibleEmployeeCosts = 105,
    SBIENonEligiblePayrollCosts = 106,
    SBIECorrectionCapitalisedCosts = 107,
    SBIEOtherCorrectionPayrollCosts = 108,
    SBIEPayrollCostsAttributableToExcludedShippingIncome = 109,
    SBIEEligiblePayrollCostsAfterAllocationToFlowThroughEntities = 110,
    SBIERelevantMarkUpEligiblePayrollCostsPercentage = 111,
    SBIERelevantMarkUpEligiblePayrollCosts = 112,
    SBIETangibleAssetCarveOut = 113,
    SBIECarryingValueOfEligibleTangibleAssets = 114,
    SBIECarryingValueOfEligibleTangibleAssetsBeforeAllocation = 115,
    SBIETangibleAssetsAverage = 116,
    SBIEAdditionsToTangibleAssetsAverage = 117,
    SBIENonEligibleTangibleAssetsValue = 118,
    SBIELeasingAdjustmentsAverage = 119,
    SBIEOtherCorrectionTangibleAssetsAverage = 120,
    SBIETangibleAssetCarveOutEntitiesJoiningLeavingMNEGroup = 121,
    SBIECarryingValueTangibleAssetsExcludedShippingIncome = 122,
    SBIERelevantMarkUpEligibleTangibleAssetPercentage = 123,
    SBIERelevantMarkUpEligibleTangibleAsset = 124,
    SBIESumOfExcludedEligiblePayrollCostsOfFTE = 125,
    SBIESumOfExcludedCarryingValueOfEligibleTangibleAssetsOfFTE = 126,
    SBIEPayrolManualCorrectionAdjustment71 = 127,
    SBIETangibleAssetManualCorrectionAdjustment71 = 128,
    EtrAndTutReductionBecauseOfTLCB = 129,
    EtrAndTutReductionBecauseOfTLCBAddTut = 130,
    EtrAndTutGloBELossDtaCarryForward = 131,
    EtrAndTutEntcfCarryForward = 132,
    EtrAndTutEtrAdjustmentArt = 133,
    EtrAndTutYear = 134,
    EtrAndTutPrevReportedNetGloBEIncomeLoss = 135,
    EtrAndTutRecalcNetGloBEIncomeLoss = 136,
    EtrAndTutPrevReportedACT = 137,
    EtrAndTutRecalcACT = 138,
    EtrAndTutPrevReportedEtr = 139,
    EtrAndTutRecalcEtr = 140,
    EtrAndTutPrevReportedExcessProfit = 141,
    EtrAndTutRecalcExcessProfit = 142,
    EtrAndTutPrevReportedTutPercentage = 143,
    EtrAndTutRecalcTutPercentage = 144,
    EtrAndTutPrevReportedTut = 145,
    EtrAndTutRecalcTut = 146,
    EtrAndTutAdditionalCurrentTutOtherValue = 147,
    EtrAndTutQDMTT = 148,
    EtrAndTutFinancialAccountingStandard = 149,
}

export enum FinancialYearType {
    FinancialYear1 = 1,
    FinancialYear2 = 2,
    FinancialYear3 = 3,
    FinancialYear4 = 4,
    FinancialYear5 = 5,
}

export class FreeAllowanceToProfitDto implements IFreeAllowanceToProfitDto {
    jurisdiction!: string | undefined;
    safeHarbourGroupType!: SafeHarbourGroupType | undefined;
    number!: number | undefined;
    freeAllowanceByProfitLoss!: number | undefined;

    constructor(data?: IFreeAllowanceToProfitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jurisdiction = _data["jurisdiction"];
            this.safeHarbourGroupType = _data["safeHarbourGroupType"];
            this.number = _data["number"];
            this.freeAllowanceByProfitLoss = _data["freeAllowanceByProfitLoss"];
        }
    }

    static fromJS(data: any): FreeAllowanceToProfitDto {
        data = typeof data === 'object' ? data : {};
        let result = new FreeAllowanceToProfitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jurisdiction"] = this.jurisdiction;
        data["safeHarbourGroupType"] = this.safeHarbourGroupType;
        data["number"] = this.number;
        data["freeAllowanceByProfitLoss"] = this.freeAllowanceByProfitLoss;
        return data;
    }
}

export interface IFreeAllowanceToProfitDto {
    jurisdiction: string | undefined;
    safeHarbourGroupType: SafeHarbourGroupType | undefined;
    number: number | undefined;
    freeAllowanceByProfitLoss: number | undefined;
}

export class FullProjectManagementDto implements IFullProjectManagementDto {
    assignedUser!: AssignableUserDto | undefined;
    criticality!: Criticality | undefined;
    priority!: Priority | undefined;
    effort!: number | undefined;
    plannedStart!: DateTime | undefined;
    plannedEnd!: DateTime | undefined;

    constructor(data?: IFullProjectManagementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignedUser = _data["assignedUser"] ? AssignableUserDto.fromJS(_data["assignedUser"]) : <any>undefined;
            this.criticality = _data["criticality"];
            this.priority = _data["priority"];
            this.effort = _data["effort"];
            this.plannedStart = _data["plannedStart"] ? DateTime.fromISO(_data["plannedStart"].toString()) : <any>undefined;
            this.plannedEnd = _data["plannedEnd"] ? DateTime.fromISO(_data["plannedEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FullProjectManagementDto {
        data = typeof data === 'object' ? data : {};
        let result = new FullProjectManagementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignedUser"] = this.assignedUser ? this.assignedUser.toJSON() : <any>undefined;
        data["criticality"] = this.criticality;
        data["priority"] = this.priority;
        data["effort"] = this.effort;
        data["plannedStart"] = this.plannedStart ? this.plannedStart.toString() : <any>undefined;
        data["plannedEnd"] = this.plannedEnd ? this.plannedEnd.toString() : <any>undefined;
        return data;
    }
}

export interface IFullProjectManagementDto {
    assignedUser: AssignableUserDto | undefined;
    criticality: Criticality | undefined;
    priority: Priority | undefined;
    effort: number | undefined;
    plannedStart: DateTime | undefined;
    plannedEnd: DateTime | undefined;
}

export class FullProjectManagementInput implements IFullProjectManagementInput {
    assignedUser!: AssignableUserInput | undefined;
    criticality!: Criticality | undefined;
    priority!: Priority | undefined;
    effort!: number | undefined;
    plannedStart!: DateTime | undefined;
    plannedEnd!: DateTime | undefined;

    constructor(data?: IFullProjectManagementInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignedUser = _data["assignedUser"] ? AssignableUserInput.fromJS(_data["assignedUser"]) : <any>undefined;
            this.criticality = _data["criticality"];
            this.priority = _data["priority"];
            this.effort = _data["effort"];
            this.plannedStart = _data["plannedStart"] ? DateTime.fromISO(_data["plannedStart"].toString()) : <any>undefined;
            this.plannedEnd = _data["plannedEnd"] ? DateTime.fromISO(_data["plannedEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FullProjectManagementInput {
        data = typeof data === 'object' ? data : {};
        let result = new FullProjectManagementInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignedUser"] = this.assignedUser ? this.assignedUser.toJSON() : <any>undefined;
        data["criticality"] = this.criticality;
        data["priority"] = this.priority;
        data["effort"] = this.effort;
        data["plannedStart"] = this.plannedStart ? this.plannedStart.toString() : <any>undefined;
        data["plannedEnd"] = this.plannedEnd ? this.plannedEnd.toString() : <any>undefined;
        return data;
    }
}

export interface IFullProjectManagementInput {
    assignedUser: AssignableUserInput | undefined;
    criticality: Criticality | undefined;
    priority: Priority | undefined;
    effort: number | undefined;
    plannedStart: DateTime | undefined;
    plannedEnd: DateTime | undefined;
}

export class FullScopeCalculationsOverviewDto implements IFullScopeCalculationsOverviewDto {
    blendingCircleSubgroupId!: number | undefined;
    taxJurisdictionCountry!: string | undefined;
    subgroupType!: BlendingCircleSubgroupType | undefined;
    number!: number | undefined;

    constructor(data?: IFullScopeCalculationsOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
            this.taxJurisdictionCountry = _data["taxJurisdictionCountry"];
            this.subgroupType = _data["subgroupType"];
            this.number = _data["number"];
        }
    }

    static fromJS(data: any): FullScopeCalculationsOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new FullScopeCalculationsOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        data["taxJurisdictionCountry"] = this.taxJurisdictionCountry;
        data["subgroupType"] = this.subgroupType;
        data["number"] = this.number;
        return data;
    }
}

export interface IFullScopeCalculationsOverviewDto {
    blendingCircleSubgroupId: number | undefined;
    taxJurisdictionCountry: string | undefined;
    subgroupType: BlendingCircleSubgroupType | undefined;
    number: number | undefined;
}

export class GeneraInput implements IGeneraInput {
    name!: string | undefined;
    note!: string | undefined;
    tags!: TagDto[] | undefined;

    constructor(data?: IGeneraInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.note = _data["note"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GeneraInput {
        data = typeof data === 'object' ? data : {};
        let result = new GeneraInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["note"] = this.note;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGeneraInput {
    name: string | undefined;
    note: string | undefined;
    tags: TagDto[] | undefined;
}

export class GeneralDto implements IGeneralDto {
    name!: string | undefined;
    note!: string | undefined;
    tags!: TagDto[] | undefined;

    constructor(data?: IGeneralDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.note = _data["note"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GeneralDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["note"] = this.note;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGeneralDto {
    name: string | undefined;
    note: string | undefined;
    tags: TagDto[] | undefined;
}

export class GenerateProjectReportInput implements IGenerateProjectReportInput {
    projectId!: number;
    reportType!: ProjectReportType;
    jurisdictionCountry!: string | undefined;

    constructor(data?: IGenerateProjectReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.reportType = _data["reportType"];
            this.jurisdictionCountry = _data["jurisdictionCountry"];
        }
    }

    static fromJS(data: any): GenerateProjectReportInput {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateProjectReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["reportType"] = this.reportType;
        data["jurisdictionCountry"] = this.jurisdictionCountry;
        return data;
    }
}

export interface IGenerateProjectReportInput {
    projectId: number;
    reportType: ProjectReportType;
    jurisdictionCountry: string | undefined;
}

export class GetFinancialDataCurrencyConvertedFinalInput implements IGetFinancialDataCurrencyConvertedFinalInput {
    projectId!: number;
    safeHarbourGroupId!: number | undefined;
    organizationalEntityId!: number | undefined;
    traceId!: number;
    value!: string | undefined;
    deltaPoints!: UpdateFinancialDeltaPointInput[] | undefined;

    constructor(data?: IGetFinancialDataCurrencyConvertedFinalInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.safeHarbourGroupId = _data["safeHarbourGroupId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.traceId = _data["traceId"];
            this.value = _data["value"];
            if (Array.isArray(_data["deltaPoints"])) {
                this.deltaPoints = [] as any;
                for (let item of _data["deltaPoints"])
                    this.deltaPoints!.push(UpdateFinancialDeltaPointInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFinancialDataCurrencyConvertedFinalInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetFinancialDataCurrencyConvertedFinalInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["safeHarbourGroupId"] = this.safeHarbourGroupId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["traceId"] = this.traceId;
        data["value"] = this.value;
        if (Array.isArray(this.deltaPoints)) {
            data["deltaPoints"] = [];
            for (let item of this.deltaPoints)
                data["deltaPoints"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetFinancialDataCurrencyConvertedFinalInput {
    projectId: number;
    safeHarbourGroupId: number | undefined;
    organizationalEntityId: number | undefined;
    traceId: number;
    value: string | undefined;
    deltaPoints: UpdateFinancialDeltaPointInput[] | undefined;
}

export class GetFinancialDataOrganizationalEntityByIdsOverviewInput implements IGetFinancialDataOrganizationalEntityByIdsOverviewInput {
    projectId!: number;
    organizationalEntityIds!: number[] | undefined;
    isNotConsidered!: boolean;
    filter!: string | undefined;
    blendingCircleCountry!: string | undefined;

    constructor(data?: IGetFinancialDataOrganizationalEntityByIdsOverviewInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["organizationalEntityIds"])) {
                this.organizationalEntityIds = [] as any;
                for (let item of _data["organizationalEntityIds"])
                    this.organizationalEntityIds!.push(item);
            }
            this.isNotConsidered = _data["isNotConsidered"];
            this.filter = _data["filter"];
            this.blendingCircleCountry = _data["blendingCircleCountry"];
        }
    }

    static fromJS(data: any): GetFinancialDataOrganizationalEntityByIdsOverviewInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetFinancialDataOrganizationalEntityByIdsOverviewInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        if (Array.isArray(this.organizationalEntityIds)) {
            data["organizationalEntityIds"] = [];
            for (let item of this.organizationalEntityIds)
                data["organizationalEntityIds"].push(item);
        }
        data["isNotConsidered"] = this.isNotConsidered;
        data["filter"] = this.filter;
        data["blendingCircleCountry"] = this.blendingCircleCountry;
        return data;
    }
}

export interface IGetFinancialDataOrganizationalEntityByIdsOverviewInput {
    projectId: number;
    organizationalEntityIds: number[] | undefined;
    isNotConsidered: boolean;
    filter: string | undefined;
    blendingCircleCountry: string | undefined;
}

export class GetFinancialDataSafeHarbourGroupOverviewInput implements IGetFinancialDataSafeHarbourGroupOverviewInput {
    projectId!: number;
    organizationalEntityIds!: number[] | undefined;
    safeHarbourGroupId!: number | undefined;
    blendingCircleCountry!: string | undefined;

    constructor(data?: IGetFinancialDataSafeHarbourGroupOverviewInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["organizationalEntityIds"])) {
                this.organizationalEntityIds = [] as any;
                for (let item of _data["organizationalEntityIds"])
                    this.organizationalEntityIds!.push(item);
            }
            this.safeHarbourGroupId = _data["safeHarbourGroupId"];
            this.blendingCircleCountry = _data["blendingCircleCountry"];
        }
    }

    static fromJS(data: any): GetFinancialDataSafeHarbourGroupOverviewInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetFinancialDataSafeHarbourGroupOverviewInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        if (Array.isArray(this.organizationalEntityIds)) {
            data["organizationalEntityIds"] = [];
            for (let item of this.organizationalEntityIds)
                data["organizationalEntityIds"].push(item);
        }
        data["safeHarbourGroupId"] = this.safeHarbourGroupId;
        data["blendingCircleCountry"] = this.blendingCircleCountry;
        return data;
    }
}

export interface IGetFinancialDataSafeHarbourGroupOverviewInput {
    projectId: number;
    organizationalEntityIds: number[] | undefined;
    safeHarbourGroupId: number | undefined;
    blendingCircleCountry: string | undefined;
}

export class GetFinancialDeltaPointChangeDto implements IGetFinancialDeltaPointChangeDto {
    entityId!: string | undefined;
    delta!: string | undefined;
    description!: string | undefined;

    constructor(data?: IGetFinancialDeltaPointChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            this.delta = _data["delta"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): GetFinancialDeltaPointChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFinancialDeltaPointChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["delta"] = this.delta;
        data["description"] = this.description;
        return data;
    }
}

export interface IGetFinancialDeltaPointChangeDto {
    entityId: string | undefined;
    delta: string | undefined;
    description: string | undefined;
}

export class GetFinancialValuePointChangeDto implements IGetFinancialValuePointChangeDto {
    user!: UserDetailsDto | undefined;
    changeTime!: DateTime;
    newInitialValue!: string | undefined;
    newDeltaValues!: GetFinancialDeltaPointChangeDto[] | undefined;
    isConfirmed!: boolean;
    comment!: string | undefined;
    notes!: string | undefined;

    constructor(data?: IGetFinancialValuePointChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserDetailsDto.fromJS(_data["user"]) : <any>undefined;
            this.changeTime = _data["changeTime"] ? DateTime.fromISO(_data["changeTime"].toString()) : <any>undefined;
            this.newInitialValue = _data["newInitialValue"];
            if (Array.isArray(_data["newDeltaValues"])) {
                this.newDeltaValues = [] as any;
                for (let item of _data["newDeltaValues"])
                    this.newDeltaValues!.push(GetFinancialDeltaPointChangeDto.fromJS(item));
            }
            this.isConfirmed = _data["isConfirmed"];
            this.comment = _data["comment"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): GetFinancialValuePointChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFinancialValuePointChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["changeTime"] = this.changeTime ? this.changeTime.toString() : <any>undefined;
        data["newInitialValue"] = this.newInitialValue;
        if (Array.isArray(this.newDeltaValues)) {
            data["newDeltaValues"] = [];
            for (let item of this.newDeltaValues)
                data["newDeltaValues"].push(item.toJSON());
        }
        data["isConfirmed"] = this.isConfirmed;
        data["comment"] = this.comment;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IGetFinancialValuePointChangeDto {
    user: UserDetailsDto | undefined;
    changeTime: DateTime;
    newInitialValue: string | undefined;
    newDeltaValues: GetFinancialDeltaPointChangeDto[] | undefined;
    isConfirmed: boolean;
    comment: string | undefined;
    notes: string | undefined;
}

export class GetJurisdictionsOverviewInput implements IGetJurisdictionsOverviewInput {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    projectId!: number;
    filter!: string | undefined;
    jurisdictionsFilter!: string[] | undefined;
    iirStatusFilter!: JurisdictionRuleStatusType[] | undefined;
    utprStatusFilter!: JurisdictionRuleStatusType[] | undefined;
    qdmttStatusFilter!: JurisdictionRuleStatusType[] | undefined;

    constructor(data?: IGetJurisdictionsOverviewInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.projectId = _data["projectId"];
            this.filter = _data["filter"];
            if (Array.isArray(_data["jurisdictionsFilter"])) {
                this.jurisdictionsFilter = [] as any;
                for (let item of _data["jurisdictionsFilter"])
                    this.jurisdictionsFilter!.push(item);
            }
            if (Array.isArray(_data["iirStatusFilter"])) {
                this.iirStatusFilter = [] as any;
                for (let item of _data["iirStatusFilter"])
                    this.iirStatusFilter!.push(item);
            }
            if (Array.isArray(_data["utprStatusFilter"])) {
                this.utprStatusFilter = [] as any;
                for (let item of _data["utprStatusFilter"])
                    this.utprStatusFilter!.push(item);
            }
            if (Array.isArray(_data["qdmttStatusFilter"])) {
                this.qdmttStatusFilter = [] as any;
                for (let item of _data["qdmttStatusFilter"])
                    this.qdmttStatusFilter!.push(item);
            }
        }
    }

    static fromJS(data: any): GetJurisdictionsOverviewInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetJurisdictionsOverviewInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["projectId"] = this.projectId;
        data["filter"] = this.filter;
        if (Array.isArray(this.jurisdictionsFilter)) {
            data["jurisdictionsFilter"] = [];
            for (let item of this.jurisdictionsFilter)
                data["jurisdictionsFilter"].push(item);
        }
        if (Array.isArray(this.iirStatusFilter)) {
            data["iirStatusFilter"] = [];
            for (let item of this.iirStatusFilter)
                data["iirStatusFilter"].push(item);
        }
        if (Array.isArray(this.utprStatusFilter)) {
            data["utprStatusFilter"] = [];
            for (let item of this.utprStatusFilter)
                data["utprStatusFilter"].push(item);
        }
        if (Array.isArray(this.qdmttStatusFilter)) {
            data["qdmttStatusFilter"] = [];
            for (let item of this.qdmttStatusFilter)
                data["qdmttStatusFilter"].push(item);
        }
        return data;
    }
}

export interface IGetJurisdictionsOverviewInput {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    projectId: number;
    filter: string | undefined;
    jurisdictionsFilter: string[] | undefined;
    iirStatusFilter: JurisdictionRuleStatusType[] | undefined;
    utprStatusFilter: JurisdictionRuleStatusType[] | undefined;
    qdmttStatusFilter: JurisdictionRuleStatusType[] | undefined;
}

export class GetObligationsOverviewInput implements IGetObligationsOverviewInput {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    projectId!: number;
    filter!: string | undefined;
    jurisdictionsFilter!: string[] | undefined;
    returnTypesFilter!: string[] | undefined;
    currentStatusesFilter!: string[] | undefined;
    assignedUsersFilter!: number[] | undefined;
    organizationalEntitiesFilter!: number[] | undefined;
    dueDateFilter!: string[] | undefined;
    hideCompleted!: boolean;
    hideEmptyFilingObligations!: boolean;

    constructor(data?: IGetObligationsOverviewInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.projectId = _data["projectId"];
            this.filter = _data["filter"];
            if (Array.isArray(_data["jurisdictionsFilter"])) {
                this.jurisdictionsFilter = [] as any;
                for (let item of _data["jurisdictionsFilter"])
                    this.jurisdictionsFilter!.push(item);
            }
            if (Array.isArray(_data["returnTypesFilter"])) {
                this.returnTypesFilter = [] as any;
                for (let item of _data["returnTypesFilter"])
                    this.returnTypesFilter!.push(item);
            }
            if (Array.isArray(_data["currentStatusesFilter"])) {
                this.currentStatusesFilter = [] as any;
                for (let item of _data["currentStatusesFilter"])
                    this.currentStatusesFilter!.push(item);
            }
            if (Array.isArray(_data["assignedUsersFilter"])) {
                this.assignedUsersFilter = [] as any;
                for (let item of _data["assignedUsersFilter"])
                    this.assignedUsersFilter!.push(item);
            }
            if (Array.isArray(_data["organizationalEntitiesFilter"])) {
                this.organizationalEntitiesFilter = [] as any;
                for (let item of _data["organizationalEntitiesFilter"])
                    this.organizationalEntitiesFilter!.push(item);
            }
            if (Array.isArray(_data["dueDateFilter"])) {
                this.dueDateFilter = [] as any;
                for (let item of _data["dueDateFilter"])
                    this.dueDateFilter!.push(item);
            }
            this.hideCompleted = _data["hideCompleted"];
            this.hideEmptyFilingObligations = _data["hideEmptyFilingObligations"];
        }
    }

    static fromJS(data: any): GetObligationsOverviewInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetObligationsOverviewInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["projectId"] = this.projectId;
        data["filter"] = this.filter;
        if (Array.isArray(this.jurisdictionsFilter)) {
            data["jurisdictionsFilter"] = [];
            for (let item of this.jurisdictionsFilter)
                data["jurisdictionsFilter"].push(item);
        }
        if (Array.isArray(this.returnTypesFilter)) {
            data["returnTypesFilter"] = [];
            for (let item of this.returnTypesFilter)
                data["returnTypesFilter"].push(item);
        }
        if (Array.isArray(this.currentStatusesFilter)) {
            data["currentStatusesFilter"] = [];
            for (let item of this.currentStatusesFilter)
                data["currentStatusesFilter"].push(item);
        }
        if (Array.isArray(this.assignedUsersFilter)) {
            data["assignedUsersFilter"] = [];
            for (let item of this.assignedUsersFilter)
                data["assignedUsersFilter"].push(item);
        }
        if (Array.isArray(this.organizationalEntitiesFilter)) {
            data["organizationalEntitiesFilter"] = [];
            for (let item of this.organizationalEntitiesFilter)
                data["organizationalEntitiesFilter"].push(item);
        }
        if (Array.isArray(this.dueDateFilter)) {
            data["dueDateFilter"] = [];
            for (let item of this.dueDateFilter)
                data["dueDateFilter"].push(item);
        }
        data["hideCompleted"] = this.hideCompleted;
        data["hideEmptyFilingObligations"] = this.hideEmptyFilingObligations;
        return data;
    }
}

export interface IGetObligationsOverviewInput {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    projectId: number;
    filter: string | undefined;
    jurisdictionsFilter: string[] | undefined;
    returnTypesFilter: string[] | undefined;
    currentStatusesFilter: string[] | undefined;
    assignedUsersFilter: number[] | undefined;
    organizationalEntitiesFilter: number[] | undefined;
    dueDateFilter: string[] | undefined;
    hideCompleted: boolean;
    hideEmptyFilingObligations: boolean;
}

export class GetOrganizationalChartInput implements IGetOrganizationalChartInput {
    projectId!: number;
    jurisdictionsFilter!: string[] | undefined;
    organizationalEntitiesFilter!: number[] | undefined;

    constructor(data?: IGetOrganizationalChartInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["jurisdictionsFilter"])) {
                this.jurisdictionsFilter = [] as any;
                for (let item of _data["jurisdictionsFilter"])
                    this.jurisdictionsFilter!.push(item);
            }
            if (Array.isArray(_data["organizationalEntitiesFilter"])) {
                this.organizationalEntitiesFilter = [] as any;
                for (let item of _data["organizationalEntitiesFilter"])
                    this.organizationalEntitiesFilter!.push(item);
            }
        }
    }

    static fromJS(data: any): GetOrganizationalChartInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrganizationalChartInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        if (Array.isArray(this.jurisdictionsFilter)) {
            data["jurisdictionsFilter"] = [];
            for (let item of this.jurisdictionsFilter)
                data["jurisdictionsFilter"].push(item);
        }
        if (Array.isArray(this.organizationalEntitiesFilter)) {
            data["organizationalEntitiesFilter"] = [];
            for (let item of this.organizationalEntitiesFilter)
                data["organizationalEntitiesFilter"].push(item);
        }
        return data;
    }
}

export interface IGetOrganizationalChartInput {
    projectId: number;
    jurisdictionsFilter: string[] | undefined;
    organizationalEntitiesFilter: number[] | undefined;
}

export class GetSafeHarbourGroupOverviewInput implements IGetSafeHarbourGroupOverviewInput {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    filter!: string | undefined;
    jurisdictionsFilter!: string[] | undefined;
    deMinimisStatuses!: CheckResultStatus[] | undefined;
    setrStatuses!: CheckResultStatus[] | undefined;
    rptStatuses!: CheckResultStatus[] | undefined;
    isChartRequest!: boolean;
    projectId!: number;

    constructor(data?: IGetSafeHarbourGroupOverviewInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.filter = _data["filter"];
            if (Array.isArray(_data["jurisdictionsFilter"])) {
                this.jurisdictionsFilter = [] as any;
                for (let item of _data["jurisdictionsFilter"])
                    this.jurisdictionsFilter!.push(item);
            }
            if (Array.isArray(_data["deMinimisStatuses"])) {
                this.deMinimisStatuses = [] as any;
                for (let item of _data["deMinimisStatuses"])
                    this.deMinimisStatuses!.push(item);
            }
            if (Array.isArray(_data["setrStatuses"])) {
                this.setrStatuses = [] as any;
                for (let item of _data["setrStatuses"])
                    this.setrStatuses!.push(item);
            }
            if (Array.isArray(_data["rptStatuses"])) {
                this.rptStatuses = [] as any;
                for (let item of _data["rptStatuses"])
                    this.rptStatuses!.push(item);
            }
            this.isChartRequest = _data["isChartRequest"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): GetSafeHarbourGroupOverviewInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSafeHarbourGroupOverviewInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["filter"] = this.filter;
        if (Array.isArray(this.jurisdictionsFilter)) {
            data["jurisdictionsFilter"] = [];
            for (let item of this.jurisdictionsFilter)
                data["jurisdictionsFilter"].push(item);
        }
        if (Array.isArray(this.deMinimisStatuses)) {
            data["deMinimisStatuses"] = [];
            for (let item of this.deMinimisStatuses)
                data["deMinimisStatuses"].push(item);
        }
        if (Array.isArray(this.setrStatuses)) {
            data["setrStatuses"] = [];
            for (let item of this.setrStatuses)
                data["setrStatuses"].push(item);
        }
        if (Array.isArray(this.rptStatuses)) {
            data["rptStatuses"] = [];
            for (let item of this.rptStatuses)
                data["rptStatuses"].push(item);
        }
        data["isChartRequest"] = this.isChartRequest;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IGetSafeHarbourGroupOverviewInput {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    filter: string | undefined;
    jurisdictionsFilter: string[] | undefined;
    deMinimisStatuses: CheckResultStatus[] | undefined;
    setrStatuses: CheckResultStatus[] | undefined;
    rptStatuses: CheckResultStatus[] | undefined;
    isChartRequest: boolean;
    projectId: number;
}

export class GetUserOrOrganizationalUnitBulkPermissionsInput implements IGetUserOrOrganizationalUnitBulkPermissionsInput {
    projectId!: number;
    organizationalEntityIds!: number[] | undefined;
    countryCodes!: string[] | undefined;
    updateInput!: UpdateAccessManagementInput | undefined;

    constructor(data?: IGetUserOrOrganizationalUnitBulkPermissionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["organizationalEntityIds"])) {
                this.organizationalEntityIds = [] as any;
                for (let item of _data["organizationalEntityIds"])
                    this.organizationalEntityIds!.push(item);
            }
            if (Array.isArray(_data["countryCodes"])) {
                this.countryCodes = [] as any;
                for (let item of _data["countryCodes"])
                    this.countryCodes!.push(item);
            }
            this.updateInput = _data["updateInput"] ? UpdateAccessManagementInput.fromJS(_data["updateInput"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUserOrOrganizationalUnitBulkPermissionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserOrOrganizationalUnitBulkPermissionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        if (Array.isArray(this.organizationalEntityIds)) {
            data["organizationalEntityIds"] = [];
            for (let item of this.organizationalEntityIds)
                data["organizationalEntityIds"].push(item);
        }
        if (Array.isArray(this.countryCodes)) {
            data["countryCodes"] = [];
            for (let item of this.countryCodes)
                data["countryCodes"].push(item);
        }
        data["updateInput"] = this.updateInput ? this.updateInput.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetUserOrOrganizationalUnitBulkPermissionsInput {
    projectId: number;
    organizationalEntityIds: number[] | undefined;
    countryCodes: string[] | undefined;
    updateInput: UpdateAccessManagementInput | undefined;
}

export class GetUserOrOrganizationalUnitPermissionDto implements IGetUserOrOrganizationalUnitPermissionDto {
    isActivated!: boolean;
    inheritedFromCountryCode!: string | undefined;
    allUsersWithPermission!: UserOrOrganizationUnitDto[] | undefined;
    selectedUsersOrOrganizationUnits!: UserOrOrganizationUnitDto[] | undefined;
    availableUsersOrOrganizationUnits!: UserOrOrganizationUnitDto[] | undefined;

    constructor(data?: IGetUserOrOrganizationalUnitPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActivated = _data["isActivated"];
            this.inheritedFromCountryCode = _data["inheritedFromCountryCode"];
            if (Array.isArray(_data["allUsersWithPermission"])) {
                this.allUsersWithPermission = [] as any;
                for (let item of _data["allUsersWithPermission"])
                    this.allUsersWithPermission!.push(UserOrOrganizationUnitDto.fromJS(item));
            }
            if (Array.isArray(_data["selectedUsersOrOrganizationUnits"])) {
                this.selectedUsersOrOrganizationUnits = [] as any;
                for (let item of _data["selectedUsersOrOrganizationUnits"])
                    this.selectedUsersOrOrganizationUnits!.push(UserOrOrganizationUnitDto.fromJS(item));
            }
            if (Array.isArray(_data["availableUsersOrOrganizationUnits"])) {
                this.availableUsersOrOrganizationUnits = [] as any;
                for (let item of _data["availableUsersOrOrganizationUnits"])
                    this.availableUsersOrOrganizationUnits!.push(UserOrOrganizationUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserOrOrganizationalUnitPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserOrOrganizationalUnitPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActivated"] = this.isActivated;
        data["inheritedFromCountryCode"] = this.inheritedFromCountryCode;
        if (Array.isArray(this.allUsersWithPermission)) {
            data["allUsersWithPermission"] = [];
            for (let item of this.allUsersWithPermission)
                data["allUsersWithPermission"].push(item.toJSON());
        }
        if (Array.isArray(this.selectedUsersOrOrganizationUnits)) {
            data["selectedUsersOrOrganizationUnits"] = [];
            for (let item of this.selectedUsersOrOrganizationUnits)
                data["selectedUsersOrOrganizationUnits"].push(item.toJSON());
        }
        if (Array.isArray(this.availableUsersOrOrganizationUnits)) {
            data["availableUsersOrOrganizationUnits"] = [];
            for (let item of this.availableUsersOrOrganizationUnits)
                data["availableUsersOrOrganizationUnits"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUserOrOrganizationalUnitPermissionDto {
    isActivated: boolean;
    inheritedFromCountryCode: string | undefined;
    allUsersWithPermission: UserOrOrganizationUnitDto[] | undefined;
    selectedUsersOrOrganizationUnits: UserOrOrganizationUnitDto[] | undefined;
    availableUsersOrOrganizationUnits: UserOrOrganizationUnitDto[] | undefined;
}

export class GetUserOrOrganizationalUnitPermissionsDto implements IGetUserOrOrganizationalUnitPermissionsDto {
    readingPermission!: GetUserOrOrganizationalUnitPermissionDto | undefined;
    writingPermission!: GetUserOrOrganizationalUnitPermissionDto | undefined;

    constructor(data?: IGetUserOrOrganizationalUnitPermissionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.readingPermission = _data["readingPermission"] ? GetUserOrOrganizationalUnitPermissionDto.fromJS(_data["readingPermission"]) : <any>undefined;
            this.writingPermission = _data["writingPermission"] ? GetUserOrOrganizationalUnitPermissionDto.fromJS(_data["writingPermission"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUserOrOrganizationalUnitPermissionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserOrOrganizationalUnitPermissionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["readingPermission"] = this.readingPermission ? this.readingPermission.toJSON() : <any>undefined;
        data["writingPermission"] = this.writingPermission ? this.writingPermission.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetUserOrOrganizationalUnitPermissionsDto {
    readingPermission: GetUserOrOrganizationalUnitPermissionDto | undefined;
    writingPermission: GetUserOrOrganizationalUnitPermissionDto | undefined;
}

export class GetUserOrOrganizationalUnitPermissionsInput implements IGetUserOrOrganizationalUnitPermissionsInput {
    projectId!: number;
    organizationalEntityId!: number | undefined;
    countryCode!: string | undefined;
    updateInput!: UpdateAccessManagementInput | undefined;

    constructor(data?: IGetUserOrOrganizationalUnitPermissionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.countryCode = _data["countryCode"];
            this.updateInput = _data["updateInput"] ? UpdateAccessManagementInput.fromJS(_data["updateInput"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUserOrOrganizationalUnitPermissionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserOrOrganizationalUnitPermissionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["countryCode"] = this.countryCode;
        data["updateInput"] = this.updateInput ? this.updateInput.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetUserOrOrganizationalUnitPermissionsInput {
    projectId: number;
    organizationalEntityId: number | undefined;
    countryCode: string | undefined;
    updateInput: UpdateAccessManagementInput | undefined;
}

export class GetUtprDataPointChangeDto implements IGetUtprDataPointChangeDto {
    user!: UserDetailsDto | undefined;
    changeTime!: DateTime;
    newInitialValue!: string | undefined;
    isConfirmed!: boolean;
    comment!: string | undefined;
    notes!: string | undefined;

    constructor(data?: IGetUtprDataPointChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserDetailsDto.fromJS(_data["user"]) : <any>undefined;
            this.changeTime = _data["changeTime"] ? DateTime.fromISO(_data["changeTime"].toString()) : <any>undefined;
            this.newInitialValue = _data["newInitialValue"];
            this.isConfirmed = _data["isConfirmed"];
            this.comment = _data["comment"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): GetUtprDataPointChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUtprDataPointChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["changeTime"] = this.changeTime ? this.changeTime.toString() : <any>undefined;
        data["newInitialValue"] = this.newInitialValue;
        data["isConfirmed"] = this.isConfirmed;
        data["comment"] = this.comment;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IGetUtprDataPointChangeDto {
    user: UserDetailsDto | undefined;
    changeTime: DateTime;
    newInitialValue: string | undefined;
    isConfirmed: boolean;
    comment: string | undefined;
    notes: string | undefined;
}

export class GetUtprJurisdictionsOverviewInput implements IGetUtprJurisdictionsOverviewInput {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    projectId!: number;
    filter!: string | undefined;
    jurisdictionsFilter!: string[] | undefined;

    constructor(data?: IGetUtprJurisdictionsOverviewInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.projectId = _data["projectId"];
            this.filter = _data["filter"];
            if (Array.isArray(_data["jurisdictionsFilter"])) {
                this.jurisdictionsFilter = [] as any;
                for (let item of _data["jurisdictionsFilter"])
                    this.jurisdictionsFilter!.push(item);
            }
        }
    }

    static fromJS(data: any): GetUtprJurisdictionsOverviewInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUtprJurisdictionsOverviewInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["projectId"] = this.projectId;
        data["filter"] = this.filter;
        if (Array.isArray(this.jurisdictionsFilter)) {
            data["jurisdictionsFilter"] = [];
            for (let item of this.jurisdictionsFilter)
                data["jurisdictionsFilter"].push(item);
        }
        return data;
    }
}

export interface IGetUtprJurisdictionsOverviewInput {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    projectId: number;
    filter: string | undefined;
    jurisdictionsFilter: string[] | undefined;
}

export enum GloBEParentType {
    OrganizationalEntity = 0,
    OwnershipChange = 1,
}

export enum GloBEStatus {
    UltimateParentEntity = 1,
    ConstituentEntity = 2,
    FlowThroughEntityTaxTransparent = 3,
    FlowThroughEntityReverseHybrid = 5,
    HybridEntity = 6,
    PermanentEstablishment = 7,
    MainEntity = 8,
    MinorityOwnedParentEntity = 9,
    MinorityOwnedSubsidiary = 10,
    MinorityOwnedConstituentEntity = 11,
    InvestmentEntity = 12,
    InsuranceInvestmentEntity = 13,
    JointVenture = 14,
    JointVentureSubsidiary = 15,
    ExcludedEntity = 16,
    NonMaterialConstituentEntity = 17,
    NonGroupMember = 18,
    SecuritizationEntity = 102,
    ParentEntityRequiredToApplyQiir = 103,
}

export class ImportFileInfoDto implements IImportFileInfoDto {
    hasNewerVersion!: boolean;
    importType!: ProjectImportType;
    hasNmceWarning!: boolean;
    hasExcludedEntityWarning!: boolean;
    isVersionOutdated!: boolean;

    constructor(data?: IImportFileInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasNewerVersion = _data["hasNewerVersion"];
            this.importType = _data["importType"];
            this.hasNmceWarning = _data["hasNmceWarning"];
            this.hasExcludedEntityWarning = _data["hasExcludedEntityWarning"];
            this.isVersionOutdated = _data["isVersionOutdated"];
        }
    }

    static fromJS(data: any): ImportFileInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportFileInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasNewerVersion"] = this.hasNewerVersion;
        data["importType"] = this.importType;
        data["hasNmceWarning"] = this.hasNmceWarning;
        data["hasExcludedEntityWarning"] = this.hasExcludedEntityWarning;
        data["isVersionOutdated"] = this.isVersionOutdated;
        return data;
    }
}

export interface IImportFileInfoDto {
    hasNewerVersion: boolean;
    importType: ProjectImportType;
    hasNmceWarning: boolean;
    hasExcludedEntityWarning: boolean;
    isVersionOutdated: boolean;
}

export class ImportOverviewDto implements IImportOverviewDto {
    id!: number;
    fileName!: string | undefined;
    tags!: TagDto[] | undefined;
    creationTime!: DateTime;
    author!: string | undefined;
    creatorUserId!: number | undefined;
    comment!: string | undefined;

    constructor(data?: IImportOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.author = _data["author"];
            this.creatorUserId = _data["creatorUserId"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): ImportOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["author"] = this.author;
        data["creatorUserId"] = this.creatorUserId;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IImportOverviewDto {
    id: number;
    fileName: string | undefined;
    tags: TagDto[] | undefined;
    creationTime: DateTime;
    author: string | undefined;
    creatorUserId: number | undefined;
    comment: string | undefined;
}

export class ImportReportInput implements IImportReportInput {
    fileToken!: string | undefined;
    comment!: string | undefined;
    projectId!: number;
    addNewData!: boolean;
    deleteExistingData!: boolean;
    emptyValues!: boolean;
    ignoreInapplicableValues!: boolean;
    confirmAllData!: boolean;
    automaticallyDetermineValues!: boolean;
    overwriteExisting!: boolean;
    alignBlendingCircleCountries!: boolean;
    tags!: TagDto[] | undefined;
    testImport!: boolean;
    financialTreeType!: FinancialTreeType;

    constructor(data?: IImportReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileToken = _data["fileToken"];
            this.comment = _data["comment"];
            this.projectId = _data["projectId"];
            this.addNewData = _data["addNewData"];
            this.deleteExistingData = _data["deleteExistingData"];
            this.emptyValues = _data["emptyValues"];
            this.ignoreInapplicableValues = _data["ignoreInapplicableValues"];
            this.confirmAllData = _data["confirmAllData"];
            this.automaticallyDetermineValues = _data["automaticallyDetermineValues"];
            this.overwriteExisting = _data["overwriteExisting"];
            this.alignBlendingCircleCountries = _data["alignBlendingCircleCountries"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
            this.testImport = _data["testImport"];
            this.financialTreeType = _data["financialTreeType"];
        }
    }

    static fromJS(data: any): ImportReportInput {
        data = typeof data === 'object' ? data : {};
        let result = new ImportReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileToken"] = this.fileToken;
        data["comment"] = this.comment;
        data["projectId"] = this.projectId;
        data["addNewData"] = this.addNewData;
        data["deleteExistingData"] = this.deleteExistingData;
        data["emptyValues"] = this.emptyValues;
        data["ignoreInapplicableValues"] = this.ignoreInapplicableValues;
        data["confirmAllData"] = this.confirmAllData;
        data["automaticallyDetermineValues"] = this.automaticallyDetermineValues;
        data["overwriteExisting"] = this.overwriteExisting;
        data["alignBlendingCircleCountries"] = this.alignBlendingCircleCountries;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["testImport"] = this.testImport;
        data["financialTreeType"] = this.financialTreeType;
        return data;
    }
}

export interface IImportReportInput {
    fileToken: string | undefined;
    comment: string | undefined;
    projectId: number;
    addNewData: boolean;
    deleteExistingData: boolean;
    emptyValues: boolean;
    ignoreInapplicableValues: boolean;
    confirmAllData: boolean;
    automaticallyDetermineValues: boolean;
    overwriteExisting: boolean;
    alignBlendingCircleCountries: boolean;
    tags: TagDto[] | undefined;
    testImport: boolean;
    financialTreeType: FinancialTreeType;
}

export class InitialPhaseDetailsDto implements IInitialPhaseDetailsDto {
    startDate!: DateTime;
    initialPhaseJurisdictions!: InitialPhaseJurisdictionEntryDto[] | undefined;
    numberOfJurisdictions!: number | undefined;
    sumOfTangibleAssets!: number | undefined;

    constructor(data?: IInitialPhaseDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["initialPhaseJurisdictions"])) {
                this.initialPhaseJurisdictions = [] as any;
                for (let item of _data["initialPhaseJurisdictions"])
                    this.initialPhaseJurisdictions!.push(InitialPhaseJurisdictionEntryDto.fromJS(item));
            }
            this.numberOfJurisdictions = _data["numberOfJurisdictions"];
            this.sumOfTangibleAssets = _data["sumOfTangibleAssets"];
        }
    }

    static fromJS(data: any): InitialPhaseDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new InitialPhaseDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        if (Array.isArray(this.initialPhaseJurisdictions)) {
            data["initialPhaseJurisdictions"] = [];
            for (let item of this.initialPhaseJurisdictions)
                data["initialPhaseJurisdictions"].push(item.toJSON());
        }
        data["numberOfJurisdictions"] = this.numberOfJurisdictions;
        data["sumOfTangibleAssets"] = this.sumOfTangibleAssets;
        return data;
    }
}

export interface IInitialPhaseDetailsDto {
    startDate: DateTime;
    initialPhaseJurisdictions: InitialPhaseJurisdictionEntryDto[] | undefined;
    numberOfJurisdictions: number | undefined;
    sumOfTangibleAssets: number | undefined;
}

export class InitialPhaseDetailsInput implements IInitialPhaseDetailsInput {
    startDate!: DateTime;
    initialPhaseJurisdictions!: InitialPhaseJurisdictionEntryInput[] | undefined;
    numberOfJurisdictions!: number | undefined;
    sumOfTangibleAssets!: number | undefined;

    constructor(data?: IInitialPhaseDetailsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["initialPhaseJurisdictions"])) {
                this.initialPhaseJurisdictions = [] as any;
                for (let item of _data["initialPhaseJurisdictions"])
                    this.initialPhaseJurisdictions!.push(InitialPhaseJurisdictionEntryInput.fromJS(item));
            }
            this.numberOfJurisdictions = _data["numberOfJurisdictions"];
            this.sumOfTangibleAssets = _data["sumOfTangibleAssets"];
        }
    }

    static fromJS(data: any): InitialPhaseDetailsInput {
        data = typeof data === 'object' ? data : {};
        let result = new InitialPhaseDetailsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        if (Array.isArray(this.initialPhaseJurisdictions)) {
            data["initialPhaseJurisdictions"] = [];
            for (let item of this.initialPhaseJurisdictions)
                data["initialPhaseJurisdictions"].push(item.toJSON());
        }
        data["numberOfJurisdictions"] = this.numberOfJurisdictions;
        data["sumOfTangibleAssets"] = this.sumOfTangibleAssets;
        return data;
    }
}

export interface IInitialPhaseDetailsInput {
    startDate: DateTime;
    initialPhaseJurisdictions: InitialPhaseJurisdictionEntryInput[] | undefined;
    numberOfJurisdictions: number | undefined;
    sumOfTangibleAssets: number | undefined;
}

export class InitialPhaseJurisdictionEntryDto implements IInitialPhaseJurisdictionEntryDto {
    country!: string | undefined;
    tangibleAssetValue!: number;

    constructor(data?: IInitialPhaseJurisdictionEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.country = _data["country"];
            this.tangibleAssetValue = _data["tangibleAssetValue"];
        }
    }

    static fromJS(data: any): InitialPhaseJurisdictionEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new InitialPhaseJurisdictionEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country;
        data["tangibleAssetValue"] = this.tangibleAssetValue;
        return data;
    }
}

export interface IInitialPhaseJurisdictionEntryDto {
    country: string | undefined;
    tangibleAssetValue: number;
}

export class InitialPhaseJurisdictionEntryInput implements IInitialPhaseJurisdictionEntryInput {
    country!: string | undefined;
    tangibleAssetValue!: number;

    constructor(data?: IInitialPhaseJurisdictionEntryInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.country = _data["country"];
            this.tangibleAssetValue = _data["tangibleAssetValue"];
        }
    }

    static fromJS(data: any): InitialPhaseJurisdictionEntryInput {
        data = typeof data === 'object' ? data : {};
        let result = new InitialPhaseJurisdictionEntryInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country;
        data["tangibleAssetValue"] = this.tangibleAssetValue;
        return data;
    }
}

export interface IInitialPhaseJurisdictionEntryInput {
    country: string | undefined;
    tangibleAssetValue: number;
}

export class InitiateEmailConversationInput implements IInitiateEmailConversationInput {
    channelId!: number;
    referenceId!: number;

    constructor(data?: IInitiateEmailConversationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelId = _data["channelId"];
            this.referenceId = _data["referenceId"];
        }
    }

    static fromJS(data: any): InitiateEmailConversationInput {
        data = typeof data === 'object' ? data : {};
        let result = new InitiateEmailConversationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelId"] = this.channelId;
        data["referenceId"] = this.referenceId;
        return data;
    }
}

export interface IInitiateEmailConversationInput {
    channelId: number;
    referenceId: number;
}

export enum InternationalShippingIncomeCategory {
    Article332a = 1,
    Article332b = 2,
    Article332c = 3,
    Article332d = 4,
    Article332e = 5,
    Article332f = 6,
    Article333a = 7,
    Article333b = 8,
    Article333c = 9,
    Article333d = 10,
    Article333e = 11,
}

export class InternationalShippingIncomeDetailInput implements IInternationalShippingIncomeDetailInput {
    category!: InternationalShippingIncomeCategory[] | undefined;
    revenue!: string | undefined;
    cost!: string | undefined;

    constructor(data?: IInternationalShippingIncomeDetailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["category"])) {
                this.category = [] as any;
                for (let item of _data["category"])
                    this.category!.push(item);
            }
            this.revenue = _data["revenue"];
            this.cost = _data["cost"];
        }
    }

    static fromJS(data: any): InternationalShippingIncomeDetailInput {
        data = typeof data === 'object' ? data : {};
        let result = new InternationalShippingIncomeDetailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.category)) {
            data["category"] = [];
            for (let item of this.category)
                data["category"].push(item);
        }
        data["revenue"] = this.revenue;
        data["cost"] = this.cost;
        return data;
    }
}

export interface IInternationalShippingIncomeDetailInput {
    category: InternationalShippingIncomeCategory[] | undefined;
    revenue: string | undefined;
    cost: string | undefined;
}

export class InternationalShippingIncomeDetailsDto implements IInternationalShippingIncomeDetailsDto {
    internationalShippingIncomeCategory!: InternationalShippingIncomeCategory[] | undefined;
    internationalShippingIncomeRevenue!: string | undefined;
    internationalShippingIncomeCost!: string | undefined;
    qualifiedAncillaryInternationalShippingIncomeCategory!: InternationalShippingIncomeCategory[] | undefined;
    doesQualifiedAncillaryInternationalShippingIncomeCategoryMatch!: boolean;
    qualifiedAncillaryInternationalShippingIncomeRevenue!: string | undefined;
    qualifiedAncillaryInternationalShippingIncomeCost!: string | undefined;
    internationalShippingIncome!: string | undefined;
    qualifiedAncillaryInternationalShippingIncome!: string | undefined;
    totalShippingIncomeForAllCes!: string | undefined;
    fiftyPercentageCap!: string | undefined;
    totalQualifiedAncillaryShippingIncomeForAllCes!: string | undefined;
    nonExcludedQualifiedAncillaryShippingIncomeForAllCes!: string | undefined;
    excludedQualifiedAncillaryShippingIncomeForThisCe!: string | undefined;

    constructor(data?: IInternationalShippingIncomeDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["internationalShippingIncomeCategory"])) {
                this.internationalShippingIncomeCategory = [] as any;
                for (let item of _data["internationalShippingIncomeCategory"])
                    this.internationalShippingIncomeCategory!.push(item);
            }
            this.internationalShippingIncomeRevenue = _data["internationalShippingIncomeRevenue"];
            this.internationalShippingIncomeCost = _data["internationalShippingIncomeCost"];
            if (Array.isArray(_data["qualifiedAncillaryInternationalShippingIncomeCategory"])) {
                this.qualifiedAncillaryInternationalShippingIncomeCategory = [] as any;
                for (let item of _data["qualifiedAncillaryInternationalShippingIncomeCategory"])
                    this.qualifiedAncillaryInternationalShippingIncomeCategory!.push(item);
            }
            this.doesQualifiedAncillaryInternationalShippingIncomeCategoryMatch = _data["doesQualifiedAncillaryInternationalShippingIncomeCategoryMatch"];
            this.qualifiedAncillaryInternationalShippingIncomeRevenue = _data["qualifiedAncillaryInternationalShippingIncomeRevenue"];
            this.qualifiedAncillaryInternationalShippingIncomeCost = _data["qualifiedAncillaryInternationalShippingIncomeCost"];
            this.internationalShippingIncome = _data["internationalShippingIncome"];
            this.qualifiedAncillaryInternationalShippingIncome = _data["qualifiedAncillaryInternationalShippingIncome"];
            this.totalShippingIncomeForAllCes = _data["totalShippingIncomeForAllCes"];
            this.fiftyPercentageCap = _data["fiftyPercentageCap"];
            this.totalQualifiedAncillaryShippingIncomeForAllCes = _data["totalQualifiedAncillaryShippingIncomeForAllCes"];
            this.nonExcludedQualifiedAncillaryShippingIncomeForAllCes = _data["nonExcludedQualifiedAncillaryShippingIncomeForAllCes"];
            this.excludedQualifiedAncillaryShippingIncomeForThisCe = _data["excludedQualifiedAncillaryShippingIncomeForThisCe"];
        }
    }

    static fromJS(data: any): InternationalShippingIncomeDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new InternationalShippingIncomeDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.internationalShippingIncomeCategory)) {
            data["internationalShippingIncomeCategory"] = [];
            for (let item of this.internationalShippingIncomeCategory)
                data["internationalShippingIncomeCategory"].push(item);
        }
        data["internationalShippingIncomeRevenue"] = this.internationalShippingIncomeRevenue;
        data["internationalShippingIncomeCost"] = this.internationalShippingIncomeCost;
        if (Array.isArray(this.qualifiedAncillaryInternationalShippingIncomeCategory)) {
            data["qualifiedAncillaryInternationalShippingIncomeCategory"] = [];
            for (let item of this.qualifiedAncillaryInternationalShippingIncomeCategory)
                data["qualifiedAncillaryInternationalShippingIncomeCategory"].push(item);
        }
        data["doesQualifiedAncillaryInternationalShippingIncomeCategoryMatch"] = this.doesQualifiedAncillaryInternationalShippingIncomeCategoryMatch;
        data["qualifiedAncillaryInternationalShippingIncomeRevenue"] = this.qualifiedAncillaryInternationalShippingIncomeRevenue;
        data["qualifiedAncillaryInternationalShippingIncomeCost"] = this.qualifiedAncillaryInternationalShippingIncomeCost;
        data["internationalShippingIncome"] = this.internationalShippingIncome;
        data["qualifiedAncillaryInternationalShippingIncome"] = this.qualifiedAncillaryInternationalShippingIncome;
        data["totalShippingIncomeForAllCes"] = this.totalShippingIncomeForAllCes;
        data["fiftyPercentageCap"] = this.fiftyPercentageCap;
        data["totalQualifiedAncillaryShippingIncomeForAllCes"] = this.totalQualifiedAncillaryShippingIncomeForAllCes;
        data["nonExcludedQualifiedAncillaryShippingIncomeForAllCes"] = this.nonExcludedQualifiedAncillaryShippingIncomeForAllCes;
        data["excludedQualifiedAncillaryShippingIncomeForThisCe"] = this.excludedQualifiedAncillaryShippingIncomeForThisCe;
        return data;
    }
}

export interface IInternationalShippingIncomeDetailsDto {
    internationalShippingIncomeCategory: InternationalShippingIncomeCategory[] | undefined;
    internationalShippingIncomeRevenue: string | undefined;
    internationalShippingIncomeCost: string | undefined;
    qualifiedAncillaryInternationalShippingIncomeCategory: InternationalShippingIncomeCategory[] | undefined;
    doesQualifiedAncillaryInternationalShippingIncomeCategoryMatch: boolean;
    qualifiedAncillaryInternationalShippingIncomeRevenue: string | undefined;
    qualifiedAncillaryInternationalShippingIncomeCost: string | undefined;
    internationalShippingIncome: string | undefined;
    qualifiedAncillaryInternationalShippingIncome: string | undefined;
    totalShippingIncomeForAllCes: string | undefined;
    fiftyPercentageCap: string | undefined;
    totalQualifiedAncillaryShippingIncomeForAllCes: string | undefined;
    nonExcludedQualifiedAncillaryShippingIncomeForAllCes: string | undefined;
    excludedQualifiedAncillaryShippingIncomeForThisCe: string | undefined;
}

export enum InvestmentElectionType {
    SevenPointFive = 75,
    SevenPointSix = 76,
}

export class JurisdictionOverviewDto implements IJurisdictionOverviewDto {
    id!: number;
    jurisdictionCountry!: string | undefined;
    iirImplemented!: boolean | undefined;
    iirApplicableFrom!: DateTime | undefined;
    iirIncludesOwnLowTaxedIncome!: boolean | undefined;
    iirStatus!: JurisdictionRuleStatusType;
    isUTPRSafeHarbor!: boolean | undefined;
    utprSafeHarborRate!: number | undefined;
    utprImplemented!: boolean | undefined;
    utprApplicableFrom!: DateTime | undefined;
    utprStatus!: JurisdictionRuleStatusType;
    qdmttImplemented!: boolean | undefined;
    qdmttApplicableFrom!: DateTime | undefined;
    qdmttStatus!: JurisdictionRuleStatusType;
    qdmttSafeHarbourImplemented!: boolean | undefined;
    localCurrencyDeviatesFromPresentationCurrencyImplemented!: boolean | undefined;
    areFlowThroughStatelessEntitiesSubjectToQDMTT!: boolean | undefined;
    isQDMTTFasDeviatesFromUPEForFASPurposes!: boolean | undefined;
    fas!: string | undefined;
    isSBIEAvailableForQDMTT!: boolean | undefined;
    isDeminimisExclusionAvailableForQDMTT!: boolean | undefined;
    doesCurrencyElectionApply!: boolean | undefined;
    currencyElectionYear!: DateTime | undefined;
    revocationYear!: DateTime | undefined;
    electionCurrency!: ElectionCurrency | undefined;
    arePermanentEntitiesSubjectToQdmtt!: boolean | undefined;
    localCurrency!: string | undefined;
    canBeDeleted!: boolean;
    hasWritePermission!: boolean;
    containsUpeEntity!: boolean;

    constructor(data?: IJurisdictionOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.jurisdictionCountry = _data["jurisdictionCountry"];
            this.iirImplemented = _data["iirImplemented"];
            this.iirApplicableFrom = _data["iirApplicableFrom"] ? DateTime.fromISO(_data["iirApplicableFrom"].toString()) : <any>undefined;
            this.iirIncludesOwnLowTaxedIncome = _data["iirIncludesOwnLowTaxedIncome"];
            this.iirStatus = _data["iirStatus"];
            this.isUTPRSafeHarbor = _data["isUTPRSafeHarbor"];
            this.utprSafeHarborRate = _data["utprSafeHarborRate"];
            this.utprImplemented = _data["utprImplemented"];
            this.utprApplicableFrom = _data["utprApplicableFrom"] ? DateTime.fromISO(_data["utprApplicableFrom"].toString()) : <any>undefined;
            this.utprStatus = _data["utprStatus"];
            this.qdmttImplemented = _data["qdmttImplemented"];
            this.qdmttApplicableFrom = _data["qdmttApplicableFrom"] ? DateTime.fromISO(_data["qdmttApplicableFrom"].toString()) : <any>undefined;
            this.qdmttStatus = _data["qdmttStatus"];
            this.qdmttSafeHarbourImplemented = _data["qdmttSafeHarbourImplemented"];
            this.localCurrencyDeviatesFromPresentationCurrencyImplemented = _data["localCurrencyDeviatesFromPresentationCurrencyImplemented"];
            this.areFlowThroughStatelessEntitiesSubjectToQDMTT = _data["areFlowThroughStatelessEntitiesSubjectToQDMTT"];
            this.isQDMTTFasDeviatesFromUPEForFASPurposes = _data["isQDMTTFasDeviatesFromUPEForFASPurposes"];
            this.fas = _data["fas"];
            this.isSBIEAvailableForQDMTT = _data["isSBIEAvailableForQDMTT"];
            this.isDeminimisExclusionAvailableForQDMTT = _data["isDeminimisExclusionAvailableForQDMTT"];
            this.doesCurrencyElectionApply = _data["doesCurrencyElectionApply"];
            this.currencyElectionYear = _data["currencyElectionYear"] ? DateTime.fromISO(_data["currencyElectionYear"].toString()) : <any>undefined;
            this.revocationYear = _data["revocationYear"] ? DateTime.fromISO(_data["revocationYear"].toString()) : <any>undefined;
            this.electionCurrency = _data["electionCurrency"];
            this.arePermanentEntitiesSubjectToQdmtt = _data["arePermanentEntitiesSubjectToQdmtt"];
            this.localCurrency = _data["localCurrency"];
            this.canBeDeleted = _data["canBeDeleted"];
            this.hasWritePermission = _data["hasWritePermission"];
            this.containsUpeEntity = _data["containsUpeEntity"];
        }
    }

    static fromJS(data: any): JurisdictionOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new JurisdictionOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["jurisdictionCountry"] = this.jurisdictionCountry;
        data["iirImplemented"] = this.iirImplemented;
        data["iirApplicableFrom"] = this.iirApplicableFrom ? this.iirApplicableFrom.toString() : <any>undefined;
        data["iirIncludesOwnLowTaxedIncome"] = this.iirIncludesOwnLowTaxedIncome;
        data["iirStatus"] = this.iirStatus;
        data["isUTPRSafeHarbor"] = this.isUTPRSafeHarbor;
        data["utprSafeHarborRate"] = this.utprSafeHarborRate;
        data["utprImplemented"] = this.utprImplemented;
        data["utprApplicableFrom"] = this.utprApplicableFrom ? this.utprApplicableFrom.toString() : <any>undefined;
        data["utprStatus"] = this.utprStatus;
        data["qdmttImplemented"] = this.qdmttImplemented;
        data["qdmttApplicableFrom"] = this.qdmttApplicableFrom ? this.qdmttApplicableFrom.toString() : <any>undefined;
        data["qdmttStatus"] = this.qdmttStatus;
        data["qdmttSafeHarbourImplemented"] = this.qdmttSafeHarbourImplemented;
        data["localCurrencyDeviatesFromPresentationCurrencyImplemented"] = this.localCurrencyDeviatesFromPresentationCurrencyImplemented;
        data["areFlowThroughStatelessEntitiesSubjectToQDMTT"] = this.areFlowThroughStatelessEntitiesSubjectToQDMTT;
        data["isQDMTTFasDeviatesFromUPEForFASPurposes"] = this.isQDMTTFasDeviatesFromUPEForFASPurposes;
        data["fas"] = this.fas;
        data["isSBIEAvailableForQDMTT"] = this.isSBIEAvailableForQDMTT;
        data["isDeminimisExclusionAvailableForQDMTT"] = this.isDeminimisExclusionAvailableForQDMTT;
        data["doesCurrencyElectionApply"] = this.doesCurrencyElectionApply;
        data["currencyElectionYear"] = this.currencyElectionYear ? this.currencyElectionYear.toString() : <any>undefined;
        data["revocationYear"] = this.revocationYear ? this.revocationYear.toString() : <any>undefined;
        data["electionCurrency"] = this.electionCurrency;
        data["arePermanentEntitiesSubjectToQdmtt"] = this.arePermanentEntitiesSubjectToQdmtt;
        data["localCurrency"] = this.localCurrency;
        data["canBeDeleted"] = this.canBeDeleted;
        data["hasWritePermission"] = this.hasWritePermission;
        data["containsUpeEntity"] = this.containsUpeEntity;
        return data;
    }
}

export interface IJurisdictionOverviewDto {
    id: number;
    jurisdictionCountry: string | undefined;
    iirImplemented: boolean | undefined;
    iirApplicableFrom: DateTime | undefined;
    iirIncludesOwnLowTaxedIncome: boolean | undefined;
    iirStatus: JurisdictionRuleStatusType;
    isUTPRSafeHarbor: boolean | undefined;
    utprSafeHarborRate: number | undefined;
    utprImplemented: boolean | undefined;
    utprApplicableFrom: DateTime | undefined;
    utprStatus: JurisdictionRuleStatusType;
    qdmttImplemented: boolean | undefined;
    qdmttApplicableFrom: DateTime | undefined;
    qdmttStatus: JurisdictionRuleStatusType;
    qdmttSafeHarbourImplemented: boolean | undefined;
    localCurrencyDeviatesFromPresentationCurrencyImplemented: boolean | undefined;
    areFlowThroughStatelessEntitiesSubjectToQDMTT: boolean | undefined;
    isQDMTTFasDeviatesFromUPEForFASPurposes: boolean | undefined;
    fas: string | undefined;
    isSBIEAvailableForQDMTT: boolean | undefined;
    isDeminimisExclusionAvailableForQDMTT: boolean | undefined;
    doesCurrencyElectionApply: boolean | undefined;
    currencyElectionYear: DateTime | undefined;
    revocationYear: DateTime | undefined;
    electionCurrency: ElectionCurrency | undefined;
    arePermanentEntitiesSubjectToQdmtt: boolean | undefined;
    localCurrency: string | undefined;
    canBeDeleted: boolean;
    hasWritePermission: boolean;
    containsUpeEntity: boolean;
}

export enum JurisdictionRuleStatusType {
    Implemented = 1,
    NotImplemented = 2,
    Unknown = 3,
}

export enum JurisdictionType {
    SafeHarbourGroup = 1,
    FilingObligation = 2,
    Jurisdiction = 3,
}

export class JurisdictionWarningsResult implements IJurisdictionWarningsResult {
    warnings!: string[] | undefined;

    constructor(data?: IJurisdictionWarningsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(item);
            }
        }
    }

    static fromJS(data: any): JurisdictionWarningsResult {
        data = typeof data === 'object' ? data : {};
        let result = new JurisdictionWarningsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item);
        }
        return data;
    }
}

export interface IJurisdictionWarningsResult {
    warnings: string[] | undefined;
}

export class LastProjectNotificationReport implements ILastProjectNotificationReport {
    id!: number;
    referenceId!: number;
    creationTime!: DateTime | undefined;
    status!: NotificationReportStatusType | undefined;

    constructor(data?: ILastProjectNotificationReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.referenceId = _data["referenceId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.status = _data["status"] ? NotificationReportStatusType.fromJS(_data["status"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LastProjectNotificationReport {
        data = typeof data === 'object' ? data : {};
        let result = new LastProjectNotificationReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["referenceId"] = this.referenceId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILastProjectNotificationReport {
    id: number;
    referenceId: number;
    creationTime: DateTime | undefined;
    status: NotificationReportStatusType | undefined;
}

export class ListResultDtoOfBlendingCirlceSubroupReferenceDataDto implements IListResultDtoOfBlendingCirlceSubroupReferenceDataDto {
    items!: BlendingCirlceSubroupReferenceDataDto[] | undefined;

    constructor(data?: IListResultDtoOfBlendingCirlceSubroupReferenceDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BlendingCirlceSubroupReferenceDataDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfBlendingCirlceSubroupReferenceDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfBlendingCirlceSubroupReferenceDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfBlendingCirlceSubroupReferenceDataDto {
    items: BlendingCirlceSubroupReferenceDataDto[] | undefined;
}

export class ListResultDtoOfFinancialDataOrganizationalEntityOverviewDto implements IListResultDtoOfFinancialDataOrganizationalEntityOverviewDto {
    items!: FinancialDataOrganizationalEntityOverviewDto[] | undefined;

    constructor(data?: IListResultDtoOfFinancialDataOrganizationalEntityOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FinancialDataOrganizationalEntityOverviewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfFinancialDataOrganizationalEntityOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfFinancialDataOrganizationalEntityOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfFinancialDataOrganizationalEntityOverviewDto {
    items: FinancialDataOrganizationalEntityOverviewDto[] | undefined;
}

export class ListResultDtoOfFinancialGroupDataOrganizationalEntityOverviewDto implements IListResultDtoOfFinancialGroupDataOrganizationalEntityOverviewDto {
    items!: FinancialGroupDataOrganizationalEntityOverviewDto[] | undefined;

    constructor(data?: IListResultDtoOfFinancialGroupDataOrganizationalEntityOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FinancialGroupDataOrganizationalEntityOverviewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfFinancialGroupDataOrganizationalEntityOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfFinancialGroupDataOrganizationalEntityOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfFinancialGroupDataOrganizationalEntityOverviewDto {
    items: FinancialGroupDataOrganizationalEntityOverviewDto[] | undefined;
}

export class ListResultDtoOfOrganizationalEntityReferenceDto implements IListResultDtoOfOrganizationalEntityReferenceDto {
    items!: OrganizationalEntityReferenceDto[] | undefined;

    constructor(data?: IListResultDtoOfOrganizationalEntityReferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationalEntityReferenceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfOrganizationalEntityReferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfOrganizationalEntityReferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfOrganizationalEntityReferenceDto {
    items: OrganizationalEntityReferenceDto[] | undefined;
}

export class ListResultDtoOfSafeHarbourGroupReferenceDataDto implements IListResultDtoOfSafeHarbourGroupReferenceDataDto {
    items!: SafeHarbourGroupReferenceDataDto[] | undefined;

    constructor(data?: IListResultDtoOfSafeHarbourGroupReferenceDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SafeHarbourGroupReferenceDataDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfSafeHarbourGroupReferenceDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfSafeHarbourGroupReferenceDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfSafeHarbourGroupReferenceDataDto {
    items: SafeHarbourGroupReferenceDataDto[] | undefined;
}

export class ListResultDtoOfUserOrOrganizationUnitDto implements IListResultDtoOfUserOrOrganizationUnitDto {
    items!: UserOrOrganizationUnitDto[] | undefined;

    constructor(data?: IListResultDtoOfUserOrOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserOrOrganizationUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfUserOrOrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfUserOrOrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfUserOrOrganizationUnitDto {
    items: UserOrOrganizationUnitDto[] | undefined;
}

export class ManageTagsDetailsDto implements IManageTagsDetailsDto {
    uniformTags!: TagDto[] | undefined;
    nonUniformTags!: string[] | undefined;
    availableTags!: string[] | undefined;

    constructor(data?: IManageTagsDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["uniformTags"])) {
                this.uniformTags = [] as any;
                for (let item of _data["uniformTags"])
                    this.uniformTags!.push(TagDto.fromJS(item));
            }
            if (Array.isArray(_data["nonUniformTags"])) {
                this.nonUniformTags = [] as any;
                for (let item of _data["nonUniformTags"])
                    this.nonUniformTags!.push(item);
            }
            if (Array.isArray(_data["availableTags"])) {
                this.availableTags = [] as any;
                for (let item of _data["availableTags"])
                    this.availableTags!.push(item);
            }
        }
    }

    static fromJS(data: any): ManageTagsDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManageTagsDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.uniformTags)) {
            data["uniformTags"] = [];
            for (let item of this.uniformTags)
                data["uniformTags"].push(item.toJSON());
        }
        if (Array.isArray(this.nonUniformTags)) {
            data["nonUniformTags"] = [];
            for (let item of this.nonUniformTags)
                data["nonUniformTags"].push(item);
        }
        if (Array.isArray(this.availableTags)) {
            data["availableTags"] = [];
            for (let item of this.availableTags)
                data["availableTags"].push(item);
        }
        return data;
    }
}

export interface IManageTagsDetailsDto {
    uniformTags: TagDto[] | undefined;
    nonUniformTags: string[] | undefined;
    availableTags: string[] | undefined;
}

export class ManageTagsInput implements IManageTagsInput {
    ids!: number[] | undefined;
    tags!: TagDto[] | undefined;

    constructor(data?: IManageTagsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ManageTagsInput {
        data = typeof data === 'object' ? data : {};
        let result = new ManageTagsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data;
    }
}

export interface IManageTagsInput {
    ids: number[] | undefined;
    tags: TagDto[] | undefined;
}

export class MazarsColumnDefinitionDto implements IMazarsColumnDefinitionDto {
    field!: string | undefined;
    isDefault!: boolean;
    visible!: boolean;
    localizationKey!: string | undefined;
    localizationSource!: string | undefined;
    localizedField!: string | undefined;
    width!: number;
    canBeChanged!: boolean;
    order!: number;
    sortableName!: string | undefined;

    constructor(data?: IMazarsColumnDefinitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.isDefault = _data["isDefault"];
            this.visible = _data["visible"];
            this.localizationKey = _data["localizationKey"];
            this.localizationSource = _data["localizationSource"];
            this.localizedField = _data["localizedField"];
            this.width = _data["width"];
            this.canBeChanged = _data["canBeChanged"];
            this.order = _data["order"];
            this.sortableName = _data["sortableName"];
        }
    }

    static fromJS(data: any): MazarsColumnDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MazarsColumnDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["isDefault"] = this.isDefault;
        data["visible"] = this.visible;
        data["localizationKey"] = this.localizationKey;
        data["localizationSource"] = this.localizationSource;
        data["localizedField"] = this.localizedField;
        data["width"] = this.width;
        data["canBeChanged"] = this.canBeChanged;
        data["order"] = this.order;
        data["sortableName"] = this.sortableName;
        return data;
    }
}

export interface IMazarsColumnDefinitionDto {
    field: string | undefined;
    isDefault: boolean;
    visible: boolean;
    localizationKey: string | undefined;
    localizationSource: string | undefined;
    localizedField: string | undefined;
    width: number;
    canBeChanged: boolean;
    order: number;
    sortableName: string | undefined;
}

export class MazarsColumnDefinitionInput implements IMazarsColumnDefinitionInput {
    field!: string | undefined;
    isDefault!: boolean;
    visible!: boolean;
    localizationKey!: string | undefined;
    localizationSource!: string | undefined;
    width!: number;
    canBeChanged!: boolean;

    constructor(data?: IMazarsColumnDefinitionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.isDefault = _data["isDefault"];
            this.visible = _data["visible"];
            this.localizationKey = _data["localizationKey"];
            this.localizationSource = _data["localizationSource"];
            this.width = _data["width"];
            this.canBeChanged = _data["canBeChanged"];
        }
    }

    static fromJS(data: any): MazarsColumnDefinitionInput {
        data = typeof data === 'object' ? data : {};
        let result = new MazarsColumnDefinitionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["isDefault"] = this.isDefault;
        data["visible"] = this.visible;
        data["localizationKey"] = this.localizationKey;
        data["localizationSource"] = this.localizationSource;
        data["width"] = this.width;
        data["canBeChanged"] = this.canBeChanged;
        return data;
    }
}

export interface IMazarsColumnDefinitionInput {
    field: string | undefined;
    isDefault: boolean;
    visible: boolean;
    localizationKey: string | undefined;
    localizationSource: string | undefined;
    width: number;
    canBeChanged: boolean;
}

export class MazarsColumnDefinitionSettings implements IMazarsColumnDefinitionSettings {
    haveGeneralInfo!: boolean;
    haveName!: boolean;
    isTaggable!: boolean;
    haveFullProjectManagementInfo!: boolean;
    haveAssignedUser!: boolean;
    havePlanDates!: boolean;
    haveProjectInfo!: boolean;
    haveCreatedInfo!: boolean;
    haveUpdateInfo!: boolean;
    haveMultiselect!: boolean;

    constructor(data?: IMazarsColumnDefinitionSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.haveGeneralInfo = _data["haveGeneralInfo"];
            this.haveName = _data["haveName"];
            this.isTaggable = _data["isTaggable"];
            this.haveFullProjectManagementInfo = _data["haveFullProjectManagementInfo"];
            this.haveAssignedUser = _data["haveAssignedUser"];
            this.havePlanDates = _data["havePlanDates"];
            this.haveProjectInfo = _data["haveProjectInfo"];
            this.haveCreatedInfo = _data["haveCreatedInfo"];
            this.haveUpdateInfo = _data["haveUpdateInfo"];
            this.haveMultiselect = _data["haveMultiselect"];
        }
    }

    static fromJS(data: any): MazarsColumnDefinitionSettings {
        data = typeof data === 'object' ? data : {};
        let result = new MazarsColumnDefinitionSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["haveGeneralInfo"] = this.haveGeneralInfo;
        data["haveName"] = this.haveName;
        data["isTaggable"] = this.isTaggable;
        data["haveFullProjectManagementInfo"] = this.haveFullProjectManagementInfo;
        data["haveAssignedUser"] = this.haveAssignedUser;
        data["havePlanDates"] = this.havePlanDates;
        data["haveProjectInfo"] = this.haveProjectInfo;
        data["haveCreatedInfo"] = this.haveCreatedInfo;
        data["haveUpdateInfo"] = this.haveUpdateInfo;
        data["haveMultiselect"] = this.haveMultiselect;
        return data;
    }
}

export interface IMazarsColumnDefinitionSettings {
    haveGeneralInfo: boolean;
    haveName: boolean;
    isTaggable: boolean;
    haveFullProjectManagementInfo: boolean;
    haveAssignedUser: boolean;
    havePlanDates: boolean;
    haveProjectInfo: boolean;
    haveCreatedInfo: boolean;
    haveUpdateInfo: boolean;
    haveMultiselect: boolean;
}

export class MazarsGridDefinitionDto implements IMazarsGridDefinitionDto {
    tableId!: string | undefined;
    settings!: MazarsColumnDefinitionSettings | undefined;
    configuration!: MazarsColumnDefinitionDto[] | undefined;

    constructor(data?: IMazarsGridDefinitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tableId = _data["tableId"];
            this.settings = _data["settings"] ? MazarsColumnDefinitionSettings.fromJS(_data["settings"]) : <any>undefined;
            if (Array.isArray(_data["configuration"])) {
                this.configuration = [] as any;
                for (let item of _data["configuration"])
                    this.configuration!.push(MazarsColumnDefinitionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MazarsGridDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MazarsGridDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableId"] = this.tableId;
        data["settings"] = this.settings ? this.settings.toJSON() : <any>undefined;
        if (Array.isArray(this.configuration)) {
            data["configuration"] = [];
            for (let item of this.configuration)
                data["configuration"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMazarsGridDefinitionDto {
    tableId: string | undefined;
    settings: MazarsColumnDefinitionSettings | undefined;
    configuration: MazarsColumnDefinitionDto[] | undefined;
}

export class MazarsGridDefinitionInput implements IMazarsGridDefinitionInput {
    tableId!: string | undefined;
    configuration!: MazarsColumnDefinitionInput[] | undefined;

    constructor(data?: IMazarsGridDefinitionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tableId = _data["tableId"];
            if (Array.isArray(_data["configuration"])) {
                this.configuration = [] as any;
                for (let item of _data["configuration"])
                    this.configuration!.push(MazarsColumnDefinitionInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MazarsGridDefinitionInput {
        data = typeof data === 'object' ? data : {};
        let result = new MazarsGridDefinitionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableId"] = this.tableId;
        if (Array.isArray(this.configuration)) {
            data["configuration"] = [];
            for (let item of this.configuration)
                data["configuration"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMazarsGridDefinitionInput {
    tableId: string | undefined;
    configuration: MazarsColumnDefinitionInput[] | undefined;
}

export class MazarsPagedResultDtoOfSubmissionOverviewDto implements IMazarsPagedResultDtoOfSubmissionOverviewDto {
    items!: SubmissionOverviewDto[] | undefined;
    totalCount!: number;
    currentPage!: number | undefined;

    constructor(data?: IMazarsPagedResultDtoOfSubmissionOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SubmissionOverviewDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.currentPage = _data["currentPage"];
        }
    }

    static fromJS(data: any): MazarsPagedResultDtoOfSubmissionOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new MazarsPagedResultDtoOfSubmissionOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["currentPage"] = this.currentPage;
        return data;
    }
}

export interface IMazarsPagedResultDtoOfSubmissionOverviewDto {
    items: SubmissionOverviewDto[] | undefined;
    totalCount: number;
    currentPage: number | undefined;
}

export class NaturalPersonShareholderDto implements INaturalPersonShareholderDto {
    id!: number;
    organizationalEntityId!: number;
    jurisdiction!: ConfirmableDtoOfString | undefined;
    taxRate!: ConfirmableDtoOfNullableOfDecimal | undefined;
    eligibilityReductionType!: ConfirmableDtoOfNullableOfEligibilityReductionType | undefined;
    numberOfShareholders!: ConfirmableDtoOfNullableOfInt32 | undefined;
    totalOwnershipPercentage!: ConfirmableDtoOfString | undefined;

    constructor(data?: INaturalPersonShareholderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.jurisdiction = _data["jurisdiction"] ? ConfirmableDtoOfString.fromJS(_data["jurisdiction"]) : <any>undefined;
            this.taxRate = _data["taxRate"] ? ConfirmableDtoOfNullableOfDecimal.fromJS(_data["taxRate"]) : <any>undefined;
            this.eligibilityReductionType = _data["eligibilityReductionType"] ? ConfirmableDtoOfNullableOfEligibilityReductionType.fromJS(_data["eligibilityReductionType"]) : <any>undefined;
            this.numberOfShareholders = _data["numberOfShareholders"] ? ConfirmableDtoOfNullableOfInt32.fromJS(_data["numberOfShareholders"]) : <any>undefined;
            this.totalOwnershipPercentage = _data["totalOwnershipPercentage"] ? ConfirmableDtoOfString.fromJS(_data["totalOwnershipPercentage"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NaturalPersonShareholderDto {
        data = typeof data === 'object' ? data : {};
        let result = new NaturalPersonShareholderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["jurisdiction"] = this.jurisdiction ? this.jurisdiction.toJSON() : <any>undefined;
        data["taxRate"] = this.taxRate ? this.taxRate.toJSON() : <any>undefined;
        data["eligibilityReductionType"] = this.eligibilityReductionType ? this.eligibilityReductionType.toJSON() : <any>undefined;
        data["numberOfShareholders"] = this.numberOfShareholders ? this.numberOfShareholders.toJSON() : <any>undefined;
        data["totalOwnershipPercentage"] = this.totalOwnershipPercentage ? this.totalOwnershipPercentage.toJSON() : <any>undefined;
        return data;
    }
}

export interface INaturalPersonShareholderDto {
    id: number;
    organizationalEntityId: number;
    jurisdiction: ConfirmableDtoOfString | undefined;
    taxRate: ConfirmableDtoOfNullableOfDecimal | undefined;
    eligibilityReductionType: ConfirmableDtoOfNullableOfEligibilityReductionType | undefined;
    numberOfShareholders: ConfirmableDtoOfNullableOfInt32 | undefined;
    totalOwnershipPercentage: ConfirmableDtoOfString | undefined;
}

export enum NotificationArea {
    EntityInformation = 1,
    Ownership = 2,
    SBIE = 3,
    ETRAndTuT = 4,
    Currencies = 5,
    SafeHarbourTests = 6,
    FullScopeCalculation = 7,
    Globe = 8,
}

export enum NotificationDataPointType {
    OrganizationalEntity = 1,
    BlendingCircleSubgroup = 2,
    ConversionRate = 3,
    SafeHarbourGroup = 4,
    OwnershipChange = 5,
    BlendingCircle = 6,
}

export enum NotificationQuickLink {
    ScopingEntityInformation = 1,
    FullScopeCalculationEntitySubstanceBasedIncomeExclusion = 2,
    FullScopeCalculationBlendingCircleSubgroup = 3,
    Currencies = 4,
    SafeHarbourTests = 5,
}

export class NotificationReportStatusType implements INotificationReportStatusType {
    readonly name!: string | undefined;
    readonly value!: string | undefined;
    readonly orderIndex!: number;

    constructor(data?: INotificationReportStatusType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            (<any>this).value = _data["value"];
            (<any>this).orderIndex = _data["orderIndex"];
        }
    }

    static fromJS(data: any): NotificationReportStatusType {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationReportStatusType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        data["orderIndex"] = this.orderIndex;
        return data;
    }
}

export interface INotificationReportStatusType {
    name: string | undefined;
    value: string | undefined;
    orderIndex: number;
}

export enum NotificationType {
    Info = 1,
    Warning = 2,
    Error = 3,
}

export class ObligationAssignedUserInput implements IObligationAssignedUserInput {
    assignedUserId!: number | undefined;
    projectId!: number;
    obligationId!: number;
    organizationalEntityId!: number | undefined;
    obligationCountry!: string | undefined;
    obligationReturnType!: ObligationReturnType;

    constructor(data?: IObligationAssignedUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignedUserId = _data["assignedUserId"];
            this.projectId = _data["projectId"];
            this.obligationId = _data["obligationId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.obligationCountry = _data["obligationCountry"];
            this.obligationReturnType = _data["obligationReturnType"];
        }
    }

    static fromJS(data: any): ObligationAssignedUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new ObligationAssignedUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignedUserId"] = this.assignedUserId;
        data["projectId"] = this.projectId;
        data["obligationId"] = this.obligationId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["obligationCountry"] = this.obligationCountry;
        data["obligationReturnType"] = this.obligationReturnType;
        return data;
    }
}

export interface IObligationAssignedUserInput {
    assignedUserId: number | undefined;
    projectId: number;
    obligationId: number;
    organizationalEntityId: number | undefined;
    obligationCountry: string | undefined;
    obligationReturnType: ObligationReturnType;
}

export class ObligationAttachmentLinkDto implements IObligationAttachmentLinkDto {
    id!: number;
    attachment!: AttachmentDto | undefined;
    obligationReference!: string | undefined;
    hasPreview!: boolean;

    constructor(data?: IObligationAttachmentLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.attachment = _data["attachment"] ? AttachmentDto.fromJS(_data["attachment"]) : <any>undefined;
            this.obligationReference = _data["obligationReference"];
            this.hasPreview = _data["hasPreview"];
        }
    }

    static fromJS(data: any): ObligationAttachmentLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new ObligationAttachmentLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["attachment"] = this.attachment ? this.attachment.toJSON() : <any>undefined;
        data["obligationReference"] = this.obligationReference;
        data["hasPreview"] = this.hasPreview;
        return data;
    }
}

export interface IObligationAttachmentLinkDto {
    id: number;
    attachment: AttachmentDto | undefined;
    obligationReference: string | undefined;
    hasPreview: boolean;
}

export class ObligationOverviewDto implements IObligationOverviewDto {
    id!: number;
    jurisdiction!: string | undefined;
    obligationReturnType!: ObligationReturnType;
    obligationStatus!: ObligationStatus;
    dueDate!: DateTime | undefined;
    dueDateStatus!: DueDateStatus | undefined;
    assignedUser!: AssignableUserDto | undefined;
    organizationalEntityId!: number | undefined;
    legalNameEntityNumber!: string | undefined;
    note!: string | undefined;
    submissionName!: string | undefined;
    submissionId!: number | undefined;
    process!: ProcessDto | undefined;
    canBeDeleted!: boolean;
    hasEntitiesInTheProject!: boolean;
    numberOfAttachments!: number;
    hasWritePermission!: boolean;
    ignoreDueDateStatusForReminder!: boolean;
    submissions!: SubmissionShorthandDto[] | undefined;

    constructor(data?: IObligationOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.jurisdiction = _data["jurisdiction"];
            this.obligationReturnType = _data["obligationReturnType"];
            this.obligationStatus = _data["obligationStatus"];
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
            this.dueDateStatus = _data["dueDateStatus"];
            this.assignedUser = _data["assignedUser"] ? AssignableUserDto.fromJS(_data["assignedUser"]) : <any>undefined;
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.legalNameEntityNumber = _data["legalNameEntityNumber"];
            this.note = _data["note"];
            this.submissionName = _data["submissionName"];
            this.submissionId = _data["submissionId"];
            this.process = _data["process"] ? ProcessDto.fromJS(_data["process"]) : <any>undefined;
            this.canBeDeleted = _data["canBeDeleted"];
            this.hasEntitiesInTheProject = _data["hasEntitiesInTheProject"];
            this.numberOfAttachments = _data["numberOfAttachments"];
            this.hasWritePermission = _data["hasWritePermission"];
            this.ignoreDueDateStatusForReminder = _data["ignoreDueDateStatusForReminder"];
            if (Array.isArray(_data["submissions"])) {
                this.submissions = [] as any;
                for (let item of _data["submissions"])
                    this.submissions!.push(SubmissionShorthandDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ObligationOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ObligationOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["jurisdiction"] = this.jurisdiction;
        data["obligationReturnType"] = this.obligationReturnType;
        data["obligationStatus"] = this.obligationStatus;
        data["dueDate"] = this.dueDate ? this.dueDate.toString() : <any>undefined;
        data["dueDateStatus"] = this.dueDateStatus;
        data["assignedUser"] = this.assignedUser ? this.assignedUser.toJSON() : <any>undefined;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["legalNameEntityNumber"] = this.legalNameEntityNumber;
        data["note"] = this.note;
        data["submissionName"] = this.submissionName;
        data["submissionId"] = this.submissionId;
        data["process"] = this.process ? this.process.toJSON() : <any>undefined;
        data["canBeDeleted"] = this.canBeDeleted;
        data["hasEntitiesInTheProject"] = this.hasEntitiesInTheProject;
        data["numberOfAttachments"] = this.numberOfAttachments;
        data["hasWritePermission"] = this.hasWritePermission;
        data["ignoreDueDateStatusForReminder"] = this.ignoreDueDateStatusForReminder;
        if (Array.isArray(this.submissions)) {
            data["submissions"] = [];
            for (let item of this.submissions)
                data["submissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IObligationOverviewDto {
    id: number;
    jurisdiction: string | undefined;
    obligationReturnType: ObligationReturnType;
    obligationStatus: ObligationStatus;
    dueDate: DateTime | undefined;
    dueDateStatus: DueDateStatus | undefined;
    assignedUser: AssignableUserDto | undefined;
    organizationalEntityId: number | undefined;
    legalNameEntityNumber: string | undefined;
    note: string | undefined;
    submissionName: string | undefined;
    submissionId: number | undefined;
    process: ProcessDto | undefined;
    canBeDeleted: boolean;
    hasEntitiesInTheProject: boolean;
    numberOfAttachments: number;
    hasWritePermission: boolean;
    ignoreDueDateStatusForReminder: boolean;
    submissions: SubmissionShorthandDto[] | undefined;
}

export enum ObligationReturnType {
    RegistrationObligation = 0,
    GloBEInformationReturn = 1,
    GIRNotification = 2,
    MinimumTaxReturn = 3,
}

export class ObligationSetDueDateInput implements IObligationSetDueDateInput {
    referenceId!: number;
    rootEntityId!: number;
    dueDate!: DateTime | undefined;
    organizationalEntityId!: number | undefined;
    obligationCountry!: string | undefined;
    obligationReturnType!: ObligationReturnType;

    constructor(data?: IObligationSetDueDateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referenceId = _data["referenceId"];
            this.rootEntityId = _data["rootEntityId"];
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.obligationCountry = _data["obligationCountry"];
            this.obligationReturnType = _data["obligationReturnType"];
        }
    }

    static fromJS(data: any): ObligationSetDueDateInput {
        data = typeof data === 'object' ? data : {};
        let result = new ObligationSetDueDateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceId"] = this.referenceId;
        data["rootEntityId"] = this.rootEntityId;
        data["dueDate"] = this.dueDate ? this.dueDate.toString() : <any>undefined;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["obligationCountry"] = this.obligationCountry;
        data["obligationReturnType"] = this.obligationReturnType;
        return data;
    }
}

export interface IObligationSetDueDateInput {
    referenceId: number;
    rootEntityId: number;
    dueDate: DateTime | undefined;
    organizationalEntityId: number | undefined;
    obligationCountry: string | undefined;
    obligationReturnType: ObligationReturnType;
}

export enum ObligationStatus {
    CheckFilingObligation = 0,
    FilingNotRequired = 1,
    FilingRequired = 2,
    FilingCompleted = 3,
}

export class OrganizationalChartDto implements IOrganizationalChartDto {
    projectId!: number;
    chartTitle!: string | undefined;
    nodes!: OrganizationalNodeDto[] | undefined;
    links!: OrganizationalLinkDto[] | undefined;

    constructor(data?: IOrganizationalChartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.chartTitle = _data["chartTitle"];
            if (Array.isArray(_data["nodes"])) {
                this.nodes = [] as any;
                for (let item of _data["nodes"])
                    this.nodes!.push(OrganizationalNodeDto.fromJS(item));
            }
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(OrganizationalLinkDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrganizationalChartDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationalChartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["chartTitle"] = this.chartTitle;
        if (Array.isArray(this.nodes)) {
            data["nodes"] = [];
            for (let item of this.nodes)
                data["nodes"].push(item.toJSON());
        }
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrganizationalChartDto {
    projectId: number;
    chartTitle: string | undefined;
    nodes: OrganizationalNodeDto[] | undefined;
    links: OrganizationalLinkDto[] | undefined;
}

export enum OrganizationalChartNodeType {
    Default = 0,
    FTE = 1,
    PE = 2,
    HE = 3,
    RHE = 4,
    TP = 5,
}

export class OrganizationalEntityDto implements IOrganizationalEntityDto {
    id!: number;
    entityNumber!: ConfirmableDtoOfString | undefined;
    legalName!: ConfirmableDtoOfString | undefined;
    gloBEStatus!: ConfirmableDtoOfIListOfGloBEStatus | undefined;
    tin!: ConfirmableDtoOfString | undefined;
    tinIssuedBy!: ConfirmableDtoOfString | undefined;
    typeOfTIN!: ConfirmableDtoOfNullableOfTinType | undefined;
    taxJurisdictionCountry!: ConfirmableDtoOfString | undefined;
    taxTreatment!: ConfirmableDtoOfNullableOfTaxTreatment | undefined;
    isUpeAsFlowThrough!: ConfirmableDtoOfNullableOfBoolean | undefined;
    isUpeSubjectToDeductiveDividendRegime!: ConfirmableDtoOfNullableOfBoolean | undefined;
    typeOfExcluded!: ConfirmableDtoOfNullableOfOrganizationalEntityExcludedType | undefined;
    notTreatingEntityAsExcludedEntity!: ConfirmableDtoOfNullableOfBoolean | undefined;
    electionYear!: DateTime | undefined;
    revocationYear!: DateTime | undefined;
    isPermanentEstablishment!: ConfirmableDtoOfNullableOfBoolean | undefined;
    mainEntityId!: ConfirmableDtoOfNullableOfInt64 | undefined;
    taxFunctionalCurrency!: ConfirmableDtoOfString | undefined;
    accountingFunctionalCurrency!: ConfirmableDtoOfString | undefined;
    consolidationMethod!: ConfirmableDtoOfNullableOfConsolidationMethod | undefined;
    financialAccountingStandardOfCe!: ConfirmableDtoOfString | undefined;
    blendingCircleCountry!: ConfirmableDtoOfString | undefined;
    blendingCircleSubgroupDisplayName!: ConfirmableDtoOfString | undefined;
    safeHarbourGroupCountry!: string | undefined;
    safeHarbourGroupType!: string | undefined;
    number!: number | undefined;
    controllingInterestEntityId!: number | undefined;
    shareholders!: ShareholdersDto | undefined;
    hasWritePermission!: boolean;
    hasAllRequiredFields!: boolean;
    hasGroupShareErrors!: boolean;
    ownershipChanges!: OwnershipChangeDto[] | undefined;
    corporateShareholders!: CorporateShareholderDto[] | undefined;
    naturalPersonShareholders!: NaturalPersonShareholderDto[] | undefined;
    blendingCircle!: BlendingCircleDto | undefined;
    groupShare!: OrganizationalEntityGroupShareDto | undefined;

    constructor(data?: IOrganizationalEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entityNumber = _data["entityNumber"] ? ConfirmableDtoOfString.fromJS(_data["entityNumber"]) : <any>undefined;
            this.legalName = _data["legalName"] ? ConfirmableDtoOfString.fromJS(_data["legalName"]) : <any>undefined;
            this.gloBEStatus = _data["gloBEStatus"] ? ConfirmableDtoOfIListOfGloBEStatus.fromJS(_data["gloBEStatus"]) : <any>undefined;
            this.tin = _data["tin"] ? ConfirmableDtoOfString.fromJS(_data["tin"]) : <any>undefined;
            this.tinIssuedBy = _data["tinIssuedBy"] ? ConfirmableDtoOfString.fromJS(_data["tinIssuedBy"]) : <any>undefined;
            this.typeOfTIN = _data["typeOfTIN"] ? ConfirmableDtoOfNullableOfTinType.fromJS(_data["typeOfTIN"]) : <any>undefined;
            this.taxJurisdictionCountry = _data["taxJurisdictionCountry"] ? ConfirmableDtoOfString.fromJS(_data["taxJurisdictionCountry"]) : <any>undefined;
            this.taxTreatment = _data["taxTreatment"] ? ConfirmableDtoOfNullableOfTaxTreatment.fromJS(_data["taxTreatment"]) : <any>undefined;
            this.isUpeAsFlowThrough = _data["isUpeAsFlowThrough"] ? ConfirmableDtoOfNullableOfBoolean.fromJS(_data["isUpeAsFlowThrough"]) : <any>undefined;
            this.isUpeSubjectToDeductiveDividendRegime = _data["isUpeSubjectToDeductiveDividendRegime"] ? ConfirmableDtoOfNullableOfBoolean.fromJS(_data["isUpeSubjectToDeductiveDividendRegime"]) : <any>undefined;
            this.typeOfExcluded = _data["typeOfExcluded"] ? ConfirmableDtoOfNullableOfOrganizationalEntityExcludedType.fromJS(_data["typeOfExcluded"]) : <any>undefined;
            this.notTreatingEntityAsExcludedEntity = _data["notTreatingEntityAsExcludedEntity"] ? ConfirmableDtoOfNullableOfBoolean.fromJS(_data["notTreatingEntityAsExcludedEntity"]) : <any>undefined;
            this.electionYear = _data["electionYear"] ? DateTime.fromISO(_data["electionYear"].toString()) : <any>undefined;
            this.revocationYear = _data["revocationYear"] ? DateTime.fromISO(_data["revocationYear"].toString()) : <any>undefined;
            this.isPermanentEstablishment = _data["isPermanentEstablishment"] ? ConfirmableDtoOfNullableOfBoolean.fromJS(_data["isPermanentEstablishment"]) : <any>undefined;
            this.mainEntityId = _data["mainEntityId"] ? ConfirmableDtoOfNullableOfInt64.fromJS(_data["mainEntityId"]) : <any>undefined;
            this.taxFunctionalCurrency = _data["taxFunctionalCurrency"] ? ConfirmableDtoOfString.fromJS(_data["taxFunctionalCurrency"]) : <any>undefined;
            this.accountingFunctionalCurrency = _data["accountingFunctionalCurrency"] ? ConfirmableDtoOfString.fromJS(_data["accountingFunctionalCurrency"]) : <any>undefined;
            this.consolidationMethod = _data["consolidationMethod"] ? ConfirmableDtoOfNullableOfConsolidationMethod.fromJS(_data["consolidationMethod"]) : <any>undefined;
            this.financialAccountingStandardOfCe = _data["financialAccountingStandardOfCe"] ? ConfirmableDtoOfString.fromJS(_data["financialAccountingStandardOfCe"]) : <any>undefined;
            this.blendingCircleCountry = _data["blendingCircleCountry"] ? ConfirmableDtoOfString.fromJS(_data["blendingCircleCountry"]) : <any>undefined;
            this.blendingCircleSubgroupDisplayName = _data["blendingCircleSubgroupDisplayName"] ? ConfirmableDtoOfString.fromJS(_data["blendingCircleSubgroupDisplayName"]) : <any>undefined;
            this.safeHarbourGroupCountry = _data["safeHarbourGroupCountry"];
            this.safeHarbourGroupType = _data["safeHarbourGroupType"];
            this.number = _data["number"];
            this.controllingInterestEntityId = _data["controllingInterestEntityId"];
            this.shareholders = _data["shareholders"] ? ShareholdersDto.fromJS(_data["shareholders"]) : <any>undefined;
            this.hasWritePermission = _data["hasWritePermission"];
            this.hasAllRequiredFields = _data["hasAllRequiredFields"];
            this.hasGroupShareErrors = _data["hasGroupShareErrors"];
            if (Array.isArray(_data["ownershipChanges"])) {
                this.ownershipChanges = [] as any;
                for (let item of _data["ownershipChanges"])
                    this.ownershipChanges!.push(OwnershipChangeDto.fromJS(item));
            }
            if (Array.isArray(_data["corporateShareholders"])) {
                this.corporateShareholders = [] as any;
                for (let item of _data["corporateShareholders"])
                    this.corporateShareholders!.push(CorporateShareholderDto.fromJS(item));
            }
            if (Array.isArray(_data["naturalPersonShareholders"])) {
                this.naturalPersonShareholders = [] as any;
                for (let item of _data["naturalPersonShareholders"])
                    this.naturalPersonShareholders!.push(NaturalPersonShareholderDto.fromJS(item));
            }
            this.blendingCircle = _data["blendingCircle"] ? BlendingCircleDto.fromJS(_data["blendingCircle"]) : <any>undefined;
            this.groupShare = _data["groupShare"] ? OrganizationalEntityGroupShareDto.fromJS(_data["groupShare"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrganizationalEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationalEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityNumber"] = this.entityNumber ? this.entityNumber.toJSON() : <any>undefined;
        data["legalName"] = this.legalName ? this.legalName.toJSON() : <any>undefined;
        data["gloBEStatus"] = this.gloBEStatus ? this.gloBEStatus.toJSON() : <any>undefined;
        data["tin"] = this.tin ? this.tin.toJSON() : <any>undefined;
        data["tinIssuedBy"] = this.tinIssuedBy ? this.tinIssuedBy.toJSON() : <any>undefined;
        data["typeOfTIN"] = this.typeOfTIN ? this.typeOfTIN.toJSON() : <any>undefined;
        data["taxJurisdictionCountry"] = this.taxJurisdictionCountry ? this.taxJurisdictionCountry.toJSON() : <any>undefined;
        data["taxTreatment"] = this.taxTreatment ? this.taxTreatment.toJSON() : <any>undefined;
        data["isUpeAsFlowThrough"] = this.isUpeAsFlowThrough ? this.isUpeAsFlowThrough.toJSON() : <any>undefined;
        data["isUpeSubjectToDeductiveDividendRegime"] = this.isUpeSubjectToDeductiveDividendRegime ? this.isUpeSubjectToDeductiveDividendRegime.toJSON() : <any>undefined;
        data["typeOfExcluded"] = this.typeOfExcluded ? this.typeOfExcluded.toJSON() : <any>undefined;
        data["notTreatingEntityAsExcludedEntity"] = this.notTreatingEntityAsExcludedEntity ? this.notTreatingEntityAsExcludedEntity.toJSON() : <any>undefined;
        data["electionYear"] = this.electionYear ? this.electionYear.toString() : <any>undefined;
        data["revocationYear"] = this.revocationYear ? this.revocationYear.toString() : <any>undefined;
        data["isPermanentEstablishment"] = this.isPermanentEstablishment ? this.isPermanentEstablishment.toJSON() : <any>undefined;
        data["mainEntityId"] = this.mainEntityId ? this.mainEntityId.toJSON() : <any>undefined;
        data["taxFunctionalCurrency"] = this.taxFunctionalCurrency ? this.taxFunctionalCurrency.toJSON() : <any>undefined;
        data["accountingFunctionalCurrency"] = this.accountingFunctionalCurrency ? this.accountingFunctionalCurrency.toJSON() : <any>undefined;
        data["consolidationMethod"] = this.consolidationMethod ? this.consolidationMethod.toJSON() : <any>undefined;
        data["financialAccountingStandardOfCe"] = this.financialAccountingStandardOfCe ? this.financialAccountingStandardOfCe.toJSON() : <any>undefined;
        data["blendingCircleCountry"] = this.blendingCircleCountry ? this.blendingCircleCountry.toJSON() : <any>undefined;
        data["blendingCircleSubgroupDisplayName"] = this.blendingCircleSubgroupDisplayName ? this.blendingCircleSubgroupDisplayName.toJSON() : <any>undefined;
        data["safeHarbourGroupCountry"] = this.safeHarbourGroupCountry;
        data["safeHarbourGroupType"] = this.safeHarbourGroupType;
        data["number"] = this.number;
        data["controllingInterestEntityId"] = this.controllingInterestEntityId;
        data["shareholders"] = this.shareholders ? this.shareholders.toJSON() : <any>undefined;
        data["hasWritePermission"] = this.hasWritePermission;
        data["hasAllRequiredFields"] = this.hasAllRequiredFields;
        data["hasGroupShareErrors"] = this.hasGroupShareErrors;
        if (Array.isArray(this.ownershipChanges)) {
            data["ownershipChanges"] = [];
            for (let item of this.ownershipChanges)
                data["ownershipChanges"].push(item.toJSON());
        }
        if (Array.isArray(this.corporateShareholders)) {
            data["corporateShareholders"] = [];
            for (let item of this.corporateShareholders)
                data["corporateShareholders"].push(item.toJSON());
        }
        if (Array.isArray(this.naturalPersonShareholders)) {
            data["naturalPersonShareholders"] = [];
            for (let item of this.naturalPersonShareholders)
                data["naturalPersonShareholders"].push(item.toJSON());
        }
        data["blendingCircle"] = this.blendingCircle ? this.blendingCircle.toJSON() : <any>undefined;
        data["groupShare"] = this.groupShare ? this.groupShare.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOrganizationalEntityDto {
    id: number;
    entityNumber: ConfirmableDtoOfString | undefined;
    legalName: ConfirmableDtoOfString | undefined;
    gloBEStatus: ConfirmableDtoOfIListOfGloBEStatus | undefined;
    tin: ConfirmableDtoOfString | undefined;
    tinIssuedBy: ConfirmableDtoOfString | undefined;
    typeOfTIN: ConfirmableDtoOfNullableOfTinType | undefined;
    taxJurisdictionCountry: ConfirmableDtoOfString | undefined;
    taxTreatment: ConfirmableDtoOfNullableOfTaxTreatment | undefined;
    isUpeAsFlowThrough: ConfirmableDtoOfNullableOfBoolean | undefined;
    isUpeSubjectToDeductiveDividendRegime: ConfirmableDtoOfNullableOfBoolean | undefined;
    typeOfExcluded: ConfirmableDtoOfNullableOfOrganizationalEntityExcludedType | undefined;
    notTreatingEntityAsExcludedEntity: ConfirmableDtoOfNullableOfBoolean | undefined;
    electionYear: DateTime | undefined;
    revocationYear: DateTime | undefined;
    isPermanentEstablishment: ConfirmableDtoOfNullableOfBoolean | undefined;
    mainEntityId: ConfirmableDtoOfNullableOfInt64 | undefined;
    taxFunctionalCurrency: ConfirmableDtoOfString | undefined;
    accountingFunctionalCurrency: ConfirmableDtoOfString | undefined;
    consolidationMethod: ConfirmableDtoOfNullableOfConsolidationMethod | undefined;
    financialAccountingStandardOfCe: ConfirmableDtoOfString | undefined;
    blendingCircleCountry: ConfirmableDtoOfString | undefined;
    blendingCircleSubgroupDisplayName: ConfirmableDtoOfString | undefined;
    safeHarbourGroupCountry: string | undefined;
    safeHarbourGroupType: string | undefined;
    number: number | undefined;
    controllingInterestEntityId: number | undefined;
    shareholders: ShareholdersDto | undefined;
    hasWritePermission: boolean;
    hasAllRequiredFields: boolean;
    hasGroupShareErrors: boolean;
    ownershipChanges: OwnershipChangeDto[] | undefined;
    corporateShareholders: CorporateShareholderDto[] | undefined;
    naturalPersonShareholders: NaturalPersonShareholderDto[] | undefined;
    blendingCircle: BlendingCircleDto | undefined;
    groupShare: OrganizationalEntityGroupShareDto | undefined;
}

export class OrganizationalEntityElectionInput implements IOrganizationalEntityElectionInput {
    id!: number;
    projectId!: number;
    electionType!: ElectionType | undefined;
    value!: boolean | undefined;
    electionYear!: DateTime | undefined;
    revocationYear!: DateTime | undefined;
    inclusionType!: ElectionInclusionType | undefined;
    equityInvestmentDetails!: EquityInvestmentInclusionElectionDetailsDto | undefined;
    permanentSafeHarbourTypes!: PermanentSafeHarbourType[] | undefined;
    organizationalEntityId!: number;

    constructor(data?: IOrganizationalEntityElectionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.electionType = _data["electionType"];
            this.value = _data["value"];
            this.electionYear = _data["electionYear"] ? DateTime.fromISO(_data["electionYear"].toString()) : <any>undefined;
            this.revocationYear = _data["revocationYear"] ? DateTime.fromISO(_data["revocationYear"].toString()) : <any>undefined;
            this.inclusionType = _data["inclusionType"];
            this.equityInvestmentDetails = _data["equityInvestmentDetails"] ? EquityInvestmentInclusionElectionDetailsDto.fromJS(_data["equityInvestmentDetails"]) : <any>undefined;
            if (Array.isArray(_data["permanentSafeHarbourTypes"])) {
                this.permanentSafeHarbourTypes = [] as any;
                for (let item of _data["permanentSafeHarbourTypes"])
                    this.permanentSafeHarbourTypes!.push(item);
            }
            this.organizationalEntityId = _data["organizationalEntityId"];
        }
    }

    static fromJS(data: any): OrganizationalEntityElectionInput {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationalEntityElectionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["electionType"] = this.electionType;
        data["value"] = this.value;
        data["electionYear"] = this.electionYear ? this.electionYear.toString() : <any>undefined;
        data["revocationYear"] = this.revocationYear ? this.revocationYear.toString() : <any>undefined;
        data["inclusionType"] = this.inclusionType;
        data["equityInvestmentDetails"] = this.equityInvestmentDetails ? this.equityInvestmentDetails.toJSON() : <any>undefined;
        if (Array.isArray(this.permanentSafeHarbourTypes)) {
            data["permanentSafeHarbourTypes"] = [];
            for (let item of this.permanentSafeHarbourTypes)
                data["permanentSafeHarbourTypes"].push(item);
        }
        data["organizationalEntityId"] = this.organizationalEntityId;
        return data;
    }
}

export interface IOrganizationalEntityElectionInput {
    id: number;
    projectId: number;
    electionType: ElectionType | undefined;
    value: boolean | undefined;
    electionYear: DateTime | undefined;
    revocationYear: DateTime | undefined;
    inclusionType: ElectionInclusionType | undefined;
    equityInvestmentDetails: EquityInvestmentInclusionElectionDetailsDto | undefined;
    permanentSafeHarbourTypes: PermanentSafeHarbourType[] | undefined;
    organizationalEntityId: number;
}

export enum OrganizationalEntityExcludedType {
    GovernmentalEntity = 1,
    InternationalOrganisation = 2,
    NonPofitOrganisation = 3,
    PensionFund = 4,
    InvestmentFundUPE = 5,
    RealEstateInvestmentVehicleUPE = 6,
    EntityOwnedByExcludedEntitiesUnderArticle152a = 7,
    EntityOwnedByExcludedEntitiesUnderArticle152b = 8,
}

export class OrganizationalEntityGroupShareDto implements IOrganizationalEntityGroupShareDto {
    groupShareValue!: number | undefined;
    canCalculateGroupShare!: boolean;
    localizedErrorMessages!: string[] | undefined;

    constructor(data?: IOrganizationalEntityGroupShareDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupShareValue = _data["groupShareValue"];
            this.canCalculateGroupShare = _data["canCalculateGroupShare"];
            if (Array.isArray(_data["localizedErrorMessages"])) {
                this.localizedErrorMessages = [] as any;
                for (let item of _data["localizedErrorMessages"])
                    this.localizedErrorMessages!.push(item);
            }
        }
    }

    static fromJS(data: any): OrganizationalEntityGroupShareDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationalEntityGroupShareDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupShareValue"] = this.groupShareValue;
        data["canCalculateGroupShare"] = this.canCalculateGroupShare;
        if (Array.isArray(this.localizedErrorMessages)) {
            data["localizedErrorMessages"] = [];
            for (let item of this.localizedErrorMessages)
                data["localizedErrorMessages"].push(item);
        }
        return data;
    }
}

export interface IOrganizationalEntityGroupShareDto {
    groupShareValue: number | undefined;
    canCalculateGroupShare: boolean;
    localizedErrorMessages: string[] | undefined;
}

export class OrganizationalEntityOverviewDto implements IOrganizationalEntityOverviewDto {
    id!: number;
    entityNumber!: ConfirmableDtoOfString | undefined;
    legalName!: ConfirmableDtoOfString | undefined;
    gloBEStatus!: ConfirmableDtoOfIListOfGloBEStatus | undefined;
    tin!: ConfirmableDtoOfString | undefined;
    tinIssuedBy!: ConfirmableDtoOfString | undefined;
    typeOfTIN!: ConfirmableDtoOfNullableOfTinType | undefined;
    taxJurisdictionCountry!: ConfirmableDtoOfString | undefined;
    taxTreatment!: ConfirmableDtoOfNullableOfTaxTreatment | undefined;
    isUpeAsFlowThrough!: ConfirmableDtoOfNullableOfBoolean | undefined;
    isUpeSubjectToDeductiveDividendRegime!: ConfirmableDtoOfNullableOfBoolean | undefined;
    typeOfExcluded!: ConfirmableDtoOfNullableOfOrganizationalEntityExcludedType | undefined;
    notTreatingEntityAsExcludedEntity!: ConfirmableDtoOfNullableOfBoolean | undefined;
    electionYear!: DateTime | undefined;
    revocationYear!: DateTime | undefined;
    isPermanentEstablishment!: ConfirmableDtoOfNullableOfBoolean | undefined;
    mainEntityId!: ConfirmableDtoOfNullableOfInt64 | undefined;
    taxFunctionalCurrency!: ConfirmableDtoOfString | undefined;
    accountingFunctionalCurrency!: ConfirmableDtoOfString | undefined;
    consolidationMethod!: ConfirmableDtoOfNullableOfConsolidationMethod | undefined;
    financialAccountingStandardOfCe!: ConfirmableDtoOfString | undefined;
    blendingCircleCountry!: ConfirmableDtoOfString | undefined;
    blendingCircleSubgroupDisplayName!: ConfirmableDtoOfString | undefined;
    safeHarbourGroupCountry!: string | undefined;
    safeHarbourGroupType!: string | undefined;
    number!: number | undefined;
    controllingInterestEntityId!: number | undefined;
    shareholders!: ShareholdersDto | undefined;
    hasWritePermission!: boolean;
    hasAllRequiredFields!: boolean;
    hasGroupShareErrors!: boolean;
    ownershipChanges!: OwnershipChangeDto[] | undefined;
    corporateShareholders!: CorporateShareholderDto[] | undefined;
    naturalPersonShareholders!: NaturalPersonShareholderDto[] | undefined;

    constructor(data?: IOrganizationalEntityOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entityNumber = _data["entityNumber"] ? ConfirmableDtoOfString.fromJS(_data["entityNumber"]) : <any>undefined;
            this.legalName = _data["legalName"] ? ConfirmableDtoOfString.fromJS(_data["legalName"]) : <any>undefined;
            this.gloBEStatus = _data["gloBEStatus"] ? ConfirmableDtoOfIListOfGloBEStatus.fromJS(_data["gloBEStatus"]) : <any>undefined;
            this.tin = _data["tin"] ? ConfirmableDtoOfString.fromJS(_data["tin"]) : <any>undefined;
            this.tinIssuedBy = _data["tinIssuedBy"] ? ConfirmableDtoOfString.fromJS(_data["tinIssuedBy"]) : <any>undefined;
            this.typeOfTIN = _data["typeOfTIN"] ? ConfirmableDtoOfNullableOfTinType.fromJS(_data["typeOfTIN"]) : <any>undefined;
            this.taxJurisdictionCountry = _data["taxJurisdictionCountry"] ? ConfirmableDtoOfString.fromJS(_data["taxJurisdictionCountry"]) : <any>undefined;
            this.taxTreatment = _data["taxTreatment"] ? ConfirmableDtoOfNullableOfTaxTreatment.fromJS(_data["taxTreatment"]) : <any>undefined;
            this.isUpeAsFlowThrough = _data["isUpeAsFlowThrough"] ? ConfirmableDtoOfNullableOfBoolean.fromJS(_data["isUpeAsFlowThrough"]) : <any>undefined;
            this.isUpeSubjectToDeductiveDividendRegime = _data["isUpeSubjectToDeductiveDividendRegime"] ? ConfirmableDtoOfNullableOfBoolean.fromJS(_data["isUpeSubjectToDeductiveDividendRegime"]) : <any>undefined;
            this.typeOfExcluded = _data["typeOfExcluded"] ? ConfirmableDtoOfNullableOfOrganizationalEntityExcludedType.fromJS(_data["typeOfExcluded"]) : <any>undefined;
            this.notTreatingEntityAsExcludedEntity = _data["notTreatingEntityAsExcludedEntity"] ? ConfirmableDtoOfNullableOfBoolean.fromJS(_data["notTreatingEntityAsExcludedEntity"]) : <any>undefined;
            this.electionYear = _data["electionYear"] ? DateTime.fromISO(_data["electionYear"].toString()) : <any>undefined;
            this.revocationYear = _data["revocationYear"] ? DateTime.fromISO(_data["revocationYear"].toString()) : <any>undefined;
            this.isPermanentEstablishment = _data["isPermanentEstablishment"] ? ConfirmableDtoOfNullableOfBoolean.fromJS(_data["isPermanentEstablishment"]) : <any>undefined;
            this.mainEntityId = _data["mainEntityId"] ? ConfirmableDtoOfNullableOfInt64.fromJS(_data["mainEntityId"]) : <any>undefined;
            this.taxFunctionalCurrency = _data["taxFunctionalCurrency"] ? ConfirmableDtoOfString.fromJS(_data["taxFunctionalCurrency"]) : <any>undefined;
            this.accountingFunctionalCurrency = _data["accountingFunctionalCurrency"] ? ConfirmableDtoOfString.fromJS(_data["accountingFunctionalCurrency"]) : <any>undefined;
            this.consolidationMethod = _data["consolidationMethod"] ? ConfirmableDtoOfNullableOfConsolidationMethod.fromJS(_data["consolidationMethod"]) : <any>undefined;
            this.financialAccountingStandardOfCe = _data["financialAccountingStandardOfCe"] ? ConfirmableDtoOfString.fromJS(_data["financialAccountingStandardOfCe"]) : <any>undefined;
            this.blendingCircleCountry = _data["blendingCircleCountry"] ? ConfirmableDtoOfString.fromJS(_data["blendingCircleCountry"]) : <any>undefined;
            this.blendingCircleSubgroupDisplayName = _data["blendingCircleSubgroupDisplayName"] ? ConfirmableDtoOfString.fromJS(_data["blendingCircleSubgroupDisplayName"]) : <any>undefined;
            this.safeHarbourGroupCountry = _data["safeHarbourGroupCountry"];
            this.safeHarbourGroupType = _data["safeHarbourGroupType"];
            this.number = _data["number"];
            this.controllingInterestEntityId = _data["controllingInterestEntityId"];
            this.shareholders = _data["shareholders"] ? ShareholdersDto.fromJS(_data["shareholders"]) : <any>undefined;
            this.hasWritePermission = _data["hasWritePermission"];
            this.hasAllRequiredFields = _data["hasAllRequiredFields"];
            this.hasGroupShareErrors = _data["hasGroupShareErrors"];
            if (Array.isArray(_data["ownershipChanges"])) {
                this.ownershipChanges = [] as any;
                for (let item of _data["ownershipChanges"])
                    this.ownershipChanges!.push(OwnershipChangeDto.fromJS(item));
            }
            if (Array.isArray(_data["corporateShareholders"])) {
                this.corporateShareholders = [] as any;
                for (let item of _data["corporateShareholders"])
                    this.corporateShareholders!.push(CorporateShareholderDto.fromJS(item));
            }
            if (Array.isArray(_data["naturalPersonShareholders"])) {
                this.naturalPersonShareholders = [] as any;
                for (let item of _data["naturalPersonShareholders"])
                    this.naturalPersonShareholders!.push(NaturalPersonShareholderDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrganizationalEntityOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationalEntityOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityNumber"] = this.entityNumber ? this.entityNumber.toJSON() : <any>undefined;
        data["legalName"] = this.legalName ? this.legalName.toJSON() : <any>undefined;
        data["gloBEStatus"] = this.gloBEStatus ? this.gloBEStatus.toJSON() : <any>undefined;
        data["tin"] = this.tin ? this.tin.toJSON() : <any>undefined;
        data["tinIssuedBy"] = this.tinIssuedBy ? this.tinIssuedBy.toJSON() : <any>undefined;
        data["typeOfTIN"] = this.typeOfTIN ? this.typeOfTIN.toJSON() : <any>undefined;
        data["taxJurisdictionCountry"] = this.taxJurisdictionCountry ? this.taxJurisdictionCountry.toJSON() : <any>undefined;
        data["taxTreatment"] = this.taxTreatment ? this.taxTreatment.toJSON() : <any>undefined;
        data["isUpeAsFlowThrough"] = this.isUpeAsFlowThrough ? this.isUpeAsFlowThrough.toJSON() : <any>undefined;
        data["isUpeSubjectToDeductiveDividendRegime"] = this.isUpeSubjectToDeductiveDividendRegime ? this.isUpeSubjectToDeductiveDividendRegime.toJSON() : <any>undefined;
        data["typeOfExcluded"] = this.typeOfExcluded ? this.typeOfExcluded.toJSON() : <any>undefined;
        data["notTreatingEntityAsExcludedEntity"] = this.notTreatingEntityAsExcludedEntity ? this.notTreatingEntityAsExcludedEntity.toJSON() : <any>undefined;
        data["electionYear"] = this.electionYear ? this.electionYear.toString() : <any>undefined;
        data["revocationYear"] = this.revocationYear ? this.revocationYear.toString() : <any>undefined;
        data["isPermanentEstablishment"] = this.isPermanentEstablishment ? this.isPermanentEstablishment.toJSON() : <any>undefined;
        data["mainEntityId"] = this.mainEntityId ? this.mainEntityId.toJSON() : <any>undefined;
        data["taxFunctionalCurrency"] = this.taxFunctionalCurrency ? this.taxFunctionalCurrency.toJSON() : <any>undefined;
        data["accountingFunctionalCurrency"] = this.accountingFunctionalCurrency ? this.accountingFunctionalCurrency.toJSON() : <any>undefined;
        data["consolidationMethod"] = this.consolidationMethod ? this.consolidationMethod.toJSON() : <any>undefined;
        data["financialAccountingStandardOfCe"] = this.financialAccountingStandardOfCe ? this.financialAccountingStandardOfCe.toJSON() : <any>undefined;
        data["blendingCircleCountry"] = this.blendingCircleCountry ? this.blendingCircleCountry.toJSON() : <any>undefined;
        data["blendingCircleSubgroupDisplayName"] = this.blendingCircleSubgroupDisplayName ? this.blendingCircleSubgroupDisplayName.toJSON() : <any>undefined;
        data["safeHarbourGroupCountry"] = this.safeHarbourGroupCountry;
        data["safeHarbourGroupType"] = this.safeHarbourGroupType;
        data["number"] = this.number;
        data["controllingInterestEntityId"] = this.controllingInterestEntityId;
        data["shareholders"] = this.shareholders ? this.shareholders.toJSON() : <any>undefined;
        data["hasWritePermission"] = this.hasWritePermission;
        data["hasAllRequiredFields"] = this.hasAllRequiredFields;
        data["hasGroupShareErrors"] = this.hasGroupShareErrors;
        if (Array.isArray(this.ownershipChanges)) {
            data["ownershipChanges"] = [];
            for (let item of this.ownershipChanges)
                data["ownershipChanges"].push(item.toJSON());
        }
        if (Array.isArray(this.corporateShareholders)) {
            data["corporateShareholders"] = [];
            for (let item of this.corporateShareholders)
                data["corporateShareholders"].push(item.toJSON());
        }
        if (Array.isArray(this.naturalPersonShareholders)) {
            data["naturalPersonShareholders"] = [];
            for (let item of this.naturalPersonShareholders)
                data["naturalPersonShareholders"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrganizationalEntityOverviewDto {
    id: number;
    entityNumber: ConfirmableDtoOfString | undefined;
    legalName: ConfirmableDtoOfString | undefined;
    gloBEStatus: ConfirmableDtoOfIListOfGloBEStatus | undefined;
    tin: ConfirmableDtoOfString | undefined;
    tinIssuedBy: ConfirmableDtoOfString | undefined;
    typeOfTIN: ConfirmableDtoOfNullableOfTinType | undefined;
    taxJurisdictionCountry: ConfirmableDtoOfString | undefined;
    taxTreatment: ConfirmableDtoOfNullableOfTaxTreatment | undefined;
    isUpeAsFlowThrough: ConfirmableDtoOfNullableOfBoolean | undefined;
    isUpeSubjectToDeductiveDividendRegime: ConfirmableDtoOfNullableOfBoolean | undefined;
    typeOfExcluded: ConfirmableDtoOfNullableOfOrganizationalEntityExcludedType | undefined;
    notTreatingEntityAsExcludedEntity: ConfirmableDtoOfNullableOfBoolean | undefined;
    electionYear: DateTime | undefined;
    revocationYear: DateTime | undefined;
    isPermanentEstablishment: ConfirmableDtoOfNullableOfBoolean | undefined;
    mainEntityId: ConfirmableDtoOfNullableOfInt64 | undefined;
    taxFunctionalCurrency: ConfirmableDtoOfString | undefined;
    accountingFunctionalCurrency: ConfirmableDtoOfString | undefined;
    consolidationMethod: ConfirmableDtoOfNullableOfConsolidationMethod | undefined;
    financialAccountingStandardOfCe: ConfirmableDtoOfString | undefined;
    blendingCircleCountry: ConfirmableDtoOfString | undefined;
    blendingCircleSubgroupDisplayName: ConfirmableDtoOfString | undefined;
    safeHarbourGroupCountry: string | undefined;
    safeHarbourGroupType: string | undefined;
    number: number | undefined;
    controllingInterestEntityId: number | undefined;
    shareholders: ShareholdersDto | undefined;
    hasWritePermission: boolean;
    hasAllRequiredFields: boolean;
    hasGroupShareErrors: boolean;
    ownershipChanges: OwnershipChangeDto[] | undefined;
    corporateShareholders: CorporateShareholderDto[] | undefined;
    naturalPersonShareholders: NaturalPersonShareholderDto[] | undefined;
}

export class OrganizationalEntityOverviewInput implements IOrganizationalEntityOverviewInput {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    projectId!: number;
    filter!: string | undefined;
    taxJurisdictionsFilter!: string[] | undefined;
    blendingCircleSubgroupsFilter!: number[] | undefined;
    safeHarbourGroupsFilter!: string[] | undefined;
    consolidationMethodFilter!: string[] | undefined;
    globeStatusFilter!: string[] | undefined;
    accountingFunctionalCurrencyFilter!: string[] | undefined;

    constructor(data?: IOrganizationalEntityOverviewInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.projectId = _data["projectId"];
            this.filter = _data["filter"];
            if (Array.isArray(_data["taxJurisdictionsFilter"])) {
                this.taxJurisdictionsFilter = [] as any;
                for (let item of _data["taxJurisdictionsFilter"])
                    this.taxJurisdictionsFilter!.push(item);
            }
            if (Array.isArray(_data["blendingCircleSubgroupsFilter"])) {
                this.blendingCircleSubgroupsFilter = [] as any;
                for (let item of _data["blendingCircleSubgroupsFilter"])
                    this.blendingCircleSubgroupsFilter!.push(item);
            }
            if (Array.isArray(_data["safeHarbourGroupsFilter"])) {
                this.safeHarbourGroupsFilter = [] as any;
                for (let item of _data["safeHarbourGroupsFilter"])
                    this.safeHarbourGroupsFilter!.push(item);
            }
            if (Array.isArray(_data["consolidationMethodFilter"])) {
                this.consolidationMethodFilter = [] as any;
                for (let item of _data["consolidationMethodFilter"])
                    this.consolidationMethodFilter!.push(item);
            }
            if (Array.isArray(_data["globeStatusFilter"])) {
                this.globeStatusFilter = [] as any;
                for (let item of _data["globeStatusFilter"])
                    this.globeStatusFilter!.push(item);
            }
            if (Array.isArray(_data["accountingFunctionalCurrencyFilter"])) {
                this.accountingFunctionalCurrencyFilter = [] as any;
                for (let item of _data["accountingFunctionalCurrencyFilter"])
                    this.accountingFunctionalCurrencyFilter!.push(item);
            }
        }
    }

    static fromJS(data: any): OrganizationalEntityOverviewInput {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationalEntityOverviewInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["projectId"] = this.projectId;
        data["filter"] = this.filter;
        if (Array.isArray(this.taxJurisdictionsFilter)) {
            data["taxJurisdictionsFilter"] = [];
            for (let item of this.taxJurisdictionsFilter)
                data["taxJurisdictionsFilter"].push(item);
        }
        if (Array.isArray(this.blendingCircleSubgroupsFilter)) {
            data["blendingCircleSubgroupsFilter"] = [];
            for (let item of this.blendingCircleSubgroupsFilter)
                data["blendingCircleSubgroupsFilter"].push(item);
        }
        if (Array.isArray(this.safeHarbourGroupsFilter)) {
            data["safeHarbourGroupsFilter"] = [];
            for (let item of this.safeHarbourGroupsFilter)
                data["safeHarbourGroupsFilter"].push(item);
        }
        if (Array.isArray(this.consolidationMethodFilter)) {
            data["consolidationMethodFilter"] = [];
            for (let item of this.consolidationMethodFilter)
                data["consolidationMethodFilter"].push(item);
        }
        if (Array.isArray(this.globeStatusFilter)) {
            data["globeStatusFilter"] = [];
            for (let item of this.globeStatusFilter)
                data["globeStatusFilter"].push(item);
        }
        if (Array.isArray(this.accountingFunctionalCurrencyFilter)) {
            data["accountingFunctionalCurrencyFilter"] = [];
            for (let item of this.accountingFunctionalCurrencyFilter)
                data["accountingFunctionalCurrencyFilter"].push(item);
        }
        return data;
    }
}

export interface IOrganizationalEntityOverviewInput {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    projectId: number;
    filter: string | undefined;
    taxJurisdictionsFilter: string[] | undefined;
    blendingCircleSubgroupsFilter: number[] | undefined;
    safeHarbourGroupsFilter: string[] | undefined;
    consolidationMethodFilter: string[] | undefined;
    globeStatusFilter: string[] | undefined;
    accountingFunctionalCurrencyFilter: string[] | undefined;
}

export class OrganizationalEntityReferenceDataDto implements IOrganizationalEntityReferenceDataDto {
    id!: number;
    text!: string | undefined;
    blendingCircleSubgroupId!: number | undefined;
    blendingCircleCountry!: string | undefined;

    constructor(data?: IOrganizationalEntityReferenceDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            this.blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
            this.blendingCircleCountry = _data["blendingCircleCountry"];
        }
    }

    static fromJS(data: any): OrganizationalEntityReferenceDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationalEntityReferenceDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        data["blendingCircleCountry"] = this.blendingCircleCountry;
        return data;
    }
}

export interface IOrganizationalEntityReferenceDataDto {
    id: number;
    text: string | undefined;
    blendingCircleSubgroupId: number | undefined;
    blendingCircleCountry: string | undefined;
}

export class OrganizationalEntityReferenceDto implements IOrganizationalEntityReferenceDto {
    id!: number;
    legalName!: string | undefined;
    entityNumber!: string | undefined;
    isNonGroupMember!: boolean;
    isInvestmentEntity!: boolean;

    constructor(data?: IOrganizationalEntityReferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.legalName = _data["legalName"];
            this.entityNumber = _data["entityNumber"];
            this.isNonGroupMember = _data["isNonGroupMember"];
            this.isInvestmentEntity = _data["isInvestmentEntity"];
        }
    }

    static fromJS(data: any): OrganizationalEntityReferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationalEntityReferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["legalName"] = this.legalName;
        data["entityNumber"] = this.entityNumber;
        data["isNonGroupMember"] = this.isNonGroupMember;
        data["isInvestmentEntity"] = this.isInvestmentEntity;
        return data;
    }
}

export interface IOrganizationalEntityReferenceDto {
    id: number;
    legalName: string | undefined;
    entityNumber: string | undefined;
    isNonGroupMember: boolean;
    isInvestmentEntity: boolean;
}

export class OrganizationalEntityShareholderDto implements IOrganizationalEntityShareholderDto {
    id!: number;
    interestValue!: ConfirmableDtoOfString | undefined;
    holdingOrganizationalEntityId!: ConfirmableDtoOfInt64 | undefined;
    investmentElection!: ConfirmableDtoOfNullableOfInvestmentElectionType | undefined;
    electionYear!: DateTime | undefined;
    revocationYear!: DateTime | undefined;

    constructor(data?: IOrganizationalEntityShareholderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.interestValue = _data["interestValue"] ? ConfirmableDtoOfString.fromJS(_data["interestValue"]) : <any>undefined;
            this.holdingOrganizationalEntityId = _data["holdingOrganizationalEntityId"] ? ConfirmableDtoOfInt64.fromJS(_data["holdingOrganizationalEntityId"]) : <any>undefined;
            this.investmentElection = _data["investmentElection"] ? ConfirmableDtoOfNullableOfInvestmentElectionType.fromJS(_data["investmentElection"]) : <any>undefined;
            this.electionYear = _data["electionYear"] ? DateTime.fromISO(_data["electionYear"].toString()) : <any>undefined;
            this.revocationYear = _data["revocationYear"] ? DateTime.fromISO(_data["revocationYear"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OrganizationalEntityShareholderDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationalEntityShareholderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["interestValue"] = this.interestValue ? this.interestValue.toJSON() : <any>undefined;
        data["holdingOrganizationalEntityId"] = this.holdingOrganizationalEntityId ? this.holdingOrganizationalEntityId.toJSON() : <any>undefined;
        data["investmentElection"] = this.investmentElection ? this.investmentElection.toJSON() : <any>undefined;
        data["electionYear"] = this.electionYear ? this.electionYear.toString() : <any>undefined;
        data["revocationYear"] = this.revocationYear ? this.revocationYear.toString() : <any>undefined;
        return data;
    }
}

export interface IOrganizationalEntityShareholderDto {
    id: number;
    interestValue: ConfirmableDtoOfString | undefined;
    holdingOrganizationalEntityId: ConfirmableDtoOfInt64 | undefined;
    investmentElection: ConfirmableDtoOfNullableOfInvestmentElectionType | undefined;
    electionYear: DateTime | undefined;
    revocationYear: DateTime | undefined;
}

export class OrganizationalEntityShareholderInput implements IOrganizationalEntityShareholderInput {
    id!: number | undefined;
    interestValue!: ConfirmableInputOfString | undefined;
    holdingOrganizationalEntityId!: ConfirmableInputOfNullableOfInt64 | undefined;
    investmentElection!: ConfirmableInputOfNullableOfInvestmentElectionType | undefined;
    electionYear!: DateTime | undefined;
    revocationYear!: DateTime | undefined;

    constructor(data?: IOrganizationalEntityShareholderInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.interestValue = _data["interestValue"] ? ConfirmableInputOfString.fromJS(_data["interestValue"]) : <any>undefined;
            this.holdingOrganizationalEntityId = _data["holdingOrganizationalEntityId"] ? ConfirmableInputOfNullableOfInt64.fromJS(_data["holdingOrganizationalEntityId"]) : <any>undefined;
            this.investmentElection = _data["investmentElection"] ? ConfirmableInputOfNullableOfInvestmentElectionType.fromJS(_data["investmentElection"]) : <any>undefined;
            this.electionYear = _data["electionYear"] ? DateTime.fromISO(_data["electionYear"].toString()) : <any>undefined;
            this.revocationYear = _data["revocationYear"] ? DateTime.fromISO(_data["revocationYear"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OrganizationalEntityShareholderInput {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationalEntityShareholderInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["interestValue"] = this.interestValue ? this.interestValue.toJSON() : <any>undefined;
        data["holdingOrganizationalEntityId"] = this.holdingOrganizationalEntityId ? this.holdingOrganizationalEntityId.toJSON() : <any>undefined;
        data["investmentElection"] = this.investmentElection ? this.investmentElection.toJSON() : <any>undefined;
        data["electionYear"] = this.electionYear ? this.electionYear.toString() : <any>undefined;
        data["revocationYear"] = this.revocationYear ? this.revocationYear.toString() : <any>undefined;
        return data;
    }
}

export interface IOrganizationalEntityShareholderInput {
    id: number | undefined;
    interestValue: ConfirmableInputOfString | undefined;
    holdingOrganizationalEntityId: ConfirmableInputOfNullableOfInt64 | undefined;
    investmentElection: ConfirmableInputOfNullableOfInvestmentElectionType | undefined;
    electionYear: DateTime | undefined;
    revocationYear: DateTime | undefined;
}

export class OrganizationalEntityWarningsAndErrorsResult implements IOrganizationalEntityWarningsAndErrorsResult {
    warnings!: string[] | undefined;
    errors!: string[] | undefined;

    constructor(data?: IOrganizationalEntityWarningsAndErrorsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(item);
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): OrganizationalEntityWarningsAndErrorsResult {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationalEntityWarningsAndErrorsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IOrganizationalEntityWarningsAndErrorsResult {
    warnings: string[] | undefined;
    errors: string[] | undefined;
}

export class OrganizationalLinkDto implements IOrganizationalLinkDto {
    id!: string | undefined;
    from!: string | undefined;
    to!: string | undefined;
    label!: string | undefined;
    levelAs!: string | undefined;

    constructor(data?: IOrganizationalLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.from = _data["from"];
            this.to = _data["to"];
            this.label = _data["label"];
            this.levelAs = _data["levelAs"];
        }
    }

    static fromJS(data: any): OrganizationalLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationalLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["from"] = this.from;
        data["to"] = this.to;
        data["label"] = this.label;
        data["levelAs"] = this.levelAs;
        return data;
    }
}

export interface IOrganizationalLinkDto {
    id: string | undefined;
    from: string | undefined;
    to: string | undefined;
    label: string | undefined;
    levelAs: string | undefined;
}

export class OrganizationalNodeDto implements IOrganizationalNodeDto {
    id!: string | undefined;
    title!: string | undefined;
    type!: OrganizationalChartNodeType;
    entityId!: number | undefined;
    name!: string | undefined;
    countryCode!: string | undefined;
    gloBEStatus!: GloBEStatus[] | undefined;
    level!: number | undefined;

    constructor(data?: IOrganizationalNodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.type = _data["type"];
            this.entityId = _data["entityId"];
            this.name = _data["name"];
            this.countryCode = _data["countryCode"];
            if (Array.isArray(_data["gloBEStatus"])) {
                this.gloBEStatus = [] as any;
                for (let item of _data["gloBEStatus"])
                    this.gloBEStatus!.push(item);
            }
            this.level = _data["level"];
        }
    }

    static fromJS(data: any): OrganizationalNodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationalNodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["type"] = this.type;
        data["entityId"] = this.entityId;
        data["name"] = this.name;
        data["countryCode"] = this.countryCode;
        if (Array.isArray(this.gloBEStatus)) {
            data["gloBEStatus"] = [];
            for (let item of this.gloBEStatus)
                data["gloBEStatus"].push(item);
        }
        data["level"] = this.level;
        return data;
    }
}

export interface IOrganizationalNodeDto {
    id: string | undefined;
    title: string | undefined;
    type: OrganizationalChartNodeType;
    entityId: number | undefined;
    name: string | undefined;
    countryCode: string | undefined;
    gloBEStatus: GloBEStatus[] | undefined;
    level: number | undefined;
}

export class OwnershipChangeDto implements IOwnershipChangeDto {
    id!: number;
    name!: string | undefined;
    organizationalEntityId!: number;
    changeDate!: DateTime | undefined;
    ownShares!: number | undefined;
    gloBEStatus!: OwnershipChangeGloBEStatus[] | undefined;
    interestParticipation!: number;
    ownershipChangeInternalOwners!: OwnershipChangeInternalOwnerDto[] | undefined;
    ownershipChangeThirdPartyParticipations!: OwnershipChangeThirdPartyParticipationDto[] | undefined;

    constructor(data?: IOwnershipChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.changeDate = _data["changeDate"] ? DateTime.fromISO(_data["changeDate"].toString()) : <any>undefined;
            this.ownShares = _data["ownShares"];
            if (Array.isArray(_data["gloBEStatus"])) {
                this.gloBEStatus = [] as any;
                for (let item of _data["gloBEStatus"])
                    this.gloBEStatus!.push(item);
            }
            this.interestParticipation = _data["interestParticipation"];
            if (Array.isArray(_data["ownershipChangeInternalOwners"])) {
                this.ownershipChangeInternalOwners = [] as any;
                for (let item of _data["ownershipChangeInternalOwners"])
                    this.ownershipChangeInternalOwners!.push(OwnershipChangeInternalOwnerDto.fromJS(item));
            }
            if (Array.isArray(_data["ownershipChangeThirdPartyParticipations"])) {
                this.ownershipChangeThirdPartyParticipations = [] as any;
                for (let item of _data["ownershipChangeThirdPartyParticipations"])
                    this.ownershipChangeThirdPartyParticipations!.push(OwnershipChangeThirdPartyParticipationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OwnershipChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new OwnershipChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["changeDate"] = this.changeDate ? this.changeDate.toString() : <any>undefined;
        data["ownShares"] = this.ownShares;
        if (Array.isArray(this.gloBEStatus)) {
            data["gloBEStatus"] = [];
            for (let item of this.gloBEStatus)
                data["gloBEStatus"].push(item);
        }
        data["interestParticipation"] = this.interestParticipation;
        if (Array.isArray(this.ownershipChangeInternalOwners)) {
            data["ownershipChangeInternalOwners"] = [];
            for (let item of this.ownershipChangeInternalOwners)
                data["ownershipChangeInternalOwners"].push(item.toJSON());
        }
        if (Array.isArray(this.ownershipChangeThirdPartyParticipations)) {
            data["ownershipChangeThirdPartyParticipations"] = [];
            for (let item of this.ownershipChangeThirdPartyParticipations)
                data["ownershipChangeThirdPartyParticipations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOwnershipChangeDto {
    id: number;
    name: string | undefined;
    organizationalEntityId: number;
    changeDate: DateTime | undefined;
    ownShares: number | undefined;
    gloBEStatus: OwnershipChangeGloBEStatus[] | undefined;
    interestParticipation: number;
    ownershipChangeInternalOwners: OwnershipChangeInternalOwnerDto[] | undefined;
    ownershipChangeThirdPartyParticipations: OwnershipChangeThirdPartyParticipationDto[] | undefined;
}

export enum OwnershipChangeGloBEStatus {
    UltimateParentEntity = 1,
    ConstituentEntity = 2,
    FlowThroughEntityTaxTransparent = 3,
    FlowThroughEntityReverseHybrid = 5,
    HybridEntity = 6,
    PermanentEstablishment = 7,
    MainEntity = 8,
    MinorityOwnedParentEntity = 9,
    MinorityOwnedSubsidiary = 10,
    MinorityOwnedConstituentEntity = 11,
    InvestmentEntity = 12,
    InsuranceInvestmentEntity = 13,
    JointVenture = 14,
    JointVentureSubsidiary = 15,
    ExcludedEntity = 16,
    PartiallyOwnedParentEntity = 17,
    NonMaterialConstituentEntity = 18,
    NonGroupMember = 19,
    IntermediateParentEntity = 101,
    SecuritizationEntity = 102,
    ParentEntityRequiredToApplyQiir = 103,
}

export class OwnershipChangeInternalOwnerDto implements IOwnershipChangeInternalOwnerDto {
    id!: number;
    ownershipChangeId!: number;
    holdingOrganizationalEntityId!: number;
    taxTreatment!: TaxTreatment | undefined;
    interestValue!: number;

    constructor(data?: IOwnershipChangeInternalOwnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ownershipChangeId = _data["ownershipChangeId"];
            this.holdingOrganizationalEntityId = _data["holdingOrganizationalEntityId"];
            this.taxTreatment = _data["taxTreatment"];
            this.interestValue = _data["interestValue"];
        }
    }

    static fromJS(data: any): OwnershipChangeInternalOwnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new OwnershipChangeInternalOwnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ownershipChangeId"] = this.ownershipChangeId;
        data["holdingOrganizationalEntityId"] = this.holdingOrganizationalEntityId;
        data["taxTreatment"] = this.taxTreatment;
        data["interestValue"] = this.interestValue;
        return data;
    }
}

export interface IOwnershipChangeInternalOwnerDto {
    id: number;
    ownershipChangeId: number;
    holdingOrganizationalEntityId: number;
    taxTreatment: TaxTreatment | undefined;
    interestValue: number;
}

export class OwnershipChangeThirdPartyParticipationDto implements IOwnershipChangeThirdPartyParticipationDto {
    id!: number;
    ownershipChangeId!: number;
    interestValue!: number;
    heldOrganizationalEntityId!: number;

    constructor(data?: IOwnershipChangeThirdPartyParticipationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ownershipChangeId = _data["ownershipChangeId"];
            this.interestValue = _data["interestValue"];
            this.heldOrganizationalEntityId = _data["heldOrganizationalEntityId"];
        }
    }

    static fromJS(data: any): OwnershipChangeThirdPartyParticipationDto {
        data = typeof data === 'object' ? data : {};
        let result = new OwnershipChangeThirdPartyParticipationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ownershipChangeId"] = this.ownershipChangeId;
        data["interestValue"] = this.interestValue;
        data["heldOrganizationalEntityId"] = this.heldOrganizationalEntityId;
        return data;
    }
}

export interface IOwnershipChangeThirdPartyParticipationDto {
    id: number;
    ownershipChangeId: number;
    interestValue: number;
    heldOrganizationalEntityId: number;
}

export class PagedResultDtoOfAttachmentOverviewDto implements IPagedResultDtoOfAttachmentOverviewDto {
    items!: AttachmentOverviewDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfAttachmentOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AttachmentOverviewDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfAttachmentOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAttachmentOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfAttachmentOverviewDto {
    items: AttachmentOverviewDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfFullScopeCalculationsOverviewDto implements IPagedResultDtoOfFullScopeCalculationsOverviewDto {
    items!: FullScopeCalculationsOverviewDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfFullScopeCalculationsOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FullScopeCalculationsOverviewDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfFullScopeCalculationsOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfFullScopeCalculationsOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfFullScopeCalculationsOverviewDto {
    items: FullScopeCalculationsOverviewDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfImportOverviewDto implements IPagedResultDtoOfImportOverviewDto {
    items!: ImportOverviewDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfImportOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ImportOverviewDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfImportOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfImportOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfImportOverviewDto {
    items: ImportOverviewDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfJurisdictionOverviewDto implements IPagedResultDtoOfJurisdictionOverviewDto {
    items!: JurisdictionOverviewDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfJurisdictionOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(JurisdictionOverviewDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfJurisdictionOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfJurisdictionOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfJurisdictionOverviewDto {
    items: JurisdictionOverviewDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfObligationOverviewDto implements IPagedResultDtoOfObligationOverviewDto {
    items!: ObligationOverviewDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfObligationOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ObligationOverviewDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfObligationOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfObligationOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfObligationOverviewDto {
    items: ObligationOverviewDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfOrganizationalEntityOverviewDto implements IPagedResultDtoOfOrganizationalEntityOverviewDto {
    items!: OrganizationalEntityOverviewDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfOrganizationalEntityOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationalEntityOverviewDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrganizationalEntityOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrganizationalEntityOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfOrganizationalEntityOverviewDto {
    items: OrganizationalEntityOverviewDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfProjectNotificationOverviewDto implements IPagedResultDtoOfProjectNotificationOverviewDto {
    items!: ProjectNotificationOverviewDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfProjectNotificationOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProjectNotificationOverviewDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfProjectNotificationOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfProjectNotificationOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfProjectNotificationOverviewDto {
    items: ProjectNotificationOverviewDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfProjectOverviewDto implements IPagedResultDtoOfProjectOverviewDto {
    items!: ProjectOverviewDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfProjectOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProjectOverviewDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfProjectOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfProjectOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfProjectOverviewDto {
    items: ProjectOverviewDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfReportOverviewDto implements IPagedResultDtoOfReportOverviewDto {
    items!: ReportOverviewDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfReportOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReportOverviewDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfReportOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfReportOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfReportOverviewDto {
    items: ReportOverviewDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfSafeHarbourGroupOverviewDto implements IPagedResultDtoOfSafeHarbourGroupOverviewDto {
    items!: SafeHarbourGroupOverviewDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfSafeHarbourGroupOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SafeHarbourGroupOverviewDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfSafeHarbourGroupOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSafeHarbourGroupOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfSafeHarbourGroupOverviewDto {
    items: SafeHarbourGroupOverviewDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfSubmissionProcessStateHistoryOverviewDto implements IPagedResultDtoOfSubmissionProcessStateHistoryOverviewDto {
    items!: SubmissionProcessStateHistoryOverviewDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfSubmissionProcessStateHistoryOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SubmissionProcessStateHistoryOverviewDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfSubmissionProcessStateHistoryOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSubmissionProcessStateHistoryOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfSubmissionProcessStateHistoryOverviewDto {
    items: SubmissionProcessStateHistoryOverviewDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfTopUpTaxAssignmentDto implements IPagedResultDtoOfTopUpTaxAssignmentDto {
    items!: TopUpTaxAssignmentDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfTopUpTaxAssignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TopUpTaxAssignmentDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfTopUpTaxAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTopUpTaxAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfTopUpTaxAssignmentDto {
    items: TopUpTaxAssignmentDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfUtprJurisdictionOverviewDto implements IPagedResultDtoOfUtprJurisdictionOverviewDto {
    items!: UtprJurisdictionOverviewDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfUtprJurisdictionOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UtprJurisdictionOverviewDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfUtprJurisdictionOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUtprJurisdictionOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfUtprJurisdictionOverviewDto {
    items: UtprJurisdictionOverviewDto[] | undefined;
    totalCount: number;
}

export enum PermanentSafeHarbourType {
    DeMinimisTest = 1,
    EtrTest = 2,
    RoutineProfitTest = 3,
}

export class Pillar2AdminSettingsDto implements IPillar2AdminSettingsDto {
    isAccessRestriction!: boolean;
    chancelleryViewAdminSettings!: ChancelleryViewAdminSettings | undefined;
    isCreateSubmission!: boolean;
    isEditSubmission!: boolean;
    isSubmitSubmission!: boolean;
    isReviewSubmission!: boolean;
    isAdditionalForReviewSubmission!: boolean;
    isReviewSubmissionFourEyes!: boolean;
    isSpecialPermission!: boolean;
    dueDateFirstReminder!: number;
    dueDateHasExceeded!: boolean;
    dueDateFirstReminderActive!: boolean;

    constructor(data?: IPillar2AdminSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAccessRestriction = _data["isAccessRestriction"];
            this.chancelleryViewAdminSettings = _data["chancelleryViewAdminSettings"] ? ChancelleryViewAdminSettings.fromJS(_data["chancelleryViewAdminSettings"]) : <any>undefined;
            this.isCreateSubmission = _data["isCreateSubmission"];
            this.isEditSubmission = _data["isEditSubmission"];
            this.isSubmitSubmission = _data["isSubmitSubmission"];
            this.isReviewSubmission = _data["isReviewSubmission"];
            this.isAdditionalForReviewSubmission = _data["isAdditionalForReviewSubmission"];
            this.isReviewSubmissionFourEyes = _data["isReviewSubmissionFourEyes"];
            this.isSpecialPermission = _data["isSpecialPermission"];
            this.dueDateFirstReminder = _data["dueDateFirstReminder"];
            this.dueDateHasExceeded = _data["dueDateHasExceeded"];
            this.dueDateFirstReminderActive = _data["dueDateFirstReminderActive"];
        }
    }

    static fromJS(data: any): Pillar2AdminSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new Pillar2AdminSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAccessRestriction"] = this.isAccessRestriction;
        data["chancelleryViewAdminSettings"] = this.chancelleryViewAdminSettings ? this.chancelleryViewAdminSettings.toJSON() : <any>undefined;
        data["isCreateSubmission"] = this.isCreateSubmission;
        data["isEditSubmission"] = this.isEditSubmission;
        data["isSubmitSubmission"] = this.isSubmitSubmission;
        data["isReviewSubmission"] = this.isReviewSubmission;
        data["isAdditionalForReviewSubmission"] = this.isAdditionalForReviewSubmission;
        data["isReviewSubmissionFourEyes"] = this.isReviewSubmissionFourEyes;
        data["isSpecialPermission"] = this.isSpecialPermission;
        data["dueDateFirstReminder"] = this.dueDateFirstReminder;
        data["dueDateHasExceeded"] = this.dueDateHasExceeded;
        data["dueDateFirstReminderActive"] = this.dueDateFirstReminderActive;
        return data;
    }
}

export interface IPillar2AdminSettingsDto {
    isAccessRestriction: boolean;
    chancelleryViewAdminSettings: ChancelleryViewAdminSettings | undefined;
    isCreateSubmission: boolean;
    isEditSubmission: boolean;
    isSubmitSubmission: boolean;
    isReviewSubmission: boolean;
    isAdditionalForReviewSubmission: boolean;
    isReviewSubmissionFourEyes: boolean;
    isSpecialPermission: boolean;
    dueDateFirstReminder: number;
    dueDateHasExceeded: boolean;
    dueDateFirstReminderActive: boolean;
}

export class Pillar2AdminSettingsInput implements IPillar2AdminSettingsInput {
    isAccessRestriction!: boolean;
    chancelleryViewAdminSettings!: ChancelleryViewAdminSettings | undefined;
    isCreateSubmission!: boolean;
    isEditSubmission!: boolean;
    isSubmitSubmission!: boolean;
    isReviewSubmission!: boolean;
    isReviewSubmissionFourEyes!: boolean;
    isAdditionalForReviewSubmission!: boolean;
    isSpecialPermission!: boolean;
    dueDateFirstReminder!: number;
    dueDateHasExceeded!: boolean;
    dueDateFirstReminderActive!: boolean;

    constructor(data?: IPillar2AdminSettingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAccessRestriction = _data["isAccessRestriction"];
            this.chancelleryViewAdminSettings = _data["chancelleryViewAdminSettings"] ? ChancelleryViewAdminSettings.fromJS(_data["chancelleryViewAdminSettings"]) : <any>undefined;
            this.isCreateSubmission = _data["isCreateSubmission"];
            this.isEditSubmission = _data["isEditSubmission"];
            this.isSubmitSubmission = _data["isSubmitSubmission"];
            this.isReviewSubmission = _data["isReviewSubmission"];
            this.isReviewSubmissionFourEyes = _data["isReviewSubmissionFourEyes"];
            this.isAdditionalForReviewSubmission = _data["isAdditionalForReviewSubmission"];
            this.isSpecialPermission = _data["isSpecialPermission"];
            this.dueDateFirstReminder = _data["dueDateFirstReminder"];
            this.dueDateHasExceeded = _data["dueDateHasExceeded"];
            this.dueDateFirstReminderActive = _data["dueDateFirstReminderActive"];
        }
    }

    static fromJS(data: any): Pillar2AdminSettingsInput {
        data = typeof data === 'object' ? data : {};
        let result = new Pillar2AdminSettingsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAccessRestriction"] = this.isAccessRestriction;
        data["chancelleryViewAdminSettings"] = this.chancelleryViewAdminSettings ? this.chancelleryViewAdminSettings.toJSON() : <any>undefined;
        data["isCreateSubmission"] = this.isCreateSubmission;
        data["isEditSubmission"] = this.isEditSubmission;
        data["isSubmitSubmission"] = this.isSubmitSubmission;
        data["isReviewSubmission"] = this.isReviewSubmission;
        data["isReviewSubmissionFourEyes"] = this.isReviewSubmissionFourEyes;
        data["isAdditionalForReviewSubmission"] = this.isAdditionalForReviewSubmission;
        data["isSpecialPermission"] = this.isSpecialPermission;
        data["dueDateFirstReminder"] = this.dueDateFirstReminder;
        data["dueDateHasExceeded"] = this.dueDateHasExceeded;
        data["dueDateFirstReminderActive"] = this.dueDateFirstReminderActive;
        return data;
    }
}

export interface IPillar2AdminSettingsInput {
    isAccessRestriction: boolean;
    chancelleryViewAdminSettings: ChancelleryViewAdminSettings | undefined;
    isCreateSubmission: boolean;
    isEditSubmission: boolean;
    isSubmitSubmission: boolean;
    isReviewSubmission: boolean;
    isReviewSubmissionFourEyes: boolean;
    isAdditionalForReviewSubmission: boolean;
    isSpecialPermission: boolean;
    dueDateFirstReminder: number;
    dueDateHasExceeded: boolean;
    dueDateFirstReminderActive: boolean;
}

export enum Priority {
    One = 1,
    Two = 2,
    Three = 3,
    Four = 4,
}

export class ProcessDto implements IProcessDto {
    stateType!: string | undefined;
    name!: string | undefined;

    constructor(data?: IProcessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stateType = _data["stateType"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ProcessDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stateType"] = this.stateType;
        data["name"] = this.name;
        return data;
    }
}

export interface IProcessDto {
    stateType: string | undefined;
    name: string | undefined;
}

export class ProcessStateGroupedDto implements IProcessStateGroupedDto {
    processGroup!: string | undefined;
    processStates!: string[] | undefined;

    constructor(data?: IProcessStateGroupedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.processGroup = _data["processGroup"];
            if (Array.isArray(_data["processStates"])) {
                this.processStates = [] as any;
                for (let item of _data["processStates"])
                    this.processStates!.push(item);
            }
        }
    }

    static fromJS(data: any): ProcessStateGroupedDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessStateGroupedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processGroup"] = this.processGroup;
        if (Array.isArray(this.processStates)) {
            data["processStates"] = [];
            for (let item of this.processStates)
                data["processStates"].push(item);
        }
        return data;
    }
}

export interface IProcessStateGroupedDto {
    processGroup: string | undefined;
    processStates: string[] | undefined;
}

export class ProjectAccessAndPermissionDto implements IProjectAccessAndPermissionDto {
    accessRestrictionPossibleUsers!: UserOrOrganizationUnitDto[] | undefined;
    selectedAccessRestrictionPossibleUsers!: UserOrOrganizationUnitDto[] | undefined;
    isAccessRestrictionActive!: boolean;
    customPermissions!: EntityPermissionDto[] | undefined;
    isWorkflowReviewFourEyes!: boolean;
    isReviewDataPreparation!: boolean;
    isReviewDataPreparationFourEyes!: boolean;
    isReviewMapping!: boolean;
    isReviewMappingFourEyes!: boolean;
    isSpecialPermissionActive!: boolean;

    constructor(data?: IProjectAccessAndPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accessRestrictionPossibleUsers"])) {
                this.accessRestrictionPossibleUsers = [] as any;
                for (let item of _data["accessRestrictionPossibleUsers"])
                    this.accessRestrictionPossibleUsers!.push(UserOrOrganizationUnitDto.fromJS(item));
            }
            if (Array.isArray(_data["selectedAccessRestrictionPossibleUsers"])) {
                this.selectedAccessRestrictionPossibleUsers = [] as any;
                for (let item of _data["selectedAccessRestrictionPossibleUsers"])
                    this.selectedAccessRestrictionPossibleUsers!.push(UserOrOrganizationUnitDto.fromJS(item));
            }
            this.isAccessRestrictionActive = _data["isAccessRestrictionActive"];
            if (Array.isArray(_data["customPermissions"])) {
                this.customPermissions = [] as any;
                for (let item of _data["customPermissions"])
                    this.customPermissions!.push(EntityPermissionDto.fromJS(item));
            }
            this.isWorkflowReviewFourEyes = _data["isWorkflowReviewFourEyes"];
            this.isReviewDataPreparation = _data["isReviewDataPreparation"];
            this.isReviewDataPreparationFourEyes = _data["isReviewDataPreparationFourEyes"];
            this.isReviewMapping = _data["isReviewMapping"];
            this.isReviewMappingFourEyes = _data["isReviewMappingFourEyes"];
            this.isSpecialPermissionActive = _data["isSpecialPermissionActive"];
        }
    }

    static fromJS(data: any): ProjectAccessAndPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectAccessAndPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accessRestrictionPossibleUsers)) {
            data["accessRestrictionPossibleUsers"] = [];
            for (let item of this.accessRestrictionPossibleUsers)
                data["accessRestrictionPossibleUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.selectedAccessRestrictionPossibleUsers)) {
            data["selectedAccessRestrictionPossibleUsers"] = [];
            for (let item of this.selectedAccessRestrictionPossibleUsers)
                data["selectedAccessRestrictionPossibleUsers"].push(item.toJSON());
        }
        data["isAccessRestrictionActive"] = this.isAccessRestrictionActive;
        if (Array.isArray(this.customPermissions)) {
            data["customPermissions"] = [];
            for (let item of this.customPermissions)
                data["customPermissions"].push(item.toJSON());
        }
        data["isWorkflowReviewFourEyes"] = this.isWorkflowReviewFourEyes;
        data["isReviewDataPreparation"] = this.isReviewDataPreparation;
        data["isReviewDataPreparationFourEyes"] = this.isReviewDataPreparationFourEyes;
        data["isReviewMapping"] = this.isReviewMapping;
        data["isReviewMappingFourEyes"] = this.isReviewMappingFourEyes;
        data["isSpecialPermissionActive"] = this.isSpecialPermissionActive;
        return data;
    }
}

export interface IProjectAccessAndPermissionDto {
    accessRestrictionPossibleUsers: UserOrOrganizationUnitDto[] | undefined;
    selectedAccessRestrictionPossibleUsers: UserOrOrganizationUnitDto[] | undefined;
    isAccessRestrictionActive: boolean;
    customPermissions: EntityPermissionDto[] | undefined;
    isWorkflowReviewFourEyes: boolean;
    isReviewDataPreparation: boolean;
    isReviewDataPreparationFourEyes: boolean;
    isReviewMapping: boolean;
    isReviewMappingFourEyes: boolean;
    isSpecialPermissionActive: boolean;
}

export class ProjectAccessAndPermissionInput implements IProjectAccessAndPermissionInput {
    accessRestriction!: CustomGrantsForPermissionInput | undefined;
    customPermissions!: CustomGrantsForPermissionInput[] | undefined;

    constructor(data?: IProjectAccessAndPermissionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessRestriction = _data["accessRestriction"] ? CustomGrantsForPermissionInput.fromJS(_data["accessRestriction"]) : <any>undefined;
            if (Array.isArray(_data["customPermissions"])) {
                this.customPermissions = [] as any;
                for (let item of _data["customPermissions"])
                    this.customPermissions!.push(CustomGrantsForPermissionInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectAccessAndPermissionInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectAccessAndPermissionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessRestriction"] = this.accessRestriction ? this.accessRestriction.toJSON() : <any>undefined;
        if (Array.isArray(this.customPermissions)) {
            data["customPermissions"] = [];
            for (let item of this.customPermissions)
                data["customPermissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectAccessAndPermissionInput {
    accessRestriction: CustomGrantsForPermissionInput | undefined;
    customPermissions: CustomGrantsForPermissionInput[] | undefined;
}

export class ProjectAccessRestrictedUsersDto implements IProjectAccessRestrictedUsersDto {
    userOrOrganizations!: UserOrOrganizationUnitDto[] | undefined;
    isAccessRestrictionActive!: boolean;

    constructor(data?: IProjectAccessRestrictedUsersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userOrOrganizations"])) {
                this.userOrOrganizations = [] as any;
                for (let item of _data["userOrOrganizations"])
                    this.userOrOrganizations!.push(UserOrOrganizationUnitDto.fromJS(item));
            }
            this.isAccessRestrictionActive = _data["isAccessRestrictionActive"];
        }
    }

    static fromJS(data: any): ProjectAccessRestrictedUsersDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectAccessRestrictedUsersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userOrOrganizations)) {
            data["userOrOrganizations"] = [];
            for (let item of this.userOrOrganizations)
                data["userOrOrganizations"].push(item.toJSON());
        }
        data["isAccessRestrictionActive"] = this.isAccessRestrictionActive;
        return data;
    }
}

export interface IProjectAccessRestrictedUsersDto {
    userOrOrganizations: UserOrOrganizationUnitDto[] | undefined;
    isAccessRestrictionActive: boolean;
}

export class ProjectCurrencyRateOverviewDto implements IProjectCurrencyRateOverviewDto {
    sourceCurrency!: string | undefined;
    targetCurrency!: string | undefined;
    currencyPairs!: ProjectCurrencyRatePairDto[] | undefined;

    constructor(data?: IProjectCurrencyRateOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceCurrency = _data["sourceCurrency"];
            this.targetCurrency = _data["targetCurrency"];
            if (Array.isArray(_data["currencyPairs"])) {
                this.currencyPairs = [] as any;
                for (let item of _data["currencyPairs"])
                    this.currencyPairs!.push(ProjectCurrencyRatePairDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectCurrencyRateOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectCurrencyRateOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceCurrency"] = this.sourceCurrency;
        data["targetCurrency"] = this.targetCurrency;
        if (Array.isArray(this.currencyPairs)) {
            data["currencyPairs"] = [];
            for (let item of this.currencyPairs)
                data["currencyPairs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectCurrencyRateOverviewDto {
    sourceCurrency: string | undefined;
    targetCurrency: string | undefined;
    currencyPairs: ProjectCurrencyRatePairDto[] | undefined;
}

export class ProjectCurrencyRatePairDto implements IProjectCurrencyRatePairDto {
    id!: number;
    rate!: ConfirmableDtoOfString | undefined;
    currencyRateType!: ProjectCurrencyRateType;
    comment!: string | undefined;
    notes!: string | undefined;
    currencyRateInfo!: string | undefined;

    constructor(data?: IProjectCurrencyRatePairDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rate = _data["rate"] ? ConfirmableDtoOfString.fromJS(_data["rate"]) : <any>undefined;
            this.currencyRateType = _data["currencyRateType"];
            this.comment = _data["comment"];
            this.notes = _data["notes"];
            this.currencyRateInfo = _data["currencyRateInfo"];
        }
    }

    static fromJS(data: any): ProjectCurrencyRatePairDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectCurrencyRatePairDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rate"] = this.rate ? this.rate.toJSON() : <any>undefined;
        data["currencyRateType"] = this.currencyRateType;
        data["comment"] = this.comment;
        data["notes"] = this.notes;
        data["currencyRateInfo"] = this.currencyRateInfo;
        return data;
    }
}

export interface IProjectCurrencyRatePairDto {
    id: number;
    rate: ConfirmableDtoOfString | undefined;
    currencyRateType: ProjectCurrencyRateType;
    comment: string | undefined;
    notes: string | undefined;
    currencyRateInfo: string | undefined;
}

export enum ProjectCurrencyRateType {
    AverageFiscalYear = 1,
    SpotRateFirstDayFiscalYear = 2,
    SpotRateLastDayFiscalYear = 3,
    AverageDecemberBeforeFiscalYear = 4,
}

export class ProjectDataExcelExportInput implements IProjectDataExcelExportInput {
    templateType!: ProjectTemplateType;
    scopingType!: ProjectScopingDataType;
    projectId!: number;
    safeHarbourGroupDataType!: ProjectSafeHarbourGroupDataType;
    financialTreeType!: FinancialTreeType;

    constructor(data?: IProjectDataExcelExportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateType = _data["templateType"];
            this.scopingType = _data["scopingType"];
            this.projectId = _data["projectId"];
            this.safeHarbourGroupDataType = _data["safeHarbourGroupDataType"];
            this.financialTreeType = _data["financialTreeType"];
        }
    }

    static fromJS(data: any): ProjectDataExcelExportInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDataExcelExportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateType"] = this.templateType;
        data["scopingType"] = this.scopingType;
        data["projectId"] = this.projectId;
        data["safeHarbourGroupDataType"] = this.safeHarbourGroupDataType;
        data["financialTreeType"] = this.financialTreeType;
        return data;
    }
}

export interface IProjectDataExcelExportInput {
    templateType: ProjectTemplateType;
    scopingType: ProjectScopingDataType;
    projectId: number;
    safeHarbourGroupDataType: ProjectSafeHarbourGroupDataType;
    financialTreeType: FinancialTreeType;
}

export class ProjectDto implements IProjectDto {
    id!: number;
    general!: GeneralDto | undefined;
    accessAndPermission!: ProjectAccessAndPermissionDto | undefined;
    projectManagement!: FullProjectManagementDto | undefined;
    specifics!: ProjectSpecificDto | undefined;
    permissions!: string[] | undefined;
    templateDescription!: string | undefined;
    comment!: string | undefined;

    constructor(data?: IProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.general = _data["general"] ? GeneralDto.fromJS(_data["general"]) : <any>undefined;
            this.accessAndPermission = _data["accessAndPermission"] ? ProjectAccessAndPermissionDto.fromJS(_data["accessAndPermission"]) : <any>undefined;
            this.projectManagement = _data["projectManagement"] ? FullProjectManagementDto.fromJS(_data["projectManagement"]) : <any>undefined;
            this.specifics = _data["specifics"] ? ProjectSpecificDto.fromJS(_data["specifics"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            this.templateDescription = _data["templateDescription"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): ProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["accessAndPermission"] = this.accessAndPermission ? this.accessAndPermission.toJSON() : <any>undefined;
        data["projectManagement"] = this.projectManagement ? this.projectManagement.toJSON() : <any>undefined;
        data["specifics"] = this.specifics ? this.specifics.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["templateDescription"] = this.templateDescription;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IProjectDto {
    id: number;
    general: GeneralDto | undefined;
    accessAndPermission: ProjectAccessAndPermissionDto | undefined;
    projectManagement: FullProjectManagementDto | undefined;
    specifics: ProjectSpecificDto | undefined;
    permissions: string[] | undefined;
    templateDescription: string | undefined;
    comment: string | undefined;
}

export enum ProjectImportType {
    Unknown = 0,
    EntityJurisdictionImport = 1,
    FullScopeImport = 2,
    CurrenciesData = 3,
    JurisdictionsData = 4,
    JurisdictionsElectionsData = 5,
    OrganizationalEntityElectionsData = 6,
}

export class ProjectNotificationOverviewDto implements IProjectNotificationOverviewDto {
    notificationReportId!: number;
    type!: NotificationType;
    datapointType!: NotificationDataPointType;
    datapointTypeLocalizationArgs!: string | undefined;
    area!: NotificationArea;
    quickLink!: NotificationQuickLink;
    datapointId!: number;
    additionalInfo!: string | undefined;
    message!: string | undefined;
    messageArgs!: string | undefined;
    financialTreeType!: FinancialTreeType | undefined;

    constructor(data?: IProjectNotificationOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationReportId = _data["notificationReportId"];
            this.type = _data["type"];
            this.datapointType = _data["datapointType"];
            this.datapointTypeLocalizationArgs = _data["datapointTypeLocalizationArgs"];
            this.area = _data["area"];
            this.quickLink = _data["quickLink"];
            this.datapointId = _data["datapointId"];
            this.additionalInfo = _data["additionalInfo"];
            this.message = _data["message"];
            this.messageArgs = _data["messageArgs"];
            this.financialTreeType = _data["financialTreeType"];
        }
    }

    static fromJS(data: any): ProjectNotificationOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectNotificationOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationReportId"] = this.notificationReportId;
        data["type"] = this.type;
        data["datapointType"] = this.datapointType;
        data["datapointTypeLocalizationArgs"] = this.datapointTypeLocalizationArgs;
        data["area"] = this.area;
        data["quickLink"] = this.quickLink;
        data["datapointId"] = this.datapointId;
        data["additionalInfo"] = this.additionalInfo;
        data["message"] = this.message;
        data["messageArgs"] = this.messageArgs;
        data["financialTreeType"] = this.financialTreeType;
        return data;
    }
}

export interface IProjectNotificationOverviewDto {
    notificationReportId: number;
    type: NotificationType;
    datapointType: NotificationDataPointType;
    datapointTypeLocalizationArgs: string | undefined;
    area: NotificationArea;
    quickLink: NotificationQuickLink;
    datapointId: number;
    additionalInfo: string | undefined;
    message: string | undefined;
    messageArgs: string | undefined;
    financialTreeType: FinancialTreeType | undefined;
}

export class ProjectOverviewDto implements IProjectOverviewDto {
    id!: number;
    fiscalYearPeriod!: DateTime[] | undefined;
    groupName!: string | undefined;
    name!: string | undefined;
    creationDate!: DateTime;
    assignedUser!: AssignableUserDto | undefined;
    tags!: TagDto[] | undefined;
    permissions!: string[] | undefined;
    isAccessRestrictionActive!: boolean;
    lastModifier!: string | undefined;
    lastModifierUserId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    chancelleryDetails!: ChancelleryDetailsDto | undefined;

    constructor(data?: IProjectOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["fiscalYearPeriod"])) {
                this.fiscalYearPeriod = [] as any;
                for (let item of _data["fiscalYearPeriod"])
                    this.fiscalYearPeriod!.push(DateTime.fromISO(item));
            }
            this.groupName = _data["groupName"];
            this.name = _data["name"];
            this.creationDate = _data["creationDate"] ? DateTime.fromISO(_data["creationDate"].toString()) : <any>undefined;
            this.assignedUser = _data["assignedUser"] ? AssignableUserDto.fromJS(_data["assignedUser"]) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            this.isAccessRestrictionActive = _data["isAccessRestrictionActive"];
            this.lastModifier = _data["lastModifier"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.chancelleryDetails = _data["chancelleryDetails"] ? ChancelleryDetailsDto.fromJS(_data["chancelleryDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProjectOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.fiscalYearPeriod)) {
            data["fiscalYearPeriod"] = [];
            for (let item of this.fiscalYearPeriod)
                data["fiscalYearPeriod"].push(item.toString());
        }
        data["groupName"] = this.groupName;
        data["name"] = this.name;
        data["creationDate"] = this.creationDate ? this.creationDate.toString() : <any>undefined;
        data["assignedUser"] = this.assignedUser ? this.assignedUser.toJSON() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["isAccessRestrictionActive"] = this.isAccessRestrictionActive;
        data["lastModifier"] = this.lastModifier;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["chancelleryDetails"] = this.chancelleryDetails ? this.chancelleryDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProjectOverviewDto {
    id: number;
    fiscalYearPeriod: DateTime[] | undefined;
    groupName: string | undefined;
    name: string | undefined;
    creationDate: DateTime;
    assignedUser: AssignableUserDto | undefined;
    tags: TagDto[] | undefined;
    permissions: string[] | undefined;
    isAccessRestrictionActive: boolean;
    lastModifier: string | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: DateTime | undefined;
    chancelleryDetails: ChancelleryDetailsDto | undefined;
}

export class ProjectReferenceChannelDto implements IProjectReferenceChannelDto {
    title!: string | undefined;
    communications!: ProjectReferenceCommentsDto[] | undefined;

    constructor(data?: IProjectReferenceChannelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            if (Array.isArray(_data["communications"])) {
                this.communications = [] as any;
                for (let item of _data["communications"])
                    this.communications!.push(ProjectReferenceCommentsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectReferenceChannelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectReferenceChannelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        if (Array.isArray(this.communications)) {
            data["communications"] = [];
            for (let item of this.communications)
                data["communications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectReferenceChannelDto {
    title: string | undefined;
    communications: ProjectReferenceCommentsDto[] | undefined;
}

export class ProjectReferenceCommentsDto implements IProjectReferenceCommentsDto {
    creatorUserId!: number | undefined;
    creationTime!: DateTime;
    content!: string | undefined;
    userDetails!: UserDetailsDto[] | undefined;

    constructor(data?: IProjectReferenceCommentsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.content = _data["content"];
            if (Array.isArray(_data["userDetails"])) {
                this.userDetails = [] as any;
                for (let item of _data["userDetails"])
                    this.userDetails!.push(UserDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectReferenceCommentsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectReferenceCommentsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["content"] = this.content;
        if (Array.isArray(this.userDetails)) {
            data["userDetails"] = [];
            for (let item of this.userDetails)
                data["userDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectReferenceCommentsDto {
    creatorUserId: number | undefined;
    creationTime: DateTime;
    content: string | undefined;
    userDetails: UserDetailsDto[] | undefined;
}

export enum ProjectReportType {
    SafeHarbourReport = 0,
    TopUpTaxReport = 1,
    TaxReturnSummaryReport = 2,
}

export enum ProjectSafeHarbourGroupDataType {
    EnteredData = 1,
    EnteredDataAndAutomaticallyCalculatedSums = 2,
}

export enum ProjectScopingDataType {
    EntireImportExport = 1,
    EntitiesOnly = 2,
    FinancialDataOnly = 3,
}

export class ProjectSpecificDto implements IProjectSpecificDto {
    groupName!: string | undefined;
    engagementLetterDated!: DateTime | undefined;
    fiscalYearPeriod!: DateTime[] | undefined;
    globeRulesApplicableAsOf!: number | undefined;
    currency!: string | undefined;
    chancelleryDetails!: ChancelleryDetailsDto | undefined;
    isSpecialPermissionActive!: boolean;
    consolidatedFinancialStatements!: ConsolidatedFinancialStatementsDto | undefined;
    financialAccountingStandard!: string | undefined;
    initialPhaseDetails!: InitialPhaseDetailsDto | undefined;
    isFrenchSbieMarkupExceptionActive!: boolean;

    constructor(data?: IProjectSpecificDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupName = _data["groupName"];
            this.engagementLetterDated = _data["engagementLetterDated"] ? DateTime.fromISO(_data["engagementLetterDated"].toString()) : <any>undefined;
            if (Array.isArray(_data["fiscalYearPeriod"])) {
                this.fiscalYearPeriod = [] as any;
                for (let item of _data["fiscalYearPeriod"])
                    this.fiscalYearPeriod!.push(DateTime.fromISO(item));
            }
            this.globeRulesApplicableAsOf = _data["globeRulesApplicableAsOf"];
            this.currency = _data["currency"];
            this.chancelleryDetails = _data["chancelleryDetails"] ? ChancelleryDetailsDto.fromJS(_data["chancelleryDetails"]) : <any>undefined;
            this.isSpecialPermissionActive = _data["isSpecialPermissionActive"];
            this.consolidatedFinancialStatements = _data["consolidatedFinancialStatements"];
            this.financialAccountingStandard = _data["financialAccountingStandard"];
            this.initialPhaseDetails = _data["initialPhaseDetails"] ? InitialPhaseDetailsDto.fromJS(_data["initialPhaseDetails"]) : <any>undefined;
            this.isFrenchSbieMarkupExceptionActive = _data["isFrenchSbieMarkupExceptionActive"];
        }
    }

    static fromJS(data: any): ProjectSpecificDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectSpecificDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupName"] = this.groupName;
        data["engagementLetterDated"] = this.engagementLetterDated ? this.engagementLetterDated.toString() : <any>undefined;
        if (Array.isArray(this.fiscalYearPeriod)) {
            data["fiscalYearPeriod"] = [];
            for (let item of this.fiscalYearPeriod)
                data["fiscalYearPeriod"].push(item.toString());
        }
        data["globeRulesApplicableAsOf"] = this.globeRulesApplicableAsOf;
        data["currency"] = this.currency;
        data["chancelleryDetails"] = this.chancelleryDetails ? this.chancelleryDetails.toJSON() : <any>undefined;
        data["isSpecialPermissionActive"] = this.isSpecialPermissionActive;
        data["consolidatedFinancialStatements"] = this.consolidatedFinancialStatements;
        data["financialAccountingStandard"] = this.financialAccountingStandard;
        data["initialPhaseDetails"] = this.initialPhaseDetails ? this.initialPhaseDetails.toJSON() : <any>undefined;
        data["isFrenchSbieMarkupExceptionActive"] = this.isFrenchSbieMarkupExceptionActive;
        return data;
    }
}

export interface IProjectSpecificDto {
    groupName: string | undefined;
    engagementLetterDated: DateTime | undefined;
    fiscalYearPeriod: DateTime[] | undefined;
    globeRulesApplicableAsOf: number | undefined;
    currency: string | undefined;
    chancelleryDetails: ChancelleryDetailsDto | undefined;
    isSpecialPermissionActive: boolean;
    consolidatedFinancialStatements: ConsolidatedFinancialStatementsDto | undefined;
    financialAccountingStandard: string | undefined;
    initialPhaseDetails: InitialPhaseDetailsDto | undefined;
    isFrenchSbieMarkupExceptionActive: boolean;
}

export class ProjectSpecificInput implements IProjectSpecificInput {
    groupName!: string | undefined;
    fiscalYearPeriod!: DateTime[] | undefined;
    engagementLetterDated!: DateTime | undefined;
    globeRulesApplicableAsOf!: number | undefined;
    currency!: string | undefined;
    chancelleryDetails!: ChancelleryDetailsInput | undefined;
    consolidatedFinancialStatements!: ConsolidatedFinancialStatementsDto;
    financialAccountingStandard!: string | undefined;
    initialPhaseDetails!: InitialPhaseDetailsInput | undefined;
    isFrenchSbieMarkupExceptionActive!: boolean;

    constructor(data?: IProjectSpecificInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupName = _data["groupName"];
            if (Array.isArray(_data["fiscalYearPeriod"])) {
                this.fiscalYearPeriod = [] as any;
                for (let item of _data["fiscalYearPeriod"])
                    this.fiscalYearPeriod!.push(DateTime.fromISO(item));
            }
            this.engagementLetterDated = _data["engagementLetterDated"] ? DateTime.fromISO(_data["engagementLetterDated"].toString()) : <any>undefined;
            this.globeRulesApplicableAsOf = _data["globeRulesApplicableAsOf"];
            this.currency = _data["currency"];
            this.chancelleryDetails = _data["chancelleryDetails"] ? ChancelleryDetailsInput.fromJS(_data["chancelleryDetails"]) : <any>undefined;
            this.consolidatedFinancialStatements = _data["consolidatedFinancialStatements"];
            this.financialAccountingStandard = _data["financialAccountingStandard"];
            this.initialPhaseDetails = _data["initialPhaseDetails"] ? InitialPhaseDetailsInput.fromJS(_data["initialPhaseDetails"]) : <any>undefined;
            this.isFrenchSbieMarkupExceptionActive = _data["isFrenchSbieMarkupExceptionActive"];
        }
    }

    static fromJS(data: any): ProjectSpecificInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectSpecificInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupName"] = this.groupName;
        if (Array.isArray(this.fiscalYearPeriod)) {
            data["fiscalYearPeriod"] = [];
            for (let item of this.fiscalYearPeriod)
                data["fiscalYearPeriod"].push(item.toString());
        }
        data["engagementLetterDated"] = this.engagementLetterDated ? this.engagementLetterDated.toString() : <any>undefined;
        data["globeRulesApplicableAsOf"] = this.globeRulesApplicableAsOf;
        data["currency"] = this.currency;
        data["chancelleryDetails"] = this.chancelleryDetails ? this.chancelleryDetails.toJSON() : <any>undefined;
        data["consolidatedFinancialStatements"] = this.consolidatedFinancialStatements;
        data["financialAccountingStandard"] = this.financialAccountingStandard;
        data["initialPhaseDetails"] = this.initialPhaseDetails ? this.initialPhaseDetails.toJSON() : <any>undefined;
        data["isFrenchSbieMarkupExceptionActive"] = this.isFrenchSbieMarkupExceptionActive;
        return data;
    }
}

export interface IProjectSpecificInput {
    groupName: string | undefined;
    fiscalYearPeriod: DateTime[] | undefined;
    engagementLetterDated: DateTime | undefined;
    globeRulesApplicableAsOf: number | undefined;
    currency: string | undefined;
    chancelleryDetails: ChancelleryDetailsInput | undefined;
    consolidatedFinancialStatements: ConsolidatedFinancialStatementsDto;
    financialAccountingStandard: string | undefined;
    initialPhaseDetails: InitialPhaseDetailsInput | undefined;
    isFrenchSbieMarkupExceptionActive: boolean;
}

export enum ProjectTemplateType {
    ScopingData = 0,
    JurisdictionsData = 1,
    SafeHarbourGroupData = 2,
    FullScopeData = 3,
    CurrenciesData = 4,
    JurisdictionsElectionsData = 5,
    OrganizationalEntityElectionsData = 6,
}

export class ProjectUserSettingsDto implements IProjectUserSettingsDto {
    viewUnconfirmed!: boolean;
    viewConfirmed!: boolean;
    hideEmptyFilingObligations!: boolean;

    constructor(data?: IProjectUserSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.viewUnconfirmed = _data["viewUnconfirmed"];
            this.viewConfirmed = _data["viewConfirmed"];
            this.hideEmptyFilingObligations = _data["hideEmptyFilingObligations"];
        }
    }

    static fromJS(data: any): ProjectUserSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectUserSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["viewUnconfirmed"] = this.viewUnconfirmed;
        data["viewConfirmed"] = this.viewConfirmed;
        data["hideEmptyFilingObligations"] = this.hideEmptyFilingObligations;
        return data;
    }
}

export interface IProjectUserSettingsDto {
    viewUnconfirmed: boolean;
    viewConfirmed: boolean;
    hideEmptyFilingObligations: boolean;
}

export class ProjectWidgetDto implements IProjectWidgetDto {
    safeHarbourChecks!: SafeHarbourChecksDto | undefined;
    scopingStatus!: ScopingStatusDto | undefined;
    worldMap!: FinancialDataSafeHarbourGroupOverviewDto[] | undefined;

    constructor(data?: IProjectWidgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.safeHarbourChecks = _data["safeHarbourChecks"] ? SafeHarbourChecksDto.fromJS(_data["safeHarbourChecks"]) : <any>undefined;
            this.scopingStatus = _data["scopingStatus"] ? ScopingStatusDto.fromJS(_data["scopingStatus"]) : <any>undefined;
            if (Array.isArray(_data["worldMap"])) {
                this.worldMap = [] as any;
                for (let item of _data["worldMap"])
                    this.worldMap!.push(FinancialDataSafeHarbourGroupOverviewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectWidgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectWidgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["safeHarbourChecks"] = this.safeHarbourChecks ? this.safeHarbourChecks.toJSON() : <any>undefined;
        data["scopingStatus"] = this.scopingStatus ? this.scopingStatus.toJSON() : <any>undefined;
        if (Array.isArray(this.worldMap)) {
            data["worldMap"] = [];
            for (let item of this.worldMap)
                data["worldMap"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectWidgetDto {
    safeHarbourChecks: SafeHarbourChecksDto | undefined;
    scopingStatus: ScopingStatusDto | undefined;
    worldMap: FinancialDataSafeHarbourGroupOverviewDto[] | undefined;
}

export class ReadonlyRulesDto implements IReadonlyRulesDto {
    isOpenable!: boolean;
    isQuickConfirmable!: boolean;

    constructor(data?: IReadonlyRulesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isOpenable = _data["isOpenable"];
            this.isQuickConfirmable = _data["isQuickConfirmable"];
        }
    }

    static fromJS(data: any): ReadonlyRulesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReadonlyRulesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isOpenable"] = this.isOpenable;
        data["isQuickConfirmable"] = this.isQuickConfirmable;
        return data;
    }
}

export interface IReadonlyRulesDto {
    isOpenable: boolean;
    isQuickConfirmable: boolean;
}

export class RecaptureDeferredDataDto implements IRecaptureDeferredDataDto {
    dtlrFyMinus5!: number | undefined;
    recapDtlrFyMinus5!: number | undefined;
    dtlrFy!: number | undefined;
    reportingFyAmountPreTransition!: number | undefined;
    reportingFyAmountOutBalance!: number | undefined;
    reportingFyAmountUnjustified!: number | undefined;
    priorFyAmountPreTransition!: number | undefined;
    priorFyAmountOutBalance!: number | undefined;
    priorFyAmountUnjustified!: number | undefined;

    constructor(data?: IRecaptureDeferredDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dtlrFyMinus5 = _data["dtlrFyMinus5"];
            this.recapDtlrFyMinus5 = _data["recapDtlrFyMinus5"];
            this.dtlrFy = _data["dtlrFy"];
            this.reportingFyAmountPreTransition = _data["reportingFyAmountPreTransition"];
            this.reportingFyAmountOutBalance = _data["reportingFyAmountOutBalance"];
            this.reportingFyAmountUnjustified = _data["reportingFyAmountUnjustified"];
            this.priorFyAmountPreTransition = _data["priorFyAmountPreTransition"];
            this.priorFyAmountOutBalance = _data["priorFyAmountOutBalance"];
            this.priorFyAmountUnjustified = _data["priorFyAmountUnjustified"];
        }
    }

    static fromJS(data: any): RecaptureDeferredDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecaptureDeferredDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dtlrFyMinus5"] = this.dtlrFyMinus5;
        data["recapDtlrFyMinus5"] = this.recapDtlrFyMinus5;
        data["dtlrFy"] = this.dtlrFy;
        data["reportingFyAmountPreTransition"] = this.reportingFyAmountPreTransition;
        data["reportingFyAmountOutBalance"] = this.reportingFyAmountOutBalance;
        data["reportingFyAmountUnjustified"] = this.reportingFyAmountUnjustified;
        data["priorFyAmountPreTransition"] = this.priorFyAmountPreTransition;
        data["priorFyAmountOutBalance"] = this.priorFyAmountOutBalance;
        data["priorFyAmountUnjustified"] = this.priorFyAmountUnjustified;
        return data;
    }
}

export interface IRecaptureDeferredDataDto {
    dtlrFyMinus5: number | undefined;
    recapDtlrFyMinus5: number | undefined;
    dtlrFy: number | undefined;
    reportingFyAmountPreTransition: number | undefined;
    reportingFyAmountOutBalance: number | undefined;
    reportingFyAmountUnjustified: number | undefined;
    priorFyAmountPreTransition: number | undefined;
    priorFyAmountOutBalance: number | undefined;
    priorFyAmountUnjustified: number | undefined;
}

export class RefreshProjectNotificationReportInput implements IRefreshProjectNotificationReportInput {
    projectId!: number;

    constructor(data?: IRefreshProjectNotificationReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): RefreshProjectNotificationReportInput {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshProjectNotificationReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IRefreshProjectNotificationReportInput {
    projectId: number;
}

export class ReportOverviewDto implements IReportOverviewDto {
    id!: number;
    fileName!: string | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    author!: string | undefined;

    constructor(data?: IReportOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.author = _data["author"];
        }
    }

    static fromJS(data: any): ReportOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["author"] = this.author;
        return data;
    }
}

export interface IReportOverviewDto {
    id: number;
    fileName: string | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    author: string | undefined;
}

export class RequestBlendingCircleSubgroups implements IRequestBlendingCircleSubgroups {
    projectId!: number;
    entityNumber!: ConfirmableInputOfString | undefined;
    legalName!: ConfirmableInputOfString | undefined;
    gloBEStatus!: ConfirmableInputOfIListOfGloBEStatus | undefined;
    tin!: ConfirmableInputOfString | undefined;
    tinIssuedBy!: ConfirmableInputOfString | undefined;
    typeOfTIN!: ConfirmableInputOfNullableOfTinType | undefined;
    taxJurisdictionCountry!: ConfirmableInputOfString | undefined;
    taxTreatment!: ConfirmableInputOfNullableOfTaxTreatment | undefined;
    isUpeAsFlowThrough!: ConfirmableInputOfNullableOfBoolean | undefined;
    isUpeSubjectToDeductiveDividendRegime!: ConfirmableInputOfNullableOfBoolean | undefined;
    typeOfExcluded!: ConfirmableInputOfNullableOfOrganizationalEntityExcludedType | undefined;
    notTreatingEntityAsExcludedEntity!: ConfirmableInputOfNullableOfBoolean | undefined;
    electionYear!: DateTime | undefined;
    revocationYear!: DateTime | undefined;
    isPermanentEstablishment!: ConfirmableInputOfNullableOfBoolean | undefined;
    mainEntityId!: ConfirmableInputOfNullableOfInt64 | undefined;
    taxFunctionalCurrency!: ConfirmableInputOfString | undefined;
    accountingFunctionalCurrency!: ConfirmableInputOfString | undefined;
    financialAccountingStandardOfCe!: ConfirmableInputOfString | undefined;
    consolidationMethod!: ConfirmableInputOfNullableOfConsolidationMethod | undefined;
    controllingInterestEntityId!: number | undefined;
    shareholders!: ShareholderInput | undefined;
    blendingCircleInput!: BlendingCircleInput | undefined;
    ownershipChanges!: CreateOwnershipChangeInput[] | undefined;
    corporateShareholders!: CreateCorporateShareholderInput[] | undefined;
    naturalPersonShareholders!: CreateNaturalPersonShareholderInput[] | undefined;
    organizationalEntityId!: number;
    blendingCircleTaxJurisdiction!: string | undefined;
    entityLegalName!: string | undefined;

    constructor(data?: IRequestBlendingCircleSubgroups) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.entityNumber = _data["entityNumber"] ? ConfirmableInputOfString.fromJS(_data["entityNumber"]) : <any>undefined;
            this.legalName = _data["legalName"] ? ConfirmableInputOfString.fromJS(_data["legalName"]) : <any>undefined;
            this.gloBEStatus = _data["gloBEStatus"] ? ConfirmableInputOfIListOfGloBEStatus.fromJS(_data["gloBEStatus"]) : <any>undefined;
            this.tin = _data["tin"] ? ConfirmableInputOfString.fromJS(_data["tin"]) : <any>undefined;
            this.tinIssuedBy = _data["tinIssuedBy"] ? ConfirmableInputOfString.fromJS(_data["tinIssuedBy"]) : <any>undefined;
            this.typeOfTIN = _data["typeOfTIN"] ? ConfirmableInputOfNullableOfTinType.fromJS(_data["typeOfTIN"]) : <any>undefined;
            this.taxJurisdictionCountry = _data["taxJurisdictionCountry"] ? ConfirmableInputOfString.fromJS(_data["taxJurisdictionCountry"]) : <any>undefined;
            this.taxTreatment = _data["taxTreatment"] ? ConfirmableInputOfNullableOfTaxTreatment.fromJS(_data["taxTreatment"]) : <any>undefined;
            this.isUpeAsFlowThrough = _data["isUpeAsFlowThrough"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isUpeAsFlowThrough"]) : <any>undefined;
            this.isUpeSubjectToDeductiveDividendRegime = _data["isUpeSubjectToDeductiveDividendRegime"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isUpeSubjectToDeductiveDividendRegime"]) : <any>undefined;
            this.typeOfExcluded = _data["typeOfExcluded"] ? ConfirmableInputOfNullableOfOrganizationalEntityExcludedType.fromJS(_data["typeOfExcluded"]) : <any>undefined;
            this.notTreatingEntityAsExcludedEntity = _data["notTreatingEntityAsExcludedEntity"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["notTreatingEntityAsExcludedEntity"]) : <any>undefined;
            this.electionYear = _data["electionYear"] ? DateTime.fromISO(_data["electionYear"].toString()) : <any>undefined;
            this.revocationYear = _data["revocationYear"] ? DateTime.fromISO(_data["revocationYear"].toString()) : <any>undefined;
            this.isPermanentEstablishment = _data["isPermanentEstablishment"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isPermanentEstablishment"]) : <any>undefined;
            this.mainEntityId = _data["mainEntityId"] ? ConfirmableInputOfNullableOfInt64.fromJS(_data["mainEntityId"]) : <any>undefined;
            this.taxFunctionalCurrency = _data["taxFunctionalCurrency"] ? ConfirmableInputOfString.fromJS(_data["taxFunctionalCurrency"]) : <any>undefined;
            this.accountingFunctionalCurrency = _data["accountingFunctionalCurrency"] ? ConfirmableInputOfString.fromJS(_data["accountingFunctionalCurrency"]) : <any>undefined;
            this.financialAccountingStandardOfCe = _data["financialAccountingStandardOfCe"] ? ConfirmableInputOfString.fromJS(_data["financialAccountingStandardOfCe"]) : <any>undefined;
            this.consolidationMethod = _data["consolidationMethod"] ? ConfirmableInputOfNullableOfConsolidationMethod.fromJS(_data["consolidationMethod"]) : <any>undefined;
            this.controllingInterestEntityId = _data["controllingInterestEntityId"];
            this.shareholders = _data["shareholders"] ? ShareholderInput.fromJS(_data["shareholders"]) : <any>undefined;
            this.blendingCircleInput = _data["blendingCircleInput"] ? BlendingCircleInput.fromJS(_data["blendingCircleInput"]) : <any>undefined;
            if (Array.isArray(_data["ownershipChanges"])) {
                this.ownershipChanges = [] as any;
                for (let item of _data["ownershipChanges"])
                    this.ownershipChanges!.push(CreateOwnershipChangeInput.fromJS(item));
            }
            if (Array.isArray(_data["corporateShareholders"])) {
                this.corporateShareholders = [] as any;
                for (let item of _data["corporateShareholders"])
                    this.corporateShareholders!.push(CreateCorporateShareholderInput.fromJS(item));
            }
            if (Array.isArray(_data["naturalPersonShareholders"])) {
                this.naturalPersonShareholders = [] as any;
                for (let item of _data["naturalPersonShareholders"])
                    this.naturalPersonShareholders!.push(CreateNaturalPersonShareholderInput.fromJS(item));
            }
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.blendingCircleTaxJurisdiction = _data["blendingCircleTaxJurisdiction"];
            this.entityLegalName = _data["entityLegalName"];
        }
    }

    static fromJS(data: any): RequestBlendingCircleSubgroups {
        data = typeof data === 'object' ? data : {};
        let result = new RequestBlendingCircleSubgroups();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["entityNumber"] = this.entityNumber ? this.entityNumber.toJSON() : <any>undefined;
        data["legalName"] = this.legalName ? this.legalName.toJSON() : <any>undefined;
        data["gloBEStatus"] = this.gloBEStatus ? this.gloBEStatus.toJSON() : <any>undefined;
        data["tin"] = this.tin ? this.tin.toJSON() : <any>undefined;
        data["tinIssuedBy"] = this.tinIssuedBy ? this.tinIssuedBy.toJSON() : <any>undefined;
        data["typeOfTIN"] = this.typeOfTIN ? this.typeOfTIN.toJSON() : <any>undefined;
        data["taxJurisdictionCountry"] = this.taxJurisdictionCountry ? this.taxJurisdictionCountry.toJSON() : <any>undefined;
        data["taxTreatment"] = this.taxTreatment ? this.taxTreatment.toJSON() : <any>undefined;
        data["isUpeAsFlowThrough"] = this.isUpeAsFlowThrough ? this.isUpeAsFlowThrough.toJSON() : <any>undefined;
        data["isUpeSubjectToDeductiveDividendRegime"] = this.isUpeSubjectToDeductiveDividendRegime ? this.isUpeSubjectToDeductiveDividendRegime.toJSON() : <any>undefined;
        data["typeOfExcluded"] = this.typeOfExcluded ? this.typeOfExcluded.toJSON() : <any>undefined;
        data["notTreatingEntityAsExcludedEntity"] = this.notTreatingEntityAsExcludedEntity ? this.notTreatingEntityAsExcludedEntity.toJSON() : <any>undefined;
        data["electionYear"] = this.electionYear ? this.electionYear.toString() : <any>undefined;
        data["revocationYear"] = this.revocationYear ? this.revocationYear.toString() : <any>undefined;
        data["isPermanentEstablishment"] = this.isPermanentEstablishment ? this.isPermanentEstablishment.toJSON() : <any>undefined;
        data["mainEntityId"] = this.mainEntityId ? this.mainEntityId.toJSON() : <any>undefined;
        data["taxFunctionalCurrency"] = this.taxFunctionalCurrency ? this.taxFunctionalCurrency.toJSON() : <any>undefined;
        data["accountingFunctionalCurrency"] = this.accountingFunctionalCurrency ? this.accountingFunctionalCurrency.toJSON() : <any>undefined;
        data["financialAccountingStandardOfCe"] = this.financialAccountingStandardOfCe ? this.financialAccountingStandardOfCe.toJSON() : <any>undefined;
        data["consolidationMethod"] = this.consolidationMethod ? this.consolidationMethod.toJSON() : <any>undefined;
        data["controllingInterestEntityId"] = this.controllingInterestEntityId;
        data["shareholders"] = this.shareholders ? this.shareholders.toJSON() : <any>undefined;
        data["blendingCircleInput"] = this.blendingCircleInput ? this.blendingCircleInput.toJSON() : <any>undefined;
        if (Array.isArray(this.ownershipChanges)) {
            data["ownershipChanges"] = [];
            for (let item of this.ownershipChanges)
                data["ownershipChanges"].push(item.toJSON());
        }
        if (Array.isArray(this.corporateShareholders)) {
            data["corporateShareholders"] = [];
            for (let item of this.corporateShareholders)
                data["corporateShareholders"].push(item.toJSON());
        }
        if (Array.isArray(this.naturalPersonShareholders)) {
            data["naturalPersonShareholders"] = [];
            for (let item of this.naturalPersonShareholders)
                data["naturalPersonShareholders"].push(item.toJSON());
        }
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["blendingCircleTaxJurisdiction"] = this.blendingCircleTaxJurisdiction;
        data["entityLegalName"] = this.entityLegalName;
        return data;
    }
}

export interface IRequestBlendingCircleSubgroups {
    projectId: number;
    entityNumber: ConfirmableInputOfString | undefined;
    legalName: ConfirmableInputOfString | undefined;
    gloBEStatus: ConfirmableInputOfIListOfGloBEStatus | undefined;
    tin: ConfirmableInputOfString | undefined;
    tinIssuedBy: ConfirmableInputOfString | undefined;
    typeOfTIN: ConfirmableInputOfNullableOfTinType | undefined;
    taxJurisdictionCountry: ConfirmableInputOfString | undefined;
    taxTreatment: ConfirmableInputOfNullableOfTaxTreatment | undefined;
    isUpeAsFlowThrough: ConfirmableInputOfNullableOfBoolean | undefined;
    isUpeSubjectToDeductiveDividendRegime: ConfirmableInputOfNullableOfBoolean | undefined;
    typeOfExcluded: ConfirmableInputOfNullableOfOrganizationalEntityExcludedType | undefined;
    notTreatingEntityAsExcludedEntity: ConfirmableInputOfNullableOfBoolean | undefined;
    electionYear: DateTime | undefined;
    revocationYear: DateTime | undefined;
    isPermanentEstablishment: ConfirmableInputOfNullableOfBoolean | undefined;
    mainEntityId: ConfirmableInputOfNullableOfInt64 | undefined;
    taxFunctionalCurrency: ConfirmableInputOfString | undefined;
    accountingFunctionalCurrency: ConfirmableInputOfString | undefined;
    financialAccountingStandardOfCe: ConfirmableInputOfString | undefined;
    consolidationMethod: ConfirmableInputOfNullableOfConsolidationMethod | undefined;
    controllingInterestEntityId: number | undefined;
    shareholders: ShareholderInput | undefined;
    blendingCircleInput: BlendingCircleInput | undefined;
    ownershipChanges: CreateOwnershipChangeInput[] | undefined;
    corporateShareholders: CreateCorporateShareholderInput[] | undefined;
    naturalPersonShareholders: CreateNaturalPersonShareholderInput[] | undefined;
    organizationalEntityId: number;
    blendingCircleTaxJurisdiction: string | undefined;
    entityLegalName: string | undefined;
}

export class RequestCalculateFinalArticle432Input implements IRequestCalculateFinalArticle432Input {
    projectId!: number;
    organizationalEntityId!: number;
    value!: string | undefined;
    initialValue!: string | undefined;
    financialTreeType!: FinancialTreeType;
    basisForAdjustments!: BasisForAdjustmentsType;
    targetOrganizationalEntityId!: number | undefined;
    pointId!: number | undefined;
    thereofOnActiveIncome!: string | undefined;

    constructor(data?: IRequestCalculateFinalArticle432Input) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.value = _data["value"];
            this.initialValue = _data["initialValue"];
            this.financialTreeType = _data["financialTreeType"];
            this.basisForAdjustments = _data["basisForAdjustments"];
            this.targetOrganizationalEntityId = _data["targetOrganizationalEntityId"];
            this.pointId = _data["pointId"];
            this.thereofOnActiveIncome = _data["thereofOnActiveIncome"];
        }
    }

    static fromJS(data: any): RequestCalculateFinalArticle432Input {
        data = typeof data === 'object' ? data : {};
        let result = new RequestCalculateFinalArticle432Input();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["value"] = this.value;
        data["initialValue"] = this.initialValue;
        data["financialTreeType"] = this.financialTreeType;
        data["basisForAdjustments"] = this.basisForAdjustments;
        data["targetOrganizationalEntityId"] = this.targetOrganizationalEntityId;
        data["pointId"] = this.pointId;
        data["thereofOnActiveIncome"] = this.thereofOnActiveIncome;
        return data;
    }
}

export interface IRequestCalculateFinalArticle432Input {
    projectId: number;
    organizationalEntityId: number;
    value: string | undefined;
    initialValue: string | undefined;
    financialTreeType: FinancialTreeType;
    basisForAdjustments: BasisForAdjustmentsType;
    targetOrganizationalEntityId: number | undefined;
    pointId: number | undefined;
    thereofOnActiveIncome: string | undefined;
}

export class RequestRecalculateCombinedNodeInput implements IRequestRecalculateCombinedNodeInput {
    projectId!: number;
    organizationalEntityId!: number;
    financialNodeGroupType!: FinancialNodeGroupType | undefined;
    multipleNodeGroupId!: number | undefined;
    childInvestmentEntityId!: number | undefined;
    value!: string | undefined;
    valueAccordingToFinancialStatements!: string | undefined;
    disposingJurisdiction!: string | undefined;
    taxPaidInRespectOfTheTransaction!: string | undefined;
    netDeferredTaxAsset!: string | undefined;
    globeCarryingValue!: string | undefined;
    netDeferredTaxAssetYearBeginning!: string | undefined;
    deemedDistribution!: string | undefined;
    thereofAlreadyIncludedInGlobeIncomeComputation!: string | undefined;
    localCreditableTaxGrossup!: string | undefined;
    isConfirmed!: boolean;
    comment!: string | undefined;
    notes!: string | undefined;
    financialTreeType!: FinancialTreeType;
    financialCombinedType!: FinancialCombinedType;
    pointId!: number | undefined;

    constructor(data?: IRequestRecalculateCombinedNodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.financialNodeGroupType = _data["financialNodeGroupType"];
            this.multipleNodeGroupId = _data["multipleNodeGroupId"];
            this.childInvestmentEntityId = _data["childInvestmentEntityId"];
            this.value = _data["value"];
            this.valueAccordingToFinancialStatements = _data["valueAccordingToFinancialStatements"];
            this.disposingJurisdiction = _data["disposingJurisdiction"];
            this.taxPaidInRespectOfTheTransaction = _data["taxPaidInRespectOfTheTransaction"];
            this.netDeferredTaxAsset = _data["netDeferredTaxAsset"];
            this.globeCarryingValue = _data["globeCarryingValue"];
            this.netDeferredTaxAssetYearBeginning = _data["netDeferredTaxAssetYearBeginning"];
            this.deemedDistribution = _data["deemedDistribution"];
            this.thereofAlreadyIncludedInGlobeIncomeComputation = _data["thereofAlreadyIncludedInGlobeIncomeComputation"];
            this.localCreditableTaxGrossup = _data["localCreditableTaxGrossup"];
            this.isConfirmed = _data["isConfirmed"];
            this.comment = _data["comment"];
            this.notes = _data["notes"];
            this.financialTreeType = _data["financialTreeType"];
            this.financialCombinedType = _data["financialCombinedType"];
            this.pointId = _data["pointId"];
        }
    }

    static fromJS(data: any): RequestRecalculateCombinedNodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new RequestRecalculateCombinedNodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["financialNodeGroupType"] = this.financialNodeGroupType;
        data["multipleNodeGroupId"] = this.multipleNodeGroupId;
        data["childInvestmentEntityId"] = this.childInvestmentEntityId;
        data["value"] = this.value;
        data["valueAccordingToFinancialStatements"] = this.valueAccordingToFinancialStatements;
        data["disposingJurisdiction"] = this.disposingJurisdiction;
        data["taxPaidInRespectOfTheTransaction"] = this.taxPaidInRespectOfTheTransaction;
        data["netDeferredTaxAsset"] = this.netDeferredTaxAsset;
        data["globeCarryingValue"] = this.globeCarryingValue;
        data["netDeferredTaxAssetYearBeginning"] = this.netDeferredTaxAssetYearBeginning;
        data["deemedDistribution"] = this.deemedDistribution;
        data["thereofAlreadyIncludedInGlobeIncomeComputation"] = this.thereofAlreadyIncludedInGlobeIncomeComputation;
        data["localCreditableTaxGrossup"] = this.localCreditableTaxGrossup;
        data["isConfirmed"] = this.isConfirmed;
        data["comment"] = this.comment;
        data["notes"] = this.notes;
        data["financialTreeType"] = this.financialTreeType;
        data["financialCombinedType"] = this.financialCombinedType;
        data["pointId"] = this.pointId;
        return data;
    }
}

export interface IRequestRecalculateCombinedNodeInput {
    projectId: number;
    organizationalEntityId: number;
    financialNodeGroupType: FinancialNodeGroupType | undefined;
    multipleNodeGroupId: number | undefined;
    childInvestmentEntityId: number | undefined;
    value: string | undefined;
    valueAccordingToFinancialStatements: string | undefined;
    disposingJurisdiction: string | undefined;
    taxPaidInRespectOfTheTransaction: string | undefined;
    netDeferredTaxAsset: string | undefined;
    globeCarryingValue: string | undefined;
    netDeferredTaxAssetYearBeginning: string | undefined;
    deemedDistribution: string | undefined;
    thereofAlreadyIncludedInGlobeIncomeComputation: string | undefined;
    localCreditableTaxGrossup: string | undefined;
    isConfirmed: boolean;
    comment: string | undefined;
    notes: string | undefined;
    financialTreeType: FinancialTreeType;
    financialCombinedType: FinancialCombinedType;
    pointId: number | undefined;
}

export class RequestRecalculateShiftNodeInput implements IRequestRecalculateShiftNodeInput {
    projectId!: number;
    value!: string | undefined;
    comment!: string | undefined;
    notes!: string | undefined;
    isConfirmed!: boolean;
    financialShiftType!: FinancialShiftType;
    targetOrganizationalEntityId!: number | undefined;
    basisForAdjustments!: BasisForAdjustmentsType | undefined;
    maxTaxRateOfMainEntityJurisdiction!: string | undefined;
    passiveIncomeOfCEOrHybridEntity!: string | undefined;
    thereofOnActiveIncome!: string | undefined;
    fiscalYearBeginning!: string | undefined;
    fiscalYearEnd!: string | undefined;
    financialTreeType!: FinancialTreeType;
    directionType!: DirectionType | undefined;
    finalValue!: string | undefined;
    pointId!: number | undefined;
    sourceOrganizationalEntityId!: number | undefined;
    financialNodeGroupType!: FinancialNodeGroupType | undefined;

    constructor(data?: IRequestRecalculateShiftNodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.value = _data["value"];
            this.comment = _data["comment"];
            this.notes = _data["notes"];
            this.isConfirmed = _data["isConfirmed"];
            this.financialShiftType = _data["financialShiftType"];
            this.targetOrganizationalEntityId = _data["targetOrganizationalEntityId"];
            this.basisForAdjustments = _data["basisForAdjustments"];
            this.maxTaxRateOfMainEntityJurisdiction = _data["maxTaxRateOfMainEntityJurisdiction"];
            this.passiveIncomeOfCEOrHybridEntity = _data["passiveIncomeOfCEOrHybridEntity"];
            this.thereofOnActiveIncome = _data["thereofOnActiveIncome"];
            this.fiscalYearBeginning = _data["fiscalYearBeginning"];
            this.fiscalYearEnd = _data["fiscalYearEnd"];
            this.financialTreeType = _data["financialTreeType"];
            this.directionType = _data["directionType"];
            this.finalValue = _data["finalValue"];
            this.pointId = _data["pointId"];
            this.sourceOrganizationalEntityId = _data["sourceOrganizationalEntityId"];
            this.financialNodeGroupType = _data["financialNodeGroupType"];
        }
    }

    static fromJS(data: any): RequestRecalculateShiftNodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new RequestRecalculateShiftNodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["value"] = this.value;
        data["comment"] = this.comment;
        data["notes"] = this.notes;
        data["isConfirmed"] = this.isConfirmed;
        data["financialShiftType"] = this.financialShiftType;
        data["targetOrganizationalEntityId"] = this.targetOrganizationalEntityId;
        data["basisForAdjustments"] = this.basisForAdjustments;
        data["maxTaxRateOfMainEntityJurisdiction"] = this.maxTaxRateOfMainEntityJurisdiction;
        data["passiveIncomeOfCEOrHybridEntity"] = this.passiveIncomeOfCEOrHybridEntity;
        data["thereofOnActiveIncome"] = this.thereofOnActiveIncome;
        data["fiscalYearBeginning"] = this.fiscalYearBeginning;
        data["fiscalYearEnd"] = this.fiscalYearEnd;
        data["financialTreeType"] = this.financialTreeType;
        data["directionType"] = this.directionType;
        data["finalValue"] = this.finalValue;
        data["pointId"] = this.pointId;
        data["sourceOrganizationalEntityId"] = this.sourceOrganizationalEntityId;
        data["financialNodeGroupType"] = this.financialNodeGroupType;
        return data;
    }
}

export interface IRequestRecalculateShiftNodeInput {
    projectId: number;
    value: string | undefined;
    comment: string | undefined;
    notes: string | undefined;
    isConfirmed: boolean;
    financialShiftType: FinancialShiftType;
    targetOrganizationalEntityId: number | undefined;
    basisForAdjustments: BasisForAdjustmentsType | undefined;
    maxTaxRateOfMainEntityJurisdiction: string | undefined;
    passiveIncomeOfCEOrHybridEntity: string | undefined;
    thereofOnActiveIncome: string | undefined;
    fiscalYearBeginning: string | undefined;
    fiscalYearEnd: string | undefined;
    financialTreeType: FinancialTreeType;
    directionType: DirectionType | undefined;
    finalValue: string | undefined;
    pointId: number | undefined;
    sourceOrganizationalEntityId: number | undefined;
    financialNodeGroupType: FinancialNodeGroupType | undefined;
}

export class RequestRecalculateValueNodeInput implements IRequestRecalculateValueNodeInput {
    projectId!: number;
    organizationalEntityId!: number | undefined;
    blendingCircleSubgroupId!: number | undefined;
    organizationalEntityUpeShareholderId!: number | undefined;
    ownerId!: number | undefined;
    assignedEntityId!: number | undefined;
    financialTreeType!: FinancialTreeType;
    financialValueType!: FinancialValueType;
    value!: string | undefined;
    isConfirmed!: boolean;
    isValueInLocalCurrency!: boolean;
    comment!: string | undefined;
    notes!: string | undefined;
    financialYear!: FinancialYearType | undefined;
    lossCarryBack!: string | undefined;
    domesticTaxRate!: string | undefined;
    nonEligibleEmployeeCostsPreliminary!: string | undefined;
    percentageRateWorkingTimeInJurisdiction!: number | undefined;
    percentageRateOfLocationTimeInJurisdiction!: number | undefined;
    proRataTemporis!: number | undefined;
    fiscalYearBeginning!: string | undefined;
    fiscalYearEnd!: string | undefined;
    proportionalReductionOfAct!: string | undefined;
    financialNodeGroupType!: FinancialNodeGroupType | undefined;
    multipleNodeGroupId!: number | undefined;
    financialValueTracePointAdditionalInput!: UpdateFinancialValueTracePointAdditionalInput | undefined;
    internationalShippingIncome!: InternationalShippingIncomeDetailInput | undefined;
    qualifiedAncillaryInternationalShippingIncome!: InternationalShippingIncomeDetailInput | undefined;
    pointId!: number | undefined;

    constructor(data?: IRequestRecalculateValueNodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
            this.organizationalEntityUpeShareholderId = _data["organizationalEntityUpeShareholderId"];
            this.ownerId = _data["ownerId"];
            this.assignedEntityId = _data["assignedEntityId"];
            this.financialTreeType = _data["financialTreeType"];
            this.financialValueType = _data["financialValueType"];
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
            this.isValueInLocalCurrency = _data["isValueInLocalCurrency"];
            this.comment = _data["comment"];
            this.notes = _data["notes"];
            this.financialYear = _data["financialYear"];
            this.lossCarryBack = _data["lossCarryBack"];
            this.domesticTaxRate = _data["domesticTaxRate"];
            this.nonEligibleEmployeeCostsPreliminary = _data["nonEligibleEmployeeCostsPreliminary"];
            this.percentageRateWorkingTimeInJurisdiction = _data["percentageRateWorkingTimeInJurisdiction"];
            this.percentageRateOfLocationTimeInJurisdiction = _data["percentageRateOfLocationTimeInJurisdiction"];
            this.proRataTemporis = _data["proRataTemporis"];
            this.fiscalYearBeginning = _data["fiscalYearBeginning"];
            this.fiscalYearEnd = _data["fiscalYearEnd"];
            this.proportionalReductionOfAct = _data["proportionalReductionOfAct"];
            this.financialNodeGroupType = _data["financialNodeGroupType"];
            this.multipleNodeGroupId = _data["multipleNodeGroupId"];
            this.financialValueTracePointAdditionalInput = _data["financialValueTracePointAdditionalInput"] ? UpdateFinancialValueTracePointAdditionalInput.fromJS(_data["financialValueTracePointAdditionalInput"]) : <any>undefined;
            this.internationalShippingIncome = _data["internationalShippingIncome"] ? InternationalShippingIncomeDetailInput.fromJS(_data["internationalShippingIncome"]) : <any>undefined;
            this.qualifiedAncillaryInternationalShippingIncome = _data["qualifiedAncillaryInternationalShippingIncome"] ? InternationalShippingIncomeDetailInput.fromJS(_data["qualifiedAncillaryInternationalShippingIncome"]) : <any>undefined;
            this.pointId = _data["pointId"];
        }
    }

    static fromJS(data: any): RequestRecalculateValueNodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new RequestRecalculateValueNodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        data["organizationalEntityUpeShareholderId"] = this.organizationalEntityUpeShareholderId;
        data["ownerId"] = this.ownerId;
        data["assignedEntityId"] = this.assignedEntityId;
        data["financialTreeType"] = this.financialTreeType;
        data["financialValueType"] = this.financialValueType;
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        data["isValueInLocalCurrency"] = this.isValueInLocalCurrency;
        data["comment"] = this.comment;
        data["notes"] = this.notes;
        data["financialYear"] = this.financialYear;
        data["lossCarryBack"] = this.lossCarryBack;
        data["domesticTaxRate"] = this.domesticTaxRate;
        data["nonEligibleEmployeeCostsPreliminary"] = this.nonEligibleEmployeeCostsPreliminary;
        data["percentageRateWorkingTimeInJurisdiction"] = this.percentageRateWorkingTimeInJurisdiction;
        data["percentageRateOfLocationTimeInJurisdiction"] = this.percentageRateOfLocationTimeInJurisdiction;
        data["proRataTemporis"] = this.proRataTemporis;
        data["fiscalYearBeginning"] = this.fiscalYearBeginning;
        data["fiscalYearEnd"] = this.fiscalYearEnd;
        data["proportionalReductionOfAct"] = this.proportionalReductionOfAct;
        data["financialNodeGroupType"] = this.financialNodeGroupType;
        data["multipleNodeGroupId"] = this.multipleNodeGroupId;
        data["financialValueTracePointAdditionalInput"] = this.financialValueTracePointAdditionalInput ? this.financialValueTracePointAdditionalInput.toJSON() : <any>undefined;
        data["internationalShippingIncome"] = this.internationalShippingIncome ? this.internationalShippingIncome.toJSON() : <any>undefined;
        data["qualifiedAncillaryInternationalShippingIncome"] = this.qualifiedAncillaryInternationalShippingIncome ? this.qualifiedAncillaryInternationalShippingIncome.toJSON() : <any>undefined;
        data["pointId"] = this.pointId;
        return data;
    }
}

export interface IRequestRecalculateValueNodeInput {
    projectId: number;
    organizationalEntityId: number | undefined;
    blendingCircleSubgroupId: number | undefined;
    organizationalEntityUpeShareholderId: number | undefined;
    ownerId: number | undefined;
    assignedEntityId: number | undefined;
    financialTreeType: FinancialTreeType;
    financialValueType: FinancialValueType;
    value: string | undefined;
    isConfirmed: boolean;
    isValueInLocalCurrency: boolean;
    comment: string | undefined;
    notes: string | undefined;
    financialYear: FinancialYearType | undefined;
    lossCarryBack: string | undefined;
    domesticTaxRate: string | undefined;
    nonEligibleEmployeeCostsPreliminary: string | undefined;
    percentageRateWorkingTimeInJurisdiction: number | undefined;
    percentageRateOfLocationTimeInJurisdiction: number | undefined;
    proRataTemporis: number | undefined;
    fiscalYearBeginning: string | undefined;
    fiscalYearEnd: string | undefined;
    proportionalReductionOfAct: string | undefined;
    financialNodeGroupType: FinancialNodeGroupType | undefined;
    multipleNodeGroupId: number | undefined;
    financialValueTracePointAdditionalInput: UpdateFinancialValueTracePointAdditionalInput | undefined;
    internationalShippingIncome: InternationalShippingIncomeDetailInput | undefined;
    qualifiedAncillaryInternationalShippingIncome: InternationalShippingIncomeDetailInput | undefined;
    pointId: number | undefined;
}

export class ResultMessageDto implements IResultMessageDto {
    type!: string | undefined;
    code!: string | undefined;
    reference!: string | undefined;
    labels!: ResultMessageLabelDto | undefined;

    constructor(data?: IResultMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.code = _data["code"];
            this.reference = _data["reference"];
            this.labels = _data["labels"] ? ResultMessageLabelDto.fromJS(_data["labels"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["code"] = this.code;
        data["reference"] = this.reference;
        data["labels"] = this.labels ? this.labels.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResultMessageDto {
    type: string | undefined;
    code: string | undefined;
    reference: string | undefined;
    labels: ResultMessageLabelDto | undefined;
}

export class ResultMessageLabelDto implements IResultMessageLabelDto {
    en!: string | undefined;
    de!: string | undefined;

    constructor(data?: IResultMessageLabelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.en = _data["en"];
            this.de = _data["de"];
        }
    }

    static fromJS(data: any): ResultMessageLabelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultMessageLabelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["en"] = this.en;
        data["de"] = this.de;
        return data;
    }
}

export interface IResultMessageLabelDto {
    en: string | undefined;
    de: string | undefined;
}

export class RevenueToProfitLossCoparisonDto implements IRevenueToProfitLossCoparisonDto {
    jurisdiction!: string | undefined;
    safeHarbourGroupType!: SafeHarbourGroupType | undefined;
    number!: number | undefined;
    revenue!: number | undefined;
    profitLoss!: number | undefined;
    ratioOfRevenueToThreshold!: number | undefined;
    ratioOfProfitLossToThreshold!: number | undefined;

    constructor(data?: IRevenueToProfitLossCoparisonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jurisdiction = _data["jurisdiction"];
            this.safeHarbourGroupType = _data["safeHarbourGroupType"];
            this.number = _data["number"];
            this.revenue = _data["revenue"];
            this.profitLoss = _data["profitLoss"];
            this.ratioOfRevenueToThreshold = _data["ratioOfRevenueToThreshold"];
            this.ratioOfProfitLossToThreshold = _data["ratioOfProfitLossToThreshold"];
        }
    }

    static fromJS(data: any): RevenueToProfitLossCoparisonDto {
        data = typeof data === 'object' ? data : {};
        let result = new RevenueToProfitLossCoparisonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jurisdiction"] = this.jurisdiction;
        data["safeHarbourGroupType"] = this.safeHarbourGroupType;
        data["number"] = this.number;
        data["revenue"] = this.revenue;
        data["profitLoss"] = this.profitLoss;
        data["ratioOfRevenueToThreshold"] = this.ratioOfRevenueToThreshold;
        data["ratioOfProfitLossToThreshold"] = this.ratioOfProfitLossToThreshold;
        return data;
    }
}

export interface IRevenueToProfitLossCoparisonDto {
    jurisdiction: string | undefined;
    safeHarbourGroupType: SafeHarbourGroupType | undefined;
    number: number | undefined;
    revenue: number | undefined;
    profitLoss: number | undefined;
    ratioOfRevenueToThreshold: number | undefined;
    ratioOfProfitLossToThreshold: number | undefined;
}

export class RiskIndicationDataDto implements IRiskIndicationDataDto {
    jurisdiction!: string | undefined;
    safeHarbourGroupType!: SafeHarbourGroupType | undefined;
    number!: number | undefined;
    totalPoints!: number;
    riskIndicationType!: RiskIndicationType;

    constructor(data?: IRiskIndicationDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jurisdiction = _data["jurisdiction"];
            this.safeHarbourGroupType = _data["safeHarbourGroupType"];
            this.number = _data["number"];
            this.totalPoints = _data["totalPoints"];
            this.riskIndicationType = _data["riskIndicationType"];
        }
    }

    static fromJS(data: any): RiskIndicationDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new RiskIndicationDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jurisdiction"] = this.jurisdiction;
        data["safeHarbourGroupType"] = this.safeHarbourGroupType;
        data["number"] = this.number;
        data["totalPoints"] = this.totalPoints;
        data["riskIndicationType"] = this.riskIndicationType;
        return data;
    }
}

export interface IRiskIndicationDataDto {
    jurisdiction: string | undefined;
    safeHarbourGroupType: SafeHarbourGroupType | undefined;
    number: number | undefined;
    totalPoints: number;
    riskIndicationType: RiskIndicationType;
}

export enum RiskIndicationType {
    Low = 1,
    Medium = 2,
    High = 3,
}

export class SafeHarbourCheckResultDto implements ISafeHarbourCheckResultDto {
    checkResultStatus!: CheckResultStatus;
    resultReasons!: string[] | undefined;

    constructor(data?: ISafeHarbourCheckResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checkResultStatus = _data["checkResultStatus"];
            if (Array.isArray(_data["resultReasons"])) {
                this.resultReasons = [] as any;
                for (let item of _data["resultReasons"])
                    this.resultReasons!.push(item);
            }
        }
    }

    static fromJS(data: any): SafeHarbourCheckResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SafeHarbourCheckResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkResultStatus"] = this.checkResultStatus;
        if (Array.isArray(this.resultReasons)) {
            data["resultReasons"] = [];
            for (let item of this.resultReasons)
                data["resultReasons"].push(item);
        }
        return data;
    }
}

export interface ISafeHarbourCheckResultDto {
    checkResultStatus: CheckResultStatus;
    resultReasons: string[] | undefined;
}

export class SafeHarbourChecksDto implements ISafeHarbourChecksDto {
    jurisdictions!: number;
    applicableJurisdictions!: number;

    constructor(data?: ISafeHarbourChecksDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jurisdictions = _data["jurisdictions"];
            this.applicableJurisdictions = _data["applicableJurisdictions"];
        }
    }

    static fromJS(data: any): SafeHarbourChecksDto {
        data = typeof data === 'object' ? data : {};
        let result = new SafeHarbourChecksDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jurisdictions"] = this.jurisdictions;
        data["applicableJurisdictions"] = this.applicableJurisdictions;
        return data;
    }
}

export interface ISafeHarbourChecksDto {
    jurisdictions: number;
    applicableJurisdictions: number;
}

export enum SafeHarbourGirReportingSelection {
    TransitionalCbcrSafeHarbourDeMinimisTest = 1,
    TransitionalCbcrSafeHarbourEtrTest = 2,
    TransitionalCbcrSafeHarbourRoutineProfitTest = 3,
}

export class SafeHarbourGroupOverviewDto implements ISafeHarbourGroupOverviewDto {
    safeHarbourGroupId!: number | undefined;
    safeHarbourGroupType!: SafeHarbourGroupType | undefined;
    number!: number | undefined;
    readonly blendingCircleSubgroupId!: number | undefined;
    blendingCircleCountry!: string | undefined;
    organizationalEntityIds!: number[] | undefined;
    girReportingSelections!: SafeHarbourGirReportingSelection[] | undefined;
    hasGirReportingSelectionWarning!: boolean;

    constructor(data?: ISafeHarbourGroupOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.safeHarbourGroupId = _data["safeHarbourGroupId"];
            this.safeHarbourGroupType = _data["safeHarbourGroupType"];
            this.number = _data["number"];
            (<any>this).blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
            this.blendingCircleCountry = _data["blendingCircleCountry"];
            if (Array.isArray(_data["organizationalEntityIds"])) {
                this.organizationalEntityIds = [] as any;
                for (let item of _data["organizationalEntityIds"])
                    this.organizationalEntityIds!.push(item);
            }
            if (Array.isArray(_data["girReportingSelections"])) {
                this.girReportingSelections = [] as any;
                for (let item of _data["girReportingSelections"])
                    this.girReportingSelections!.push(item);
            }
            this.hasGirReportingSelectionWarning = _data["hasGirReportingSelectionWarning"];
        }
    }

    static fromJS(data: any): SafeHarbourGroupOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new SafeHarbourGroupOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["safeHarbourGroupId"] = this.safeHarbourGroupId;
        data["safeHarbourGroupType"] = this.safeHarbourGroupType;
        data["number"] = this.number;
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        data["blendingCircleCountry"] = this.blendingCircleCountry;
        if (Array.isArray(this.organizationalEntityIds)) {
            data["organizationalEntityIds"] = [];
            for (let item of this.organizationalEntityIds)
                data["organizationalEntityIds"].push(item);
        }
        if (Array.isArray(this.girReportingSelections)) {
            data["girReportingSelections"] = [];
            for (let item of this.girReportingSelections)
                data["girReportingSelections"].push(item);
        }
        data["hasGirReportingSelectionWarning"] = this.hasGirReportingSelectionWarning;
        return data;
    }
}

export interface ISafeHarbourGroupOverviewDto {
    safeHarbourGroupId: number | undefined;
    safeHarbourGroupType: SafeHarbourGroupType | undefined;
    number: number | undefined;
    blendingCircleSubgroupId: number | undefined;
    blendingCircleCountry: string | undefined;
    organizationalEntityIds: number[] | undefined;
    girReportingSelections: SafeHarbourGirReportingSelection[] | undefined;
    hasGirReportingSelectionWarning: boolean;
}

export class SafeHarbourGroupReferenceDataDto implements ISafeHarbourGroupReferenceDataDto {
    id!: string | undefined;
    text!: string | undefined;
    safeHarbourGroupType!: SafeHarbourGroupType;
    number!: number | undefined;

    constructor(data?: ISafeHarbourGroupReferenceDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            this.safeHarbourGroupType = _data["safeHarbourGroupType"];
            this.number = _data["number"];
        }
    }

    static fromJS(data: any): SafeHarbourGroupReferenceDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new SafeHarbourGroupReferenceDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["safeHarbourGroupType"] = this.safeHarbourGroupType;
        data["number"] = this.number;
        return data;
    }
}

export interface ISafeHarbourGroupReferenceDataDto {
    id: string | undefined;
    text: string | undefined;
    safeHarbourGroupType: SafeHarbourGroupType;
    number: number | undefined;
}

export enum SafeHarbourGroupType {
    StandardPlus = 1,
    JointVenture = 2,
    NotConsidered = 3,
}

export class SafeHarbourGroupWorldMapDto implements ISafeHarbourGroupWorldMapDto {
    testStatus!: TestsStatus;
    financialData!: FinancialDataSafeHarbourGroupWorldMapDto[] | undefined;

    constructor(data?: ISafeHarbourGroupWorldMapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.testStatus = _data["testStatus"];
            if (Array.isArray(_data["financialData"])) {
                this.financialData = [] as any;
                for (let item of _data["financialData"])
                    this.financialData!.push(FinancialDataSafeHarbourGroupWorldMapDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SafeHarbourGroupWorldMapDto {
        data = typeof data === 'object' ? data : {};
        let result = new SafeHarbourGroupWorldMapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["testStatus"] = this.testStatus;
        if (Array.isArray(this.financialData)) {
            data["financialData"] = [];
            for (let item of this.financialData)
                data["financialData"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISafeHarbourGroupWorldMapDto {
    testStatus: TestsStatus;
    financialData: FinancialDataSafeHarbourGroupWorldMapDto[] | undefined;
}

export class SaveAllItems implements ISaveAllItems {
    channelId!: number;
    email!: string;
    id!: number | undefined;

    constructor(data?: ISaveAllItems) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelId = _data["channelId"];
            this.email = _data["email"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SaveAllItems {
        data = typeof data === 'object' ? data : {};
        let result = new SaveAllItems();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelId"] = this.channelId;
        data["email"] = this.email;
        data["id"] = this.id;
        return data;
    }
}

export interface ISaveAllItems {
    channelId: number;
    email: string;
    id: number | undefined;
}

export class SaveAllWhiteListInput implements ISaveAllWhiteListInput {
    channelId!: number;
    items!: SaveAllItems[] | undefined;

    constructor(data?: ISaveAllWhiteListInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelId = _data["channelId"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SaveAllItems.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveAllWhiteListInput {
        data = typeof data === 'object' ? data : {};
        let result = new SaveAllWhiteListInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelId"] = this.channelId;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveAllWhiteListInput {
    channelId: number;
    items: SaveAllItems[] | undefined;
}

export class SaveRecaptureDeferredDataInput implements ISaveRecaptureDeferredDataInput {
    projectId!: number;
    blendingCircleSubgroupId!: number;
    dtlrFyMinus5!: number | undefined;
    recapDtlrFyMinus5!: number | undefined;
    dtlrFy!: number | undefined;
    reportingFyAmountPreTransition!: number | undefined;
    reportingFyAmountOutBalance!: number | undefined;
    reportingFyAmountUnjustified!: number | undefined;
    priorFyAmountPreTransition!: number | undefined;
    priorFyAmountOutBalance!: number | undefined;
    priorFyAmountUnjustified!: number | undefined;

    constructor(data?: ISaveRecaptureDeferredDataInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
            this.dtlrFyMinus5 = _data["dtlrFyMinus5"];
            this.recapDtlrFyMinus5 = _data["recapDtlrFyMinus5"];
            this.dtlrFy = _data["dtlrFy"];
            this.reportingFyAmountPreTransition = _data["reportingFyAmountPreTransition"];
            this.reportingFyAmountOutBalance = _data["reportingFyAmountOutBalance"];
            this.reportingFyAmountUnjustified = _data["reportingFyAmountUnjustified"];
            this.priorFyAmountPreTransition = _data["priorFyAmountPreTransition"];
            this.priorFyAmountOutBalance = _data["priorFyAmountOutBalance"];
            this.priorFyAmountUnjustified = _data["priorFyAmountUnjustified"];
        }
    }

    static fromJS(data: any): SaveRecaptureDeferredDataInput {
        data = typeof data === 'object' ? data : {};
        let result = new SaveRecaptureDeferredDataInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        data["dtlrFyMinus5"] = this.dtlrFyMinus5;
        data["recapDtlrFyMinus5"] = this.recapDtlrFyMinus5;
        data["dtlrFy"] = this.dtlrFy;
        data["reportingFyAmountPreTransition"] = this.reportingFyAmountPreTransition;
        data["reportingFyAmountOutBalance"] = this.reportingFyAmountOutBalance;
        data["reportingFyAmountUnjustified"] = this.reportingFyAmountUnjustified;
        data["priorFyAmountPreTransition"] = this.priorFyAmountPreTransition;
        data["priorFyAmountOutBalance"] = this.priorFyAmountOutBalance;
        data["priorFyAmountUnjustified"] = this.priorFyAmountUnjustified;
        return data;
    }
}

export interface ISaveRecaptureDeferredDataInput {
    projectId: number;
    blendingCircleSubgroupId: number;
    dtlrFyMinus5: number | undefined;
    recapDtlrFyMinus5: number | undefined;
    dtlrFy: number | undefined;
    reportingFyAmountPreTransition: number | undefined;
    reportingFyAmountOutBalance: number | undefined;
    reportingFyAmountUnjustified: number | undefined;
    priorFyAmountPreTransition: number | undefined;
    priorFyAmountOutBalance: number | undefined;
    priorFyAmountUnjustified: number | undefined;
}

export class SaveTransitionDataInput implements ISaveTransitionDataInput {
    projectId!: number;
    blendingCircleSubgroupId!: number;
    year!: DateTime | undefined;
    altJurisdiction!: string | undefined;
    deferredTaxLiabilityStart!: number | undefined;
    deferredTaxLiabilityRecast!: number | undefined;
    deferredTaxAssetStart!: number | undefined;
    deferredTaxAssetRecast!: number | undefined;
    deferredTaxAssetExcluded!: number | undefined;

    constructor(data?: ISaveTransitionDataInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
            this.year = _data["year"] ? DateTime.fromISO(_data["year"].toString()) : <any>undefined;
            this.altJurisdiction = _data["altJurisdiction"];
            this.deferredTaxLiabilityStart = _data["deferredTaxLiabilityStart"];
            this.deferredTaxLiabilityRecast = _data["deferredTaxLiabilityRecast"];
            this.deferredTaxAssetStart = _data["deferredTaxAssetStart"];
            this.deferredTaxAssetRecast = _data["deferredTaxAssetRecast"];
            this.deferredTaxAssetExcluded = _data["deferredTaxAssetExcluded"];
        }
    }

    static fromJS(data: any): SaveTransitionDataInput {
        data = typeof data === 'object' ? data : {};
        let result = new SaveTransitionDataInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        data["year"] = this.year ? this.year.toString() : <any>undefined;
        data["altJurisdiction"] = this.altJurisdiction;
        data["deferredTaxLiabilityStart"] = this.deferredTaxLiabilityStart;
        data["deferredTaxLiabilityRecast"] = this.deferredTaxLiabilityRecast;
        data["deferredTaxAssetStart"] = this.deferredTaxAssetStart;
        data["deferredTaxAssetRecast"] = this.deferredTaxAssetRecast;
        data["deferredTaxAssetExcluded"] = this.deferredTaxAssetExcluded;
        return data;
    }
}

export interface ISaveTransitionDataInput {
    projectId: number;
    blendingCircleSubgroupId: number;
    year: DateTime | undefined;
    altJurisdiction: string | undefined;
    deferredTaxLiabilityStart: number | undefined;
    deferredTaxLiabilityRecast: number | undefined;
    deferredTaxAssetStart: number | undefined;
    deferredTaxAssetRecast: number | undefined;
    deferredTaxAssetExcluded: number | undefined;
}

export class SbieConsistencyResultDto implements ISbieConsistencyResultDto {
    hasInconsistency!: boolean;
    groupNames!: string[] | undefined;
    inconsitencies!: EnititySbieInconsistencyResultDto[] | undefined;

    constructor(data?: ISbieConsistencyResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasInconsistency = _data["hasInconsistency"];
            if (Array.isArray(_data["groupNames"])) {
                this.groupNames = [] as any;
                for (let item of _data["groupNames"])
                    this.groupNames!.push(item);
            }
            if (Array.isArray(_data["inconsitencies"])) {
                this.inconsitencies = [] as any;
                for (let item of _data["inconsitencies"])
                    this.inconsitencies!.push(EnititySbieInconsistencyResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SbieConsistencyResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SbieConsistencyResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasInconsistency"] = this.hasInconsistency;
        if (Array.isArray(this.groupNames)) {
            data["groupNames"] = [];
            for (let item of this.groupNames)
                data["groupNames"].push(item);
        }
        if (Array.isArray(this.inconsitencies)) {
            data["inconsitencies"] = [];
            for (let item of this.inconsitencies)
                data["inconsitencies"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISbieConsistencyResultDto {
    hasInconsistency: boolean;
    groupNames: string[] | undefined;
    inconsitencies: EnititySbieInconsistencyResultDto[] | undefined;
}

export class SbieSafeHarbourVerificationInput implements ISbieSafeHarbourVerificationInput {
    projectId!: number;
    organisationalEntityIds!: number[] | undefined;

    constructor(data?: ISbieSafeHarbourVerificationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["organisationalEntityIds"])) {
                this.organisationalEntityIds = [] as any;
                for (let item of _data["organisationalEntityIds"])
                    this.organisationalEntityIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SbieSafeHarbourVerificationInput {
        data = typeof data === 'object' ? data : {};
        let result = new SbieSafeHarbourVerificationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        if (Array.isArray(this.organisationalEntityIds)) {
            data["organisationalEntityIds"] = [];
            for (let item of this.organisationalEntityIds)
                data["organisationalEntityIds"].push(item);
        }
        return data;
    }
}

export interface ISbieSafeHarbourVerificationInput {
    projectId: number;
    organisationalEntityIds: number[] | undefined;
}

export class ScopingStatusDto implements IScopingStatusDto {
    confirmedProjectFields!: number;
    filledNotConfirmedProjectFields!: number;
    missingValueNotConfirmedFields!: number;

    constructor(data?: IScopingStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.confirmedProjectFields = _data["confirmedProjectFields"];
            this.filledNotConfirmedProjectFields = _data["filledNotConfirmedProjectFields"];
            this.missingValueNotConfirmedFields = _data["missingValueNotConfirmedFields"];
        }
    }

    static fromJS(data: any): ScopingStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScopingStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["confirmedProjectFields"] = this.confirmedProjectFields;
        data["filledNotConfirmedProjectFields"] = this.filledNotConfirmedProjectFields;
        data["missingValueNotConfirmedFields"] = this.missingValueNotConfirmedFields;
        return data;
    }
}

export interface IScopingStatusDto {
    confirmedProjectFields: number;
    filledNotConfirmedProjectFields: number;
    missingValueNotConfirmedFields: number;
}

export class SearchCommunicationDto implements ISearchCommunicationDto {
    id!: number;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    title!: string | undefined;
    isRead!: boolean;
    countryCode!: string | undefined;
    entityId!: number;
    communications!: CommunicationDto[] | undefined;

    constructor(data?: ISearchCommunicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.isRead = _data["isRead"];
            this.countryCode = _data["countryCode"];
            this.entityId = _data["entityId"];
            if (Array.isArray(_data["communications"])) {
                this.communications = [] as any;
                for (let item of _data["communications"])
                    this.communications!.push(CommunicationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchCommunicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchCommunicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["title"] = this.title;
        data["isRead"] = this.isRead;
        data["countryCode"] = this.countryCode;
        data["entityId"] = this.entityId;
        if (Array.isArray(this.communications)) {
            data["communications"] = [];
            for (let item of this.communications)
                data["communications"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchCommunicationDto {
    id: number;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    title: string | undefined;
    isRead: boolean;
    countryCode: string | undefined;
    entityId: number;
    communications: CommunicationDto[] | undefined;
}

export class SetAssignedUserInput implements ISetAssignedUserInput {
    assignedUserId!: number | undefined;
    referenceId!: number;
    rootEntityId!: number | undefined;
    referenceName!: string | undefined;
    referenceEmailContent!: string | undefined;

    constructor(data?: ISetAssignedUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignedUserId = _data["assignedUserId"];
            this.referenceId = _data["referenceId"];
            this.rootEntityId = _data["rootEntityId"];
            this.referenceName = _data["referenceName"];
            this.referenceEmailContent = _data["referenceEmailContent"];
        }
    }

    static fromJS(data: any): SetAssignedUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new SetAssignedUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignedUserId"] = this.assignedUserId;
        data["referenceId"] = this.referenceId;
        data["rootEntityId"] = this.rootEntityId;
        data["referenceName"] = this.referenceName;
        data["referenceEmailContent"] = this.referenceEmailContent;
        return data;
    }
}

export interface ISetAssignedUserInput {
    assignedUserId: number | undefined;
    referenceId: number;
    rootEntityId: number | undefined;
    referenceName: string | undefined;
    referenceEmailContent: string | undefined;
}

export class SetDueDateInput implements ISetDueDateInput {
    referenceId!: number;
    rootEntityId!: number;
    dueDate!: DateTime | undefined;

    constructor(data?: ISetDueDateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referenceId = _data["referenceId"];
            this.rootEntityId = _data["rootEntityId"];
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SetDueDateInput {
        data = typeof data === 'object' ? data : {};
        let result = new SetDueDateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceId"] = this.referenceId;
        data["rootEntityId"] = this.rootEntityId;
        data["dueDate"] = this.dueDate ? this.dueDate.toString() : <any>undefined;
        return data;
    }
}

export interface ISetDueDateInput {
    referenceId: number;
    rootEntityId: number;
    dueDate: DateTime | undefined;
}

export class SetrCheckDataDto implements ISetrCheckDataDto {
    jurisdiction!: string | undefined;
    safeHarbourGroupType!: SafeHarbourGroupType | undefined;
    number!: number | undefined;
    setrPercentage!: number | undefined;

    constructor(data?: ISetrCheckDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jurisdiction = _data["jurisdiction"];
            this.safeHarbourGroupType = _data["safeHarbourGroupType"];
            this.number = _data["number"];
            this.setrPercentage = _data["setrPercentage"];
        }
    }

    static fromJS(data: any): SetrCheckDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetrCheckDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jurisdiction"] = this.jurisdiction;
        data["safeHarbourGroupType"] = this.safeHarbourGroupType;
        data["number"] = this.number;
        data["setrPercentage"] = this.setrPercentage;
        return data;
    }
}

export interface ISetrCheckDataDto {
    jurisdiction: string | undefined;
    safeHarbourGroupType: SafeHarbourGroupType | undefined;
    number: number | undefined;
    setrPercentage: number | undefined;
}

export class ShareholderInput implements IShareholderInput {
    organizationalEntityShareholders!: OrganizationalEntityShareholderInput[] | undefined;
    thirdPartyShareholders!: ThirdPartyShareholderInput[] | undefined;
    thirdPartyParticipations!: ThirdPartyParticipationInput[] | undefined;
    interestValue!: ConfirmableInputOfString | undefined;

    constructor(data?: IShareholderInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["organizationalEntityShareholders"])) {
                this.organizationalEntityShareholders = [] as any;
                for (let item of _data["organizationalEntityShareholders"])
                    this.organizationalEntityShareholders!.push(OrganizationalEntityShareholderInput.fromJS(item));
            }
            if (Array.isArray(_data["thirdPartyShareholders"])) {
                this.thirdPartyShareholders = [] as any;
                for (let item of _data["thirdPartyShareholders"])
                    this.thirdPartyShareholders!.push(ThirdPartyShareholderInput.fromJS(item));
            }
            if (Array.isArray(_data["thirdPartyParticipations"])) {
                this.thirdPartyParticipations = [] as any;
                for (let item of _data["thirdPartyParticipations"])
                    this.thirdPartyParticipations!.push(ThirdPartyParticipationInput.fromJS(item));
            }
            this.interestValue = _data["interestValue"] ? ConfirmableInputOfString.fromJS(_data["interestValue"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ShareholderInput {
        data = typeof data === 'object' ? data : {};
        let result = new ShareholderInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.organizationalEntityShareholders)) {
            data["organizationalEntityShareholders"] = [];
            for (let item of this.organizationalEntityShareholders)
                data["organizationalEntityShareholders"].push(item.toJSON());
        }
        if (Array.isArray(this.thirdPartyShareholders)) {
            data["thirdPartyShareholders"] = [];
            for (let item of this.thirdPartyShareholders)
                data["thirdPartyShareholders"].push(item.toJSON());
        }
        if (Array.isArray(this.thirdPartyParticipations)) {
            data["thirdPartyParticipations"] = [];
            for (let item of this.thirdPartyParticipations)
                data["thirdPartyParticipations"].push(item.toJSON());
        }
        data["interestValue"] = this.interestValue ? this.interestValue.toJSON() : <any>undefined;
        return data;
    }
}

export interface IShareholderInput {
    organizationalEntityShareholders: OrganizationalEntityShareholderInput[] | undefined;
    thirdPartyShareholders: ThirdPartyShareholderInput[] | undefined;
    thirdPartyParticipations: ThirdPartyParticipationInput[] | undefined;
    interestValue: ConfirmableInputOfString | undefined;
}

export class ShareholdersDto implements IShareholdersDto {
    organizationalEntityShareholders!: OrganizationalEntityShareholderDto[] | undefined;
    thirdPartyShareholders!: ThirdPartyShareholderDto[] | undefined;
    thirdPartyParticipations!: ThirdPartyParticipationDto[] | undefined;
    interestValue!: ConfirmableDtoOfString | undefined;

    constructor(data?: IShareholdersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["organizationalEntityShareholders"])) {
                this.organizationalEntityShareholders = [] as any;
                for (let item of _data["organizationalEntityShareholders"])
                    this.organizationalEntityShareholders!.push(OrganizationalEntityShareholderDto.fromJS(item));
            }
            if (Array.isArray(_data["thirdPartyShareholders"])) {
                this.thirdPartyShareholders = [] as any;
                for (let item of _data["thirdPartyShareholders"])
                    this.thirdPartyShareholders!.push(ThirdPartyShareholderDto.fromJS(item));
            }
            if (Array.isArray(_data["thirdPartyParticipations"])) {
                this.thirdPartyParticipations = [] as any;
                for (let item of _data["thirdPartyParticipations"])
                    this.thirdPartyParticipations!.push(ThirdPartyParticipationDto.fromJS(item));
            }
            this.interestValue = _data["interestValue"] ? ConfirmableDtoOfString.fromJS(_data["interestValue"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ShareholdersDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShareholdersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.organizationalEntityShareholders)) {
            data["organizationalEntityShareholders"] = [];
            for (let item of this.organizationalEntityShareholders)
                data["organizationalEntityShareholders"].push(item.toJSON());
        }
        if (Array.isArray(this.thirdPartyShareholders)) {
            data["thirdPartyShareholders"] = [];
            for (let item of this.thirdPartyShareholders)
                data["thirdPartyShareholders"].push(item.toJSON());
        }
        if (Array.isArray(this.thirdPartyParticipations)) {
            data["thirdPartyParticipations"] = [];
            for (let item of this.thirdPartyParticipations)
                data["thirdPartyParticipations"].push(item.toJSON());
        }
        data["interestValue"] = this.interestValue ? this.interestValue.toJSON() : <any>undefined;
        return data;
    }
}

export interface IShareholdersDto {
    organizationalEntityShareholders: OrganizationalEntityShareholderDto[] | undefined;
    thirdPartyShareholders: ThirdPartyShareholderDto[] | undefined;
    thirdPartyParticipations: ThirdPartyParticipationDto[] | undefined;
    interestValue: ConfirmableDtoOfString | undefined;
}

export class SubmissionCorrectionAvaliableCountriesDto implements ISubmissionCorrectionAvaliableCountriesDto {
    summarySectionCountries!: string[] | undefined;
    jurisdictionSectionCountries!: string[] | undefined;

    constructor(data?: ISubmissionCorrectionAvaliableCountriesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["summarySectionCountries"])) {
                this.summarySectionCountries = [] as any;
                for (let item of _data["summarySectionCountries"])
                    this.summarySectionCountries!.push(item);
            }
            if (Array.isArray(_data["jurisdictionSectionCountries"])) {
                this.jurisdictionSectionCountries = [] as any;
                for (let item of _data["jurisdictionSectionCountries"])
                    this.jurisdictionSectionCountries!.push(item);
            }
        }
    }

    static fromJS(data: any): SubmissionCorrectionAvaliableCountriesDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmissionCorrectionAvaliableCountriesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.summarySectionCountries)) {
            data["summarySectionCountries"] = [];
            for (let item of this.summarySectionCountries)
                data["summarySectionCountries"].push(item);
        }
        if (Array.isArray(this.jurisdictionSectionCountries)) {
            data["jurisdictionSectionCountries"] = [];
            for (let item of this.jurisdictionSectionCountries)
                data["jurisdictionSectionCountries"].push(item);
        }
        return data;
    }
}

export interface ISubmissionCorrectionAvaliableCountriesDto {
    summarySectionCountries: string[] | undefined;
    jurisdictionSectionCountries: string[] | undefined;
}

export class SubmissionCorrectionInput implements ISubmissionCorrectionInput {
    filingInfo!: boolean;
    generalSection!: boolean;
    summary!: boolean;
    jurisdictionSection!: boolean;
    utprAttribution!: boolean;
    summaryCountries!: string[] | undefined;
    jurisdictionSectionCountries!: string[] | undefined;

    constructor(data?: ISubmissionCorrectionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filingInfo = _data["filingInfo"];
            this.generalSection = _data["generalSection"];
            this.summary = _data["summary"];
            this.jurisdictionSection = _data["jurisdictionSection"];
            this.utprAttribution = _data["utprAttribution"];
            if (Array.isArray(_data["summaryCountries"])) {
                this.summaryCountries = [] as any;
                for (let item of _data["summaryCountries"])
                    this.summaryCountries!.push(item);
            }
            if (Array.isArray(_data["jurisdictionSectionCountries"])) {
                this.jurisdictionSectionCountries = [] as any;
                for (let item of _data["jurisdictionSectionCountries"])
                    this.jurisdictionSectionCountries!.push(item);
            }
        }
    }

    static fromJS(data: any): SubmissionCorrectionInput {
        data = typeof data === 'object' ? data : {};
        let result = new SubmissionCorrectionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filingInfo"] = this.filingInfo;
        data["generalSection"] = this.generalSection;
        data["summary"] = this.summary;
        data["jurisdictionSection"] = this.jurisdictionSection;
        data["utprAttribution"] = this.utprAttribution;
        if (Array.isArray(this.summaryCountries)) {
            data["summaryCountries"] = [];
            for (let item of this.summaryCountries)
                data["summaryCountries"].push(item);
        }
        if (Array.isArray(this.jurisdictionSectionCountries)) {
            data["jurisdictionSectionCountries"] = [];
            for (let item of this.jurisdictionSectionCountries)
                data["jurisdictionSectionCountries"].push(item);
        }
        return data;
    }
}

export interface ISubmissionCorrectionInput {
    filingInfo: boolean;
    generalSection: boolean;
    summary: boolean;
    jurisdictionSection: boolean;
    utprAttribution: boolean;
    summaryCountries: string[] | undefined;
    jurisdictionSectionCountries: string[] | undefined;
}

export class SubmissionDetailsDto implements ISubmissionDetailsDto {
    filingConstituentEntity!: string | undefined;
    role!: SubmissionRoleType;
    countrySpecificParams!: { [key: string]: string; } | undefined;

    constructor(data?: ISubmissionDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filingConstituentEntity = _data["filingConstituentEntity"];
            this.role = _data["role"];
            if (_data["countrySpecificParams"]) {
                this.countrySpecificParams = {} as any;
                for (let key in _data["countrySpecificParams"]) {
                    if (_data["countrySpecificParams"].hasOwnProperty(key))
                        (<any>this.countrySpecificParams)![key] = _data["countrySpecificParams"][key];
                }
            }
        }
    }

    static fromJS(data: any): SubmissionDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmissionDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filingConstituentEntity"] = this.filingConstituentEntity;
        data["role"] = this.role;
        if (this.countrySpecificParams) {
            data["countrySpecificParams"] = {};
            for (let key in this.countrySpecificParams) {
                if (this.countrySpecificParams.hasOwnProperty(key))
                    (<any>data["countrySpecificParams"])[key] = (<any>this.countrySpecificParams)[key];
            }
        }
        return data;
    }
}

export interface ISubmissionDetailsDto {
    filingConstituentEntity: string | undefined;
    role: SubmissionRoleType;
    countrySpecificParams: { [key: string]: string; } | undefined;
}

export class SubmissionDetailsInput implements ISubmissionDetailsInput {
    filingConstituentEntity!: number | undefined;
    role!: SubmissionRoleType;
    countrySpecificParams!: { [key: string]: string; } | undefined;

    constructor(data?: ISubmissionDetailsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filingConstituentEntity = _data["filingConstituentEntity"];
            this.role = _data["role"];
            if (_data["countrySpecificParams"]) {
                this.countrySpecificParams = {} as any;
                for (let key in _data["countrySpecificParams"]) {
                    if (_data["countrySpecificParams"].hasOwnProperty(key))
                        (<any>this.countrySpecificParams)![key] = _data["countrySpecificParams"][key];
                }
            }
        }
    }

    static fromJS(data: any): SubmissionDetailsInput {
        data = typeof data === 'object' ? data : {};
        let result = new SubmissionDetailsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filingConstituentEntity"] = this.filingConstituentEntity;
        data["role"] = this.role;
        if (this.countrySpecificParams) {
            data["countrySpecificParams"] = {};
            for (let key in this.countrySpecificParams) {
                if (this.countrySpecificParams.hasOwnProperty(key))
                    (<any>data["countrySpecificParams"])[key] = (<any>this.countrySpecificParams)[key];
            }
        }
        return data;
    }
}

export interface ISubmissionDetailsInput {
    filingConstituentEntity: number | undefined;
    role: SubmissionRoleType;
    countrySpecificParams: { [key: string]: string; } | undefined;
}

export class SubmissionDto implements ISubmissionDto {
    id!: number;
    projectId!: number;
    obligationId!: number | undefined;
    hasSubmissions!: boolean;
    isReviewEditSubmission!: boolean;
    transactionNumber!: string | undefined;
    isAutomatic!: boolean;
    tags!: TagDto[] | undefined;
    process!: ProcessDto | undefined;
    general!: GeneralDto | undefined;
    projectManagement!: FullProjectManagementDto | undefined;
    specifics!: SubmissionSpecificDto | undefined;
    details!: SubmissionDetailsDto | undefined;

    constructor(data?: ISubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.obligationId = _data["obligationId"];
            this.hasSubmissions = _data["hasSubmissions"];
            this.isReviewEditSubmission = _data["isReviewEditSubmission"];
            this.transactionNumber = _data["transactionNumber"];
            this.isAutomatic = _data["isAutomatic"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
            this.process = _data["process"] ? ProcessDto.fromJS(_data["process"]) : <any>undefined;
            this.general = _data["general"] ? GeneralDto.fromJS(_data["general"]) : <any>undefined;
            this.projectManagement = _data["projectManagement"] ? FullProjectManagementDto.fromJS(_data["projectManagement"]) : <any>undefined;
            this.specifics = _data["specifics"] ? SubmissionSpecificDto.fromJS(_data["specifics"]) : <any>undefined;
            this.details = _data["details"] ? SubmissionDetailsDto.fromJS(_data["details"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["obligationId"] = this.obligationId;
        data["hasSubmissions"] = this.hasSubmissions;
        data["isReviewEditSubmission"] = this.isReviewEditSubmission;
        data["transactionNumber"] = this.transactionNumber;
        data["isAutomatic"] = this.isAutomatic;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["process"] = this.process ? this.process.toJSON() : <any>undefined;
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["projectManagement"] = this.projectManagement ? this.projectManagement.toJSON() : <any>undefined;
        data["specifics"] = this.specifics ? this.specifics.toJSON() : <any>undefined;
        data["details"] = this.details ? this.details.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISubmissionDto {
    id: number;
    projectId: number;
    obligationId: number | undefined;
    hasSubmissions: boolean;
    isReviewEditSubmission: boolean;
    transactionNumber: string | undefined;
    isAutomatic: boolean;
    tags: TagDto[] | undefined;
    process: ProcessDto | undefined;
    general: GeneralDto | undefined;
    projectManagement: FullProjectManagementDto | undefined;
    specifics: SubmissionSpecificDto | undefined;
    details: SubmissionDetailsDto | undefined;
}

export class SubmissionFileDto implements ISubmissionFileDto {
    fileId!: number;
    fileName!: string | undefined;
    hasPreview!: boolean;

    constructor(data?: ISubmissionFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.fileName = _data["fileName"];
            this.hasPreview = _data["hasPreview"];
        }
    }

    static fromJS(data: any): SubmissionFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmissionFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["hasPreview"] = this.hasPreview;
        return data;
    }
}

export interface ISubmissionFileDto {
    fileId: number;
    fileName: string | undefined;
    hasPreview: boolean;
}

export class SubmissionFilesDto implements ISubmissionFilesDto {
    feedbackFiles!: SubmissionFileDto[] | undefined;
    userUploads!: SubmissionFileDto[] | undefined;

    constructor(data?: ISubmissionFilesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["feedbackFiles"])) {
                this.feedbackFiles = [] as any;
                for (let item of _data["feedbackFiles"])
                    this.feedbackFiles!.push(SubmissionFileDto.fromJS(item));
            }
            if (Array.isArray(_data["userUploads"])) {
                this.userUploads = [] as any;
                for (let item of _data["userUploads"])
                    this.userUploads!.push(SubmissionFileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubmissionFilesDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmissionFilesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.feedbackFiles)) {
            data["feedbackFiles"] = [];
            for (let item of this.feedbackFiles)
                data["feedbackFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.userUploads)) {
            data["userUploads"] = [];
            for (let item of this.userUploads)
                data["userUploads"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISubmissionFilesDto {
    feedbackFiles: SubmissionFileDto[] | undefined;
    userUploads: SubmissionFileDto[] | undefined;
}

export class SubmissionFinishEditingInput implements ISubmissionFinishEditingInput {
    id!: number;
    submissionId!: number;
    comment!: string | undefined;
    assignedUserId!: number | undefined;

    constructor(data?: ISubmissionFinishEditingInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.submissionId = _data["submissionId"];
            this.comment = _data["comment"];
            this.assignedUserId = _data["assignedUserId"];
        }
    }

    static fromJS(data: any): SubmissionFinishEditingInput {
        data = typeof data === 'object' ? data : {};
        let result = new SubmissionFinishEditingInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["submissionId"] = this.submissionId;
        data["comment"] = this.comment;
        data["assignedUserId"] = this.assignedUserId;
        return data;
    }
}

export interface ISubmissionFinishEditingInput {
    id: number;
    submissionId: number;
    comment: string | undefined;
    assignedUserId: number | undefined;
}

export class SubmissionFinishInput implements ISubmissionFinishInput {
    id!: number;
    submissionId!: number;
    comment!: string | undefined;
    assignedUserId!: number | undefined;

    constructor(data?: ISubmissionFinishInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.submissionId = _data["submissionId"];
            this.comment = _data["comment"];
            this.assignedUserId = _data["assignedUserId"];
        }
    }

    static fromJS(data: any): SubmissionFinishInput {
        data = typeof data === 'object' ? data : {};
        let result = new SubmissionFinishInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["submissionId"] = this.submissionId;
        data["comment"] = this.comment;
        data["assignedUserId"] = this.assignedUserId;
        return data;
    }
}

export interface ISubmissionFinishInput {
    id: number;
    submissionId: number;
    comment: string | undefined;
    assignedUserId: number | undefined;
}

export class SubmissionFinishReviewInput implements ISubmissionFinishReviewInput {
    id!: number;
    submissionId!: number;
    comment!: string | undefined;
    assignedUserId!: number | undefined;
    submissionDecision!: SubmissionReviewDecision;
    isBulkOperation!: boolean;

    constructor(data?: ISubmissionFinishReviewInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.submissionId = _data["submissionId"];
            this.comment = _data["comment"];
            this.assignedUserId = _data["assignedUserId"];
            this.submissionDecision = _data["submissionDecision"];
            this.isBulkOperation = _data["isBulkOperation"];
        }
    }

    static fromJS(data: any): SubmissionFinishReviewInput {
        data = typeof data === 'object' ? data : {};
        let result = new SubmissionFinishReviewInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["submissionId"] = this.submissionId;
        data["comment"] = this.comment;
        data["assignedUserId"] = this.assignedUserId;
        data["submissionDecision"] = this.submissionDecision;
        data["isBulkOperation"] = this.isBulkOperation;
        return data;
    }
}

export interface ISubmissionFinishReviewInput {
    id: number;
    submissionId: number;
    comment: string | undefined;
    assignedUserId: number | undefined;
    submissionDecision: SubmissionReviewDecision;
    isBulkOperation: boolean;
}

export class SubmissionFormDto implements ISubmissionFormDto {
    id!: number;
    submissionFormId!: string | undefined;
    submissionFormVersion!: string | undefined;
    submissionForm!: string | undefined;
    submissionFormData!: string | undefined;

    constructor(data?: ISubmissionFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.submissionFormId = _data["submissionFormId"];
            this.submissionFormVersion = _data["submissionFormVersion"];
            this.submissionForm = _data["submissionForm"];
            this.submissionFormData = _data["submissionFormData"];
        }
    }

    static fromJS(data: any): SubmissionFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmissionFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["submissionFormId"] = this.submissionFormId;
        data["submissionFormVersion"] = this.submissionFormVersion;
        data["submissionForm"] = this.submissionForm;
        data["submissionFormData"] = this.submissionFormData;
        return data;
    }
}

export interface ISubmissionFormDto {
    id: number;
    submissionFormId: string | undefined;
    submissionFormVersion: string | undefined;
    submissionForm: string | undefined;
    submissionFormData: string | undefined;
}

export class SubmissionGeneralInput implements ISubmissionGeneralInput {
    note!: string | undefined;
    name!: string;
    tags!: TagDto[] | undefined;

    constructor(data?: ISubmissionGeneralInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.note = _data["note"];
            this.name = _data["name"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubmissionGeneralInput {
        data = typeof data === 'object' ? data : {};
        let result = new SubmissionGeneralInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["note"] = this.note;
        data["name"] = this.name;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISubmissionGeneralInput {
    note: string | undefined;
    name: string;
    tags: TagDto[] | undefined;
}

export class SubmissionOverviewDto implements ISubmissionOverviewDto {
    id!: number;
    name!: string | undefined;
    projectId!: number;
    obligationId!: number;
    filingObligationName!: string | undefined;
    transactionNumber!: string | undefined;
    isAutomatic!: boolean;
    isSubmitted!: boolean;
    submissionDeadline!: DateTime | undefined;
    tags!: TagDto[] | undefined;
    assignedUser!: AssignableUserDto | undefined;
    process!: ProcessDto | undefined;
    criticality!: Criticality | undefined;
    priority!: Priority | undefined;
    plannedStart!: DateTime | undefined;
    plannedEnd!: DateTime | undefined;
    effort!: number | undefined;
    lastModifier!: string | undefined;
    lastModifierUserId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    creatorUserId!: number | undefined;
    author!: string | undefined;
    creationTime!: DateTime;

    constructor(data?: ISubmissionOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.obligationId = _data["obligationId"];
            this.filingObligationName = _data["filingObligationName"];
            this.transactionNumber = _data["transactionNumber"];
            this.isAutomatic = _data["isAutomatic"];
            this.isSubmitted = _data["isSubmitted"];
            this.submissionDeadline = _data["submissionDeadline"] ? DateTime.fromISO(_data["submissionDeadline"].toString()) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
            this.assignedUser = _data["assignedUser"] ? AssignableUserDto.fromJS(_data["assignedUser"]) : <any>undefined;
            this.process = _data["process"] ? ProcessDto.fromJS(_data["process"]) : <any>undefined;
            this.criticality = _data["criticality"];
            this.priority = _data["priority"];
            this.plannedStart = _data["plannedStart"] ? DateTime.fromISO(_data["plannedStart"].toString()) : <any>undefined;
            this.plannedEnd = _data["plannedEnd"] ? DateTime.fromISO(_data["plannedEnd"].toString()) : <any>undefined;
            this.effort = _data["effort"];
            this.lastModifier = _data["lastModifier"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.author = _data["author"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SubmissionOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmissionOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["obligationId"] = this.obligationId;
        data["filingObligationName"] = this.filingObligationName;
        data["transactionNumber"] = this.transactionNumber;
        data["isAutomatic"] = this.isAutomatic;
        data["isSubmitted"] = this.isSubmitted;
        data["submissionDeadline"] = this.submissionDeadline ? this.submissionDeadline.toString() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["assignedUser"] = this.assignedUser ? this.assignedUser.toJSON() : <any>undefined;
        data["process"] = this.process ? this.process.toJSON() : <any>undefined;
        data["criticality"] = this.criticality;
        data["priority"] = this.priority;
        data["plannedStart"] = this.plannedStart ? this.plannedStart.toString() : <any>undefined;
        data["plannedEnd"] = this.plannedEnd ? this.plannedEnd.toString() : <any>undefined;
        data["effort"] = this.effort;
        data["lastModifier"] = this.lastModifier;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["author"] = this.author;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface ISubmissionOverviewDto {
    id: number;
    name: string | undefined;
    projectId: number;
    obligationId: number;
    filingObligationName: string | undefined;
    transactionNumber: string | undefined;
    isAutomatic: boolean;
    isSubmitted: boolean;
    submissionDeadline: DateTime | undefined;
    tags: TagDto[] | undefined;
    assignedUser: AssignableUserDto | undefined;
    process: ProcessDto | undefined;
    criticality: Criticality | undefined;
    priority: Priority | undefined;
    plannedStart: DateTime | undefined;
    plannedEnd: DateTime | undefined;
    effort: number | undefined;
    lastModifier: string | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: DateTime | undefined;
    creatorUserId: number | undefined;
    author: string | undefined;
    creationTime: DateTime;
}

export class SubmissionProcessStateHistoryOverviewDto implements ISubmissionProcessStateHistoryOverviewDto {
    id!: number;
    completedState!: string | undefined;
    activatedState!: string | undefined;
    comment!: string | undefined;
    creationTime!: DateTime;
    author!: string | undefined;
    creatorUserId!: number | undefined;
    assignedUser!: AssignableUserDto | undefined;

    constructor(data?: ISubmissionProcessStateHistoryOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.completedState = _data["completedState"];
            this.activatedState = _data["activatedState"];
            this.comment = _data["comment"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.author = _data["author"];
            this.creatorUserId = _data["creatorUserId"];
            this.assignedUser = _data["assignedUser"] ? AssignableUserDto.fromJS(_data["assignedUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SubmissionProcessStateHistoryOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmissionProcessStateHistoryOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["completedState"] = this.completedState;
        data["activatedState"] = this.activatedState;
        data["comment"] = this.comment;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["author"] = this.author;
        data["creatorUserId"] = this.creatorUserId;
        data["assignedUser"] = this.assignedUser ? this.assignedUser.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISubmissionProcessStateHistoryOverviewDto {
    id: number;
    completedState: string | undefined;
    activatedState: string | undefined;
    comment: string | undefined;
    creationTime: DateTime;
    author: string | undefined;
    creatorUserId: number | undefined;
    assignedUser: AssignableUserDto | undefined;
}

export enum SubmissionProcessSubmitType {
    Manual = 1,
    Automatic = 2,
}

export enum SubmissionReviewDecision {
    Approve = 0,
    Decline = 1,
}

export class SubmissionRevokeInput implements ISubmissionRevokeInput {
    id!: number;
    submissionId!: number;
    comment!: string | undefined;
    assignedUserId!: number | undefined;

    constructor(data?: ISubmissionRevokeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.submissionId = _data["submissionId"];
            this.comment = _data["comment"];
            this.assignedUserId = _data["assignedUserId"];
        }
    }

    static fromJS(data: any): SubmissionRevokeInput {
        data = typeof data === 'object' ? data : {};
        let result = new SubmissionRevokeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["submissionId"] = this.submissionId;
        data["comment"] = this.comment;
        data["assignedUserId"] = this.assignedUserId;
        return data;
    }
}

export interface ISubmissionRevokeInput {
    id: number;
    submissionId: number;
    comment: string | undefined;
    assignedUserId: number | undefined;
}

export enum SubmissionRoleType {
    UltimateParentEntity = 1,
    DesignatedFilingEntity = 2,
    DesignatedLocalEntity = 3,
    ConstituentEntity = 4,
    Other = 5,
}

export class SubmissionShorthandDto implements ISubmissionShorthandDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: ISubmissionShorthandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SubmissionShorthandDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmissionShorthandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ISubmissionShorthandDto {
    id: number;
    name: string | undefined;
}

export class SubmissionSpecificDto implements ISubmissionSpecificDto {
    obligationCountry!: string | undefined;
    belongingObligation!: string | undefined;
    submissionType!: SubmissionType;
    submissionDeadline!: DateTime | undefined;

    constructor(data?: ISubmissionSpecificDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.obligationCountry = _data["obligationCountry"];
            this.belongingObligation = _data["belongingObligation"];
            this.submissionType = _data["submissionType"];
            this.submissionDeadline = _data["submissionDeadline"] ? DateTime.fromISO(_data["submissionDeadline"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SubmissionSpecificDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmissionSpecificDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["obligationCountry"] = this.obligationCountry;
        data["belongingObligation"] = this.belongingObligation;
        data["submissionType"] = this.submissionType;
        data["submissionDeadline"] = this.submissionDeadline ? this.submissionDeadline.toString() : <any>undefined;
        return data;
    }
}

export interface ISubmissionSpecificDto {
    obligationCountry: string | undefined;
    belongingObligation: string | undefined;
    submissionType: SubmissionType;
    submissionDeadline: DateTime | undefined;
}

export class SubmissionSpecificInput implements ISubmissionSpecificInput {
    obligationId!: number | undefined;
    obligationCountry!: string | undefined;
    submissionType!: SubmissionType;
    submissionDeadline!: DateTime;

    constructor(data?: ISubmissionSpecificInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.obligationId = _data["obligationId"];
            this.obligationCountry = _data["obligationCountry"];
            this.submissionType = _data["submissionType"];
            this.submissionDeadline = _data["submissionDeadline"] ? DateTime.fromISO(_data["submissionDeadline"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SubmissionSpecificInput {
        data = typeof data === 'object' ? data : {};
        let result = new SubmissionSpecificInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["obligationId"] = this.obligationId;
        data["obligationCountry"] = this.obligationCountry;
        data["submissionType"] = this.submissionType;
        data["submissionDeadline"] = this.submissionDeadline ? this.submissionDeadline.toString() : <any>undefined;
        return data;
    }
}

export interface ISubmissionSpecificInput {
    obligationId: number | undefined;
    obligationCountry: string | undefined;
    submissionType: SubmissionType;
    submissionDeadline: DateTime;
}

export class SubmissionStatusUpdateInput implements ISubmissionStatusUpdateInput {
    submissionId!: number;
    assignedUserId!: number | undefined;
    comment!: string | undefined;

    constructor(data?: ISubmissionStatusUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submissionId = _data["submissionId"];
            this.assignedUserId = _data["assignedUserId"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): SubmissionStatusUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new SubmissionStatusUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submissionId"] = this.submissionId;
        data["assignedUserId"] = this.assignedUserId;
        data["comment"] = this.comment;
        return data;
    }
}

export interface ISubmissionStatusUpdateInput {
    submissionId: number;
    assignedUserId: number | undefined;
    comment: string | undefined;
}

export class SubmissionSubmitInput implements ISubmissionSubmitInput {
    id!: number;
    submissionId!: number;
    comment!: string | undefined;
    assignedUserId!: number | undefined;
    submitType!: SubmissionProcessSubmitType | undefined;
    skipValidation!: boolean;

    constructor(data?: ISubmissionSubmitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.submissionId = _data["submissionId"];
            this.comment = _data["comment"];
            this.assignedUserId = _data["assignedUserId"];
            this.submitType = _data["submitType"];
            this.skipValidation = _data["skipValidation"];
        }
    }

    static fromJS(data: any): SubmissionSubmitInput {
        data = typeof data === 'object' ? data : {};
        let result = new SubmissionSubmitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["submissionId"] = this.submissionId;
        data["comment"] = this.comment;
        data["assignedUserId"] = this.assignedUserId;
        data["submitType"] = this.submitType;
        data["skipValidation"] = this.skipValidation;
        return data;
    }
}

export interface ISubmissionSubmitInput {
    id: number;
    submissionId: number;
    comment: string | undefined;
    assignedUserId: number | undefined;
    submitType: SubmissionProcessSubmitType | undefined;
    skipValidation: boolean;
}

export enum SubmissionType {
    Gir = 1,
}

export class SubmissionsRequestOverviewInput implements ISubmissionsRequestOverviewInput {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    projectId!: number | undefined;
    obligationId!: number | undefined;
    filter!: string | undefined;
    deadlineDateRange!: DateRange | undefined;
    assignedUsersFilter!: number[] | undefined;
    tagsFilter!: string[] | undefined;
    processStatesFilter!: string[] | undefined;
    submissionId!: number | undefined;

    constructor(data?: ISubmissionsRequestOverviewInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.projectId = _data["projectId"];
            this.obligationId = _data["obligationId"];
            this.filter = _data["filter"];
            this.deadlineDateRange = _data["deadlineDateRange"] ? DateRange.fromJS(_data["deadlineDateRange"]) : <any>undefined;
            if (Array.isArray(_data["assignedUsersFilter"])) {
                this.assignedUsersFilter = [] as any;
                for (let item of _data["assignedUsersFilter"])
                    this.assignedUsersFilter!.push(item);
            }
            if (Array.isArray(_data["tagsFilter"])) {
                this.tagsFilter = [] as any;
                for (let item of _data["tagsFilter"])
                    this.tagsFilter!.push(item);
            }
            if (Array.isArray(_data["processStatesFilter"])) {
                this.processStatesFilter = [] as any;
                for (let item of _data["processStatesFilter"])
                    this.processStatesFilter!.push(item);
            }
            this.submissionId = _data["submissionId"];
        }
    }

    static fromJS(data: any): SubmissionsRequestOverviewInput {
        data = typeof data === 'object' ? data : {};
        let result = new SubmissionsRequestOverviewInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["projectId"] = this.projectId;
        data["obligationId"] = this.obligationId;
        data["filter"] = this.filter;
        data["deadlineDateRange"] = this.deadlineDateRange ? this.deadlineDateRange.toJSON() : <any>undefined;
        if (Array.isArray(this.assignedUsersFilter)) {
            data["assignedUsersFilter"] = [];
            for (let item of this.assignedUsersFilter)
                data["assignedUsersFilter"].push(item);
        }
        if (Array.isArray(this.tagsFilter)) {
            data["tagsFilter"] = [];
            for (let item of this.tagsFilter)
                data["tagsFilter"].push(item);
        }
        if (Array.isArray(this.processStatesFilter)) {
            data["processStatesFilter"] = [];
            for (let item of this.processStatesFilter)
                data["processStatesFilter"].push(item);
        }
        data["submissionId"] = this.submissionId;
        return data;
    }
}

export interface ISubmissionsRequestOverviewInput {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    projectId: number | undefined;
    obligationId: number | undefined;
    filter: string | undefined;
    deadlineDateRange: DateRange | undefined;
    assignedUsersFilter: number[] | undefined;
    tagsFilter: string[] | undefined;
    processStatesFilter: string[] | undefined;
    submissionId: number | undefined;
}

export class SurveyLookupDto implements ISurveyLookupDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: ISurveyLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SurveyLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ISurveyLookupDto {
    id: number;
    name: string | undefined;
}

export class TagDto implements ITagDto {
    name!: string | undefined;

    constructor(data?: ITagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TagDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ITagDto {
    name: string | undefined;
}

export class TaskDto implements ITaskDto {
    id!: number;
    moduleName!: string | undefined;
    taskName!: string | undefined;
    isUrgent!: boolean;
    dueDate!: DateTime | undefined;
    process!: ProcessDto | undefined;
    customQueryPath!: string | undefined;

    constructor(data?: ITaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.moduleName = _data["moduleName"];
            this.taskName = _data["taskName"];
            this.isUrgent = _data["isUrgent"];
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
            this.process = _data["process"] ? ProcessDto.fromJS(_data["process"]) : <any>undefined;
            this.customQueryPath = _data["customQueryPath"];
        }
    }

    static fromJS(data: any): TaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["moduleName"] = this.moduleName;
        data["taskName"] = this.taskName;
        data["isUrgent"] = this.isUrgent;
        data["dueDate"] = this.dueDate ? this.dueDate.toString() : <any>undefined;
        data["process"] = this.process ? this.process.toJSON() : <any>undefined;
        data["customQueryPath"] = this.customQueryPath;
        return data;
    }
}

export interface ITaskDto {
    id: number;
    moduleName: string | undefined;
    taskName: string | undefined;
    isUrgent: boolean;
    dueDate: DateTime | undefined;
    process: ProcessDto | undefined;
    customQueryPath: string | undefined;
}

export class TaxJurisdictionCountryReferenceDataDto implements ITaxJurisdictionCountryReferenceDataDto {
    id!: string | undefined;
    text!: string | undefined;
    obligationId!: number | undefined;

    constructor(data?: ITaxJurisdictionCountryReferenceDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            this.obligationId = _data["obligationId"];
        }
    }

    static fromJS(data: any): TaxJurisdictionCountryReferenceDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxJurisdictionCountryReferenceDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["obligationId"] = this.obligationId;
        return data;
    }
}

export interface ITaxJurisdictionCountryReferenceDataDto {
    id: string | undefined;
    text: string | undefined;
    obligationId: number | undefined;
}

export enum TaxTreatment {
    Opaque = 1,
    Transparent = 2,
}

export enum TestsStatus {
    Green = 1,
    Red = 2,
    Blue = 3,
}

export class ThirdPartyParticipationDto implements IThirdPartyParticipationDto {
    id!: number | undefined;
    interestParticipation!: number;
    thirdPartyShareholderRelationshipId!: number;
    organizationalEntityId!: number;

    constructor(data?: IThirdPartyParticipationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.interestParticipation = _data["interestParticipation"];
            this.thirdPartyShareholderRelationshipId = _data["thirdPartyShareholderRelationshipId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
        }
    }

    static fromJS(data: any): ThirdPartyParticipationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThirdPartyParticipationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["interestParticipation"] = this.interestParticipation;
        data["thirdPartyShareholderRelationshipId"] = this.thirdPartyShareholderRelationshipId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        return data;
    }
}

export interface IThirdPartyParticipationDto {
    id: number | undefined;
    interestParticipation: number;
    thirdPartyShareholderRelationshipId: number;
    organizationalEntityId: number;
}

export class ThirdPartyParticipationInput implements IThirdPartyParticipationInput {
    id!: number | undefined;
    interestParticipation!: number;
    thirdPartyShareholderRelationshipId!: number;
    organizationalEntityId!: number;

    constructor(data?: IThirdPartyParticipationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.interestParticipation = _data["interestParticipation"];
            this.thirdPartyShareholderRelationshipId = _data["thirdPartyShareholderRelationshipId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
        }
    }

    static fromJS(data: any): ThirdPartyParticipationInput {
        data = typeof data === 'object' ? data : {};
        let result = new ThirdPartyParticipationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["interestParticipation"] = this.interestParticipation;
        data["thirdPartyShareholderRelationshipId"] = this.thirdPartyShareholderRelationshipId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        return data;
    }
}

export interface IThirdPartyParticipationInput {
    id: number | undefined;
    interestParticipation: number;
    thirdPartyShareholderRelationshipId: number;
    organizationalEntityId: number;
}

export class ThirdPartyShareholderDto implements IThirdPartyShareholderDto {
    id!: number;
    interestValue!: ConfirmableDtoOfString | undefined;
    thirdPartyName!: ConfirmableDtoOfString | undefined;

    constructor(data?: IThirdPartyShareholderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.interestValue = _data["interestValue"] ? ConfirmableDtoOfString.fromJS(_data["interestValue"]) : <any>undefined;
            this.thirdPartyName = _data["thirdPartyName"] ? ConfirmableDtoOfString.fromJS(_data["thirdPartyName"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ThirdPartyShareholderDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThirdPartyShareholderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["interestValue"] = this.interestValue ? this.interestValue.toJSON() : <any>undefined;
        data["thirdPartyName"] = this.thirdPartyName ? this.thirdPartyName.toJSON() : <any>undefined;
        return data;
    }
}

export interface IThirdPartyShareholderDto {
    id: number;
    interestValue: ConfirmableDtoOfString | undefined;
    thirdPartyName: ConfirmableDtoOfString | undefined;
}

export class ThirdPartyShareholderInput implements IThirdPartyShareholderInput {
    id!: number | undefined;
    interestValue!: ConfirmableInputOfString | undefined;
    thirdPartyName!: ConfirmableInputOfString | undefined;

    constructor(data?: IThirdPartyShareholderInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.interestValue = _data["interestValue"] ? ConfirmableInputOfString.fromJS(_data["interestValue"]) : <any>undefined;
            this.thirdPartyName = _data["thirdPartyName"] ? ConfirmableInputOfString.fromJS(_data["thirdPartyName"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ThirdPartyShareholderInput {
        data = typeof data === 'object' ? data : {};
        let result = new ThirdPartyShareholderInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["interestValue"] = this.interestValue ? this.interestValue.toJSON() : <any>undefined;
        data["thirdPartyName"] = this.thirdPartyName ? this.thirdPartyName.toJSON() : <any>undefined;
        return data;
    }
}

export interface IThirdPartyShareholderInput {
    id: number | undefined;
    interestValue: ConfirmableInputOfString | undefined;
    thirdPartyName: ConfirmableInputOfString | undefined;
}

export enum TinType {
    TaxIdentificationNumber = 1,
    FunctionallyEquivalentNumber = 2,
    AgreedGIRDesignatedNumber = 3,
    NotRequiredToBeReported = 4,
}

export class ToggleConfirmationInput implements IToggleConfirmationInput {
    projectId!: number;
    organizationalEntityId!: number | undefined;
    isConfirmed!: boolean;

    constructor(data?: IToggleConfirmationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ToggleConfirmationInput {
        data = typeof data === 'object' ? data : {};
        let result = new ToggleConfirmationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IToggleConfirmationInput {
    projectId: number;
    organizationalEntityId: number | undefined;
    isConfirmed: boolean;
}

export class TopUpTaxAssignmentDto implements ITopUpTaxAssignmentDto {
    assignedPercentage!: string | undefined;
    assignedTopUpTax!: string | undefined;
    inclusioRatioPercentage!: string | undefined;
    topUpTaxShare!: string | undefined;
    iirOffSet!: string | undefined;
    topUpTaxCurrency!: string | undefined;
    assignedEntityLegalName!: string | undefined;
    assignedEntityJurisdiction!: string | undefined;
    originEntityLegalName!: string | undefined;
    originEntityJurisdiction!: string | undefined;
    topUpTaxAssignmentReason!: string | undefined;

    constructor(data?: ITopUpTaxAssignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignedPercentage = _data["assignedPercentage"];
            this.assignedTopUpTax = _data["assignedTopUpTax"];
            this.inclusioRatioPercentage = _data["inclusioRatioPercentage"];
            this.topUpTaxShare = _data["topUpTaxShare"];
            this.iirOffSet = _data["iirOffSet"];
            this.topUpTaxCurrency = _data["topUpTaxCurrency"];
            this.assignedEntityLegalName = _data["assignedEntityLegalName"];
            this.assignedEntityJurisdiction = _data["assignedEntityJurisdiction"];
            this.originEntityLegalName = _data["originEntityLegalName"];
            this.originEntityJurisdiction = _data["originEntityJurisdiction"];
            this.topUpTaxAssignmentReason = _data["topUpTaxAssignmentReason"];
        }
    }

    static fromJS(data: any): TopUpTaxAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new TopUpTaxAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignedPercentage"] = this.assignedPercentage;
        data["assignedTopUpTax"] = this.assignedTopUpTax;
        data["inclusioRatioPercentage"] = this.inclusioRatioPercentage;
        data["topUpTaxShare"] = this.topUpTaxShare;
        data["iirOffSet"] = this.iirOffSet;
        data["topUpTaxCurrency"] = this.topUpTaxCurrency;
        data["assignedEntityLegalName"] = this.assignedEntityLegalName;
        data["assignedEntityJurisdiction"] = this.assignedEntityJurisdiction;
        data["originEntityLegalName"] = this.originEntityLegalName;
        data["originEntityJurisdiction"] = this.originEntityJurisdiction;
        data["topUpTaxAssignmentReason"] = this.topUpTaxAssignmentReason;
        return data;
    }
}

export interface ITopUpTaxAssignmentDto {
    assignedPercentage: string | undefined;
    assignedTopUpTax: string | undefined;
    inclusioRatioPercentage: string | undefined;
    topUpTaxShare: string | undefined;
    iirOffSet: string | undefined;
    topUpTaxCurrency: string | undefined;
    assignedEntityLegalName: string | undefined;
    assignedEntityJurisdiction: string | undefined;
    originEntityLegalName: string | undefined;
    originEntityJurisdiction: string | undefined;
    topUpTaxAssignmentReason: string | undefined;
}

export class TransitionDataDto implements ITransitionDataDto {
    year!: DateTime | undefined;
    altJurisdiction!: string | undefined;
    deferredTaxLiabilityStart!: number | undefined;
    deferredTaxLiabilityRecast!: number | undefined;
    deferredTaxAssetStart!: number | undefined;
    deferredTaxAssetRecast!: number | undefined;
    deferredTaxAssetExcluded!: number | undefined;

    constructor(data?: ITransitionDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"] ? DateTime.fromISO(_data["year"].toString()) : <any>undefined;
            this.altJurisdiction = _data["altJurisdiction"];
            this.deferredTaxLiabilityStart = _data["deferredTaxLiabilityStart"];
            this.deferredTaxLiabilityRecast = _data["deferredTaxLiabilityRecast"];
            this.deferredTaxAssetStart = _data["deferredTaxAssetStart"];
            this.deferredTaxAssetRecast = _data["deferredTaxAssetRecast"];
            this.deferredTaxAssetExcluded = _data["deferredTaxAssetExcluded"];
        }
    }

    static fromJS(data: any): TransitionDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransitionDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year ? this.year.toString() : <any>undefined;
        data["altJurisdiction"] = this.altJurisdiction;
        data["deferredTaxLiabilityStart"] = this.deferredTaxLiabilityStart;
        data["deferredTaxLiabilityRecast"] = this.deferredTaxLiabilityRecast;
        data["deferredTaxAssetStart"] = this.deferredTaxAssetStart;
        data["deferredTaxAssetRecast"] = this.deferredTaxAssetRecast;
        data["deferredTaxAssetExcluded"] = this.deferredTaxAssetExcluded;
        return data;
    }
}

export interface ITransitionDataDto {
    year: DateTime | undefined;
    altJurisdiction: string | undefined;
    deferredTaxLiabilityStart: number | undefined;
    deferredTaxLiabilityRecast: number | undefined;
    deferredTaxAssetStart: number | undefined;
    deferredTaxAssetRecast: number | undefined;
    deferredTaxAssetExcluded: number | undefined;
}

export class TutBlendingCirclesOverviewDto implements ITutBlendingCirclesOverviewDto {
    columns!: TutOverviewColumnsDto[] | undefined;
    tutOverviewDtos!: TutOverviewDto[] | undefined;

    constructor(data?: ITutBlendingCirclesOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(TutOverviewColumnsDto.fromJS(item));
            }
            if (Array.isArray(_data["tutOverviewDtos"])) {
                this.tutOverviewDtos = [] as any;
                for (let item of _data["tutOverviewDtos"])
                    this.tutOverviewDtos!.push(TutOverviewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TutBlendingCirclesOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new TutBlendingCirclesOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        if (Array.isArray(this.tutOverviewDtos)) {
            data["tutOverviewDtos"] = [];
            for (let item of this.tutOverviewDtos)
                data["tutOverviewDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITutBlendingCirclesOverviewDto {
    columns: TutOverviewColumnsDto[] | undefined;
    tutOverviewDtos: TutOverviewDto[] | undefined;
}

export class TutCurrentValueDto implements ITutCurrentValueDto {
    value!: FinancialValueDto | undefined;
    isConfirmed!: boolean;
    country!: string | undefined;
    blendingCircleSubgroupId!: number | undefined;
    blendingCircleSubgroupType!: string | undefined;
    blendingCircleSubgroupNumber!: number | undefined;
    financialValueTracePointAdditionalInfo!: FinancialValueTracePointAdditionalDto | undefined;
    localizationKey!: string | undefined;

    constructor(data?: ITutCurrentValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? FinancialValueDto.fromJS(_data["value"]) : <any>undefined;
            this.isConfirmed = _data["isConfirmed"];
            this.country = _data["country"];
            this.blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
            this.blendingCircleSubgroupType = _data["blendingCircleSubgroupType"];
            this.blendingCircleSubgroupNumber = _data["blendingCircleSubgroupNumber"];
            this.financialValueTracePointAdditionalInfo = _data["financialValueTracePointAdditionalInfo"] ? FinancialValueTracePointAdditionalDto.fromJS(_data["financialValueTracePointAdditionalInfo"]) : <any>undefined;
            this.localizationKey = _data["localizationKey"];
        }
    }

    static fromJS(data: any): TutCurrentValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new TutCurrentValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        data["isConfirmed"] = this.isConfirmed;
        data["country"] = this.country;
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        data["blendingCircleSubgroupType"] = this.blendingCircleSubgroupType;
        data["blendingCircleSubgroupNumber"] = this.blendingCircleSubgroupNumber;
        data["financialValueTracePointAdditionalInfo"] = this.financialValueTracePointAdditionalInfo ? this.financialValueTracePointAdditionalInfo.toJSON() : <any>undefined;
        data["localizationKey"] = this.localizationKey;
        return data;
    }
}

export interface ITutCurrentValueDto {
    value: FinancialValueDto | undefined;
    isConfirmed: boolean;
    country: string | undefined;
    blendingCircleSubgroupId: number | undefined;
    blendingCircleSubgroupType: string | undefined;
    blendingCircleSubgroupNumber: number | undefined;
    financialValueTracePointAdditionalInfo: FinancialValueTracePointAdditionalDto | undefined;
    localizationKey: string | undefined;
}

export class TutForBlendingCircleSubgroupDto implements ITutForBlendingCircleSubgroupDto {
    tutValues!: TutForOrganizationalEntityDto[] | undefined;
    totalTutForEntitiesWithoutAccess!: string | undefined;
    hasReadPermissionForCountry!: boolean;
    switchOffDetails!: TutSwitchOffDetails | undefined;

    constructor(data?: ITutForBlendingCircleSubgroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tutValues"])) {
                this.tutValues = [] as any;
                for (let item of _data["tutValues"])
                    this.tutValues!.push(TutForOrganizationalEntityDto.fromJS(item));
            }
            this.totalTutForEntitiesWithoutAccess = _data["totalTutForEntitiesWithoutAccess"];
            this.hasReadPermissionForCountry = _data["hasReadPermissionForCountry"];
            this.switchOffDetails = _data["switchOffDetails"] ? TutSwitchOffDetails.fromJS(_data["switchOffDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TutForBlendingCircleSubgroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new TutForBlendingCircleSubgroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tutValues)) {
            data["tutValues"] = [];
            for (let item of this.tutValues)
                data["tutValues"].push(item.toJSON());
        }
        data["totalTutForEntitiesWithoutAccess"] = this.totalTutForEntitiesWithoutAccess;
        data["hasReadPermissionForCountry"] = this.hasReadPermissionForCountry;
        data["switchOffDetails"] = this.switchOffDetails ? this.switchOffDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITutForBlendingCircleSubgroupDto {
    tutValues: TutForOrganizationalEntityDto[] | undefined;
    totalTutForEntitiesWithoutAccess: string | undefined;
    hasReadPermissionForCountry: boolean;
    switchOffDetails: TutSwitchOffDetails | undefined;
}

export class TutForOrganizationalEntityDto implements ITutForOrganizationalEntityDto {
    isGlobeIncomePositive!: boolean;
    globeIncome!: string | undefined;
    tutValue!: string | undefined;
    legalName!: string | undefined;
    entityNumber!: string | undefined;
    tutCurrency!: string | undefined;

    constructor(data?: ITutForOrganizationalEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isGlobeIncomePositive = _data["isGlobeIncomePositive"];
            this.globeIncome = _data["globeIncome"];
            this.tutValue = _data["tutValue"];
            this.legalName = _data["legalName"];
            this.entityNumber = _data["entityNumber"];
            this.tutCurrency = _data["tutCurrency"];
        }
    }

    static fromJS(data: any): TutForOrganizationalEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new TutForOrganizationalEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isGlobeIncomePositive"] = this.isGlobeIncomePositive;
        data["globeIncome"] = this.globeIncome;
        data["tutValue"] = this.tutValue;
        data["legalName"] = this.legalName;
        data["entityNumber"] = this.entityNumber;
        data["tutCurrency"] = this.tutCurrency;
        return data;
    }
}

export interface ITutForOrganizationalEntityDto {
    isGlobeIncomePositive: boolean;
    globeIncome: string | undefined;
    tutValue: string | undefined;
    legalName: string | undefined;
    entityNumber: string | undefined;
    tutCurrency: string | undefined;
}

export class TutOverviewColumnsDto implements ITutOverviewColumnsDto {
    isQdmttActive!: boolean;
    country!: string | undefined;
    label!: string | undefined;
    subgroup!: string | undefined;
    blendingCircleSubgroupId!: number;
    number!: number | undefined;

    constructor(data?: ITutOverviewColumnsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isQdmttActive = _data["isQdmttActive"];
            this.country = _data["country"];
            this.label = _data["label"];
            this.subgroup = _data["subgroup"];
            this.blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
            this.number = _data["number"];
        }
    }

    static fromJS(data: any): TutOverviewColumnsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TutOverviewColumnsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isQdmttActive"] = this.isQdmttActive;
        data["country"] = this.country;
        data["label"] = this.label;
        data["subgroup"] = this.subgroup;
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        data["number"] = this.number;
        return data;
    }
}

export interface ITutOverviewColumnsDto {
    isQdmttActive: boolean;
    country: string | undefined;
    label: string | undefined;
    subgroup: string | undefined;
    blendingCircleSubgroupId: number;
    number: number | undefined;
}

export class TutOverviewDto implements ITutOverviewDto {
    id!: string | undefined;
    path!: string[] | undefined;
    financialNodeType!: FinancialNodeType;
    name!: string | undefined;
    footerName!: string | undefined;
    localizationKey!: string | undefined;
    validationLogic!: FinancialTraceValidationLogic | undefined;
    currentValue!: TutCurrentValueDto[] | undefined;

    constructor(data?: ITutOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["path"])) {
                this.path = [] as any;
                for (let item of _data["path"])
                    this.path!.push(item);
            }
            this.financialNodeType = _data["financialNodeType"];
            this.name = _data["name"];
            this.footerName = _data["footerName"];
            this.localizationKey = _data["localizationKey"];
            this.validationLogic = _data["validationLogic"] ? FinancialTraceValidationLogic.fromJS(_data["validationLogic"]) : <any>undefined;
            if (Array.isArray(_data["currentValue"])) {
                this.currentValue = [] as any;
                for (let item of _data["currentValue"])
                    this.currentValue!.push(TutCurrentValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TutOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new TutOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.path)) {
            data["path"] = [];
            for (let item of this.path)
                data["path"].push(item);
        }
        data["financialNodeType"] = this.financialNodeType;
        data["name"] = this.name;
        data["footerName"] = this.footerName;
        data["localizationKey"] = this.localizationKey;
        data["validationLogic"] = this.validationLogic ? this.validationLogic.toJSON() : <any>undefined;
        if (Array.isArray(this.currentValue)) {
            data["currentValue"] = [];
            for (let item of this.currentValue)
                data["currentValue"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITutOverviewDto {
    id: string | undefined;
    path: string[] | undefined;
    financialNodeType: FinancialNodeType;
    name: string | undefined;
    footerName: string | undefined;
    localizationKey: string | undefined;
    validationLogic: FinancialTraceValidationLogic | undefined;
    currentValue: TutCurrentValueDto[] | undefined;
}

export class TutSwitchOffDetails implements ITutSwitchOffDetails {
    canBeChanged!: boolean;
    isEnabled!: boolean;

    constructor(data?: ITutSwitchOffDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canBeChanged = _data["canBeChanged"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): TutSwitchOffDetails {
        data = typeof data === 'object' ? data : {};
        let result = new TutSwitchOffDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canBeChanged"] = this.canBeChanged;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface ITutSwitchOffDetails {
    canBeChanged: boolean;
    isEnabled: boolean;
}

export class UpdateAccessManagementInput implements IUpdateAccessManagementInput {
    projectId!: number;
    isReadingActivated!: boolean;
    readingCountryCodeInherited!: string | undefined;
    readingUsersAndOrganizationUnits!: UserOrOrganizationUnitInput[] | undefined;
    isWritingActivated!: boolean;
    writingCountryCodeInherited!: string | undefined;
    writingUsersAndOrganizationUnits!: UserOrOrganizationUnitInput[] | undefined;
    organizationalEntityId!: number | undefined;
    countryCode!: string | undefined;

    constructor(data?: IUpdateAccessManagementInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.isReadingActivated = _data["isReadingActivated"];
            this.readingCountryCodeInherited = _data["readingCountryCodeInherited"];
            if (Array.isArray(_data["readingUsersAndOrganizationUnits"])) {
                this.readingUsersAndOrganizationUnits = [] as any;
                for (let item of _data["readingUsersAndOrganizationUnits"])
                    this.readingUsersAndOrganizationUnits!.push(UserOrOrganizationUnitInput.fromJS(item));
            }
            this.isWritingActivated = _data["isWritingActivated"];
            this.writingCountryCodeInherited = _data["writingCountryCodeInherited"];
            if (Array.isArray(_data["writingUsersAndOrganizationUnits"])) {
                this.writingUsersAndOrganizationUnits = [] as any;
                for (let item of _data["writingUsersAndOrganizationUnits"])
                    this.writingUsersAndOrganizationUnits!.push(UserOrOrganizationUnitInput.fromJS(item));
            }
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.countryCode = _data["countryCode"];
        }
    }

    static fromJS(data: any): UpdateAccessManagementInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAccessManagementInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["isReadingActivated"] = this.isReadingActivated;
        data["readingCountryCodeInherited"] = this.readingCountryCodeInherited;
        if (Array.isArray(this.readingUsersAndOrganizationUnits)) {
            data["readingUsersAndOrganizationUnits"] = [];
            for (let item of this.readingUsersAndOrganizationUnits)
                data["readingUsersAndOrganizationUnits"].push(item.toJSON());
        }
        data["isWritingActivated"] = this.isWritingActivated;
        data["writingCountryCodeInherited"] = this.writingCountryCodeInherited;
        if (Array.isArray(this.writingUsersAndOrganizationUnits)) {
            data["writingUsersAndOrganizationUnits"] = [];
            for (let item of this.writingUsersAndOrganizationUnits)
                data["writingUsersAndOrganizationUnits"].push(item.toJSON());
        }
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["countryCode"] = this.countryCode;
        return data;
    }
}

export interface IUpdateAccessManagementInput {
    projectId: number;
    isReadingActivated: boolean;
    readingCountryCodeInherited: string | undefined;
    readingUsersAndOrganizationUnits: UserOrOrganizationUnitInput[] | undefined;
    isWritingActivated: boolean;
    writingCountryCodeInherited: string | undefined;
    writingUsersAndOrganizationUnits: UserOrOrganizationUnitInput[] | undefined;
    organizationalEntityId: number | undefined;
    countryCode: string | undefined;
}

export class UpdateAttachmentInput implements IUpdateAttachmentInput {
    note!: string | undefined;
    dateOfAttachment!: DateTime | undefined;
    tags!: TagDto[] | undefined;
    id!: number;
    referenceId!: number;

    constructor(data?: IUpdateAttachmentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.note = _data["note"];
            this.dateOfAttachment = _data["dateOfAttachment"] ? DateTime.fromISO(_data["dateOfAttachment"].toString()) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
            this.id = _data["id"];
            this.referenceId = _data["referenceId"];
        }
    }

    static fromJS(data: any): UpdateAttachmentInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAttachmentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["note"] = this.note;
        data["dateOfAttachment"] = this.dateOfAttachment ? this.dateOfAttachment.toString() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["referenceId"] = this.referenceId;
        return data;
    }
}

export interface IUpdateAttachmentInput {
    note: string | undefined;
    dateOfAttachment: DateTime | undefined;
    tags: TagDto[] | undefined;
    id: number;
    referenceId: number;
}

export class UpdateCombinedDataPointInput implements IUpdateCombinedDataPointInput {
    projectId!: number;
    organizationalEntityId!: number;
    financialNodeGroupType!: FinancialNodeGroupType | undefined;
    multipleNodeGroupId!: number | undefined;
    childInvestmentEntityId!: number | undefined;
    value!: string | undefined;
    valueAccordingToFinancialStatements!: string | undefined;
    disposingJurisdiction!: string | undefined;
    taxPaidInRespectOfTheTransaction!: string | undefined;
    netDeferredTaxAsset!: string | undefined;
    globeCarryingValue!: string | undefined;
    netDeferredTaxAssetYearBeginning!: string | undefined;
    deemedDistribution!: string | undefined;
    thereofAlreadyIncludedInGlobeIncomeComputation!: string | undefined;
    localCreditableTaxGrossup!: string | undefined;
    isConfirmed!: boolean;
    comment!: string | undefined;
    notes!: string | undefined;
    financialTreeType!: FinancialTreeType;
    financialCombinedType!: FinancialCombinedType;
    id!: number;

    constructor(data?: IUpdateCombinedDataPointInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.financialNodeGroupType = _data["financialNodeGroupType"];
            this.multipleNodeGroupId = _data["multipleNodeGroupId"];
            this.childInvestmentEntityId = _data["childInvestmentEntityId"];
            this.value = _data["value"];
            this.valueAccordingToFinancialStatements = _data["valueAccordingToFinancialStatements"];
            this.disposingJurisdiction = _data["disposingJurisdiction"];
            this.taxPaidInRespectOfTheTransaction = _data["taxPaidInRespectOfTheTransaction"];
            this.netDeferredTaxAsset = _data["netDeferredTaxAsset"];
            this.globeCarryingValue = _data["globeCarryingValue"];
            this.netDeferredTaxAssetYearBeginning = _data["netDeferredTaxAssetYearBeginning"];
            this.deemedDistribution = _data["deemedDistribution"];
            this.thereofAlreadyIncludedInGlobeIncomeComputation = _data["thereofAlreadyIncludedInGlobeIncomeComputation"];
            this.localCreditableTaxGrossup = _data["localCreditableTaxGrossup"];
            this.isConfirmed = _data["isConfirmed"];
            this.comment = _data["comment"];
            this.notes = _data["notes"];
            this.financialTreeType = _data["financialTreeType"];
            this.financialCombinedType = _data["financialCombinedType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateCombinedDataPointInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCombinedDataPointInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["financialNodeGroupType"] = this.financialNodeGroupType;
        data["multipleNodeGroupId"] = this.multipleNodeGroupId;
        data["childInvestmentEntityId"] = this.childInvestmentEntityId;
        data["value"] = this.value;
        data["valueAccordingToFinancialStatements"] = this.valueAccordingToFinancialStatements;
        data["disposingJurisdiction"] = this.disposingJurisdiction;
        data["taxPaidInRespectOfTheTransaction"] = this.taxPaidInRespectOfTheTransaction;
        data["netDeferredTaxAsset"] = this.netDeferredTaxAsset;
        data["globeCarryingValue"] = this.globeCarryingValue;
        data["netDeferredTaxAssetYearBeginning"] = this.netDeferredTaxAssetYearBeginning;
        data["deemedDistribution"] = this.deemedDistribution;
        data["thereofAlreadyIncludedInGlobeIncomeComputation"] = this.thereofAlreadyIncludedInGlobeIncomeComputation;
        data["localCreditableTaxGrossup"] = this.localCreditableTaxGrossup;
        data["isConfirmed"] = this.isConfirmed;
        data["comment"] = this.comment;
        data["notes"] = this.notes;
        data["financialTreeType"] = this.financialTreeType;
        data["financialCombinedType"] = this.financialCombinedType;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateCombinedDataPointInput {
    projectId: number;
    organizationalEntityId: number;
    financialNodeGroupType: FinancialNodeGroupType | undefined;
    multipleNodeGroupId: number | undefined;
    childInvestmentEntityId: number | undefined;
    value: string | undefined;
    valueAccordingToFinancialStatements: string | undefined;
    disposingJurisdiction: string | undefined;
    taxPaidInRespectOfTheTransaction: string | undefined;
    netDeferredTaxAsset: string | undefined;
    globeCarryingValue: string | undefined;
    netDeferredTaxAssetYearBeginning: string | undefined;
    deemedDistribution: string | undefined;
    thereofAlreadyIncludedInGlobeIncomeComputation: string | undefined;
    localCreditableTaxGrossup: string | undefined;
    isConfirmed: boolean;
    comment: string | undefined;
    notes: string | undefined;
    financialTreeType: FinancialTreeType;
    financialCombinedType: FinancialCombinedType;
    id: number;
}

export class UpdateDataPointStatusInput implements IUpdateDataPointStatusInput {
    projectId!: number;
    dataPointId!: number;
    isConfirmed!: boolean;
    organizationalEntityId!: number | undefined;
    blendingCircleSubgroupId!: number | undefined;
    organizationalEntityUpeShareholderId!: number | undefined;
    ownerId!: number | undefined;
    assignedEntityId!: number | undefined;
    financialValueType!: FinancialValueType | undefined;
    financialCombinedType!: FinancialCombinedType | undefined;
    financialNodeGroupType!: FinancialNodeGroupType | undefined;
    financialTreeType!: FinancialTreeType;

    constructor(data?: IUpdateDataPointStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.dataPointId = _data["dataPointId"];
            this.isConfirmed = _data["isConfirmed"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
            this.organizationalEntityUpeShareholderId = _data["organizationalEntityUpeShareholderId"];
            this.ownerId = _data["ownerId"];
            this.assignedEntityId = _data["assignedEntityId"];
            this.financialValueType = _data["financialValueType"];
            this.financialCombinedType = _data["financialCombinedType"];
            this.financialNodeGroupType = _data["financialNodeGroupType"];
            this.financialTreeType = _data["financialTreeType"];
        }
    }

    static fromJS(data: any): UpdateDataPointStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDataPointStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["dataPointId"] = this.dataPointId;
        data["isConfirmed"] = this.isConfirmed;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        data["organizationalEntityUpeShareholderId"] = this.organizationalEntityUpeShareholderId;
        data["ownerId"] = this.ownerId;
        data["assignedEntityId"] = this.assignedEntityId;
        data["financialValueType"] = this.financialValueType;
        data["financialCombinedType"] = this.financialCombinedType;
        data["financialNodeGroupType"] = this.financialNodeGroupType;
        data["financialTreeType"] = this.financialTreeType;
        return data;
    }
}

export interface IUpdateDataPointStatusInput {
    projectId: number;
    dataPointId: number;
    isConfirmed: boolean;
    organizationalEntityId: number | undefined;
    blendingCircleSubgroupId: number | undefined;
    organizationalEntityUpeShareholderId: number | undefined;
    ownerId: number | undefined;
    assignedEntityId: number | undefined;
    financialValueType: FinancialValueType | undefined;
    financialCombinedType: FinancialCombinedType | undefined;
    financialNodeGroupType: FinancialNodeGroupType | undefined;
    financialTreeType: FinancialTreeType;
}

export class UpdateFinancialDeltaPointInput implements IUpdateFinancialDeltaPointInput {
    id!: number;
    financialValuePointId!: number;
    delta!: string | undefined;
    description!: string | undefined;

    constructor(data?: IUpdateFinancialDeltaPointInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.financialValuePointId = _data["financialValuePointId"];
            this.delta = _data["delta"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdateFinancialDeltaPointInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFinancialDeltaPointInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["financialValuePointId"] = this.financialValuePointId;
        data["delta"] = this.delta;
        data["description"] = this.description;
        return data;
    }
}

export interface IUpdateFinancialDeltaPointInput {
    id: number;
    financialValuePointId: number;
    delta: string | undefined;
    description: string | undefined;
}

export class UpdateFinancialGroupConfirmationInput implements IUpdateFinancialGroupConfirmationInput {
    projectId!: number;
    blendingCircleCountry!: string | undefined;
    blendingCircleSubgroupId!: number;
    organizationalEntityId!: number | undefined;
    financialGroupType!: FinancialGroupType;
    financialTreeType!: FinancialTreeType;
    isConfirmed!: boolean;
    comment!: string | undefined;
    notes!: string | undefined;
    confirmAllPoints!: boolean;

    constructor(data?: IUpdateFinancialGroupConfirmationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.blendingCircleCountry = _data["blendingCircleCountry"];
            this.blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.financialGroupType = _data["financialGroupType"];
            this.financialTreeType = _data["financialTreeType"];
            this.isConfirmed = _data["isConfirmed"];
            this.comment = _data["comment"];
            this.notes = _data["notes"];
            this.confirmAllPoints = _data["confirmAllPoints"];
        }
    }

    static fromJS(data: any): UpdateFinancialGroupConfirmationInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFinancialGroupConfirmationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["blendingCircleCountry"] = this.blendingCircleCountry;
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["financialGroupType"] = this.financialGroupType;
        data["financialTreeType"] = this.financialTreeType;
        data["isConfirmed"] = this.isConfirmed;
        data["comment"] = this.comment;
        data["notes"] = this.notes;
        data["confirmAllPoints"] = this.confirmAllPoints;
        return data;
    }
}

export interface IUpdateFinancialGroupConfirmationInput {
    projectId: number;
    blendingCircleCountry: string | undefined;
    blendingCircleSubgroupId: number;
    organizationalEntityId: number | undefined;
    financialGroupType: FinancialGroupType;
    financialTreeType: FinancialTreeType;
    isConfirmed: boolean;
    comment: string | undefined;
    notes: string | undefined;
    confirmAllPoints: boolean;
}

export class UpdateFinancialShiftInput implements IUpdateFinancialShiftInput {
    projectId!: number;
    value!: string | undefined;
    comment!: string | undefined;
    notes!: string | undefined;
    isConfirmed!: boolean;
    financialShiftType!: FinancialShiftType;
    targetOrganizationalEntityId!: number | undefined;
    basisForAdjustments!: BasisForAdjustmentsType | undefined;
    maxTaxRateOfMainEntityJurisdiction!: string | undefined;
    passiveIncomeOfCEOrHybridEntity!: string | undefined;
    thereofOnActiveIncome!: string | undefined;
    fiscalYearBeginning!: string | undefined;
    fiscalYearEnd!: string | undefined;
    financialTreeType!: FinancialTreeType;
    directionType!: DirectionType | undefined;
    finalValue!: string | undefined;
    id!: number;
    organizationalEntityId!: number;

    constructor(data?: IUpdateFinancialShiftInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.value = _data["value"];
            this.comment = _data["comment"];
            this.notes = _data["notes"];
            this.isConfirmed = _data["isConfirmed"];
            this.financialShiftType = _data["financialShiftType"];
            this.targetOrganizationalEntityId = _data["targetOrganizationalEntityId"];
            this.basisForAdjustments = _data["basisForAdjustments"];
            this.maxTaxRateOfMainEntityJurisdiction = _data["maxTaxRateOfMainEntityJurisdiction"];
            this.passiveIncomeOfCEOrHybridEntity = _data["passiveIncomeOfCEOrHybridEntity"];
            this.thereofOnActiveIncome = _data["thereofOnActiveIncome"];
            this.fiscalYearBeginning = _data["fiscalYearBeginning"];
            this.fiscalYearEnd = _data["fiscalYearEnd"];
            this.financialTreeType = _data["financialTreeType"];
            this.directionType = _data["directionType"];
            this.finalValue = _data["finalValue"];
            this.id = _data["id"];
            this.organizationalEntityId = _data["organizationalEntityId"];
        }
    }

    static fromJS(data: any): UpdateFinancialShiftInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFinancialShiftInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["value"] = this.value;
        data["comment"] = this.comment;
        data["notes"] = this.notes;
        data["isConfirmed"] = this.isConfirmed;
        data["financialShiftType"] = this.financialShiftType;
        data["targetOrganizationalEntityId"] = this.targetOrganizationalEntityId;
        data["basisForAdjustments"] = this.basisForAdjustments;
        data["maxTaxRateOfMainEntityJurisdiction"] = this.maxTaxRateOfMainEntityJurisdiction;
        data["passiveIncomeOfCEOrHybridEntity"] = this.passiveIncomeOfCEOrHybridEntity;
        data["thereofOnActiveIncome"] = this.thereofOnActiveIncome;
        data["fiscalYearBeginning"] = this.fiscalYearBeginning;
        data["fiscalYearEnd"] = this.fiscalYearEnd;
        data["financialTreeType"] = this.financialTreeType;
        data["directionType"] = this.directionType;
        data["finalValue"] = this.finalValue;
        data["id"] = this.id;
        data["organizationalEntityId"] = this.organizationalEntityId;
        return data;
    }
}

export interface IUpdateFinancialShiftInput {
    projectId: number;
    value: string | undefined;
    comment: string | undefined;
    notes: string | undefined;
    isConfirmed: boolean;
    financialShiftType: FinancialShiftType;
    targetOrganizationalEntityId: number | undefined;
    basisForAdjustments: BasisForAdjustmentsType | undefined;
    maxTaxRateOfMainEntityJurisdiction: string | undefined;
    passiveIncomeOfCEOrHybridEntity: string | undefined;
    thereofOnActiveIncome: string | undefined;
    fiscalYearBeginning: string | undefined;
    fiscalYearEnd: string | undefined;
    financialTreeType: FinancialTreeType;
    directionType: DirectionType | undefined;
    finalValue: string | undefined;
    id: number;
    organizationalEntityId: number;
}

export class UpdateFinancialValueInput implements IUpdateFinancialValueInput {
    projectId!: number;
    organizationalEntityId!: number | undefined;
    blendingCircleSubgroupId!: number | undefined;
    organizationalEntityUpeShareholderId!: number | undefined;
    ownerId!: number | undefined;
    assignedEntityId!: number | undefined;
    financialTreeType!: FinancialTreeType;
    financialValueType!: FinancialValueType;
    value!: string | undefined;
    isConfirmed!: boolean;
    isValueInLocalCurrency!: boolean;
    comment!: string | undefined;
    notes!: string | undefined;
    financialYear!: FinancialYearType | undefined;
    lossCarryBack!: string | undefined;
    domesticTaxRate!: string | undefined;
    nonEligibleEmployeeCostsPreliminary!: string | undefined;
    percentageRateWorkingTimeInJurisdiction!: number | undefined;
    percentageRateOfLocationTimeInJurisdiction!: number | undefined;
    proRataTemporis!: number | undefined;
    fiscalYearBeginning!: string | undefined;
    fiscalYearEnd!: string | undefined;
    proportionalReductionOfAct!: string | undefined;
    financialNodeGroupType!: FinancialNodeGroupType | undefined;
    multipleNodeGroupId!: number | undefined;
    financialValueTracePointAdditionalInput!: UpdateFinancialValueTracePointAdditionalInput | undefined;
    internationalShippingIncome!: InternationalShippingIncomeDetailInput | undefined;
    qualifiedAncillaryInternationalShippingIncome!: InternationalShippingIncomeDetailInput | undefined;
    id!: number;

    constructor(data?: IUpdateFinancialValueInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
            this.organizationalEntityUpeShareholderId = _data["organizationalEntityUpeShareholderId"];
            this.ownerId = _data["ownerId"];
            this.assignedEntityId = _data["assignedEntityId"];
            this.financialTreeType = _data["financialTreeType"];
            this.financialValueType = _data["financialValueType"];
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
            this.isValueInLocalCurrency = _data["isValueInLocalCurrency"];
            this.comment = _data["comment"];
            this.notes = _data["notes"];
            this.financialYear = _data["financialYear"];
            this.lossCarryBack = _data["lossCarryBack"];
            this.domesticTaxRate = _data["domesticTaxRate"];
            this.nonEligibleEmployeeCostsPreliminary = _data["nonEligibleEmployeeCostsPreliminary"];
            this.percentageRateWorkingTimeInJurisdiction = _data["percentageRateWorkingTimeInJurisdiction"];
            this.percentageRateOfLocationTimeInJurisdiction = _data["percentageRateOfLocationTimeInJurisdiction"];
            this.proRataTemporis = _data["proRataTemporis"];
            this.fiscalYearBeginning = _data["fiscalYearBeginning"];
            this.fiscalYearEnd = _data["fiscalYearEnd"];
            this.proportionalReductionOfAct = _data["proportionalReductionOfAct"];
            this.financialNodeGroupType = _data["financialNodeGroupType"];
            this.multipleNodeGroupId = _data["multipleNodeGroupId"];
            this.financialValueTracePointAdditionalInput = _data["financialValueTracePointAdditionalInput"] ? UpdateFinancialValueTracePointAdditionalInput.fromJS(_data["financialValueTracePointAdditionalInput"]) : <any>undefined;
            this.internationalShippingIncome = _data["internationalShippingIncome"] ? InternationalShippingIncomeDetailInput.fromJS(_data["internationalShippingIncome"]) : <any>undefined;
            this.qualifiedAncillaryInternationalShippingIncome = _data["qualifiedAncillaryInternationalShippingIncome"] ? InternationalShippingIncomeDetailInput.fromJS(_data["qualifiedAncillaryInternationalShippingIncome"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateFinancialValueInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFinancialValueInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        data["organizationalEntityUpeShareholderId"] = this.organizationalEntityUpeShareholderId;
        data["ownerId"] = this.ownerId;
        data["assignedEntityId"] = this.assignedEntityId;
        data["financialTreeType"] = this.financialTreeType;
        data["financialValueType"] = this.financialValueType;
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        data["isValueInLocalCurrency"] = this.isValueInLocalCurrency;
        data["comment"] = this.comment;
        data["notes"] = this.notes;
        data["financialYear"] = this.financialYear;
        data["lossCarryBack"] = this.lossCarryBack;
        data["domesticTaxRate"] = this.domesticTaxRate;
        data["nonEligibleEmployeeCostsPreliminary"] = this.nonEligibleEmployeeCostsPreliminary;
        data["percentageRateWorkingTimeInJurisdiction"] = this.percentageRateWorkingTimeInJurisdiction;
        data["percentageRateOfLocationTimeInJurisdiction"] = this.percentageRateOfLocationTimeInJurisdiction;
        data["proRataTemporis"] = this.proRataTemporis;
        data["fiscalYearBeginning"] = this.fiscalYearBeginning;
        data["fiscalYearEnd"] = this.fiscalYearEnd;
        data["proportionalReductionOfAct"] = this.proportionalReductionOfAct;
        data["financialNodeGroupType"] = this.financialNodeGroupType;
        data["multipleNodeGroupId"] = this.multipleNodeGroupId;
        data["financialValueTracePointAdditionalInput"] = this.financialValueTracePointAdditionalInput ? this.financialValueTracePointAdditionalInput.toJSON() : <any>undefined;
        data["internationalShippingIncome"] = this.internationalShippingIncome ? this.internationalShippingIncome.toJSON() : <any>undefined;
        data["qualifiedAncillaryInternationalShippingIncome"] = this.qualifiedAncillaryInternationalShippingIncome ? this.qualifiedAncillaryInternationalShippingIncome.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateFinancialValueInput {
    projectId: number;
    organizationalEntityId: number | undefined;
    blendingCircleSubgroupId: number | undefined;
    organizationalEntityUpeShareholderId: number | undefined;
    ownerId: number | undefined;
    assignedEntityId: number | undefined;
    financialTreeType: FinancialTreeType;
    financialValueType: FinancialValueType;
    value: string | undefined;
    isConfirmed: boolean;
    isValueInLocalCurrency: boolean;
    comment: string | undefined;
    notes: string | undefined;
    financialYear: FinancialYearType | undefined;
    lossCarryBack: string | undefined;
    domesticTaxRate: string | undefined;
    nonEligibleEmployeeCostsPreliminary: string | undefined;
    percentageRateWorkingTimeInJurisdiction: number | undefined;
    percentageRateOfLocationTimeInJurisdiction: number | undefined;
    proRataTemporis: number | undefined;
    fiscalYearBeginning: string | undefined;
    fiscalYearEnd: string | undefined;
    proportionalReductionOfAct: string | undefined;
    financialNodeGroupType: FinancialNodeGroupType | undefined;
    multipleNodeGroupId: number | undefined;
    financialValueTracePointAdditionalInput: UpdateFinancialValueTracePointAdditionalInput | undefined;
    internationalShippingIncome: InternationalShippingIncomeDetailInput | undefined;
    qualifiedAncillaryInternationalShippingIncome: InternationalShippingIncomeDetailInput | undefined;
    id: number;
}

export class UpdateFinancialValuePointInput implements IUpdateFinancialValuePointInput {
    projectId!: number;
    traceId!: number;
    safeHarbourGroupId!: number | undefined;
    organizationalEntityId!: number | undefined;
    value!: string | undefined;
    isConfirmed!: boolean;
    comment!: string | undefined;
    notes!: string | undefined;
    deltaPoints!: UpdateFinancialDeltaPointInput[] | undefined;

    constructor(data?: IUpdateFinancialValuePointInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.traceId = _data["traceId"];
            this.safeHarbourGroupId = _data["safeHarbourGroupId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
            this.comment = _data["comment"];
            this.notes = _data["notes"];
            if (Array.isArray(_data["deltaPoints"])) {
                this.deltaPoints = [] as any;
                for (let item of _data["deltaPoints"])
                    this.deltaPoints!.push(UpdateFinancialDeltaPointInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateFinancialValuePointInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFinancialValuePointInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["traceId"] = this.traceId;
        data["safeHarbourGroupId"] = this.safeHarbourGroupId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        data["comment"] = this.comment;
        data["notes"] = this.notes;
        if (Array.isArray(this.deltaPoints)) {
            data["deltaPoints"] = [];
            for (let item of this.deltaPoints)
                data["deltaPoints"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateFinancialValuePointInput {
    projectId: number;
    traceId: number;
    safeHarbourGroupId: number | undefined;
    organizationalEntityId: number | undefined;
    value: string | undefined;
    isConfirmed: boolean;
    comment: string | undefined;
    notes: string | undefined;
    deltaPoints: UpdateFinancialDeltaPointInput[] | undefined;
}

export class UpdateFinancialValuePointStatusInput implements IUpdateFinancialValuePointStatusInput {
    projectId!: number;
    financialValuePointId!: number;
    safeHarbourGroupId!: number | undefined;
    organizationalEntityId!: number | undefined;
    isConfirmed!: boolean;
    automaticCalculatedValue!: string | undefined;

    constructor(data?: IUpdateFinancialValuePointStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.financialValuePointId = _data["financialValuePointId"];
            this.safeHarbourGroupId = _data["safeHarbourGroupId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.isConfirmed = _data["isConfirmed"];
            this.automaticCalculatedValue = _data["automaticCalculatedValue"];
        }
    }

    static fromJS(data: any): UpdateFinancialValuePointStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFinancialValuePointStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["financialValuePointId"] = this.financialValuePointId;
        data["safeHarbourGroupId"] = this.safeHarbourGroupId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["isConfirmed"] = this.isConfirmed;
        data["automaticCalculatedValue"] = this.automaticCalculatedValue;
        return data;
    }
}

export interface IUpdateFinancialValuePointStatusInput {
    projectId: number;
    financialValuePointId: number;
    safeHarbourGroupId: number | undefined;
    organizationalEntityId: number | undefined;
    isConfirmed: boolean;
    automaticCalculatedValue: string | undefined;
}

export class UpdateFinancialValueTracePointAdditionalInput implements IUpdateFinancialValueTracePointAdditionalInput {
    financialYear!: DateTime | undefined;
    basisForAdjustments!: BasisForAdjustmentsType | undefined;
    financialAccountingStandard!: FinancialAccountingStandard | undefined;

    constructor(data?: IUpdateFinancialValueTracePointAdditionalInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.financialYear = _data["financialYear"] ? DateTime.fromISO(_data["financialYear"].toString()) : <any>undefined;
            this.basisForAdjustments = _data["basisForAdjustments"];
            this.financialAccountingStandard = _data["financialAccountingStandard"];
        }
    }

    static fromJS(data: any): UpdateFinancialValueTracePointAdditionalInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFinancialValueTracePointAdditionalInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financialYear"] = this.financialYear ? this.financialYear.toString() : <any>undefined;
        data["basisForAdjustments"] = this.basisForAdjustments;
        data["financialAccountingStandard"] = this.financialAccountingStandard;
        return data;
    }
}

export interface IUpdateFinancialValueTracePointAdditionalInput {
    financialYear: DateTime | undefined;
    basisForAdjustments: BasisForAdjustmentsType | undefined;
    financialAccountingStandard: FinancialAccountingStandard | undefined;
}

export class UpdateJurisdictionInput implements IUpdateJurisdictionInput {
    projectId!: number;
    jurisdictionId!: number;
    jurisdictionCountry!: string | undefined;
    iirImplemented!: boolean | undefined;
    iirApplicableFrom!: DateTime | undefined;
    iirIncludesOwnLowTaxedIncome!: boolean | undefined;
    utprImplemented!: boolean | undefined;
    utprApplicableFrom!: DateTime | undefined;
    isUTPRSafeHarbor!: boolean | undefined;
    utprSafeHarborRate!: number | undefined;
    qdmttImplemented!: boolean | undefined;
    qdmttApplicableFrom!: DateTime | undefined;
    localCurrency!: string | undefined;
    qdmttSafeHarbourImplemented!: boolean | undefined;
    localCurrencyDeviatesFromPresentationCurrencyImplemented!: boolean | undefined;
    areFlowThroughStatelessEntitiesSubjectToQDMTT!: boolean | undefined;
    isQDMTTFasDeviatesFromUPEForFASPurposes!: boolean | undefined;
    fas!: string | undefined;
    isSBIEAvailableForQDMTT!: boolean | undefined;
    isDeminimisExclusionAvailableForQDMTT!: boolean | undefined;
    doesCurrencyElectionApply!: boolean | undefined;
    currencyElectionYear!: DateTime | undefined;
    revocationYear!: DateTime | undefined;
    electionCurrency!: string | undefined;
    arePermanentEntitiesSubjectToQdmtt!: boolean | undefined;

    constructor(data?: IUpdateJurisdictionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.jurisdictionId = _data["jurisdictionId"];
            this.jurisdictionCountry = _data["jurisdictionCountry"];
            this.iirImplemented = _data["iirImplemented"];
            this.iirApplicableFrom = _data["iirApplicableFrom"] ? DateTime.fromISO(_data["iirApplicableFrom"].toString()) : <any>undefined;
            this.iirIncludesOwnLowTaxedIncome = _data["iirIncludesOwnLowTaxedIncome"];
            this.utprImplemented = _data["utprImplemented"];
            this.utprApplicableFrom = _data["utprApplicableFrom"] ? DateTime.fromISO(_data["utprApplicableFrom"].toString()) : <any>undefined;
            this.isUTPRSafeHarbor = _data["isUTPRSafeHarbor"];
            this.utprSafeHarborRate = _data["utprSafeHarborRate"];
            this.qdmttImplemented = _data["qdmttImplemented"];
            this.qdmttApplicableFrom = _data["qdmttApplicableFrom"] ? DateTime.fromISO(_data["qdmttApplicableFrom"].toString()) : <any>undefined;
            this.localCurrency = _data["localCurrency"];
            this.qdmttSafeHarbourImplemented = _data["qdmttSafeHarbourImplemented"];
            this.localCurrencyDeviatesFromPresentationCurrencyImplemented = _data["localCurrencyDeviatesFromPresentationCurrencyImplemented"];
            this.areFlowThroughStatelessEntitiesSubjectToQDMTT = _data["areFlowThroughStatelessEntitiesSubjectToQDMTT"];
            this.isQDMTTFasDeviatesFromUPEForFASPurposes = _data["isQDMTTFasDeviatesFromUPEForFASPurposes"];
            this.fas = _data["fas"];
            this.isSBIEAvailableForQDMTT = _data["isSBIEAvailableForQDMTT"];
            this.isDeminimisExclusionAvailableForQDMTT = _data["isDeminimisExclusionAvailableForQDMTT"];
            this.doesCurrencyElectionApply = _data["doesCurrencyElectionApply"];
            this.currencyElectionYear = _data["currencyElectionYear"] ? DateTime.fromISO(_data["currencyElectionYear"].toString()) : <any>undefined;
            this.revocationYear = _data["revocationYear"] ? DateTime.fromISO(_data["revocationYear"].toString()) : <any>undefined;
            this.electionCurrency = _data["electionCurrency"];
            this.arePermanentEntitiesSubjectToQdmtt = _data["arePermanentEntitiesSubjectToQdmtt"];
        }
    }

    static fromJS(data: any): UpdateJurisdictionInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateJurisdictionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["jurisdictionId"] = this.jurisdictionId;
        data["jurisdictionCountry"] = this.jurisdictionCountry;
        data["iirImplemented"] = this.iirImplemented;
        data["iirApplicableFrom"] = this.iirApplicableFrom ? this.iirApplicableFrom.toString() : <any>undefined;
        data["iirIncludesOwnLowTaxedIncome"] = this.iirIncludesOwnLowTaxedIncome;
        data["utprImplemented"] = this.utprImplemented;
        data["utprApplicableFrom"] = this.utprApplicableFrom ? this.utprApplicableFrom.toString() : <any>undefined;
        data["isUTPRSafeHarbor"] = this.isUTPRSafeHarbor;
        data["utprSafeHarborRate"] = this.utprSafeHarborRate;
        data["qdmttImplemented"] = this.qdmttImplemented;
        data["qdmttApplicableFrom"] = this.qdmttApplicableFrom ? this.qdmttApplicableFrom.toString() : <any>undefined;
        data["localCurrency"] = this.localCurrency;
        data["qdmttSafeHarbourImplemented"] = this.qdmttSafeHarbourImplemented;
        data["localCurrencyDeviatesFromPresentationCurrencyImplemented"] = this.localCurrencyDeviatesFromPresentationCurrencyImplemented;
        data["areFlowThroughStatelessEntitiesSubjectToQDMTT"] = this.areFlowThroughStatelessEntitiesSubjectToQDMTT;
        data["isQDMTTFasDeviatesFromUPEForFASPurposes"] = this.isQDMTTFasDeviatesFromUPEForFASPurposes;
        data["fas"] = this.fas;
        data["isSBIEAvailableForQDMTT"] = this.isSBIEAvailableForQDMTT;
        data["isDeminimisExclusionAvailableForQDMTT"] = this.isDeminimisExclusionAvailableForQDMTT;
        data["doesCurrencyElectionApply"] = this.doesCurrencyElectionApply;
        data["currencyElectionYear"] = this.currencyElectionYear ? this.currencyElectionYear.toString() : <any>undefined;
        data["revocationYear"] = this.revocationYear ? this.revocationYear.toString() : <any>undefined;
        data["electionCurrency"] = this.electionCurrency;
        data["arePermanentEntitiesSubjectToQdmtt"] = this.arePermanentEntitiesSubjectToQdmtt;
        return data;
    }
}

export interface IUpdateJurisdictionInput {
    projectId: number;
    jurisdictionId: number;
    jurisdictionCountry: string | undefined;
    iirImplemented: boolean | undefined;
    iirApplicableFrom: DateTime | undefined;
    iirIncludesOwnLowTaxedIncome: boolean | undefined;
    utprImplemented: boolean | undefined;
    utprApplicableFrom: DateTime | undefined;
    isUTPRSafeHarbor: boolean | undefined;
    utprSafeHarborRate: number | undefined;
    qdmttImplemented: boolean | undefined;
    qdmttApplicableFrom: DateTime | undefined;
    localCurrency: string | undefined;
    qdmttSafeHarbourImplemented: boolean | undefined;
    localCurrencyDeviatesFromPresentationCurrencyImplemented: boolean | undefined;
    areFlowThroughStatelessEntitiesSubjectToQDMTT: boolean | undefined;
    isQDMTTFasDeviatesFromUPEForFASPurposes: boolean | undefined;
    fas: string | undefined;
    isSBIEAvailableForQDMTT: boolean | undefined;
    isDeminimisExclusionAvailableForQDMTT: boolean | undefined;
    doesCurrencyElectionApply: boolean | undefined;
    currencyElectionYear: DateTime | undefined;
    revocationYear: DateTime | undefined;
    electionCurrency: string | undefined;
    arePermanentEntitiesSubjectToQdmtt: boolean | undefined;
}

export class UpdateLinkedSubmissionInput implements IUpdateLinkedSubmissionInput {
    projectId!: number;
    obligationId!: number;
    linkedSubmissionId!: number | undefined;

    constructor(data?: IUpdateLinkedSubmissionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.obligationId = _data["obligationId"];
            this.linkedSubmissionId = _data["linkedSubmissionId"];
        }
    }

    static fromJS(data: any): UpdateLinkedSubmissionInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLinkedSubmissionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["obligationId"] = this.obligationId;
        data["linkedSubmissionId"] = this.linkedSubmissionId;
        return data;
    }
}

export interface IUpdateLinkedSubmissionInput {
    projectId: number;
    obligationId: number;
    linkedSubmissionId: number | undefined;
}

export class UpdateObligationInput implements IUpdateObligationInput {
    projectId!: number;
    obligationId!: number;
    organizationalEntityId!: number | undefined;
    obligationCountry!: string | undefined;
    obligationReturnType!: ObligationReturnType;
    obligationStatus!: ObligationStatus;
    dueDate!: DateTime | undefined;
    assignedUserId!: number | undefined;
    note!: string | undefined;
    comment!: string | undefined;
    linkedSubmissioniD!: number | undefined;

    constructor(data?: IUpdateObligationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.obligationId = _data["obligationId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.obligationCountry = _data["obligationCountry"];
            this.obligationReturnType = _data["obligationReturnType"];
            this.obligationStatus = _data["obligationStatus"];
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
            this.assignedUserId = _data["assignedUserId"];
            this.note = _data["note"];
            this.comment = _data["comment"];
            this.linkedSubmissioniD = _data["linkedSubmissioniD"];
        }
    }

    static fromJS(data: any): UpdateObligationInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateObligationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["obligationId"] = this.obligationId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["obligationCountry"] = this.obligationCountry;
        data["obligationReturnType"] = this.obligationReturnType;
        data["obligationStatus"] = this.obligationStatus;
        data["dueDate"] = this.dueDate ? this.dueDate.toString() : <any>undefined;
        data["assignedUserId"] = this.assignedUserId;
        data["note"] = this.note;
        data["comment"] = this.comment;
        data["linkedSubmissioniD"] = this.linkedSubmissioniD;
        return data;
    }
}

export interface IUpdateObligationInput {
    projectId: number;
    obligationId: number;
    organizationalEntityId: number | undefined;
    obligationCountry: string | undefined;
    obligationReturnType: ObligationReturnType;
    obligationStatus: ObligationStatus;
    dueDate: DateTime | undefined;
    assignedUserId: number | undefined;
    note: string | undefined;
    comment: string | undefined;
    linkedSubmissioniD: number | undefined;
}

export class UpdateObligationStatusInput implements IUpdateObligationStatusInput {
    projectId!: number;
    obligationId!: number;
    organizationalEntityId!: number | undefined;
    obligationCountry!: string | undefined;
    obligationReturnType!: ObligationReturnType;
    obligationStatus!: ObligationStatus;

    constructor(data?: IUpdateObligationStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.obligationId = _data["obligationId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.obligationCountry = _data["obligationCountry"];
            this.obligationReturnType = _data["obligationReturnType"];
            this.obligationStatus = _data["obligationStatus"];
        }
    }

    static fromJS(data: any): UpdateObligationStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateObligationStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["obligationId"] = this.obligationId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["obligationCountry"] = this.obligationCountry;
        data["obligationReturnType"] = this.obligationReturnType;
        data["obligationStatus"] = this.obligationStatus;
        return data;
    }
}

export interface IUpdateObligationStatusInput {
    projectId: number;
    obligationId: number;
    organizationalEntityId: number | undefined;
    obligationCountry: string | undefined;
    obligationReturnType: ObligationReturnType;
    obligationStatus: ObligationStatus;
}

export class UpdateOrganizationalEntityFieldStatusInput implements IUpdateOrganizationalEntityFieldStatusInput {
    projectId!: number;
    organizationalEntityId!: number;
    field!: string | undefined;
    isConfirmed!: boolean;

    constructor(data?: IUpdateOrganizationalEntityFieldStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.field = _data["field"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): UpdateOrganizationalEntityFieldStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrganizationalEntityFieldStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["field"] = this.field;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IUpdateOrganizationalEntityFieldStatusInput {
    projectId: number;
    organizationalEntityId: number;
    field: string | undefined;
    isConfirmed: boolean;
}

export class UpdateOrganizationalEntityInput implements IUpdateOrganizationalEntityInput {
    projectId!: number;
    entityNumber!: ConfirmableInputOfString | undefined;
    legalName!: ConfirmableInputOfString | undefined;
    gloBEStatus!: ConfirmableInputOfIListOfGloBEStatus | undefined;
    tin!: ConfirmableInputOfString | undefined;
    tinIssuedBy!: ConfirmableInputOfString | undefined;
    typeOfTIN!: ConfirmableInputOfNullableOfTinType | undefined;
    taxJurisdictionCountry!: ConfirmableInputOfString | undefined;
    taxTreatment!: ConfirmableInputOfNullableOfTaxTreatment | undefined;
    isUpeAsFlowThrough!: ConfirmableInputOfNullableOfBoolean | undefined;
    isUpeSubjectToDeductiveDividendRegime!: ConfirmableInputOfNullableOfBoolean | undefined;
    typeOfExcluded!: ConfirmableInputOfNullableOfOrganizationalEntityExcludedType | undefined;
    notTreatingEntityAsExcludedEntity!: ConfirmableInputOfNullableOfBoolean | undefined;
    electionYear!: DateTime | undefined;
    revocationYear!: DateTime | undefined;
    isPermanentEstablishment!: ConfirmableInputOfNullableOfBoolean | undefined;
    mainEntityId!: ConfirmableInputOfNullableOfInt64 | undefined;
    taxFunctionalCurrency!: ConfirmableInputOfString | undefined;
    accountingFunctionalCurrency!: ConfirmableInputOfString | undefined;
    financialAccountingStandardOfCe!: ConfirmableInputOfString | undefined;
    consolidationMethod!: ConfirmableInputOfNullableOfConsolidationMethod | undefined;
    controllingInterestEntityId!: number | undefined;
    shareholders!: ShareholderInput | undefined;
    blendingCircleInput!: BlendingCircleInput | undefined;
    ownershipChanges!: CreateOwnershipChangeInput[] | undefined;
    corporateShareholders!: CreateCorporateShareholderInput[] | undefined;
    naturalPersonShareholders!: CreateNaturalPersonShareholderInput[] | undefined;
    organizationalEntityId!: number;

    constructor(data?: IUpdateOrganizationalEntityInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.entityNumber = _data["entityNumber"] ? ConfirmableInputOfString.fromJS(_data["entityNumber"]) : <any>undefined;
            this.legalName = _data["legalName"] ? ConfirmableInputOfString.fromJS(_data["legalName"]) : <any>undefined;
            this.gloBEStatus = _data["gloBEStatus"] ? ConfirmableInputOfIListOfGloBEStatus.fromJS(_data["gloBEStatus"]) : <any>undefined;
            this.tin = _data["tin"] ? ConfirmableInputOfString.fromJS(_data["tin"]) : <any>undefined;
            this.tinIssuedBy = _data["tinIssuedBy"] ? ConfirmableInputOfString.fromJS(_data["tinIssuedBy"]) : <any>undefined;
            this.typeOfTIN = _data["typeOfTIN"] ? ConfirmableInputOfNullableOfTinType.fromJS(_data["typeOfTIN"]) : <any>undefined;
            this.taxJurisdictionCountry = _data["taxJurisdictionCountry"] ? ConfirmableInputOfString.fromJS(_data["taxJurisdictionCountry"]) : <any>undefined;
            this.taxTreatment = _data["taxTreatment"] ? ConfirmableInputOfNullableOfTaxTreatment.fromJS(_data["taxTreatment"]) : <any>undefined;
            this.isUpeAsFlowThrough = _data["isUpeAsFlowThrough"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isUpeAsFlowThrough"]) : <any>undefined;
            this.isUpeSubjectToDeductiveDividendRegime = _data["isUpeSubjectToDeductiveDividendRegime"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isUpeSubjectToDeductiveDividendRegime"]) : <any>undefined;
            this.typeOfExcluded = _data["typeOfExcluded"] ? ConfirmableInputOfNullableOfOrganizationalEntityExcludedType.fromJS(_data["typeOfExcluded"]) : <any>undefined;
            this.notTreatingEntityAsExcludedEntity = _data["notTreatingEntityAsExcludedEntity"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["notTreatingEntityAsExcludedEntity"]) : <any>undefined;
            this.electionYear = _data["electionYear"] ? DateTime.fromISO(_data["electionYear"].toString()) : <any>undefined;
            this.revocationYear = _data["revocationYear"] ? DateTime.fromISO(_data["revocationYear"].toString()) : <any>undefined;
            this.isPermanentEstablishment = _data["isPermanentEstablishment"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isPermanentEstablishment"]) : <any>undefined;
            this.mainEntityId = _data["mainEntityId"] ? ConfirmableInputOfNullableOfInt64.fromJS(_data["mainEntityId"]) : <any>undefined;
            this.taxFunctionalCurrency = _data["taxFunctionalCurrency"] ? ConfirmableInputOfString.fromJS(_data["taxFunctionalCurrency"]) : <any>undefined;
            this.accountingFunctionalCurrency = _data["accountingFunctionalCurrency"] ? ConfirmableInputOfString.fromJS(_data["accountingFunctionalCurrency"]) : <any>undefined;
            this.financialAccountingStandardOfCe = _data["financialAccountingStandardOfCe"] ? ConfirmableInputOfString.fromJS(_data["financialAccountingStandardOfCe"]) : <any>undefined;
            this.consolidationMethod = _data["consolidationMethod"] ? ConfirmableInputOfNullableOfConsolidationMethod.fromJS(_data["consolidationMethod"]) : <any>undefined;
            this.controllingInterestEntityId = _data["controllingInterestEntityId"];
            this.shareholders = _data["shareholders"] ? ShareholderInput.fromJS(_data["shareholders"]) : <any>undefined;
            this.blendingCircleInput = _data["blendingCircleInput"] ? BlendingCircleInput.fromJS(_data["blendingCircleInput"]) : <any>undefined;
            if (Array.isArray(_data["ownershipChanges"])) {
                this.ownershipChanges = [] as any;
                for (let item of _data["ownershipChanges"])
                    this.ownershipChanges!.push(CreateOwnershipChangeInput.fromJS(item));
            }
            if (Array.isArray(_data["corporateShareholders"])) {
                this.corporateShareholders = [] as any;
                for (let item of _data["corporateShareholders"])
                    this.corporateShareholders!.push(CreateCorporateShareholderInput.fromJS(item));
            }
            if (Array.isArray(_data["naturalPersonShareholders"])) {
                this.naturalPersonShareholders = [] as any;
                for (let item of _data["naturalPersonShareholders"])
                    this.naturalPersonShareholders!.push(CreateNaturalPersonShareholderInput.fromJS(item));
            }
            this.organizationalEntityId = _data["organizationalEntityId"];
        }
    }

    static fromJS(data: any): UpdateOrganizationalEntityInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrganizationalEntityInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["entityNumber"] = this.entityNumber ? this.entityNumber.toJSON() : <any>undefined;
        data["legalName"] = this.legalName ? this.legalName.toJSON() : <any>undefined;
        data["gloBEStatus"] = this.gloBEStatus ? this.gloBEStatus.toJSON() : <any>undefined;
        data["tin"] = this.tin ? this.tin.toJSON() : <any>undefined;
        data["tinIssuedBy"] = this.tinIssuedBy ? this.tinIssuedBy.toJSON() : <any>undefined;
        data["typeOfTIN"] = this.typeOfTIN ? this.typeOfTIN.toJSON() : <any>undefined;
        data["taxJurisdictionCountry"] = this.taxJurisdictionCountry ? this.taxJurisdictionCountry.toJSON() : <any>undefined;
        data["taxTreatment"] = this.taxTreatment ? this.taxTreatment.toJSON() : <any>undefined;
        data["isUpeAsFlowThrough"] = this.isUpeAsFlowThrough ? this.isUpeAsFlowThrough.toJSON() : <any>undefined;
        data["isUpeSubjectToDeductiveDividendRegime"] = this.isUpeSubjectToDeductiveDividendRegime ? this.isUpeSubjectToDeductiveDividendRegime.toJSON() : <any>undefined;
        data["typeOfExcluded"] = this.typeOfExcluded ? this.typeOfExcluded.toJSON() : <any>undefined;
        data["notTreatingEntityAsExcludedEntity"] = this.notTreatingEntityAsExcludedEntity ? this.notTreatingEntityAsExcludedEntity.toJSON() : <any>undefined;
        data["electionYear"] = this.electionYear ? this.electionYear.toString() : <any>undefined;
        data["revocationYear"] = this.revocationYear ? this.revocationYear.toString() : <any>undefined;
        data["isPermanentEstablishment"] = this.isPermanentEstablishment ? this.isPermanentEstablishment.toJSON() : <any>undefined;
        data["mainEntityId"] = this.mainEntityId ? this.mainEntityId.toJSON() : <any>undefined;
        data["taxFunctionalCurrency"] = this.taxFunctionalCurrency ? this.taxFunctionalCurrency.toJSON() : <any>undefined;
        data["accountingFunctionalCurrency"] = this.accountingFunctionalCurrency ? this.accountingFunctionalCurrency.toJSON() : <any>undefined;
        data["financialAccountingStandardOfCe"] = this.financialAccountingStandardOfCe ? this.financialAccountingStandardOfCe.toJSON() : <any>undefined;
        data["consolidationMethod"] = this.consolidationMethod ? this.consolidationMethod.toJSON() : <any>undefined;
        data["controllingInterestEntityId"] = this.controllingInterestEntityId;
        data["shareholders"] = this.shareholders ? this.shareholders.toJSON() : <any>undefined;
        data["blendingCircleInput"] = this.blendingCircleInput ? this.blendingCircleInput.toJSON() : <any>undefined;
        if (Array.isArray(this.ownershipChanges)) {
            data["ownershipChanges"] = [];
            for (let item of this.ownershipChanges)
                data["ownershipChanges"].push(item.toJSON());
        }
        if (Array.isArray(this.corporateShareholders)) {
            data["corporateShareholders"] = [];
            for (let item of this.corporateShareholders)
                data["corporateShareholders"].push(item.toJSON());
        }
        if (Array.isArray(this.naturalPersonShareholders)) {
            data["naturalPersonShareholders"] = [];
            for (let item of this.naturalPersonShareholders)
                data["naturalPersonShareholders"].push(item.toJSON());
        }
        data["organizationalEntityId"] = this.organizationalEntityId;
        return data;
    }
}

export interface IUpdateOrganizationalEntityInput {
    projectId: number;
    entityNumber: ConfirmableInputOfString | undefined;
    legalName: ConfirmableInputOfString | undefined;
    gloBEStatus: ConfirmableInputOfIListOfGloBEStatus | undefined;
    tin: ConfirmableInputOfString | undefined;
    tinIssuedBy: ConfirmableInputOfString | undefined;
    typeOfTIN: ConfirmableInputOfNullableOfTinType | undefined;
    taxJurisdictionCountry: ConfirmableInputOfString | undefined;
    taxTreatment: ConfirmableInputOfNullableOfTaxTreatment | undefined;
    isUpeAsFlowThrough: ConfirmableInputOfNullableOfBoolean | undefined;
    isUpeSubjectToDeductiveDividendRegime: ConfirmableInputOfNullableOfBoolean | undefined;
    typeOfExcluded: ConfirmableInputOfNullableOfOrganizationalEntityExcludedType | undefined;
    notTreatingEntityAsExcludedEntity: ConfirmableInputOfNullableOfBoolean | undefined;
    electionYear: DateTime | undefined;
    revocationYear: DateTime | undefined;
    isPermanentEstablishment: ConfirmableInputOfNullableOfBoolean | undefined;
    mainEntityId: ConfirmableInputOfNullableOfInt64 | undefined;
    taxFunctionalCurrency: ConfirmableInputOfString | undefined;
    accountingFunctionalCurrency: ConfirmableInputOfString | undefined;
    financialAccountingStandardOfCe: ConfirmableInputOfString | undefined;
    consolidationMethod: ConfirmableInputOfNullableOfConsolidationMethod | undefined;
    controllingInterestEntityId: number | undefined;
    shareholders: ShareholderInput | undefined;
    blendingCircleInput: BlendingCircleInput | undefined;
    ownershipChanges: CreateOwnershipChangeInput[] | undefined;
    corporateShareholders: CreateCorporateShareholderInput[] | undefined;
    naturalPersonShareholders: CreateNaturalPersonShareholderInput[] | undefined;
    organizationalEntityId: number;
}

export class UpdateProjectCurrencyRateInput implements IUpdateProjectCurrencyRateInput {
    id!: number;
    projectId!: number;
    rate!: ConfirmableInputOfString | undefined;
    comment!: string | undefined;
    notes!: string | undefined;

    constructor(data?: IUpdateProjectCurrencyRateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.rate = _data["rate"] ? ConfirmableInputOfString.fromJS(_data["rate"]) : <any>undefined;
            this.comment = _data["comment"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateProjectCurrencyRateInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectCurrencyRateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["rate"] = this.rate ? this.rate.toJSON() : <any>undefined;
        data["comment"] = this.comment;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IUpdateProjectCurrencyRateInput {
    id: number;
    projectId: number;
    rate: ConfirmableInputOfString | undefined;
    comment: string | undefined;
    notes: string | undefined;
}

export class UpdateProjectInput implements IUpdateProjectInput {
    general!: GeneraInput | undefined;
    accessAndPermission!: ProjectAccessAndPermissionInput | undefined;
    projectManagement!: FullProjectManagementInput | undefined;
    specifics!: ProjectSpecificInput | undefined;
    id!: number;

    constructor(data?: IUpdateProjectInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.general = _data["general"] ? GeneraInput.fromJS(_data["general"]) : <any>undefined;
            this.accessAndPermission = _data["accessAndPermission"] ? ProjectAccessAndPermissionInput.fromJS(_data["accessAndPermission"]) : <any>undefined;
            this.projectManagement = _data["projectManagement"] ? FullProjectManagementInput.fromJS(_data["projectManagement"]) : <any>undefined;
            this.specifics = _data["specifics"] ? ProjectSpecificInput.fromJS(_data["specifics"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateProjectInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["accessAndPermission"] = this.accessAndPermission ? this.accessAndPermission.toJSON() : <any>undefined;
        data["projectManagement"] = this.projectManagement ? this.projectManagement.toJSON() : <any>undefined;
        data["specifics"] = this.specifics ? this.specifics.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateProjectInput {
    general: GeneraInput | undefined;
    accessAndPermission: ProjectAccessAndPermissionInput | undefined;
    projectManagement: FullProjectManagementInput | undefined;
    specifics: ProjectSpecificInput | undefined;
    id: number;
}

export class UpdateProjectUserConfigurationInput implements IUpdateProjectUserConfigurationInput {
    projectId!: number;
    viewUnconfirmed!: boolean;
    viewConfirmed!: boolean;
    hideEmptyFilingObligations!: boolean;

    constructor(data?: IUpdateProjectUserConfigurationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.viewUnconfirmed = _data["viewUnconfirmed"];
            this.viewConfirmed = _data["viewConfirmed"];
            this.hideEmptyFilingObligations = _data["hideEmptyFilingObligations"];
        }
    }

    static fromJS(data: any): UpdateProjectUserConfigurationInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectUserConfigurationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["viewUnconfirmed"] = this.viewUnconfirmed;
        data["viewConfirmed"] = this.viewConfirmed;
        data["hideEmptyFilingObligations"] = this.hideEmptyFilingObligations;
        return data;
    }
}

export interface IUpdateProjectUserConfigurationInput {
    projectId: number;
    viewUnconfirmed: boolean;
    viewConfirmed: boolean;
    hideEmptyFilingObligations: boolean;
}

export class UpdateSafeHarbourGroupGirReportingSelectionsInput implements IUpdateSafeHarbourGroupGirReportingSelectionsInput {
    projectId!: number;
    safeHarbourGroupId!: number | undefined;
    blendingCircleSubgroupId!: number | undefined;
    blendingCircleCountry!: string | undefined;
    safeHarbourGroupType!: SafeHarbourGroupType;
    girReportingSelections!: SafeHarbourGirReportingSelection[] | undefined;

    constructor(data?: IUpdateSafeHarbourGroupGirReportingSelectionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.safeHarbourGroupId = _data["safeHarbourGroupId"];
            this.blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
            this.blendingCircleCountry = _data["blendingCircleCountry"];
            this.safeHarbourGroupType = _data["safeHarbourGroupType"];
            if (Array.isArray(_data["girReportingSelections"])) {
                this.girReportingSelections = [] as any;
                for (let item of _data["girReportingSelections"])
                    this.girReportingSelections!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateSafeHarbourGroupGirReportingSelectionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSafeHarbourGroupGirReportingSelectionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["safeHarbourGroupId"] = this.safeHarbourGroupId;
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        data["blendingCircleCountry"] = this.blendingCircleCountry;
        data["safeHarbourGroupType"] = this.safeHarbourGroupType;
        if (Array.isArray(this.girReportingSelections)) {
            data["girReportingSelections"] = [];
            for (let item of this.girReportingSelections)
                data["girReportingSelections"].push(item);
        }
        return data;
    }
}

export interface IUpdateSafeHarbourGroupGirReportingSelectionsInput {
    projectId: number;
    safeHarbourGroupId: number | undefined;
    blendingCircleSubgroupId: number | undefined;
    blendingCircleCountry: string | undefined;
    safeHarbourGroupType: SafeHarbourGroupType;
    girReportingSelections: SafeHarbourGirReportingSelection[] | undefined;
}

export class UpdateSubmissionFormDataInput implements IUpdateSubmissionFormDataInput {
    id!: number;
    submissionFormData!: string | undefined;

    constructor(data?: IUpdateSubmissionFormDataInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.submissionFormData = _data["submissionFormData"];
        }
    }

    static fromJS(data: any): UpdateSubmissionFormDataInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSubmissionFormDataInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["submissionFormData"] = this.submissionFormData;
        return data;
    }
}

export interface IUpdateSubmissionFormDataInput {
    id: number;
    submissionFormData: string | undefined;
}

export class UpdateSubmissionInput implements IUpdateSubmissionInput {
    general!: SubmissionGeneralInput | undefined;
    projectManagement!: FullProjectManagementInput | undefined;
    specifics!: SubmissionSpecificInput | undefined;
    details!: SubmissionDetailsInput | undefined;
    projectId!: number;
    obligationId!: number | undefined;
    id!: number;

    constructor(data?: IUpdateSubmissionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.general = _data["general"] ? SubmissionGeneralInput.fromJS(_data["general"]) : <any>undefined;
            this.projectManagement = _data["projectManagement"] ? FullProjectManagementInput.fromJS(_data["projectManagement"]) : <any>undefined;
            this.specifics = _data["specifics"] ? SubmissionSpecificInput.fromJS(_data["specifics"]) : <any>undefined;
            this.details = _data["details"] ? SubmissionDetailsInput.fromJS(_data["details"]) : <any>undefined;
            this.projectId = _data["projectId"];
            this.obligationId = _data["obligationId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateSubmissionInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSubmissionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["projectManagement"] = this.projectManagement ? this.projectManagement.toJSON() : <any>undefined;
        data["specifics"] = this.specifics ? this.specifics.toJSON() : <any>undefined;
        data["details"] = this.details ? this.details.toJSON() : <any>undefined;
        data["projectId"] = this.projectId;
        data["obligationId"] = this.obligationId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateSubmissionInput {
    general: SubmissionGeneralInput | undefined;
    projectManagement: FullProjectManagementInput | undefined;
    specifics: SubmissionSpecificInput | undefined;
    details: SubmissionDetailsInput | undefined;
    projectId: number;
    obligationId: number | undefined;
    id: number;
}

export class UpdateUtprDataPointsConfirmationInput implements IUpdateUtprDataPointsConfirmationInput {
    projectId!: number;
    jurisdictionId!: number;
    comment!: string | undefined;
    isConfirmed!: boolean;
    utprDataPointId!: number | undefined;
    utprDataType!: UtprDataType;

    constructor(data?: IUpdateUtprDataPointsConfirmationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.jurisdictionId = _data["jurisdictionId"];
            this.comment = _data["comment"];
            this.isConfirmed = _data["isConfirmed"];
            this.utprDataPointId = _data["utprDataPointId"];
            this.utprDataType = _data["utprDataType"];
        }
    }

    static fromJS(data: any): UpdateUtprDataPointsConfirmationInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUtprDataPointsConfirmationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["jurisdictionId"] = this.jurisdictionId;
        data["comment"] = this.comment;
        data["isConfirmed"] = this.isConfirmed;
        data["utprDataPointId"] = this.utprDataPointId;
        data["utprDataType"] = this.utprDataType;
        return data;
    }
}

export interface IUpdateUtprDataPointsConfirmationInput {
    projectId: number;
    jurisdictionId: number;
    comment: string | undefined;
    isConfirmed: boolean;
    utprDataPointId: number | undefined;
    utprDataType: UtprDataType;
}

export class UploadSubmissionFeedbackFileInput implements IUploadSubmissionFeedbackFileInput {
    submissionId!: number;
    fileContent!: string | undefined;
    fileName!: string | undefined;

    constructor(data?: IUploadSubmissionFeedbackFileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submissionId = _data["submissionId"];
            this.fileContent = _data["fileContent"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): UploadSubmissionFeedbackFileInput {
        data = typeof data === 'object' ? data : {};
        let result = new UploadSubmissionFeedbackFileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submissionId"] = this.submissionId;
        data["fileContent"] = this.fileContent;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IUploadSubmissionFeedbackFileInput {
    submissionId: number;
    fileContent: string | undefined;
    fileName: string | undefined;
}

export class UserDetailsDto implements IUserDetailsDto {
    id!: number;
    fullName!: string | undefined;
    email!: string | undefined;
    profilePicture!: string | undefined;

    constructor(data?: IUserDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.profilePicture = _data["profilePicture"];
        }
    }

    static fromJS(data: any): UserDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["profilePicture"] = this.profilePicture;
        return data;
    }
}

export interface IUserDetailsDto {
    id: number;
    fullName: string | undefined;
    email: string | undefined;
    profilePicture: string | undefined;
}

export class UserLookupDto implements IUserLookupDto {
    id!: number;
    name!: string | undefined;
    fullName!: string | undefined;

    constructor(data?: IUserLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): UserLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IUserLookupDto {
    id: number;
    name: string | undefined;
    fullName: string | undefined;
}

export class UserOrOrganizationUnitDto implements IUserOrOrganizationUnitDto {
    type!: string | undefined;
    userOrOrganizationId!: number;
    displayName!: string | undefined;

    constructor(data?: IUserOrOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.userOrOrganizationId = _data["userOrOrganizationId"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): UserOrOrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserOrOrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["userOrOrganizationId"] = this.userOrOrganizationId;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IUserOrOrganizationUnitDto {
    type: string | undefined;
    userOrOrganizationId: number;
    displayName: string | undefined;
}

export class UserOrOrganizationUnitInput implements IUserOrOrganizationUnitInput {
    type!: string | undefined;
    userOrOrganizationId!: number;

    constructor(data?: IUserOrOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.userOrOrganizationId = _data["userOrOrganizationId"];
        }
    }

    static fromJS(data: any): UserOrOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new UserOrOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["userOrOrganizationId"] = this.userOrOrganizationId;
        return data;
    }
}

export interface IUserOrOrganizationUnitInput {
    type: string | undefined;
    userOrOrganizationId: number;
}

export class UserReferenceDataDto implements IUserReferenceDataDto {
    id!: number;
    text!: string | undefined;

    constructor(data?: IUserReferenceDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): UserReferenceDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserReferenceDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        return data;
    }
}

export interface IUserReferenceDataDto {
    id: number;
    text: string | undefined;
}

export class UtprDataPointDto implements IUtprDataPointDto {
    id!: number;
    jurisdictionId!: number;
    utprDataType!: UtprDataType;
    value!: string | undefined;
    utprValueType!: UtprValueType;
    isConfirmed!: boolean;
    notes!: string | undefined;
    readonly isEditable!: boolean;
    hasWritePermission!: boolean;

    constructor(data?: IUtprDataPointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.jurisdictionId = _data["jurisdictionId"];
            this.utprDataType = _data["utprDataType"];
            this.value = _data["value"];
            this.utprValueType = _data["utprValueType"];
            this.isConfirmed = _data["isConfirmed"];
            this.notes = _data["notes"];
            (<any>this).isEditable = _data["isEditable"];
            this.hasWritePermission = _data["hasWritePermission"];
        }
    }

    static fromJS(data: any): UtprDataPointDto {
        data = typeof data === 'object' ? data : {};
        let result = new UtprDataPointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["jurisdictionId"] = this.jurisdictionId;
        data["utprDataType"] = this.utprDataType;
        data["value"] = this.value;
        data["utprValueType"] = this.utprValueType;
        data["isConfirmed"] = this.isConfirmed;
        data["notes"] = this.notes;
        data["isEditable"] = this.isEditable;
        data["hasWritePermission"] = this.hasWritePermission;
        return data;
    }
}

export interface IUtprDataPointDto {
    id: number;
    jurisdictionId: number;
    utprDataType: UtprDataType;
    value: string | undefined;
    utprValueType: UtprValueType;
    isConfirmed: boolean;
    notes: string | undefined;
    isEditable: boolean;
    hasWritePermission: boolean;
}

export enum UtprDataType {
    UtprTopUpTaxCarryForward = 1,
    NumberOfEmployees = 2,
    ValueOfTangibleAssets = 3,
    UtprPercentage = 4,
    CashTaxExpense = 5,
}

export class UtprJurisdictionOverviewDto implements IUtprJurisdictionOverviewDto {
    id!: number;
    jurisdictionCountry!: string | undefined;
    hasWritePermission!: boolean;

    constructor(data?: IUtprJurisdictionOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.jurisdictionCountry = _data["jurisdictionCountry"];
            this.hasWritePermission = _data["hasWritePermission"];
        }
    }

    static fromJS(data: any): UtprJurisdictionOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new UtprJurisdictionOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["jurisdictionCountry"] = this.jurisdictionCountry;
        data["hasWritePermission"] = this.hasWritePermission;
        return data;
    }
}

export interface IUtprJurisdictionOverviewDto {
    id: number;
    jurisdictionCountry: string | undefined;
    hasWritePermission: boolean;
}

export enum UtprValueType {
    None = 1,
    Amount = 2,
    Percentage = 3,
}

export class ValidateResultDto implements IValidateResultDto {
    isValid!: boolean;
    description!: string | undefined;
    messages!: ResultMessageDto[] | undefined;

    constructor(data?: IValidateResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
            this.description = _data["description"];
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(ResultMessageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidateResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        data["description"] = this.description;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IValidateResultDto {
    isValid: boolean;
    description: string | undefined;
    messages: ResultMessageDto[] | undefined;
}

export class ValidateSubmissionFormDataInput implements IValidateSubmissionFormDataInput {
    id!: number;
    submissionFormData!: string | undefined;

    constructor(data?: IValidateSubmissionFormDataInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.submissionFormData = _data["submissionFormData"];
        }
    }

    static fromJS(data: any): ValidateSubmissionFormDataInput {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateSubmissionFormDataInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["submissionFormData"] = this.submissionFormData;
        return data;
    }
}

export interface IValidateSubmissionFormDataInput {
    id: number;
    submissionFormData: string | undefined;
}

export enum ValidationRuleType {
    Required = 1,
    ZeroOrBigger = 2,
    FinancialYearNotDuplicated = 3,
    InitialValueIsPercent = 4,
    InitialValueIsText = 5,
    ZeroOrLower = 6,
}

export class WhiteListOverviewDto implements IWhiteListOverviewDto {
    id!: number;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    email!: string | undefined;
    source!: string | undefined;

    constructor(data?: IWhiteListOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.source = _data["source"];
        }
    }

    static fromJS(data: any): WhiteListOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new WhiteListOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["email"] = this.email;
        data["source"] = this.source;
        return data;
    }
}

export interface IWhiteListOverviewDto {
    id: number;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    email: string | undefined;
    source: string | undefined;
}

export enum GloBEParentType2 {
    OrganizationalEntity = 0,
    OwnershipChange = 1,
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}

// copied from HttpClient.request, for some reason its not a type there
export interface RequestOptions {
    body?: any;
    headers?:
        | http.HttpHeaders
        | {
              [header: string]: string | string[];
          };
    context?: http.HttpContext;
    observe?: "body";
    params?:
        | http.HttpParams
        | {
              [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
          };
    reportProgress?: boolean;
    responseType: "arraybuffer";
    withCredentials?: boolean;
    transferCache?:
        | {
              includeHeaders?: string[];
          }
        | boolean;
}

const CALENDAR_DATE_KEYS = new Set<string>([
    "fiscalYearPeriod",
    "engagementLetterDated",
    "electionYear",
    "revocationYear",
    "iirApplicableFrom",
    "utprApplicableFrom",
    "qdmttApplicableFrom",
    "currencyElectionYear",
    "dueDate",
]);

function toDateOnlyIso(value: string): string {
    const match = /^(\d{4}-\d{2}-\d{2})/.exec(value);
    return match ? match[1] : value;
}

function normalizeCalendarValue(value: any): any {
    if (typeof value === "string") {
        return toDateOnlyIso(value);
    }

    if (Array.isArray(value)) {
        return value.map((item) => (typeof item === "string" ? toDateOnlyIso(item) : item));
    }

    return value;
}

function createPillar2CalendarDateReviver(): (key: string, value: any) => any {
    return (key: string, value: any) => {
        if (CALENDAR_DATE_KEYS.has(key)) {
            return normalizeCalendarValue(value);
        }

        return value;
    };
}